{
 " ao(à) paciente {nome}{cpf}": " al(a la) paciente {nome}{cpf}",
 " junto ao plano de saúde {c}": " ante el seguro médico {c}",
 " às {h}": " a las {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" o \"Página 1 de 10\", en la esquina que quieras.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" está en {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" no es JPG ni PNG. Conviértelo a JPG e inténtalo de nuevo.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" no es un PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" a las {hora} coincide con: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" ahora es del grupo. En menos de 1 minuto los demás miembros lo verán todo.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" se creó con los mismos datos.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" ya se agregó el {data}.",
 "% ao mês": "% al mes",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(En el ordenador del administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(copia)",
 "(sem título)": "(sin título)",
 "+ Adicionar alerta": "+ Añadir alerta",
 "+ Adicionar outra OAB": "+ Agregar otra OAB",
 "+ Adicionar pausa": "+ Añadir pausa",
 "+ Adicionar subtarefa": "+ Añadir subtarea",
 "+ Matéria em {nome}": "+ Materia en {nome}",
 "+ Perfil": "+ Perfil",
 "+ Subtarefa": "+ Subtarea",
 "+5 min": "+5 min",
 "+{n} acompanhante(s)": "+{n} acompañante(s)",
 "+{n} páginas acima da meta": "+{n} páginas por encima de la meta",
 ", carteirinha nº {n},": ", carnet n.º {n},",
 ", pago em {d}{f}": ", pagado el {d}{f}",
 "1 cápsula": "1 cápsula",
 "1 dose": "1 dosis",
 "1 dose (30 g)": "1 dosis (30 g)",
 "1 pessoa": "1 persona",
 "1 publicação nova": "1 publicación nueva",
 "1 página": "1 página",
 "1 tarja no documento": "1 franja en el documento",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Instala My Planner y crea tu cuenta.  2. Abre este enlace de nuevo (o escribe el código en Ajustes › Grupos e invitaciones).",
 "1. Quais dados tratamos": "1. Qué datos tratamos",
 "1. Sobre o app": "1. Sobre la app",
 "1ª dose": "1.ª dosis",
 "2 por folha": "2 por hoja",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 tazas de harina\n3 huevos\n1 cucharada de levadura",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 o 9 páginas en cada hoja (para imprimir).",
 "2. Para que usamos": "2. Para qué los usamos",
 "2. Sua conta": "2. Tu cuenta",
 "2ª dose": "2.ª dosis",
 "3 a 5 g": "3 a 5 g",
 "3. Bases legais (LGPD)": "3. Bases legales (LGPD)",
 "3. Uso correto": "3. Uso correcto",
 "3ª dose": "3.ª dosis",
 "4 por folha": "4 por hoja",
 "4. Com quem compartilhamos": "4. Con quién los compartimos",
 "4. Planos e testes": "4. Planes y pruebas",
 "5. Limites": "5. Límites",
 "5. Segurança": "5. Seguridad",
 "6 por folha": "6 por hoja",
 "6. Por quanto tempo": "6. Por cuánto tiempo",
 "7. Seus direitos (art. 18 da LGPD)": "7. Tus derechos (art. 18 de la LGPD)",
 "8. Crianças e adolescentes": "8. Niños y adolescentes",
 "9 por folha": "9 por hoja",
 "9. Mudanças": "9. Cambios",
 "@letra-dom": "D",
 "@letra-qua": "X",
 "@letra-qui": "J",
 "@letra-sab": "S",
 "@letra-seg": "L",
 "@letra-sex": "V",
 "@letra-ter": "M",
 "A IA está classificando...": "La IA está clasificando...",
 "A IA está lendo a caixa...": "La IA está leyendo la tarjeta...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "La IA lee las páginas y el PDF permite buscar y copiar.",
 "A IA lê o PDF e sugere um nome claro.": "La IA lee el PDF y sugiere un nombre claro.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "La IA no devolvió una respuesta en el formato esperado. Inténtalo de nuevo.",
 "A IA não encontrou dados para esta ficha no arquivo.": "La IA no encontró datos para esta ficha en el archivo.",
 "A IA não encontrou tarefas nesta caixa.": "La IA no encontró tareas en esta tarjeta.",
 "A IA resume o PDF e responde perguntas.": "La IA resume el PDF y responde preguntas.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "La SEFAZ registra que la factura llegó a tu conocimiento (no confirma ni rechaza la compra) y libera el XML completo en la próxima búsqueda, en hasta 1 hora.",
 "A VENCER (7 DIAS)": "POR VENCER (7 DÍAS)",
 "A aba inteira": "La pestaña completa",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "La pestaña {aba} está cerca del límite. Archiva o borra elementos antiguos.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "La pestaña {aba} no está suscrita. El vínculo se guarda y vuelve al suscribirte.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "La búsqueda de \"{nome}\" es demasiado amplia. Usa el nombre completo.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "La búsqueda de GIFs aún no está activada en esta app. Mientras tanto, usa los stickers animados (🎉).",
 "A cada": "Cada",
 "A cada N páginas": "Cada N páginas",
 "A cada quantos dias": "Cada cuántos días",
 "A cada {n} dia(s)": "Cada {n} día(s)",
 "A cada {n} mês(es)": "Cada {n} mes(es)",
 "A cada {n} mês(es) · dia {d}": "Cada {n} mes(es) · día {d}",
 "A cada {n} semana(s)": "Cada {n} semana(s)",
 "A cada {n} semana(s) · {dia}": "Cada {n} semana(s) · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "La tarjeta está en {aba}, en \"Notas recibidas\".",
 "A caixa foi para {destino}.": "La tarjeta se envió a {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "La clave se guarda solo en este dispositivo, en el almacén seguro del sistema. En otro dispositivo, regístrala de nuevo.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "La clave se guarda solo en este navegador. Úsalo en una computadora personal.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "La conexión está cifrada. La caja fuerte usa cifrado de extremo a extremo (AES-256): ni siquiera el soporte puede leerla. La app se puede bloquear con contraseña, patrón o biometría.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "La confirmación por WhatsApp aún no se activó en el servidor.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "La cuenta y todos los datos guardados en la nube: tareas, notas, pestañas, fichas, mensajes, archivos enviados a la app y ajustes. También se borran los datos de este dispositivo. No se puede deshacer.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "El color aparece en la barra, en los títulos y en las tareas vinculadas a esta pestaña.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "El color de My Planner es el color de acento de la app. Cada tarea puede tener su propio color en la ficha.",
 "A data de fim é anterior à de início.": "La fecha de fin es anterior a la de inicio.",
 "A data inicial precisa ser antes da final.": "La fecha inicial debe ser anterior a la final.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "El equipo revisará el error y lo corregirá en una próxima actualización.",
 "A equipe vê e altera conforme o papel de cada um": "El equipo ve y modifica según el rol de cada uno",
 "A fazer": "Por hacer",
 "A foto passa de 8 MB.": "La foto supera los 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "La foto es demasiado grande. Instala la nueva versión de la app para recortar la foto.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "La función \"nuvem\" aún no se ha publicado en el servidor. Ejecuta 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "La función \"nuvem\" aún no se ha publicado en el servidor. Ejecuta 9-LIGAR-DRIVE-ONEDRIVE.bat (ver COMO RODAR, versión 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "La grabación aún se está preparando. Inténtalo de nuevo en unos minutos.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "La hora queda fijada en este huso horario. En otro huso, la app la muestra y avisa en la hora convertida.",
 "A imagem original não está neste dispositivo.": "La imagen original no está en este dispositivo.",
 "A pagar": "Por pagar",
 "A pagar: {v}": "Por pagar: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "Se retiró el permiso del calendario. Vuelve a permitirlo en los ajustes del móvil.",
 "A pessoa sai do grupo e deixa de receber os envios.": "La persona sale del grupo y deja de recibir los envíos.",
 "A receber": "Por recibir",
 "A receber: {v}": "Por cobrar: {v}",
 "A reunião ainda está sendo gravada.": "La reunión todavía se está grabando.",
 "A senha atual não confere.": "La contraseña actual no es correcta.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "La contraseña de la caja fuerte debe tener 6 caracteres o más.",
 "A senha precisa ter 8 caracteres ou mais.": "La contraseña debe tener 8 caracteres o más.",
 "A senha precisa ter pelo menos 8 caracteres.": "La contraseña debe tener al menos 8 caracteres.",
 "A senha é a mesma no celular e no My Planner Web.": "La contraseña es la misma en el móvil y en My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "La sincronización se ejecuta al abrir la app y después de cada cambio. Las tareas vinculadas al calendario muestran 📆.",
 "A sua equipe num lugar só": "Todo tu equipo en un solo lugar",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Las tareas de la casa no entran solas en My Planner. \"Enviar a My Planner\" abre la ficha completa para elegir día, hora, frecuencia, pausas y alertas.",
 "A validade não pode ser antes da emissão.": "La fecha de vencimiento no puede ser anterior a la de emisión.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "La versión para iPhone llegará pronto a la App Store. Mientras tanto, usa My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "La versión para iPhone llegará pronto a la App Store. Mientras tanto, usa My Planner Web: en Safari, toca Compartir > Añadir a pantalla de inicio para tenerlo como un icono en el celular.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Carta, A5 u Oficio, sin cortar nada.",
 "ADICIONAR AMIGO": "AÑADIR AMIGO",
 "AGUARDANDO RESPOSTA": "ESPERANDO RESPUESTA",
 "AMIGOS": "AMIGOS",
 "ANOTAÇÕES": "NOTAS",
 "ANOTAÇÕES RECEBIDAS · {aba}": "NOTAS RECIBIDAS · {aba}",
 "ATIVIDADE": "ACTIVIDAD",
 "ATIVIDADE FÍSICA": "ACTIVIDAD FÍSICA",
 "ATRASADAS": "ATRASADAS",
 "Aba": "Pestaña",
 "Aba bloqueada": "Pestaña bloqueada",
 "Aba {nome}": "Pestaña {nome}",
 "Abas": "Pestañas",
 "Abas liberadas pelo suporte": "Pestañas habilitadas por soporte",
 "Abas para comprar": "Pestañas para comprar",
 "Abas que você já tem": "Pestañas que ya tienes",
 "Abastecimento": "Repostaje",
 "Abastecimentos": "Repostajes",
 "Abdominal": "Abdominales",
 "Abertura do prazo da declaração do IR": "Inicio del plazo de la declaración del IR",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Abre la empresa y toca \"Buscar facturas\" para escribir la contraseña de la caja fuerte.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Abre My Planner Anne e inicia sesión con tu documento y contraseña.",
 "Abra o My Planner no celular.": "Abre My Planner en el celular.",
 "Abra o cofre": "Abre la caja fuerte",
 "Abra um PDF para começar.": "Abre un PDF para empezar.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Abre una materia y toca \"Estudiar ahora\" para cronometrar. Define metas semanales en cada materia.",
 "Abraço": "Abrazo",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Abre el menú para compartir del celular: WhatsApp, correo, Google Drive, OneDrive, Guardar en Archivos y más.",
 "Abre o PDF para ler aqui mesmo.": "Abre el PDF para leerlo aquí mismo.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Abre el Escáner PDF (bordes y sombras corregidos).",
 "Abrir": "Abrir",
 "Abrir Ajustes": "Abrir Ajustes",
 "Abrir PDF": "Abrir PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Abrir PDF del celular, Drive o OneDrive",
 "Abrir a aba": "Abrir la pestaña",
 "Abrir a cópia guardada": "Abrir la copia guardada",
 "Abrir a pasta no Drive": "Abrir la carpeta en Drive",
 "Abrir com outro app": "Abrir con otra app",
 "Abrir configurações": "Abrir ajustes",
 "Abrir em outro app": "Abrir en otra app",
 "Abrir no DJEN": "Abrir en el DJEN",
 "Abrir no modo seguro": "Abrir en modo seguro",
 "Abrir normalmente": "Abrir normalmente",
 "Abrir nota fiscal": "Abrir factura",
 "Abrir o PDF": "Abrir el PDF",
 "Abrir o PDF no {nome}": "Abrir el PDF en {nome}",
 "Abrir o XML": "Abrir el XML",
 "Abrir o app": "Abrir la app",
 "Abrir o app My Planner": "Abrir la app My Planner",
 "Abrir o cartão": "Abrir la tarjeta",
 "Abrir o cofre": "Abrir la caja fuerte",
 "Abrir o cofre para ver": "Abrir la caja fuerte para ver",
 "Abrir o diário oficial": "Abrir el diario oficial",
 "Abrir ou baixar": "Abrir o descargar",
 "Abrir página": "Abrir página",
 "Abrir site": "Abrir sitio web",
 "Abrir {nome}": "Abrir {nome}",
 "Acabamento": "Acabados",
 "Acabou": "Agotado",
 "Academia": "Gimnasio",
 "Aceitar": "Aceptar",
 "Aceitar, editar ou recusar": "Aceptar, editar o rechazar",
 "Aceite os termos para continuar.": "Acepta los términos para continuar.",
 "Aceito": "Aceptado",
 "Aceito com alterações": "Aceptado con cambios",
 "Acerto de contas": "Ajuste de cuentas",
 "Acerto de contas: {v}": "Ajuste de cuentas: {v}",
 "Acessibilidade": "Accesibilidad",
 "Acesso ilimitado": "Acceso ilimitado",
 "Acesso ilimitado a todas as funções, sem prazo": "Acceso ilimitado a todas las funciones, sin plazo",
 "Achatar": "Aplanar",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Sigue todo, incluidos los gastos, y escribe en el diario.",
 "Acompanhamento": "Guarnición",
 "Acompanhantes": "Acompañantes",
 "Acrescentar no fim da página": "Añadir al final de la página",
 "Adaptador de tomada": "Adaptador de enchufe",
 "Adestramento": "Adiestramiento",
 "Adicionar": "Agregar",
 "Adicionar amigo": "Añadir amigo",
 "Adicionar amigos do app": "Añadir amigos de la app",
 "Adicionar ao Planner?": "¿Agregar al Planner?",
 "Adicionar arquivo": "Añadir archivo",
 "Adicionar cômodo": "Añadir habitación",
 "Adicionar fotos e vídeos": "Añadir fotos y videos",
 "Adicionar imagem": "Añadir imagen",
 "Adicionar item (ex.: 2 ovos mexidos)": "Añadir elemento (ej.: 2 huevos revueltos)",
 "Adicionar na página": "Añadir a la página",
 "Adicionar passo": "Añadir paso",
 "Adicionar país": "Agregar país",
 "Adicionar página": "Añadir página",
 "Adicionar texto": "Añadir texto",
 "Adicionar {nome}": "Añadir {nome}",
 "Adicionar à equipe": "Añadir al equipo",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Añade a un amigo con su código o envía tu código a quien quieras.",
 "Admin": "Admin",
 "Administração": "Administración",
 "Adubar a cada quantos dias": "Abonar cada cuántos días",
 "Adubar: {p}": "Abonar: {p}",
 "Adubei hoje": "Aboné hoy",
 "Advogado": "Abogado",
 "Advogados": "Abogados",
 "Afundo": "Zancadas",
 "Agachamento": "Sentadillas",
 "Agenda do Google": "Google Calendar",
 "Agenda limpa": "Agenda limpia",
 "Agenda não liberada": "Calendario no permitido",
 "Agenda sincronizada ✓": "Calendario sincronizado ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Agenda, notas, finanzas, estudios, mensajes y mucho más en una sola app.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Agenda, registro de pacientes y pagos, sin la historia clínica.",
 "Agendado": "Agendado",
 "Agendado no My Planner": "Agendado en My Planner",
 "Agendamento no pet shop": "Cita en la peluquería canina",
 "Agendar": "Programar",
 "Agendar no My Planner": "Agendar en My Planner",
 "Agendar no My Planner (dias e horários)": "Agendar en My Planner (días y horarios)",
 "Agora não": "Ahora no",
 "Agora o verso do documento.": "Ahora el reverso del documento.",
 "Agora, {hora}": "Ahora, {hora}",
 "Agora: {ml}": "Ahora: {ml}",
 "Aguardando o celular · {s}s": "Esperando el celular · {s}s",
 "Aguarde": "Espera",
 "Aguarde um pouco": "Espera un poco",
 "Aguarde...": "Espera...",
 "Ainda a pagar no mês": "Aún por pagar este mes",
 "Ainda a receber no mês": "Aún por cobrar este mes",
 "Ainda não confirmado": "Aún no confirmado",
 "Ainda não disponível: falta configurar no servidor.": "Aún no disponible: falta configurarlo en el servidor.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Aún no has ahorrado nada este mes. ¿Qué tal apartar {v} (10% de lo que entró) en cuanto llegue el dinero?",
 "Ainda não há feriados deste país para este ano.": "Todavía no hay feriados de este país para este año.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "Aún no hay nada en esta pestaña para compartir. Créalo primero (ej.: el viaje) y vuelve aquí.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Todavía no hay otras personas en el grupo (o no ves la lista de miembros).",
 "Ainda não marcado como feito. Toque para abrir.": "Aún no marcado como hecho. Toca para abrir.",
 "Ainda não sincronizado": "Aún no sincronizado",
 "Ainda sem chave neste dispositivo.": "Aún no hay clave en este dispositivo.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking o directo: reservas, limpieza al check-out, ingresos, gastos y ganancia del mes",
 "Ajuda na organização": "Ayuda en la organización",
 "Ajudante": "Ayudante",
 "Ajustar": "Ajustar",
 "Ajustar a data final": "Ajustar la fecha final",
 "Ajustar a folha": "Ajustar la hoja",
 "Ajustar tamanho da página": "Ajustar tamaño de página",
 "Ajuste visual": "Ajuste visual",
 "Ajustes": "Ajustes",
 "Alarme dos remédios": "Alarma de medicamentos",
 "Alarme que insiste até marcar como tomado": "Alarma que insiste hasta marcarlo como tomado",
 "Alemão": "Alemán",
 "Alergia": "Alergia",
 "Alergias": "Alergias",
 "Alergias e alertas": "Alergias y alertas",
 "Alertas": "Alertas",
 "Alertas das tarefas": "Alertas de las tareas",
 "Alertas dos compromissos": "Alertas de los compromisos",
 "Algo deu errado, mas o app continua aberto": "Algo salió mal, pero la app sigue abierta",
 "Alguns arquivos foram guardados em outro dispositivo.": "Algunos archivos se guardaron en otro dispositivo.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Algunos relojes (como los de Huawei) pueden no enviar datos a Health Connect. En ese caso, introdúcelos a mano.",
 "Alguém": "Alguien",
 "Alguém indicou o app para você?": "¿Alguien te recomendó la app?",
 "Alimentação": "Alimentación",
 "Alimentação & Despensa": "Alimentación & Despensa",
 "Alimentação {semana}": "Alimentación {semana}",
 "Alimento": "Alimento",
 "Alinhamento e balanceamento": "Alineación y equilibrado",
 "Almoço": "Almuerzo",
 "Alongamento": "Estiramiento",
 "Alta": "Alta",
 "Alterado por último por {nome}": "Modificado por última vez por {nome}",
 "Alterar metadados": "Cambiar metadatos",
 "Alterar o valor pago": "Cambiar importe pagado",
 "Alterações": "Cambios",
 "Alto-falante": "Altavoz",
 "Aluga como": "Se alquila como",
 "Alugar a casa ou um cômodo": "Alquilar la casa o una habitación",
 "Aluguel": "Alquiler",
 "Aluguel & Hospedagem": "Alquiler y Hospedaje",
 "Aluguel de carro": "Alquiler de coche",
 "Aluno": "Alumno",
 "Alunos": "Alumnos",
 "Alvará ou licença": "Permiso o licencia",
 "Alvenaria": "Albañilería",
 "Alvo": "Objetivo",
 "Alíquota do ISS (%)": "Alícuota del ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Alícuota del ISS de este servicio (%)",
 "Amanhã": "Mañana",
 "Ambiente": "Entorno",
 "Ameno": "Templado",
 "Amigos": "Amigos",
 "Amor": "Amor",
 "Amortização": "Amortización",
 "Ampliar a foto": "Ampliar la foto",
 "Amém": "Amén",
 "Analisar com IA": "Analizar con IA",
 "Anamnese e histórico (no cofre)": "Anamnesis e historial (en la caja fuerte)",
 "Anexar arquivos": "Adjuntar archivos",
 "Anexar comprovante": "Adjuntar comprobante",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Adjuntar documentos, importar extractos y guardar informes, PDFs y copias de seguridad.",
 "Anexos": "Adjuntos",
 "Anexos guardados aqui no dispositivo: {n}": "Adjuntos guardados en este dispositivo: {n}",
 "Animais e natureza": "Animales y naturaleza",
 "Animação": "Animación",
 "Anime": "Anime",
 "Aniversário": "Cumpleaños",
 "Aniversário de Campo Grande": "Aniversario de Campo Grande",
 "Aniversário de São Paulo": "Aniversario de São Paulo",
 "Ano": "Año",
 "Ano anterior": "Año anterior",
 "Ano de lançamento": "Año de estreno",
 "Ano de {ano}": "Año {ano}",
 "Ano passado": "Año pasado",
 "Anotar pela foto da página": "Anotar con la foto de la página",
 "Anotação": "Nota",
 "Anotação de {data}": "Nota del {data}",
 "Anotação do professor": "Nota del profesor",
 "Anotação à mão": "Nota a mano",
 "Anotações": "Notas",
 "Anotações Rápidas": "Notas Rápidas",
 "Anotações arquivadas": "Notas archivadas",
 "Anotações arquivadas ({n})": "Notas archivadas ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Anota cada reserva con las fechas, el origen y los valores. La limpieza del check-out se añade sola a la lista de limpiezas.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Anota el día a día de la obra con fotos. Marca las fotos como Antes o Después para ver la evolución.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Anota lo que prestaste o te prestaron, con foto y plazo. La app te avisa el día de la devolución.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Anota los lugares que quieres conocer. Búscalos en Google Maps o Waze, traza la ruta pasando por todos y agrégalos al itinerario del día.",
 "Anteriores ({n})": "Anteriores ({n})",
 "Antes": "Antes",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Antes de empezar, revisa qué usa la app y por qué. Puedes cambiarlo todo después en Ajustes > Privacidad y términos.",
 "Antes de uma data": "Antes de una fecha",
 "Antes do início": "Antes del inicio",
 "Antes e depois": "Antes y después",
 "Antes: {lista}": "Antes: {lista}",
 "Antipulgas": "Antipulgas",
 "Anual": "Anual",
 "Ao ar livre": "Al aire libre",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "Al cancelar, la pestaña queda en blanco y negro y los vínculos desaparecen de las tareas, pero no se borra nada.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Al crear la cuenta o seguir usando la app, aceptas estos términos y la política de privacidad que aparece abajo.",
 "Ao fechar, a página é salva.": "Al cerrar, la página se guarda.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "Al guardar, creas la contraseña de la caja fuerte. Este campo se cifra en el dispositivo.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Al tocar \"Archivo\" o \"Foto\" en Estudios y Documentos, el selector del móvil muestra Google Drive, OneDrive y Dropbox (si tienes las apps instaladas). Elige el archivo directamente desde ahí.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Al tocar un archivo adjunto, se abre en la app del celular que elijas (en Android, \"Solo una vez\" o \"Siempre\"). Lo que edites allí se guarda en el propio archivo.",
 "Apaga a conta e todos os vencimentos dela.": "Borra la cuenta y todos sus vencimientos.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Borra las materias y páginas de esta carpeta. Las tareas del planner se mantienen.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Borra las páginas de esta materia. El tiempo estudiado se mantiene en el historial.",
 "Apaga o cartão e as compras dele.": "Borra la tarjeta y sus compras.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Borra para siempre la cuenta y todos los datos en la nube y en este dispositivo. No se puede deshacer.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Borra todas las tareas de la agenda, pasadas y futuras.",
 "Apaga todas as {n} parcelas.": "Borra las {n} cuotas.",
 "Apaga todos os meses desta conta.": "Borra todos los meses de esta cuenta.",
 "Apagar": "Borrar",
 "Apagar \"{nome}\"?": "¿Eliminar \"{nome}\"?",
 "Apagar a caixa?": "¿Borrar la tarjeta?",
 "Apagar a chave": "Borrar la clave",
 "Apagar a chave deste dispositivo?": "¿Borrar la clave de este dispositivo?",
 "Apagar a conta?": "¿Borrar la cuenta?",
 "Apagar a lista de erros?": "¿Borrar la lista de errores?",
 "Apagar a pasta (os documentos continuam)": "Eliminar la carpeta (los documentos se conservan)",
 "Apagar as da agenda": "Borrar las del calendario",
 "Apagar caixa": "Borrar tarjeta",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Borrar de verdad (las páginas con franja se vuelven imagen)",
 "Apagar de vez": "Borrar definitivamente",
 "Apagar desenho": "Borrar dibujo",
 "Apagar envio": "Borrar envío",
 "Apagar lista": "Borrar lista",
 "Apagar minha conta": "Borrar mi cuenta",
 "Apagar minha conta e todos os dados": "Borrar mi cuenta y todos los datos",
 "Apagar o escritório": "Eliminar la oficina",
 "Apagar o escritório?": "¿Eliminar la oficina?",
 "Apagar o grupo": "Borrar el grupo",
 "Apagar o grupo?": "¿Borrar el grupo?",
 "Apagar o lançamento?": "¿Borrar el movimiento?",
 "Apagar para todos": "Eliminar para todos",
 "Apagar tudo": "Borrar todo",
 "Apagar tudo antes de": "Borrar todo antes de",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Borra de una vez las tareas de hoy, del mes, de un período o por nombre. Antes de borrar, la app muestra lo que se va a eliminar y te pide la contraseña.",
 "Aparece na barra quando estiver liberada": "Aparece en la barra cuando esté desbloqueada",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Aparecen en el Planner, junto con los días de asueto opcionales (Carnaval, Miércoles de Ceniza y Corpus Christi).",
 "Aplicar": "Aplicar",
 "Aponte a câmera do celular para este QR Code.": "Apunta la cámara del celular a este código QR.",
 "Aponte para o QR Code na tela do computador": "Apunta al código QR en la pantalla de la computadora",
 "Apostila": "Apuntes",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Apuntes, listas, diapositivas, videos, enlaces y avisos. Desde ⋮ › Enviar a un grupo, cada alumno lo recibe en su app.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App usada en el botón \"Ruta\" de las direcciones (tareas, consultas, itinerario del viaje, obras, escuela...).",
 "Apple Saúde": "Apple Salud",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: ya guarda todo en la app Salud del iPhone. No tienes que hacer nada.",
 "Apresentação": "Presentación",
 "Aprovação": "Aprobación",
 "Aqui": "Aquí",
 "Ar-condicionado": "Aire acondicionado",
 "Arco-íris": "Arcoíris",
 "Arenoso": "Arenoso",
 "Armazenamento": "Almacenamiento",
 "Armário": "Armario",
 "Arquivadas ({n})": "Archivadas ({n})",
 "Arquivados ({n})": "Archivados ({n})",
 "Arquivar": "Archivar",
 "Arquivar a caixa de anotações?": "¿Archivar la tarjeta de notas?",
 "Arquivar conversa": "Archivar chat",
 "Arquivo": "Archivo",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "Archivo (Drive, OneDrive, Dropbox o del dispositivo)",
 "Arquivo OFX ou CSV do banco": "Archivo OFX o CSV del banco",
 "Arquivo adicionado": "Archivo añadido",
 "Arquivo menor (para WhatsApp e e-mail)": "Archivo más ligero (para WhatsApp y correo)",
 "Arquivo menor para WhatsApp e e-mail.": "Archivo más pequeño para WhatsApp y correo.",
 "Arquivo não encontrado.": "Archivo no encontrado.",
 "Arquivo ou PDF": "Archivo o PDF",
 "Arquivo ou documento": "Archivo o documento",
 "Arquivos": "Archivos",
 "Arquivos (frente, verso, PDF)": "Archivos (anverso, reverso, PDF)",
 "Arquivos (importar e exportar)": "Archivos (importar y exportar)",
 "Arquivos de {nome}": "Archivos de {nome}",
 "Arquivos na nuvem e cópias de segurança": "Archivos en la nube y copias de seguridad",
 "Arrasou!": "¡Crack!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Arrastra los puntos hasta las 4 esquinas de la hoja. La app recorta y endereza la página.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Desliza el dedo sobre lo que quieres ocultar. Toca una franja para quitarla.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Desliza a la derecha para eliminar, o a la izquierda para enviar a otra pestaña.",
 "Arraste para a direita para excluir.": "Desliza a la derecha para eliminar.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Arrastra para cambiar el orden, gira, duplica, borra y añade páginas en blanco.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Arrastra para ver el resto del tablero. Crece hacia abajo y hacia la derecha.",
 "Arraste um documento para a direita para excluir.": "Desliza un documento a la derecha para eliminarlo.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Desliza una tarjeta a la izquierda para archivarla o a la derecha para eliminarla.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Desliza una caja a la izquierda para archivar o a la derecha para eliminar. Mantén pulsado ⋮⋮ para cambiar el orden.",
 "Arroz": "Arroz",
 "Artes": "Artes",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Las suscripciones Claude Pro, ChatGPT Plus y Gemini Advanced no pueden usarse en otras apps. Para activar la IA aquí, crea una clave de API en tu cuenta (Gemini tiene uso gratuito; Claude y ChatGPT cobran por uso, céntimos por análisis).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Las llamadas aún no se han activado en el servidor (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Sus compras también se quitan de Finanzas.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Las compras en cuotas entran con todas las cuotas: las siguientes ya aparecen en los próximos estados de cuenta.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Las fotos de este documento están en el dispositivo donde se escaneó. Allí puedes editarlo, compartirlo y leer el texto.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Las imágenes solo van a la IA que elegiste, con tu clave.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Las limpiezas de los check-outs aparecen aquí solas, con checklist y fotos de antes y después.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Las facturas emitidas aquí, las encontradas en la búsqueda y los XML importados aparecen en esta lista.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Las cuotas aparecen aquí. Adjunta el comprobante (foto, PDF o captura del PIX) en cada una.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Las cuotas de los próximos 12 meses ya están en My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Las cuotas pendientes se recalculan con el valor, los intereses y el plazo actuales del contrato. Las pagadas no cambian.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Las páginas de este documento están en el dispositivo donde se escaneó. Ábrelo allí o usa la copia guardada en Drive o en OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Las páginas se vuelven imágenes más ligeras: ideal para PDFs escaneados. El texto deja de ser buscable (usa el OCR después, si lo necesitas).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Las páginas van solo a la IA que elegiste, con tu clave.",
 "As receitas do cardápio já têm tudo na despensa.": "La despensa ya tiene todo para las recetas del menú.",
 "As senhas novas não conferem.": "Las contraseñas nuevas no coinciden.",
 "As senhas não conferem.": "Las contraseñas no coinciden.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Las tareas siguen en My Planner. ¿Quieres borrar también las que vinieron de Google Calendar?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Las tareas de la habitación siguen en Mi Casa, sin habitación.",
 "As tarefas vinculadas continuam no My Planner.": "Las tareas vinculadas se mantienen en My Planner.",
 "Aspirar e passar pano": "Aspirar y trapear",
 "Assinada": "Suscrita",
 "Assinar": "Firmar",
 "Assinar (simulação de teste)": "Suscribirse (simulación de prueba)",
 "Assinar o documento": "Firmar el documento",
 "Assinatura": "Firma",
 "Assinatura do profissional": "Firma del profesional",
 "Assinatura e segurança": "Firma y seguridad",
 "Assinaturas (simulação de teste)": "Suscripciones (simulación de prueba)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Suscríbete a la pestaña en Ajustes para enviarle notas.",
 "Assine a aba em Ajustes para vincular.": "Suscríbete a la pestaña en Ajustes para vincular.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Suscríbete a la pestaña en Ajustes › Compras para enviarle notas.",
 "Assine a aba em Ajustes › Compras para vincular.": "Suscríbete a la pestaña en Ajustes › Compras para vincular.",
 "Assine a aba para abrir o vínculo.": "Suscríbete a la pestaña para abrir el vínculo.",
 "Assisti mais uma aula": "Vi otra clase",
 "Assistido": "Visto",
 "Assistindo": "Viendo",
 "Assistência técnica (nome)": "Servicio técnico (nombre)",
 "Assistência: {nome}": "Servicio técnico: {nome}",
 "Assunto": "Asunto",
 "Assunto (ex.: Reunião semanal)": "Asunto (ej.: Reunión semanal)",
 "Atender": "Contestar",
 "Atendimento": "Consulta",
 "Atendimentos": "Consultas",
 "Ativar avisos": "Activar avisos",
 "Ativar monitor": "Activar monitor",
 "Ativas": "Activas",
 "Atividade": "Actividad",
 "Atividade do roteiro": "Actividad del itinerario",
 "Atividade hoje": "Actividad hoy",
 "Atividade: {blocos}": "Actividad: {blocos}",
 "Atividades": "Actividades",
 "Atividades de hoje": "Actividades de hoy",
 "Atividades e materiais": "Actividades y materiales",
 "Atividades físicas e saúde": "Actividad física y salud",
 "Atrasada": "Atrasada",
 "Atrasada há {n} dia(s)": "Atrasada hace {n} día(s)",
 "Atrasadas": "Atrasadas",
 "Atrasados": "Atrasados",
 "Atuais": "Actuales",
 "Atualidades": "Actualidad",
 "Atualizar": "Actualizar",
 "Atualizar agora": "Actualizar ahora",
 "Atualizar alarmes no My Planner": "Actualizar alarmas en My Planner",
 "Atualizar rega e adubo na agenda": "Actualizar riego y abono en la agenda",
 "Atualização automática disponível no app instalado (APK).": "Actualización automática disponible en la app instalada (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Actualización descargada. Se aplica al reabrir la app o al tocar el aviso.",
 "Atualização pronta": "Actualización lista",
 "Atualizações": "Actualizaciones",
 "Até": "Hasta",
 "Audiência": "Audiencia",
 "Aula dada": "Clase dada",
 "Aula {a} de {n} ({p}%)": "Clase {a} de {n} ({p}%)",
 "Aulas assistidas": "Clases vistas",
 "Autoajuda": "Autoayuda",
 "Autor": "Autor",
 "Avaliação": "Evaluación",
 "Avaliações e notas": "Evaluaciones y notas",
 "Avançado": "Avanzado",
 "Aveia": "Avena",
 "Avisar a hora de sair": "Avisar la hora de salir",
 "Avisar antes de vencer": "Avisar antes de que venza",
 "Avisar no celular quando alguém incluir algo": "Avisarme en el celular cuando alguien añada algo",
 "Aviso": "Aviso",
 "Aviso com as tarefas do dia": "Aviso con las tareas del día",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Aviso de prueba enviado por el servidor. Llega en unos segundos; sal de la app para verlo en la barra del móvil.",
 "Aviso enviado": "Aviso enviado",
 "Aviso {dias} dia(s) antes e no dia": "Aviso {dias} día(s) antes y el mismo día",
 "Avisos no celular": "Avisos en el móvil",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Los avisos en el móvil pasan por los servicios de Expo, Google y Apple.",
 "Ação": "Acción",
 "Ações": "Acciones",
 "BOLETO E DOCUMENTOS": "BOLETO Y DOCUMENTOS",
 "Backup importado.": "Copia de seguridad importada.",
 "Bairro": "Barrio",
 "Baixa": "Baja",
 "Baixando atualização...": "Descargando actualización...",
 "Baixar": "Descargar",
 "Baixar a versão {v}": "Descargar la versión {v}",
 "Baixar agora": "Descargar ahora",
 "Baixar o My Planner para Android": "Descargar My Planner para Android",
 "Baixar o My Planner para Android (versão {v})": "Descargar My Planner para Android (versión {v})",
 "Baixar o My Planner para iPhone": "Descargar My Planner para iPhone",
 "Baixar o PDF da nota (DANFSe)": "Descargar el PDF de la factura (DANFSe)",
 "Baixar o PDF?": "¿Descargar el PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Descargar el XML completo (da conocimiento a la SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Descarga la versión más reciente para Android: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Descarga aquí la versión más reciente: {link}",
 "Balança": "Balancea",
 "Balanço e relatórios": "Balance e informes",
 "Banana": "Plátano",
 "Banco": "Banco",
 "Banco, financeira ou pessoa": "Banco, financiera o persona",
 "Bandeiras": "Banderas",
 "Banheiro": "Baño",
 "Banho": "Baño",
 "Banho e tosa": "Baño y corte",
 "Barra": "Barra",
 "Bateria": "Batería",
 "Batimentos (média)": "Pulsaciones (media)",
 "Batizado": "Bautizo",
 "Bebida": "Bebida",
 "Bebê": "Bebé",
 "Beijo": "Beso",
 "Bem": "Bien",
 "Bem clara": "Muy clara",
 "Bem-Estar": "Bienestar",
 "Bem-Estar · Cronograma alimentar": "Bienestar · Plan de comidas",
 "Bens": "Bienes",
 "Bichos e diversão": "Animales y diversión",
 "Bicicleta": "Bicicleta",
 "Bicicleta ergométrica": "Bicicleta estática",
 "Biografia": "Biografía",
 "Biologia": "Biología",
 "Biometria (digital ou rosto)": "Biometría (huella o rostro)",
 "Biometria ({tipos})": "Biometría ({tipos})",
 "Biometria não confirmada.": "Biometría no confirmada.",
 "Bloqueado": "Bloqueado",
 "Bloquear": "Bloquear",
 "Bloquear agora": "Bloquear ahora",
 "Bloqueio": "Bloqueo",
 "Blusas de frio": "Jerséis",
 "Boa noite": "Buenas noches",
 "Boa sorte!": "¡Buena suerte!",
 "Boas-vindas ao My Planner": "Te damos la bienvenida a My Planner",
 "Boas-vindas pelo WhatsApp": "Bienvenida por WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto adjunto",
 "Boleto do banco {b}": "Boleto del banco {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto y documentos (foto, PDF o archivo)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto o factura (foto, PDF o archivo)",
 "Boleto por foto": "Boleto por foto",
 "Bolinha": "Círculo",
 "Bom dia": "Buenos días",
 "Bom dia!": "¡Buenos días!",
 "Bom dia! Seu dia no My Planner": "¡Buenos días! Tu día en My Planner",
 "Booking": "Booking",
 "Bora!": "¡Vamos!",
 "Borboleta": "Mariposa",
 "Borracha": "Borrador",
 "Botas para neve": "Botas de nieve",
 "Brasil": "Brasil",
 "Braços acima da cabeça": "Brazos sobre la cabeza",
 "Brilho": "Brillo",
 "Brinquedo ou livro para a viagem": "Juguete o libro para el viaje",
 "Busca de notas": "Búsqueda de facturas",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Busca el nombre en los diarios municipales reunidos por Querido Diário (Open Knowledge Brasil). No todos los municipios están incluidos, y los diarios oficiales no forman parte del DJEN.",
 "Buscando...": "Buscando...",
 "Buscar": "Buscar",
 "Buscar GIF (ex.: parabéns, bom dia)": "Buscar GIF (ej.: felicidades, buenos días)",
 "Buscar cidade, país ou GMT": "Buscar ciudad, país o GMT",
 "Buscar conversa": "Buscar chat",
 "Buscar documento, titular ou órgão": "Buscar documento, titular u organismo",
 "Buscar em {nome}": "Buscar en {nome}",
 "Buscar emoji (ex.: coração, risada)": "Buscar emoji (ej.: corazón, risa)",
 "Buscar figurinha": "Buscar sticker",
 "Buscar notas": "Buscar facturas",
 "Buscar ou digitar um alimento": "Buscar o escribir un alimento",
 "Buscar país": "Buscar país",
 "Buscar pelo nome ou pelo texto": "Buscar por nombre o por texto",
 "Buscar produto, loja ou observação": "Buscar producto, tienda u observación",
 "Buscar tarefas": "Buscar tareas",
 "Buscar: processo, parte, tribunal, palavra...": "Buscar: proceso, parte, tribunal, palabra...",
 "CAIXA {n}": "CAJA {n}",
 "CARDS DE ANOTAÇÕES": "TARJETAS DE NOTAS",
 "CARTÕES": "TARJETAS",
 "CEP": "CEP (código postal)",
 "CID (se o paciente pedir na declaração)": "CID (CIE, si el paciente lo pide en la declaración)",
 "CID: {c}": "CID: {c}",
 "CNH": "Licencia de conducir (CNH)",
 "CNPJ (se tiver)": "CNPJ (si tienes)",
 "CNPJ ou CPF": "CNPJ o CPF",
 "COMPROVANTE DE PAGAMENTO": "COMPROBANTE DE PAGO",
 "COMPROVANTE DE RECEBIMENTO": "COMPROBANTE DE COBRO",
 "COMPROVANTES ANTERIORES": "COMPROBANTES ANTERIORES",
 "CONTAS DO MÊS": "CUENTAS DEL MES",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brasil)",
 "CPF de quem paga": "CPF de quien paga",
 "CPF do paciente": "CPF del paciente",
 "CPF do pagador": "CPF del pagador",
 "CPF inválido": "CPF inválido",
 "CPF ou CNPJ de quem recebeu": "CPF o CNPJ de quien recibió",
 "CPF ou senha incorretos.": "CPF o contraseña incorrectos.",
 "CRIAR CÔMODO": "CREAR HABITACIÓN",
 "CRIAR UM GRUPO": "CREAR UN GRUPO",
 "CRONOGRAMA ALIMENTAR": "PLAN DE COMIDAS",
 "CUIDADOS PESSOAIS": "CUIDADO PERSONAL",
 "Cabeleireiro": "Peluquero",
 "Cabelo": "Cabello",
 "Cachorro": "Perro",
 "Cactos e suculentas": "Cactus y suculentas",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Cada pestaña extra: {n} días gratis; después {preco} al año.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Cada archivo listo va a {nome}. Los PDFs abiertos también quedan en este dispositivo, en la lista de abajo.",
 "Cada dia da semana": "Cada día de la semana",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Cada documento nuevo va a {nome} cuando sales de él. Las fotos de las páginas se quedan solo en este dispositivo.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Cada persona del equipo recibe la reunión en Recibidos y la pone en el Planner con un toque, con la alerta.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Cada persona del grupo lo recibe y decide si lo acepta.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Cada página guarda un resumen, clase o capítulo. Márcala como revisada cuando termines.",
 "Cada página vira uma imagem JPG.": "Cada página se convierte en una imagen JPG.",
 "Cada refeição se repete nos dias dela": "Cada comida se repite en sus días",
 "Cadastrar": "Registrar",
 "Cadastrar cartão de crédito": "Registrar tarjeta de crédito",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Registrar con una foto (página del curso, certificado, folleto)",
 "Cadastrar pela foto da capa": "Registrar con la foto de la portada",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Completa \"Mis datos\" para que los recibos salgan con tu nombre, colegio y número.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Registra tu identificación, licencia de conducir, pasaporte, contratos y certificados. La app te avisa antes de que venzan y envía el documento con un toque.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Registra la empresa (o a ti, como profesional) con CNPJ o CPF, municipio y régimen. Después conecta el certificado A1 para emitir NFS-e por el Padrão Nacional y buscar las facturas emitidas y recibidas.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Registra la obra y, dentro de ella, las etapas con presupuesto, el diario con fotos, los profesionales y las entregas de material.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Registra el viaje y, dentro de él, el itinerario de cada día, las reservas y la maleta. Durante el viaje, el itinerario aparece en My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Registra solo tu propio nombre y tu OAB.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Registra a los niños: exámenes, reuniones, citas y vacunas quedan dentro de cada uno.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Registra cada mascota: cartilla de vacunación, desparasitantes, medicamentos y peluquería quedan dentro de ella.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Registra cada planta con luz, suelo y cada cuántos días regar y abonar. La app arma el calendario en la agenda.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Registra cada vehículo. Dentro de él quedan los mantenimientos (con aviso por km y por fecha) y los vencimientos de IPVA, licencia y seguro.",
 "Cadastre digital ou rosto no aparelho para usar.": "Registra tu huella o rostro en el dispositivo para usarla.",
 "Cadastre o cartão primeiro": "Primero registra la tarjeta",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Registra el financiamiento o préstamo con el valor, los intereses y el número de cuotas. La app calcula las cuotas, el saldo pendiente y avisa los vencimientos.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Registra el inmueble entero o cada habitación que alquilas. Dentro de cada uno van las reservas, la limpieza y los gastos.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Registra el libro con el total de páginas y la meta diaria. Toca ⋮ para sumar las páginas leídas.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Registra el medicamento con sus horarios y toca ⋮ para ponerlo en la línea de tiempo con alarma.",
 "Cadastre os alunos da turma na aba Alunos.": "Registra a los alumnos del grupo en la pestaña Alumnos.",
 "Cadastre os clientes para separar as horas.": "Registra a los clientes para separar las horas.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Registra los clientes que reciben tus facturas. La dirección es opcional (si la completas, indica CEP, código IBGE, calle, número y barrio).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Registra los servicios que más emites, con el código de tributación nacional. A la hora de emitir, solo tienes que tocar.",
 "Cadastre primeiro em {nome}.": "Primero registra uno en {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Registra tu nombre, colegio y número de matrícula. Aparecen en los recibos y declaraciones.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Registra a tus clientes en la pestaña \"Tomadores\" de la empresa para elegirlos aquí.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Registra tus datos profesionales (nombre, colegio y número) en \"Mis datos\" para que salgan en el documento.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Registra tus datos profesionales (nombre, colegio y número) en \"Mis datos\" para que salgan en el recibo.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Registra a tus pacientes. Dentro de cada uno están las consultas con evolución, prescripción, pago, recibo y declaración para el seguro médico.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Regístrate tú y a cada persona de la familia. Dentro de cada una quedan citas, pruebas, vacunas y medicamentos. Los datos sensibles van a la caja fuerte cifrada.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Registro en espera de habilitación: desactiva \"Confirm email\" en Supabase (consulta COMO RODAR).",
 "Cadastro recebido": "Registro recibido",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Registro: nombre, CPF o correo electrónico, contraseña (guardada solo de forma protegida) y correo de contacto.",
 "Cadastros": "Registros",
 "Cadastros e comprovantes": "Registros y comprobantes",
 "Cadeira extensora": "Extensión de cuádriceps",
 "Café": "Café",
 "Café da manhã": "Desayuno",
 "Café ou bar": "Café o bar",
 "Café?": "¿Café?",
 "Cafés": "Cafeterías",
 "Caixa": "Caja",
 "Caixa arquivada": "Tarjeta archivada",
 "Caixa com checklist, lista ou texto livre": "Caja con checklist, lista o texto libre",
 "Caixa {n}": "Caja {n}",
 "Caixas": "Cajas",
 "Caixas e cronograma da mudança.": "Cajas y cronograma de la mudanza.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Cajas por habitación con etiqueta, cambio de agua, luz e internet, inspecciones y el cronograma de los días.",
 "Calculadora": "Calculadora",
 "Calculando...": "Calculando...",
 "Calendário": "Calendario",
 "Calendário da planta": "Calendario de la planta",
 "Calendário do imposto": "Calendario del impuesto",
 "Calendários": "Calendarios",
 "Calorias em atividade": "Calorías en actividad",
 "Calorias gastas em atividade (kcal)": "Calorías quemadas en actividad (kcal)",
 "Calça térmica (segunda pele)": "Pantalón térmico (primera capa)",
 "Calças ou bermudas": "Pantalones o bermudas",
 "Cama": "Cama",
 "Caminhada": "Caminata",
 "Caminhão": "Camión",
 "Camisetas": "Camisetas",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Campos de formulario",
 "Cancelada": "Cancelada",
 "Canceladas": "Canceladas",
 "Cancelar": "Cancelar",
 "Cancelar a NFS-e": "Cancelar la NFS-e",
 "Cancelar a NFS-e {n}?": "¿Cancelar la NFS-e {n}?",
 "Cancelar a nota": "Cancelar la factura",
 "Cancelar a reunião \"{nome}\"?": "¿Cancelar la reunión \"{nome}\"?",
 "Cancelar reunião": "Cancelar reunión",
 "Caneta": "Lápiz",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Captura automática del servidor: cada 2 horas, de 08:00 a 20:00",
 "Captura automática: todos os dias às 08h e 12h": "Captura automática: todos los días a las 08:00 y 12:00",
 "Card": "Tarjeta",
 "Cardápio": "Menú",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Menú de la semana, recetas, lista de la compra automática y caducidad de la despensa.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Menú solo para este día. Los demás días siguen con el de la semana.",
 "Carga (kg)": "Carga (kg)",
 "Carimbo": "Sello",
 "Carnaval": "Carnaval",
 "Carne magra": "Carne magra",
 "Carregando feriados...": "Cargando feriados...",
 "Carregando...": "Cargando...",
 "Carro": "Auto",
 "Carta": "Carta",
 "Carteira": "Cartera",
 "Carteira de trabalho": "Libreta de trabajo",
 "Carteira profissional (OAB, CRC, CREA...)": "Carné profesional (OAB, CRC, CREA...)",
 "Cartão": "Tarjeta",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Tarjeta de contacto de Mensajes: la foto, el teléfono, el correo y la frase que tú elijas poner. Solo la ven quienes chatean contigo, tus amigos y quienes comparten un grupo de la app contigo.",
 "Cartão de crédito": "Tarjeta de crédito",
 "Cartão de débito": "Tarjeta de débito",
 "Cartão parcelado": "Tarjeta en cuotas",
 "Cartões": "Tarjetas",
 "Cartões de visita": "Tarjetas de visita",
 "Cartões e dinheiro": "Tarjetas y efectivo",
 "Casa": "Casa",
 "Casa e rotina": "Casa y rutina",
 "Casa, família e veículos": "Casa, familia y vehículos",
 "Casaco leve": "Chaqueta ligera",
 "Casaco pesado": "Abrigo grueso",
 "Casamento": "Boda",
 "Castanhas": "Frutos secos",
 "Categoria": "Categoría",
 "Categoria de \"{d}\"": "Categoría de \"{d}\"",
 "Categorias": "Categorías",
 "Caução": "Fianza",
 "Ceia": "Cena ligera",
 "Celular": "Celular",
 "Celular confirmado": "Celular confirmado",
 "Celular e carregador": "Móvil y cargador",
 "Certidão": "Certificado",
 "Certificado digital": "Certificado digital",
 "Certificado digital A1": "Certificado digital A1",
 "Certificado ligado": "Certificado conectado",
 "Chamada": "Lista de asistencia",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Aún no se pasó lista este día. Toca a quien faltó o confirma que todos están presentes.",
 "Chamada, notas, planos de aula e materiais.": "Asistencia, notas, planes de clase y materiales.",
 "Chamadas": "Llamadas",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Las llamadas de audio y video pasan por los servidores de LiveKit, solo durante la llamada y sin grabación.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Las llamadas de audio y video pasan por los servidores de LiveKit, solo durante la llamada. Solo se graba en las reuniones de Oficina, cuando el administrador graba, y el archivo va directamente al almacenamiento de la app.",
 "Chamando...": "Llamando...",
 "Chapéu ou boné": "Sombrero o gorra",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Clave de IA no registrada en este dispositivo (Ajustes › Inteligencia artificial).",
 "Chave de acesso": "Clave de acceso",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} a partir de las {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} hasta las {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Checklist",
 "Chinelo": "Chanclas",
 "Chá de bebê": "Baby shower",
 "Cidade": "Ciudad",
 "Cidade (para a data dos recibos)": "Ciudad (para la fecha de los recibos)",
 "Cidade de {nome}": "Ciudad de {nome}",
 "Cidades": "Ciudades",
 "Cifrão": "Signo de dólar",
 "Cinza": "Gris",
 "Cirurgia": "Cirugía",
 "Ciências": "Ciencias",
 "Clara": "Clara",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Aclara PDFs escaneados: fondo blanco, gris o blanco y negro.",
 "Claro": "Claro",
 "Classificar categorias com IA": "Clasificar categorías con IA",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT o Gemini",
 "Cliente": "Cliente",
 "Clientes": "Clientes",
 "Clima esperado": "Clima previsto",
 "Co-anfitrião": "Coanfitrión",
 "Cobrança": "Cobro",
 "Cobranças": "Cobros",
 "Coelho": "Conejo",
 "Cofre (criptografia de ponta a ponta)": "Caja fuerte (cifrado de extremo a extremo)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Caja fuerte abierta (se cierra sola tras 5 minutos sin uso)",
 "Cofre ainda não criado": "Caja fuerte aún no creada",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Caja fuerte cifrada para DNI, carné de conducir, pasaporte, contratos y certificados, con cuenta atrás hasta el vencimiento y envío con un toque.",
 "Cofre fechado": "Caja fuerte cerrada",
 "Cofrinho": "Alcancía",
 "Cole aqui a chave ({ini}...)": "Pega aquí la clave ({ini}...)",
 "Cole o link (https://...)": "Pega el enlace (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Pega o escribe el código de barras (o el Pix copia y pega) en el campo del código: la app calcula sola el importe y el vencimiento. Con tu IA activada, lo lee todo desde la foto.",
 "Coloca arquivos dentro do PDF.": "Pone archivos dentro del PDF.",
 "Colocar na agenda": "Poner en la agenda",
 "Colocar na linha do tempo com alarme": "Poner en la línea de tiempo con alarma",
 "Colocar no My Planner": "Poner en My Planner",
 "Colocar rega e adubo na agenda": "Poner riego y abono en la agenda",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Pon el valor de la mensualidad en el grupo (Editar) o en el alumno. Los cobros de este mes que ya existen no se repiten.",
 "Coluna": "Columna",
 "Colágeno": "Colágeno",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Con la biometría activada, aparece primero. Si falla, usa el patrón o la contraseña.",
 "Com convênio": "Con seguro médico",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Con el código de país y de área. Ej.: +55 41 99999-0000",
 "Com outras pessoas": "Con otras personas",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Con plazo, la app calcula cuánto ahorrar al mes. El dinero ahorrado cuenta como \"Ahorrado\" en el mes.",
 "Com quem": "Con quién",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Quién pagó, el paciente, la fecha y el valor de cada consulta pagada. Como persona física, registra cada una en la app Receita Federal › Receita Saúde; con CNPJ, emite la factura de servicio.",
 "Com valor a receber": "Con valor por cobrar",
 "Com vencimento": "Con vencimiento",
 "Combinado": "Trato hecho",
 "Combinado 👍": "Hecho 👍",
 "Combustível": "Combustible",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Empieza registrando las cuentas fijas del mes (alquiler, luz, internet) y tu tarjeta. Te aviso antes de cada vencimiento.",
 "Comecei em": "Empecé el",
 "Comentários": "Comentarios",
 "Começa amanhã": "Empieza mañana",
 "Começa às {hora} (em {m} min)": "Empieza a las {hora} (en {m} min)",
 "Começar": "Empezar",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Empezar con el modelo: desayuno, merienda, almuerzo, merienda y cena",
 "Começar em": "Empezar en",
 "Começar o teste grátis": "Empezar la prueba gratis",
 "Comi outros alimentos ou quantidades": "Comí otros alimentos o cantidades",
 "Comida": "Comida",
 "Comidas e bebidas": "Comida y bebida",
 "Comido": "Comido",
 "Comido / alterações": "Comido / cambios",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Comido cuenta las comidas marcadas como hechas (o con cambios) hasta hoy.",
 "Comigo": "Conmigo",
 "Comissão da plataforma": "Comisión de la plataforma",
 "Como apagar a sua conta e os seus dados": "Cómo borrar tu cuenta y tus datos",
 "Como chegar": "Cómo llegar",
 "Como ela está": "Cómo está",
 "Como estou comparado ao mês passado?": "¿Cómo voy comparado con el mes pasado?",
 "Como funciona": "Cómo funciona",
 "Como planejado": "Como lo planeado",
 "Compartilhado no grupo": "Compartido en el grupo",
 "Compartilhado no grupo · só leitura": "Compartido en el grupo · solo lectura",
 "Compartilhamento indisponível neste dispositivo.": "Compartir no está disponible en este dispositivo.",
 "Compartilhar": "Compartir",
 "Compartilhar PDF": "Compartir PDF",
 "Compartilhar a limpeza": "Compartir la limpieza",
 "Compartilhar os dados": "Compartir los datos",
 "Compartilhar os dados com a equipe": "Compartir los datos con el equipo",
 "Compartilhar os dados com o grupo?": "¿Compartir los datos con el grupo?",
 "Compartilhar texto": "Compartir texto",
 "Competência (mês de referência)": "Período (mes de referencia)",
 "Competência {d}": "Período {d}",
 "Complemento": "Complemento",
 "Complete seus dados": "Completa tus datos",
 "Compra": "Compra",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Compra y venta de inmuebles, vehículos y acciones, recibos deducibles y el calendario del impuesto.",
 "Compra feita": "Compra hecha",
 "Compra no cartão": "Compra con tarjeta",
 "Compras": "Compras",
 "Compras da semana": "Compra de la semana",
 "Comprimir": "Comprimir",
 "Compromisso": "Cita",
 "Compromisso da escola": "Evento escolar",
 "Comprovante": "Comprobante",
 "Comprovante guardado": "Comprobante guardado",
 "Comprovantes": "Comprobantes",
 "Computador": "Computadora",
 "Comédia": "Comedia",
 "Concedi": "Presté",
 "Concluir": "Completar",
 "Concluir (esquerda)": "Completar (izquierda)",
 "Concluída": "Concluida",
 "Concluído": "Terminado",
 "Concluído (%)": "Terminado (%)",
 "Concluído!": "¡Completado!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Acepto que mi nombre, CPF y correo electrónico se usen solo para identificar mi cuenta, y que mis tareas y notas queden guardadas en ella. Puedo borrar la cuenta y todos los datos en cualquier momento en Ajustes › Seguridad.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Acepto que mi nombre, CPF y correo electrónico se usen solo para identificar mi cuenta, y que mis tareas y notas queden guardadas en ella. Puedo borrar la cuenta y todos los datos en cualquier momento en Ajustes.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Acepto que mi nombre, documento y correo se usen solo para identificar mi cuenta, y que mis tareas y notas se guarden en ella. Puedo borrar la cuenta y todos los datos en cualquier momento en Ajustes › Seguridad.",
 "Concursos": "Oposiciones",
 "Condicionador": "Acondicionador",
 "Condomínio": "Comunidad",
 "Condomínio e IPTU": "Comunidad e impuesto predial",
 "Conectado": "Conectado",
 "Conectando...": "Conectando...",
 "Conectar": "Conectar",
 "Conectar navegador": "Conectar navegador",
 "Conectar o {nome}": "Conectar {nome}",
 "Conectar relógio ou app de saúde": "Conectar reloj o app de salud",
 "Conectar {nome}": "Conectar {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Conecta {nome} en Ajustes › Google Drive y OneDrive.",
 "Conferindo...": "Verificando...",
 "Conferir controles, chaves e Wi-Fi": "Revisar controles, llaves y Wi-Fi",
 "Conferir o prazo no sistema oficial": "Verificar el plazo en el sistema oficial",
 "Confete": "Confeti",
 "Configuração geral": "Configuración general",
 "Confira a senha da sua conta e tente de novo.": "Revisa la contraseña de tu cuenta e inténtalo de nuevo.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Consulta las fechas oficiales en el sitio de la Receita Federal y ajusta si hace falta.",
 "Confira o código. Ele tem 6 letras e números.": "Revisa el código. Tiene 6 letras y números.",
 "Confira o e-mail ou deixe em branco.": "Revisa el correo o déjalo en blanco.",
 "Confira o e-mail.": "Revisa el correo.",
 "Confira o prazo no sistema oficial.": "Verifica el plazo en el sistema oficial.",
 "Confira os 11 números.": "Revisa los 11 números.",
 "Confira os campos antes de salvar.": "Revisa los campos antes de guardar.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Comprueba que tu cuenta de Google esté añadida en el móvil y que el calendario se esté sincronizando.",
 "Confirmada": "Confirmada",
 "Confirmado": "Confirmado",
 "Confirmar": "Confirmar",
 "Confirme a declaração sobre a empresa.": "Confirma la declaración sobre la empresa.",
 "Confirme o seu celular": "Confirma tu celular",
 "Confirme para ativar a biometria": "Confirma para activar la biometría",
 "Confirme para excluir": "Confirma para eliminar",
 "Confirme sua senha para sincronizar": "Confirma tu contraseña para sincronizar",
 "Confraternização": "Celebración",
 "Confraternização Universal": "Año Nuevo",
 "Conselho": "Colegio profesional",
 "Consignado": "Préstamo con descuento de nómina",
 "Consulta": "Consulta",
 "Consulta ou vacina": "Consulta o vacuna",
 "Consultas": "Consultas",
 "Consultório": "Consultorio",
 "Consumo médio: {v} km/L": "Consumo medio: {v} km/L",
 "Conta": "Cuenta",
 "Conta a pagar": "Cuenta por pagar",
 "Conta a receber": "Cuenta por cobrar",
 "Conta de consumo ou tributo": "Factura de servicios o impuesto",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Cuenta los días en que cada elemento estaba previsto (según sus días de la semana) y los que se marcaron como hechos.",
 "Conta paga": "Cuenta pagada",
 "Conta recebida": "Cuenta cobrada",
 "Conta vence hoje": "Cuenta vence hoy",
 "Conta vencendo": "Cuenta por vencer",
 "Contabilidade": "Contabilidad",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Contando los acompañantes. Toca el estado del invitado para cambiarlo.",
 "Contando: {cliente}": "Contando: {cliente}",
 "Contas": "Cuentas",
 "Contas a pagar": "Cuentas por pagar",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Cuentas por pagar y por cobrar, gastos del mes, aviso de vencimiento y control del MEI (Mestre Achado).",
 "Contas a receber": "Cuentas por cobrar",
 "Contas fixas": "Cuentas fijas",
 "Contato": "Contacto",
 "Contato de emergência": "Contacto de emergencia",
 "Contato do encarregado de dados:": "Contacto del encargado de datos:",
 "Conte a sua ideia para o app ficar melhor.": "Cuéntanos tu idea para mejorar la app.",
 "Conte o que está difícil ou não funciona como deveria.": "Cuéntanos qué te resulta difícil o qué no funciona como debería.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Cuéntanos qué hiciste, qué esperabas y qué apareció. Si hay un mensaje de error, cópialo aquí.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Cuéntanos problemas, errores e ideas de mejora. Tu mensaje va directo al equipo de My Planner.",
 "Conteúdo": "Contenido",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Contenido que creas: tareas, notas, finanzas, documentos, fotos, adjuntos y datos de las pestañas.",
 "Conteúdo, matéria, tarefa de casa...": "Contenido, materia, tarea...",
 "Continuar": "Continuar",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Sigue usando My Planner y Notas por {preco} al año. Tus datos siguen guardados.",
 "Contratado": "Contratado",
 "Contratado: {v}": "Contratado: {v}",
 "Contrato": "Contrato",
 "Conversa": "Chat",
 "Conversa do grupo": "Chat del grupo",
 "Conversar": "Chatear",
 "Conversar com o Mestre (precisa da sua IA)": "Hablar con el Mestre (necesita tu IA)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Chatea con amigos y grupos, y haz llamadas de audio y video.",
 "Converter de PDF": "Convertir desde PDF",
 "Converter para PDF": "Convertir a PDF",
 "Convidado": "Invitado",
 "Convidados": "Invitados",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Invitados con confirmación de asistencia, proveedores y el cronograma del gran día.",
 "Convidados e cronograma do dia, sem os valores.": "Invitados y cronograma del día, sin los importes.",
 "Convidar": "Invitar",
 "Convidar pelo WhatsApp": "Invitar por WhatsApp",
 "Convite": "Invitación",
 "Convite copiado. Cole onde quiser enviar.": "Invitación copiada. Pégala donde quieras enviarla.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Invitación no válida o cambiada por el administrador. Pide un enlace nuevo.",
 "Convite para o My Planner": "Invitación a My Planner",
 "Convênio": "Seguro médico",
 "Copiar": "Copiar",
 "Copiar a lista para uma tarefa": "Copiar la lista a una tarea",
 "Copiar o código": "Copiar código",
 "Copiar para hoje": "Copiar a hoy",
 "Copo de outro tamanho": "Vaso de otro tamaño",
 "Copo {n}": "Vaso {n}",
 "Cor": "Color",
 "Cor do fichário": "Color de la carpeta",
 "Cor do tema": "Color del tema",
 "Cor do tema de cada aba": "Color del tema de cada pestaña",
 "Coração": "Corazón",
 "Corações": "Corazones",
 "Cores das abas": "Colores de las pestañas",
 "Cores das conversas": "Colores de los chats",
 "Cores e opções desta aba": "Colores y opciones de esta pestaña",
 "Corpo": "Cuerpo",
 "Corporativo": "Corporativo",
 "Corpus Christi": "Corpus Christi",
 "Corredor": "Pasillo",
 "Correia dentada": "Correa de distribución",
 "Corrida": "Correr",
 "Corta as bordas em branco ou partes da página.": "Recorta los bordes en blanco o partes de la página.",
 "Cortesia": "Cortesía",
 "Coxa e sobrecoxa": "Muslo y contramuslo de pollo",
 "Cozinha": "Cocina",
 "Creatina": "Creatina",
 "Criada em {data}": "Creada el {data}",
 "Criado com": "Creado con",
 "Criado em": "Creado el",
 "Criança": "Niño",
 "Crianças": "Niños",
 "Criar": "Crear",
 "Criar animada": "Crear animado",
 "Criar conta": "Crear cuenta",
 "Criar do zero": "Crear desde cero",
 "Criar documento, planilha ou apresentação": "Crear documento, hoja de cálculo o presentación",
 "Criar em outro app": "Crear en otra app",
 "Criar escritório": "Crear oficina",
 "Criar fichário": "Crear carpeta",
 "Criar figurinha": "Crear sticker",
 "Criar grupo": "Crear grupo",
 "Criar grupo e convidar pessoas": "Crear grupo e invitar personas",
 "Criar minha chave de API": "Crear mi clave de API",
 "Criar o cofre": "Crear la caja fuerte",
 "Criar o grupo e convidar": "Crear el grupo e invitar",
 "Criar os prazos do IR de {ano}": "Crear los plazos del IR de {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Crear una meta (viaje, fondo, coche...)",
 "Criar uma senha nova": "Crear una contraseña nueva",
 "Criar {n} tarefa(s)": "Crear {n} tarea(s)",
 "Criação do Estado de MS": "Creación del Estado de MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Crea la mudanza y la app arma la lista de cambios (luz, agua, internet...). Luego registra las cajas por habitación, las inspecciones y el cronograma de los días.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Crea la carpeta de cada cliente, invítalo por enlace (solo ve su carpeta) e intercambien documentos en ambos sentidos: facturas, guías, nómina, extractos, contratos.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Crea el grupo (o grupo de mentoría, entrenamiento, curso) y, dentro, los alumnos, la asistencia, las notas, los planes de clase, los materiales y los cobros.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Crea el grupo y, dentro de él, los alumnos, la asistencia, las evaluaciones con notas y los planes de clase.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Crea las tareas de la casa (limpiar el baño, cambiar las sábanas...) con su frecuencia. La app avisa cuando están atrasadas, sin llenar My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Crea tarjetas con checklist, lista, texto libre o dibujo para esta materia. Desliza a la derecha para borrar y a la izquierda para archivar.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Crea la oficina, llama a tu equipo (amigos de la app o invitación por enlace) e intercambien mensajes y documentos, programen reuniones y hagan videorreuniones. Tú, como administrador, puedes grabar las reuniones.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Crea el evento y, dentro de él, la lista de invitados con confirmación de asistencia, los proveedores y el cronograma del día.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Crea el grupo y envía el enlace: quien entre recibe fecha, lugar, avisos y todo lo que envíes, y puede aceptar, editar o rechazar.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve y participa según el rol que elijas. Solo quien administra añade o quita personas.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve todo lo que hay aquí y participa (añade, edita, sube fotos). Solo quien administra añade o quita personas.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Crea tu cuenta. Tus datos se guardan en la nube y en este dispositivo.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Crea una carpeta (ej.: Doctorado, Inglés, Oposiciones) y dentro de ella las materias y páginas.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Crea un grupo (clase, pacientes, equipo, invitados, clientes), comparte el enlace de invitación y envía citas, materiales y avisos. Cada persona acepta, edita o rechaza lo que recibe.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Crea un perfil con nombre y, si eres abogado, la OAB.",
 "Criptografado no cofre, só neste dispositivo": "Cifrado en la caja fuerte, solo en este dispositivo",
 "Criptomoedas": "Criptomonedas",
 "Cronograma": "Cronograma",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Plan de comidas, cuidado personal paso a paso y agua del día.",
 "Cronograma do dia": "Cronograma del día",
 "Cronograma físico-financeiro": "Cronograma físico-financiero",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Cronograma físico-financiero por etapa, diario de obra con antes y después, profesionales y entregas.",
 "Cronômetro de horas": "Cronómetro de horas",
 "Crédito empresarial": "Crédito empresarial",
 "Créditos": "Créditos",
 "Cuida das reservas, da limpeza e das despesas.": "Se encarga de las reservas, la limpieza y los gastos.",
 "Cuidado": "Cuidado",
 "Cuidado pessoal": "Cuidado personal",
 "Cuidados": "Cuidados",
 "Cupom do mercado": "Ticket del súper",
 "Cupom do mercado (foto)": "Ticket del súper (foto)",
 "Cupom lançado": "Ticket registrado",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Curso",
 "Cursos": "Cursos",
 "Cursos livres e certificações": "Cursos libres y certificaciones",
 "Cuscuz": "Cuscús de maíz",
 "CÓDIGO PARA PAGAR": "CÓDIGO PARA PAGAR",
 "CÔMODOS": "HABITACIONES",
 "Câmera": "Cámara",
 "Câmera e galeria": "Cámara y galería",
 "Câmera não liberada": "Cámara no autorizada",
 "Código IBGE do município": "Código IBGE del municipio",
 "Código IBGE do município (7 números)": "Código IBGE del municipio (7 números)",
 "Código NBS (9 números, opcional)": "Código NBS (9 números, opcional)",
 "Código copiado": "Código copiado",
 "Código da reserva (localizador)": "Código de reserva (localizador)",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Código de barras, línea digitable o Pix copia y pega (opcional)",
 "Código de indicação": "Código de recomendación",
 "Código de indicação (opcional)": "Código de recomendación (opcional)",
 "Código de quem convidou você": "Código de quien te invitó",
 "Código de tributação nacional (6 números)": "Código de tributación nacional (6 números)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Código de tributación nacional (6 números, ej.: 171901)",
 "Código do amigo": "Código del amigo",
 "Código do convite": "Código de invitación",
 "Código do procedimento (TUSS ou do plano)": "Código del procedimiento (TUSS o del seguro)",
 "Código errado. Confira e tente de novo.": "Código incorrecto. Revísalo e inténtalo de nuevo.",
 "Código não encontrado. Confira as letras e os números.": "Código no encontrado. Revisa las letras y los números.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Código no reconocido. Revisa los números (boleto: 47 o 48 números).",
 "Código: {c}": "Código: {c}",
 "Cópia automática toda semana": "Copia automática cada semana",
 "Cópia criada.": "Copia creada.",
 "Cópia de segurança": "Copia de seguridad",
 "Cópia feita": "Copia hecha",
 "Cópia restaurada.": "Copia restaurada.",
 "Cômodo": "Habitación",
 "Cômodo ou quarto": "Habitación",
 "Cômodos da casa e as tarefas de cada um.": "Habitaciones de la casa y las tareas de cada una.",
 "DAS de {mes} pago": "DAS de {mes} pagado",
 "DAS de {mes}: vence dia {dia}": "DAS de {mes}: vence el día {dia}",
 "DAS do MEI": "DAS del MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "DECLARACIÓN DE ATENCIÓN",
 "DICA DO MESTRE ACHADO": "CONSEJO DEL MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS n.º {n}, serie {s}",
 "Da galeria ou dos arquivos": "De la galería o de archivos",
 "Da meta de passos": "De la meta de pasos",
 "Dados compartilhados": "Datos compartidos",
 "Dados compartilhados com o grupo": "Datos compartidos con el grupo",
 "Dados compartilhados · seu papel: {p}": "Datos compartidos · tu rol: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Los datos de salud que tú mismo registras se tratan solo para ti y para quien compartas, con tu consentimiento (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Datos del dispositivo: idioma, país y zona horaria (para fechas, feriados y moneda), modelo del dispositivo y el código para los avisos en el móvil.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Los datos del reloj y de salud no se usan para publicidad ni se comparten con nadie. Puedes desconectar y revocar el permiso en cualquier momento.",
 "Dança": "Baile",
 "Dar ciência": "Dar conocimiento",
 "Dar ciência da operação?": "¿Dar conocimiento de la operación?",
 "Data": "Fecha",
 "Data (embarque ou check-in)": "Fecha (embarque o check-in)",
 "Data agendada": "Fecha programada",
 "Data da aplicação": "Fecha de aplicación",
 "Data da compra": "Fecha de compra",
 "Data da entrega": "Fecha de entrega",
 "Data da venda": "Fecha de venta",
 "Data de nascimento": "Fecha de nacimiento",
 "Data do empréstimo": "Fecha del préstamo",
 "Data do pagamento": "Fecha de pago",
 "Data em que foi feita": "Fecha de realización",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Fecha sugerida con 2 días hábiles de margen. Verifícala en el sistema oficial.",
 "De": "Desde",
 "De uma foto": "De una foto",
 "De {de} para {para} ({p}% menor).": "De {de} a {para} ({p}% menos).",
 "Declaração": "Declaración",
 "Declaração de atendimento": "Declaración de atención",
 "Declaração para reembolso (PDF)": "Declaración para reembolso (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Declaro que esta empresa es mía o de un cliente que autorizó el seguimiento.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Declaro, a efectos de reembolso{conv}, que el(la) paciente {nome}{cpf}{cart} fue atendido(a) por mí el {data}{hora}, en {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Define la meta de clases por día o por semana en Editar.",
 "Defina a meta de páginas por dia em Editar.": "Define la meta de páginas por día en Editar.",
 "Defina um horário": "Define un horario",
 "Defina um horário para usar pausas.": "Define un horario para usar pausas.",
 "Demaquilante ou água micelar": "Desmaquillante o agua micelar",
 "Demolição": "Demolición",
 "Demonstração": "Demostración",
 "Dentista": "Dentista",
 "Dependentes": "Dependientes",
 "Depois": "Después",
 "Depois da aula": "Después de clase",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Una vez borradas, las tareas no se pueden recuperar. Escribe la contraseña de tu cuenta para confirmar.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Después de descargarlo, abre el archivo y toca Instalar. Si el celular lo pide, permite instalar apps de esta fuente.",
 "Depois de criar": "Después de crear",
 "Depois de {nome}. Toque para pular.": "Después de {nome}. Toca para saltar.",
 "Depois é só ajustar horários e o que comer em cada um.": "Después solo ajusta los horarios y lo que comer en cada uno.",
 "Desarquivar": "Desarchivar",
 "Desbloquear": "Desbloquear",
 "Desbloquear com": "Desbloquear con",
 "Desbloquear com biometria": "Desbloquear con biometría",
 "Desbloquear o My Planner": "Desbloquear My Planner",
 "Desbloqueio do app": "Desbloqueo de la app",
 "Descanso": "Descanso",
 "Descartadas": "Descartadas",
 "Descartar": "Descartar",
 "Descartar este tempo?": "¿Descartar este tiempo?",
 "Descobrir lugares em {d}": "Descubrir lugares en {d}",
 "Desconectar": "Desconectar",
 "Desconectar o {nome}?": "¿Desconectar {nome}?",
 "Desconto": "Descuento",
 "Desconto de {v}": "Descuento de {v}",
 "Descontos obtidos": "Descuentos obtenidos",
 "Descrição": "Descripción",
 "Descrição (cliente, nota fiscal...)": "Descripción (cliente, factura...)",
 "Descrição do serviço (sai na nota)": "Descripción del servicio (sale en la factura)",
 "Descrição que sai na nota": "Descripción que sale en la factura",
 "Desenhar a assinatura": "Dibujar la firma",
 "Desenhar com caneta ou dedo": "Dibujar con lápiz o dedo",
 "Desenhe a assinatura e escolha a página e o lugar.": "Dibuja la firma y elige la página y el lugar.",
 "Desenhe a assinatura primeiro.": "Primero dibuja la firma.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Dibuja con el dedo o con el lápiz (S Pen, Apple Pencil o lápiz de tableta).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Dibuja con el dedo o con el lápiz. Para desplazar el tablero, toca Mover.",
 "Desenhe de novo para confirmar.": "Dibuja de nuevo para confirmar.",
 "Desenhe o seu padrão": "Dibuja tu patrón",
 "Desenhe pelo menos uma tarja.": "Dibuja al menos una franja.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Dibuja un patrón uniendo al menos 4 puntos.",
 "Desenho": "Dibujo",
 "Desenho com caneta ou dedo": "Dibujo con lápiz o dedo",
 "Desenho incorreto": "Patrón incorrecto",
 "Desenho padrão": "Patrón",
 "Desenho padrão salvo.": "Patrón guardado.",
 "Desenvolvimento": "Press de hombros",
 "Desfazer": "Deshacer",
 "Desfazer amizade": "Eliminar amistad",
 "Desligar": "Desactivar",
 "Desligar a sincronização?": "¿Desactivar la sincronización?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Desliza hacia los lados para ver otros días (hasta 60 días adelante). Toca una comida para planificar el menú solo de ese día. Arrastra hacia la derecha para eliminar.",
 "Desmarcado": "Cancelado",
 "Desmarcar como recebida": "Desmarcar como cobrada",
 "Desmarcar feita hoje": "Desmarcar hecha hoy",
 "Desmarcar grupo": "Desmarcar grupo",
 "Desmarcar pagamento": "Desmarcar pago",
 "Desodorante": "Desodorante",
 "Despensa": "Despensa",
 "Despesa": "Gasto",
 "Despesas": "Gastos",
 "Destino": "Destino",
 "Detalhes": "Detalles",
 "Devolver até": "Devolver antes del",
 "Devolver: {i} ({p})": "Devolver: {i} ({p})",
 "Devolvido": "Devuelto",
 "Devolvidos": "Devueltos",
 "Dia": "Día",
 "Dia a dia": "Día a día",
 "Dia da mudança": "Día de la mudanza",
 "Dia de vencimento do DAS": "Día de vencimiento del DAS",
 "Dia do Trabalho": "Día del Trabajo",
 "Dia do vencimento": "Día de vencimiento",
 "Dia em que a fatura fecha": "Día de cierre del estado de cuenta",
 "Dia planejado": "Día planeado",
 "Dia {d} de {total}": "Día {d} de {total}",
 "Diagnóstico": "Diagnóstico",
 "Dias e horários": "Días y horarios",
 "Dias específicos": "Días específicos",
 "Dias úteis": "Días hábiles",
 "Dias: {dias}": "Días: {dias}",
 "Dicas e observações": "Consejos y notas",
 "Diesel": "Diésel",
 "Diferença": "Diferencia",
 "Digitado": "Manual",
 "Digitar": "Escribir",
 "Digitar à mão": "Introducir a mano",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Escribe la contraseña de la caja fuerte. Se cierra sola tras 5 minutos sin uso.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Escribe en minutos (90) o en horas y minutos (1:30 o 01:30) y toca OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Escribe en formato HH:MM, por ejemplo 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Escribe el código y obtén 10 días con todas las pestañas desbloqueadas. Si no tienes, déjalo en blanco.",
 "Digite o nome da tarefa.": "Escribe el nombre de la tarea.",
 "Dinheiro": "Dinero",
 "Dinheiro e documentos": "Dinero y documentos",
 "Direita": "Derecha",
 "Direito": "Derecho",
 "Direito Administrativo": "Derecho Administrativo",
 "Direito Civil": "Derecho Civil",
 "Direito Constitucional": "Derecho Constitucional",
 "Direito Empresarial": "Derecho Mercantil",
 "Direito Penal": "Derecho Penal",
 "Direito Tributário": "Derecho Tributario",
 "Direito do Trabalho": "Derecho Laboral",
 "Direto": "Directo",
 "Disciplina": "Asignatura",
 "Dispensar": "Ignorar",
 "Dispensar o aviso": "Descartar aviso",
 "Dispensar todas": "Descartar todas",
 "Disponibilizada em": "Puesta a disposición el",
 "Disponível no app novo": "Disponible en la app nueva",
 "Distância": "Distancia",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Divide el curso en materias o módulos. En cada una, marca en qué clase te quedaste y crea tarjetas de notas.",
 "Dividir": "Dividir",
 "Dividir entre (nenhum marcado = todos)": "Dividir entre (ninguno marcado = todos)",
 "Divisão das despesas": "División de gastos",
 "Diária": "Tarifa por noche",
 "Diária padrão": "Tarifa por noche estándar",
 "Diário": "Diario",
 "Diários municipais": "Diarios municipales",
 "Do celular, do Google Drive ou do OneDrive": "Del celular, de Google Drive o de OneDrive",
 "Do cliente": "Del cliente",
 "Do escritório": "De la oficina",
 "Doações": "Donaciones",
 "Docs": "Docs",
 "Documento": "Documento",
 "Documento (fundo branco)": "Documento (fondo blanco)",
 "Documento do veículo (CRLV)": "Documento del vehículo (CRLV)",
 "Documento pessoal": "Documento personal",
 "Documento vence hoje": "El documento vence hoy",
 "Documento vencendo": "Documento por vencer",
 "Documento: {o}": "Documento: {o}",
 "Documentos": "Documentos",
 "Documentos (contrato, nota, recibo...)": "Documentos (contrato, factura, recibo...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Documentos (pasaporte, DNI, carné de conducir)",
 "Documentos e autorização das crianças": "Documentos y autorización de los niños",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Los documentos protegidos, pruebas, historial de salud y otros campos con 🔒 se cifran aquí en el dispositivo (AES-256) con la contraseña de la caja fuerte. Ni el soporte puede leerlos. Sin la contraseña, estos datos no se pueden recuperar.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Documentos, recibos, cuadernos y pizarras, con varias páginas",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Los documentos, reuniones y grabaciones se eliminan para todos. La conversación sigue en Mensajes.",
 "Documentário": "Documental",
 "Doenças, cirurgias e observações": "Enfermedades, cirugías y observaciones",
 "Dois dedos ou toque duplo para ampliar": "Pellizca o toca dos veces para ampliar",
 "Domingo": "Domingo",
 "Dono da obra": "Dueño de la obra",
 "Dose": "Dosis",
 "Dose (ex.: 1 cápsula, 5 g)": "Dosis (ej.: 1 cápsula, 5 g)",
 "Dose única": "Dosis única",
 "Drama": "Drama",
 "Duplicar": "Duplicar",
 "Duplicar tarefa": "Duplicar tarea",
 "Duração": "Duración",
 "Duração de cada sessão": "Duración de cada sesión",
 "Duração {dur}": "Duración {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "¿Puedo comprar algo de 3 mil en 10 cuotas?",
 "Débito automático": "Débito automático",
 "Débito, Pix ou dinheiro": "Débito, Pix o efectivo",
 "Dê um nome ao cartão.": "Ponle un nombre a la tarjeta.",
 "Dê um nome ao cuidado.": "Ponle un nombre al cuidado.",
 "Dê um nome ao cômodo.": "Ponle un nombre a la habitación.",
 "Dê um nome ao fichário.": "Ponle un nombre a la carpeta.",
 "Dê um nome ao grupo.": "Ponle un nombre al grupo.",
 "Dê um nome ao suplemento.": "Ponle un nombre al suplemento.",
 "Dê um nome ao treino.": "Ponle un nombre al entrenamiento.",
 "Dê um nome à conta.": "Ponle un nombre a la cuenta.",
 "Dê um nome à matéria.": "Ponle un nombre a la materia.",
 "Dê um nome à meta.": "Ponle un nombre a la meta.",
 "Dê um nome à refeição.": "Ponle un nombre a la comida.",
 "Dê um nome à tarefa.": "Ponle un nombre a la tarea.",
 "E-MAIL (OPCIONAL)": "CORREO (OPCIONAL)",
 "E-mail": "Correo",
 "E-mail (recebe a nota)": "Correo (recibe la factura)",
 "E-mail de contato": "Correo de contacto",
 "E-mail do responsável": "Correo del responsable",
 "E-mail inválido": "Correo electrónico inválido",
 "E-mail inválido.": "Correo electrónico inválido.",
 "E-mail ou WhatsApp para resposta (opcional)": "Correo o WhatsApp para responderte (opcional)",
 "E-mail para contato (opcional)": "Correo de contacto (opcional)",
 "E-mail salvo.": "Correo guardado.",
 "EM ATRASO": "ATRASADO",
 "ENTRAR COM UM CÓDIGO": "UNIRSE CON UN CÓDIGO",
 "ENVIADOS": "ENVIADOS",
 "ESCOLHA AS ATIVIDADES": "ELIGE LAS ACTIVIDADES",
 "ESTA SEMANA": "ESTA SEMANA",
 "EXERCÍCIO FÍSICO": "EJERCICIO FÍSICO",
 "Economia": "Economía",
 "Edita tudo": "Edita todo",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Edita todo: etapas, presupuesto, diario y entregas.",
 "Editar": "Editar",
 "Editar cartão": "Editar tarjeta",
 "Editar compra": "Editar compra",
 "Editar cômodo": "Editar habitación",
 "Editar desenho": "Editar dibujo",
 "Editar documento": "Editar documento",
 "Editar fichário": "Editar carpeta",
 "Editar garantia": "Editar garantía",
 "Editar matéria": "Editar materia",
 "Editar meta": "Editar meta",
 "Editar perfil": "Editar perfil",
 "Editar tarefa": "Editar tarea",
 "Editar {nome}": "Editar {nome}",
 "Educação": "Educación",
 "Educação Física": "Educación Física",
 "Efeito de scanner": "Efecto escáner",
 "Ela sai da lista e dos Recebidos da equipe.": "Se quita de la lista y de los Recibidos del equipo.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "También queda guardado en \"Mis stickers\" para enviarlo de nuevo.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Viene de la pestaña Préstamos y Financiamientos. Márcala como pagada aquí o abre la pestaña para ver el contrato.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Viene de la pestaña Facturas. Márcala como cobrada cuando entre el dinero.",
 "Eleitorais": "Electorales",
 "Eletrodoméstico": "Electrodoméstico",
 "Eletrodomésticos": "Electrodomésticos",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Electrodomésticos, electrónica y muebles: factura, servicio técnico y aviso 15 días antes de que termine la garantía.",
 "Eletrônico": "Electrónico",
 "Elétrica": "Electricidad",
 "Elétrico": "Eléctrico",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "En Editar, pega el enlace del calendario (iCal) del anuncio. En Airbnb: Calendario › Disponibilidad › Conectar calendarios › Exportar calendario. En Booking: Tarifas y disponibilidad › Sincronizar calendarios.",
 "Em aberto": "Pendientes",
 "Em alta": "Tendencias",
 "Em andamento": "En curso",
 "Em atraso": "En mora",
 "Em branco": "En blanco",
 "Em casa": "En casa",
 "Em cima": "Arriba",
 "Em construção": "En construcción",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Al día. Las mejoras llegan solas cuando se abre la app.",
 "Em limpeza": "En limpieza",
 "Em quais páginas": "En qué páginas",
 "Em qual agenda criar os eventos:": "En qué calendario crear los eventos:",
 "Em qual página e onde": "En qué página y dónde",
 "Em tratamento": "En tratamiento",
 "Em um horário específico": "A una hora específica",
 "Em uso: {ia}": "En uso: {ia}",
 "Em {n} dia(s)": "En {n} día(s)",
 "Embaixo": "Abajo",
 "Embaixo à esquerda": "Abajo a la izquierda",
 "Emissão": "Emisión",
 "Emissão +": "Emisión +",
 "Emissão: {data}": "Emisión: {data}",
 "Emitida": "Emitida",
 "Emitida em {data}": "Emitida el {data}",
 "Emitida ou recebida": "Emitida o recibida",
 "Emitidas": "Emitidas",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Emitidas: {v} · Recibidas: {r} · {n} factura(s)",
 "Emitir": "Emitir",
 "Emitir NFS-e": "Emitir NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Emite NFS-e por el Padrão Nacional con el certificado A1, busca las facturas emitidas y recibidas y exporta XML, hoja de cálculo y PDF.",
 "Emitir a nota de verdade?": "¿Emitir la factura de verdad?",
 "Emitir no ambiente de teste?": "¿Emitir en el entorno de prueba?",
 "Emojis": "Emojis",
 "Emojis animados": "Emojis animados",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Emojis animados: Noto, de Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emojis, GIFs y stickers",
 "Empresa": "Empresa",
 "Empresa de mudança": "Empresa de mudanzas",
 "Empresa ou pessoa": "Empresa o persona",
 "Empresa, hotel ou voo": "Empresa, hotel o vuelo",
 "Empresas": "Empresas",
 "Emprestei": "Presté",
 "Empréstimo": "Préstamo",
 "Empréstimo entre pessoas": "Préstamo entre personas",
 "Empréstimo pessoal": "Préstamo personal",
 "Empréstimos": "Préstamos",
 "Empréstimos & Financiamentos": "Préstamos y Financiamientos",
 "Encaminhada para {nome}.": "Reenviado a {nome}.",
 "Encaminhar": "Reenviar",
 "Encaminhar para": "Reenviar a",
 "Encerrar e salvar": "Terminar y guardar",
 "Encontrada para {perfil}": "Encontrada para {perfil}",
 "Endereço": "Dirección",
 "Endereço (opcional)": "Dirección (opcional)",
 "Endereço (se for presencial)": "Dirección (si es presencial)",
 "Endereço atual": "Dirección actual",
 "Endereço da escola": "Dirección de la escuela",
 "Endereço da oficina": "Dirección del taller",
 "Endereço de quem está com o item": "Dirección de quien tiene el objeto",
 "Endereço do consultório": "Dirección del consultorio",
 "Endereço do imóvel": "Dirección del inmueble",
 "Endereço do laboratório": "Dirección del laboratorio",
 "Endereço do veterinário": "Dirección del veterinario",
 "Endereço no trabalho e na escola": "Dirección en el trabajo y la escuela",
 "Endereço nos Correios e entregas": "Dirección en Correos y entregas",
 "Endereço nos bancos e cartões": "Dirección en bancos y tarjetas",
 "Endereço novo": "Dirección nueva",
 "Endereço ou nome do lugar": "Dirección o nombre del lugar",
 "Endereço ou terminal": "Dirección o terminal",
 "Energia": "Energía",
 "Enfermeiro": "Enfermero",
 "Engenharia": "Ingeniería",
 "Engenheiro ou arquiteto": "Ingeniero o arquitecto",
 "Enquadre o documento e toque no botão": "Encuadra el documento y toca el botón",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Encuadra tu cara y toca el botón. 🔄 gira la cámara.",
 "Ensino Fundamental": "Educación Primaria y Secundaria",
 "Ensino Médio e ENEM": "Bachillerato y ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Entendí y acepto usar el monitor en estas condiciones.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Entra directo en el Planner, con horario, días y la lista de elementos. Si el horario ya está ocupado, tú eliges: reemplazar, mantener ambas o cancelar.",
 "Entrada": "Ingreso",
 "Entrada (imóvel novo)": "Entrada (vivienda nueva)",
 "Entrada de dinheiro": "Ingreso de dinero",
 "Entrando...": "Entrando...",
 "Entrar": "Entrar",
 "Entrar com CPF e senha": "Entrar con CPF y contraseña",
 "Entrar com outra conta": "Entrar con otra cuenta",
 "Entrar de novo": "Volver a entrar",
 "Entrar na chamada": "Unirse a la llamada",
 "Entrar na reunião": "Unirse a la reunión",
 "Entrar na sala online": "Entrar a la sala en línea",
 "Entrar no grupo": "Unirse al grupo",
 "Entrar no navegador?": "¿Entrar en el navegador?",
 "Entre com seu CPF e sua senha.": "Entra con tu CPF y tu contraseña.",
 "Entre com seu e-mail e sua senha.": "Inicia sesión con tu correo y tu contraseña.",
 "Entre na sua conta de novo.": "Vuelve a iniciar sesión.",
 "Entre na sua conta para usar as notas fiscais.": "Inicia sesión en tu cuenta para usar las facturas.",
 "Entre no app com o seu e-mail e a senha nova.": "Entra en la app con tu correo y la contraseña nueva.",
 "Entrega de material": "Entrega de material",
 "Entrega prevista": "Entrega prevista",
 "Entregas": "Entregas",
 "Entregue": "Entregado",
 "Entrou": "Entró",
 "Entrou no total da semana.": "Se sumó al total de la semana.",
 "Enviada": "Enviada",
 "Enviado": "Enviado",
 "Enviado para o Planner": "Enviado al Planner",
 "Enviado pelo cliente": "Enviado por el cliente",
 "Enviado pelo escritório": "Enviado por la oficina",
 "Enviado por {quem} no grupo {g}": "Enviado por {quem} en el grupo {g}",
 "Enviando {f} de {n}...": "Subiendo {f} de {n}...",
 "Enviando...": "Enviando...",
 "Enviar": "Enviar",
 "Enviar \"{nome}\"": "Enviar \"{nome}\"",
 "Enviar \"{nome}\" para…": "Enviar \"{nome}\" a…",
 "Enviar \"{titulo}\" para": "Enviar \"{titulo}\" a",
 "Enviar ao grupo": "Enviar al grupo",
 "Enviar convite": "Enviar invitación",
 "Enviar convite para {nome}": "Enviar invitación a {nome}",
 "Enviar convite pelo WhatsApp": "Enviar invitación por WhatsApp",
 "Enviar documento": "Subir documento",
 "Enviar instruções ao hóspede": "Enviar instrucciones al huésped",
 "Enviar o convite": "Enviar la invitación",
 "Enviar ou copiar o código": "Enviar o copiar el código",
 "Enviar ou imprimir a etiqueta": "Enviar o imprimir la etiqueta",
 "Enviar para Estudos": "Enviar a Estudios",
 "Enviar para My Planner": "Enviar a My Planner",
 "Enviar para a equipe": "Enviar al equipo",
 "Enviar para o My Planner": "Enviar a My Planner",
 "Enviar para o Planner": "Enviar al Planner",
 "Enviar para o grupo": "Enviar al grupo",
 "Enviar para o grupo de estudos": "Enviar al grupo de estudio",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Subir a {nome} los {n} archivo(s) de este dispositivo",
 "Enviar para um grupo": "Enviar a un grupo",
 "Enviar para {g}": "Enviar a {g}",
 "Enviar para…": "Enviar a…",
 "Enviar por e-mail": "Enviar por correo",
 "Enviar relatório": "Enviar informe",
 "Enviar relatório para a equipe": "Enviar informe al equipo",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Enviar también las tareas que ya existen (de hoy en adelante)",
 "Enviar tarefas do My Planner para a agenda": "Enviar tareas de My Planner al calendario",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Envía guías, facturas e informes al cliente, o mira lo que te mandó. Cada documento acepta fotos, PDF y enlaces.",
 "Enxaguante": "Enjuague bucal",
 "Episódio": "Episodio",
 "Equipe": "Equipo",
 "Equipe ({n})": "Equipo ({n})",
 "Equipe de limpeza": "Equipo de limpieza",
 "Equipe do consultório": "Equipo del consultorio",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Equipo del inmueble (limpieza y coanfitrión)",
 "Erro": "Error",
 "Erro na emissão": "Error en la emisión",
 "Erro: {erro}": "Error: {erro}",
 "Erros registrados neste dispositivo ({n})": "Errores registrados en este dispositivo ({n})",
 "Escanear documento": "Escanear documento",
 "Escanear o verso": "Escanear el reverso",
 "Escanear para PDF": "Escanear a PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Escanea documentos, recibos, cuadernos y pizarras: bordes y sombras corregidos, varias páginas, identificación por ambos lados, firma y PDF guardado en el celular, en Google Drive o en OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Escanea, aclara la imagen, organiza en carpetas y envía el PDF por WhatsApp, correo o Drive. Con tu IA activada, la app lee el texto, lo resume y responde preguntas sobre el documento.",
 "Escola": "Escuela",
 "Escolha a aba:": "Elige la pestaña:",
 "Escolha a data do compromisso.": "Elige la fecha de la cita.",
 "Escolha a imagem.": "Elige la imagen.",
 "Escolha a matéria": "Elige la materia",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Elige la carpeta del celular (ej.: Documentos). La app guarda ahí automáticamente.",
 "Escolha a página": "Elige la página",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Elige al menos un tribunal o marca \"Todos los tribunales\".",
 "Escolha ao menos uma agenda.": "Elige al menos un calendario.",
 "Escolha o PDF": "Elige el PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Elige el archivo .pfx (o .p12) del certificado A1 de la empresa y escribe su contraseña. Queda cifrado en tu caja fuerte.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Elige el archivo .xml de la NFS-e, NF-e o CT-e.",
 "Escolha o fichário": "Elige la carpeta",
 "Escolha o grupo para enviar: {t}": "Elige el grupo al que enviar: {t}",
 "Escolha os PDFs": "Elige los PDFs",
 "Escolha os arquivos.": "Elige los archivos.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Elige los feriados que aparecen en el Planner y en el botón 🎉 Feriados.",
 "Escolha para quem enviar.": "Elige a quién enviarlo.",
 "Escolha pelo menos um dia.": "Elige al menos un día.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Elige al menos una página que exista en el PDF (ej.: 1-3, 5).",
 "Escolha quem participa:": "Elige quién participa:",
 "Escolher": "Elegir",
 "Escolher a imagem": "Elegir la imagen",
 "Escolher a pasta": "Elegir la carpeta",
 "Escolher agendas": "Elegir calendarios",
 "Escolher alimento": "Elegir alimento",
 "Escolher arquivo": "Elegir archivo",
 "Escolher arquivos": "Elegir archivos",
 "Escolher arquivos do Drive ou do OneDrive": "Elegir archivos de Drive o de OneDrive",
 "Escolher as imagens e criar o PDF": "Elegir las imágenes y crear el PDF",
 "Escolher da galeria": "Elegir de la galería",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Elegir de la galería o archivo (foto o PDF)",
 "Escolher data": "Elegir fecha",
 "Escolher fuso": "Elegir zona horaria",
 "Escolher hora": "Elegir hora",
 "Escolher horário": "Elegir horario",
 "Escolher o certificado": "Elegir el certificado",
 "Escolher outro": "Elegir otro",
 "Escolher pessoas": "Elegir personas",
 "Escolher tribunais": "Elegir tribunales",
 "Escolher ícone": "Elegir ícono",
 "Esconder da equipe (só administradores)": "Ocultar al equipo (solo administradores)",
 "Esconder detalhes": "Ocultar detalles",
 "Esconder o texto completo": "Ocultar el texto completo",
 "Escondido de {n} pessoa(s)": "Oculto para {n} persona(s)",
 "Escondido de: {n}": "Oculto para: {n}",
 "Escondidos no Planner.": "Ocultos en el Planner.",
 "Escova e pasta de dente": "Cepillo y pasta de dientes",
 "Escovar os dentes": "Cepillarse los dientes",
 "Escreva aqui": "Escribe aquí",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Escribe y pulsa Enter (ej.: lavar la lavadora)",
 "Escreva em uma ou em todas as páginas.": "Escribe en una o en todas las páginas.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Escribe el motivo en \"Motivo de la cancelación\" en la ficha de la factura (al menos 15 letras) y vuelve a tocar aquí.",
 "Escreva o resumo, tópicos, dúvidas...": "Escribe el resumen, temas, dudas...",
 "Escreva o texto da marca d'água.": "Escribe el texto de la marca de agua.",
 "Escreva o texto.": "Escribe el texto.",
 "Escreva o título.": "Escribe el título.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Escribe o pega el texto. Una línea que empieza con \"# \" se vuelve título.",
 "Escreva ou cole um texto e gere o PDF.": "Escribe o pega un texto y genera el PDF.",
 "Escritório": "Oficina",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Oficina: documentos y reuniones del equipo. Solo el administrador de la oficina puede grabar una reunión, y todos los participantes ven el aviso \"Grabando\" mientras se graba. La grabación queda en los documentos de la oficina, visible solo para el administrador hasta que la comparta con el equipo.",
 "Escuro": "Oscuro",
 "Espanhol": "Español",
 "Espaço": "Espacio",
 "Espaço livre, dados de cada aba e anexos": "Espacio libre, datos de cada pestaña y adjuntos",
 "Especialidade": "Especialidad",
 "Espécie": "Especie",
 "Esquadro": "Escuadra",
 "Esqueci a senha": "Olvidé la contraseña",
 "Esquerda": "Izquierda",
 "Esse código é o seu.": "Ese código es el tuyo.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Ese código es el tuyo. Usa el código de quien te recomendó la app.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Esa dirección no respondió como servidor de facturas. Revísala e inténtalo de nuevo.",
 "Esta aba ainda não está no seu plano.": "Esta pestaña todavía no está en tu plan.",
 "Esta e todas as futuras": "Esta y todas las futuras",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Esta herramienta necesita ver las páginas del PDF, algo que llega con la app nueva (versión 0.50). Usa el navegador o instala el APK nuevo.",
 "Esta imagem foi guardada em outro dispositivo.": "Esta imagen se guardó en otro dispositivo.",
 "Esta janela pode ser fechada.": "Puedes cerrar esta ventana.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Esta persona aún no ha completado su tarjeta de contacto.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Esta semana: {a} de {m} clases ({p}%)",
 "Esta senha é de outra conta.": "Esta contraseña es de otra cuenta.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Esta tarea no tiene hora: \"Al inicio\" y \"Antes del inicio\" no se aplican. Usa \"A una hora específica\".",
 "Esta tarefa se repete. O que excluir?": "Esta tarea se repite. ¿Qué quieres eliminar?",
 "Esta tela teve um problema": "Esta pantalla tuvo un problema",
 "Estado (UF) do registro": "Estado (UF) del registro",
 "Estado de Mato Grosso do Sul": "Estado de Mato Grosso do Sul",
 "Estado de São Paulo": "Estado de São Paulo",
 "Estado do Paraná": "Estado de Paraná",
 "Estados": "Estados",
 "Estaduais": "Estatales",
 "Estadual": "Estatal",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Estas pestañas aparecen en la barra inferior, en este orden. My Planner, Pestañas y Ajustes están siempre. Las demás siguen aquí en la pantalla Pestañas.",
 "Estatística": "Estadística",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Este CPF ya está registrado. Usa \"Entrar\".",
 "Este PDF está no dispositivo onde foi aberto.": "Este PDF está en el dispositivo donde se abrió.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Este PDF está en el dispositivo donde se abrió. Ábrelo allí, o vuelve a abrir la copia guardada en Drive o en OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Este PDF está protegido con contraseña. Quita la contraseña en el programa donde se creó e inténtalo de nuevo.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "Este PDF no tiene campos de formulario. Usa \"Añadir texto\" para escribir en él.",
 "Este ano": "Este año",
 "Este dispositivo": "Este dispositivo",
 "Este dispositivo não consegue abrir o arquivo.": "Este dispositivo no puede abrir el archivo.",
 "Este dispositivo não consegue compartilhar arquivos.": "Este dispositivo no puede compartir archivos.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Este dispositivo no tiene datos de salud. Puedes introducirlos a mano.",
 "Este arquivo foi guardado em outro dispositivo.": "Este archivo se guardó en otro dispositivo.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Este archivo se guardó en el móvil. Ábrelo desde la app en el móvil.",
 "Este arquivo não é um backup do My Planner.": "Este archivo no es una copia de seguridad de My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Este móvil todavía no recibe avisos con la app cerrada. Instala la app {v} o más reciente (APK con los avisos del servidor). Con la app abierta, los avisos ya funcionan.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Este certificado es de {doc}, distinto del CNPJ/CPF de la empresa ({emp}).",
 "Este fichário ainda não tem matérias.": "Esta carpeta aún no tiene materias.",
 "Este grupo já está cheio.": "Este grupo ya está lleno.",
 "Este mês": "Este mes",
 "Este mês: emitidas {e} · recebidas {r}": "Este mes: emitidas {e} · recibidas {r}",
 "Este mês: {h}": "Este mes: {h}",
 "Este navegador": "Este navegador",
 "Este país só tem feriados nacionais.": "Este país solo tiene feriados nacionales.",
 "Esteira": "Cinta de correr",
 "Esteticista": "Esteticista",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Estoy usando My Planner para organizar mi agenda, mis finanzas y mucho más. Descarga la app y, al crear tu cuenta, usa mi código {codigo} para obtener 10 días con todas las pestañas desbloqueadas.",
 "Estratégia": "Estrategia",
 "Estrela": "Estrella",
 "Estudando": "Estudiando",
 "Estudar agora": "Estudiar ahora",
 "Estudar {nome}": "Estudiar {nome}",
 "Estudar: {c}": "Estudiar: {c}",
 "Estudo": "Estudio",
 "Estudos": "Estudios",
 "Estudos e exatas": "Estudios y ciencias",
 "Estudos, lazer e viagens": "Estudios, ocio y viajes",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Está en Patrimonio & Impuesto sobre la Renta › Recibos deducibles. Ábrelo ahí para adjuntar la foto del recibo y el CPF o CNPJ de quien lo recibió.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Está en la página \"{titulo}\" y en \"Ver archivos\".",
 "Etanol": "Etanol",
 "Etapa": "Etapa",
 "Etapa do cronograma": "Etapa del cronograma",
 "Etapas": "Etapas",
 "Evento": "Evento",
 "Eventos": "Eventos",
 "Eventos & Celebrações": "Eventos & Celebraciones",
 "Evolução (no cofre)": "Evolución (en la caja fuerte)",
 "Ex.: 08:00 e 20:00": "Ej.: 08:00 y 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Ej.: 08:00, 14:00 y 20:00",
 "Ex.: 09/2026": "Ej.: 09/2026",
 "Ex.: 1 comprimido": "Ej.: 1 comprimido",
 "Ex.: 1-3, 4-10, 11-": "Ej.: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Ej.: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Ej.: 171901 (consultoría), 010101 (programación)",
 "Ex.: 40 sacos de cimento": "Ej.: 40 sacos de cemento",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Ej.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Ej.: 8.º B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Ej.: Estiramiento lumbar, Dieta de 1.800 kcal",
 "Ex.: Aniversário de 30 anos da Ana": "Ej.: Cumpleaños 30 de Ana",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Ej.: Departamento de playa, Suite 1, Anexo",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Ej.: Piso en la calle X, 100 acciones PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Ej.: Clase de repaso, Consulta de control",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Ej.: Catering, DJ, decoración, fotógrafo",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Ej.: CONFIDENCIAL, COPIA, BORRADOR",
 "Ex.: Cardiologista": "Ej.: Cardiólogo",
 "Ex.: Consultoria mensal": "Ej.: Consultoría mensual",
 "Ex.: Costela-de-adão da sala": "Ej.: Costilla de Adán del salón",
 "Ex.: DAS de setembro, Extrato do Itaú": "Ej.: DAS de septiembre, Extracto de Itaú",
 "Ex.: Desmontar os móveis do quarto": "Ej.: Desmontar los muebles del dormitorio",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Ej.: Disponible · En clase hasta las 18 h · ¡A viajar!",
 "Ex.: Eletricista, loja de material": "Ej.: Electricista, tienda de materiales",
 "Ex.: Entrada dos noivos": "Ej.: Entrada de los novios",
 "Ex.: Financiamento do carro": "Ej.: Financiamiento del auto",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Ej.: Fisioterapeuta, Nutricionista, Cardiólogo",
 "Ex.: Furadeira, livro, R$ 200": "Ej.: Taladro, libro, 200 €",
 "Ex.: Hemograma": "Ej.: Hemograma",
 "Ex.: IPVA 2027, parcela 1": "Ej.: IPVA 2027, cuota 1",
 "Ex.: Lisboa, Portugal": "Ej.: Lisboa, Portugal",
 "Ex.: Mala da Ana": "Ej.: Maleta de Ana",
 "Ex.: Mensalidade de outubro, material": "Ej.: Mensualidad de octubre, material",
 "Ex.: Netflix, cinema": "Ej.: Netflix, cine",
 "Ex.: Notas de compra de setembro": "Ej.: Facturas de compra de septiembre",
 "Ex.: Onix 2022": "Ej.: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Ej.: Examen 1, Trabajo en grupo",
 "Ex.: Prova de matemática": "Ej.: Examen de matemáticas",
 "Ex.: Pôr do sol no Tejo": "Ej.: Atardecer en el Tajo",
 "Ex.: Reforma da cozinha": "Ej.: Reforma de la cocina",
 "Ex.: TAP TP 108": "Ej.: TAP TP 108",
 "Ex.: Torre de Belém": "Ej.: Torre de Belém",
 "Ex.: Troca da fiação da sala": "Ej.: Cambio del cableado del salón",
 "Ex.: V10, antirrábica": "Ej.: Polivalente, antirrábica",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Ej.: Visita al Monasterio de los Jerónimos",
 "Ex.: cerâmica 30 cm": "Ej.: cerámica 30 cm",
 "Ex.: kg, pacotes, latas": "Ej.: kg, paquetes, latas",
 "Ex.: seg e qua, 07:30": "Ej.: lun y mié, 07:30",
 "Ex.: troquei o arroz por batata doce": "Ej.: cambié el arroz por boniato",
 "Ex.: varanda, sala": "Ej.: balcón, sala",
 "Exame": "Prueba",
 "Exame da OAB": "Examen de la OAB",
 "Exames": "Pruebas",
 "Excel": "Excel",
 "Excluir": "Eliminar",
 "Excluir \"{nome}\"?": "¿Eliminar \"{nome}\"?",
 "Excluir \"{titulo}\"?": "¿Eliminar \"{titulo}\"?",
 "Excluir a caixa?": "¿Eliminar la tarjeta?",
 "Excluir a compra": "Eliminar la compra",
 "Excluir a compra?": "¿Eliminar la compra?",
 "Excluir a meta \"{m}\"?": "¿Eliminar la meta \"{m}\"?",
 "Excluir cartão": "Eliminar tarjeta",
 "Excluir conta": "Eliminar cuenta",
 "Excluir cuidado": "Eliminar cuidado",
 "Excluir cômodo": "Eliminar habitación",
 "Excluir esta página?": "¿Eliminar esta página?",
 "Excluir fichário": "Eliminar carpeta",
 "Excluir matéria": "Eliminar materia",
 "Excluir o cartão \"{c}\"?": "¿Eliminar la tarjeta \"{c}\"?",
 "Excluir o documento": "Eliminar el documento",
 "Excluir o fichário {nome}": "Eliminar la carpeta {nome}",
 "Excluir página": "Eliminar página",
 "Excluir refeição": "Eliminar comida",
 "Excluir suplemento": "Eliminar suplemento",
 "Excluir tarefa": "Eliminar tarea",
 "Excluir tarefa repetida": "Eliminar tarea repetida",
 "Excluir tarefa?": "¿Eliminar tarea?",
 "Excluir treino": "Eliminar entrenamiento",
 "Excluir {nome}?": "¿Eliminar {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Se eliminan definitivamente 30 días después de descartarse.",
 "Executivo e profissional": "Ejecutivo y profesional",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Ejecución del contrato (art. 7, V), para prestar el servicio; consentimiento (art. 7, I), para cámara, galería, micrófono y ubicación; cumplimiento de una obligación legal (art. 7, II); e interés legítimo (art. 7, IX), para seguridad y prevención de fraudes.",
 "Exemplos: 13:30, 1330, 9:05": "Ejemplos: 13:30, 1330, 9:05",
 "Exercício": "Ejercicio",
 "Exercício físico": "Ejercicio físico",
 "Experimente grátis por {n} dias": "Pruébalo gratis por {n} días",
 "Explique o motivo (para cancelar)": "Explica el motivo (para cancelar)",
 "Exportar arquivo": "Exportar archivo",
 "Exportar para o contador": "Exportar para el contador",
 "Extrair páginas": "Extraer páginas",
 "Extras (pet, check-in tardio...)": "Extras (mascota, check-in tardío...)",
 "Extrato": "Extracto",
 "Extrato bancário": "Extracto bancario",
 "Extrato do banco (foto ou PDF)": "Extracto del banco (foto o PDF)",
 "Extrato importado": "Extracto importado",
 "Extrato por foto": "Extracto por foto",
 "FRASE": "FRASE",
 "FRÁGIL": "FRÁGIL",
 "Fabricante ou estendida: {n} meses": "Del fabricante o extendida: {n} meses",
 "Facultativo": "Opcional",
 "Falar com a limpeza": "Hablar con la limpieza",
 "Fale conosco": "Contáctanos",
 "Falta": "Falta",
 "Falta XML": "Falta el XML",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Falta encender el servidor de facturas: en el ordenador, haz doble clic en 13-LIGAR-NOTAS.bat y pega aquí la dirección que muestre.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Falta Health Connect, la app de Google que reúne los datos de los relojes y apps de salud.",
 "Faltam": "Pendientes",
 "Faltam {ml} ({n} copo(s))": "Faltan {ml} ({n} vaso(s))",
 "Faltam {n} dia(s) do seu período grátis": "Te quedan {n} día(s) del período gratis",
 "Faltam {n} dias": "Faltan {n} días",
 "Faltou": "Faltó",
 "Família": "Familia",
 "Fantasia": "Fantasía",
 "Fatura": "Estado de cuenta",
 "Fatura com vencimento em {d}.": "Estado de cuenta con vencimiento el {d}.",
 "Fatura de {mes}": "Estado de cuenta de {mes}",
 "Fatura de {mes}: vence {data}": "Estado de cuenta de {mes}: vence el {data}",
 "Fatura do cartão (foto ou PDF)": "Estado de cuenta de la tarjeta (foto o PDF)",
 "Fatura importada": "Estado de cuenta importado",
 "Fatura paga (toque para desfazer)": "Estado de cuenta pagado (toca para deshacer)",
 "Fatura {c}": "Estado de cuenta {c}",
 "Faturamento em {ano}: {v} de {lim}": "Facturación en {ano}: {v} de {lim}",
 "Faturas dos cartões": "Estados de cuenta de las tarjetas",
 "Fazer agora, passo a passo": "Hacer ahora, paso a paso",
 "Fazer com este PDF": "Hacer con este PDF",
 "Fazer cópia agora": "Hacer copia ahora",
 "Fecha dia {f} · vence dia {v}": "Cierra el día {f} · vence el día {v}",
 "Fecha {f} · vence {v}": "Cierra {f} · vence {v}",
 "Fechar": "Cerrar",
 "Fechar o cofre": "Cerrar la caja fuerte",
 "Feche e abra o app de novo": "Cierra y vuelve a abrir la app",
 "Federais": "Federales",
 "Feijão": "Frijoles",
 "Feita em {data}": "Hecha el {data}",
 "Feita hoje": "Hecha hoy",
 "Feitas": "Hechas",
 "Feitas (não se repetem) · {n}": "Hechas (no se repiten) · {n}",
 "Feito": "Hecho",
 "Feito!": "¡Hecho!",
 "Feliz aniversário": "Feliz cumpleaños",
 "Feminino": "Femenino",
 "Feminino e suave": "Femenino y suave",
 "Feriado escolar": "Festivo escolar",
 "Feriado estadual": "Feriado estatal",
 "Feriado estadual: {nome}": "Feriado estatal: {nome}",
 "Feriado municipal": "Feriado municipal",
 "Feriado municipal: {nome}": "Feriado municipal: {nome}",
 "Feriado nacional": "Feriado nacional",
 "Feriado nacional: {nome}": "Feriado nacional: {nome}",
 "Feriado regional": "Feriado regional",
 "Feriado regional: {nome}": "Feriado regional: {nome}",
 "Feriados": "Feriados",
 "Feriados nacionais": "Feriados nacionales",
 "Feriados no planner": "Feriados en el planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Los feriados, las cotizaciones, las sugerencias de la inteligencia artificial y las lecturas automáticas de boletos y facturas pueden tener errores. Revísalos antes de usarlos.",
 "Ferramenta": "Herramienta",
 "Ferramentas": "Herramientas",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Ficha de cada planta, trasplantes y calendario de riego y abono en la agenda.",
 "Ficha preenchida": "Ficha completada",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Carpetas, materias y páginas, cronómetro de estudio y metas semanales.",
 "Ficção": "Ficción",
 "Figurinha": "Sticker",
 "Figurinhas": "Stickers",
 "Filme": "Película",
 "Filme ou série": "Película o serie",
 "Filmes e séries": "Películas y series",
 "Filosofia": "Filosofía",
 "Filtros": "Filtros",
 "Fim": "Fin",
 "Fim (vazio = uso contínuo)": "Fin (vacío = uso continuo)",
 "Fim da garantia": "Fin de la garantía",
 "Fim da garantia:": "Fin de la garantía:",
 "Fim da pausa. Continue: {tarefa}": "Fin de la pausa. Continúa: {tarefa}",
 "Fim de semana": "Fin de semana",
 "Fim previsto": "Fin previsto",
 "Fina": "Fino",
 "Finados": "Día de los Difuntos",
 "Finalizador": "Finalizador",
 "Financeiro": "Finanzas",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Financiero: {gasto} de {orcado} ({p}%)",
 "Financiamento": "Financiación",
 "Financiamento de veículo": "Financiamiento de vehículo",
 "Financiamento imobiliário": "Hipoteca",
 "Financiamentos": "Financiamientos",
 "Financiamentos e empréstimos": "Financiamientos y préstamos",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Financiamientos y préstamos con cuotas, intereses, saldo pendiente y comprobantes; objetos prestados con foto y aviso de devolución.",
 "Finanças": "Finanzas",
 "Finanças {p}": "Finanzas {p}",
 "Finanças · {p}": "Finanzas · {p}",
 "Fins de semana": "Fines de semana",
 "Fio dental": "Hilo dental",
 "Flex": "Flex",
 "Flexão de braço": "Flexiones",
 "Flor": "Flor",
 "Flutua": "Flota",
 "Foguete": "Cohete",
 "Fogão": "Estufa",
 "Foi no cartão de crédito? Lançar como compra no cartão": "¿Fue con tarjeta de crédito? Regístralo como compra con tarjeta",
 "Foi para {destino}.": "Se envió a {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Se envió a {destino}. ¿Quieres quitarlo de aquí?",
 "Folha de pagamento": "Nómina",
 "Fone": "Auricular",
 "Fone de ouvido": "Auriculares",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Fuentes: Brasil, calculado en la app a partir de la ordenanza federal de feriados y de las leyes de cada estado. Otros países: base pública Nager.Date (date.nager.at), descargada por internet y guardada en el dispositivo.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Fuentes: Brasil, calculado en la app a partir de la ordenanza federal de feriados, las leyes de cada estado y los calendarios oficiales de las capitales. Otros países: base pública Nager.Date (date.nager.at), descargada por internet y guardada en el dispositivo.",
 "Forma": "Forma",
 "Forma das parcelas": "Tipo de cuotas",
 "Forma de pagamento": "Forma de pago",
 "Forma de pagamento: {f}.": "Forma de pago: {f}.",
 "Formas": "Formas",
 "Formato": "Formato",
 "Formatos": "Formatos",
 "Formatura": "Graduación",
 "Fornecedor": "Proveedor",
 "Fornecedores": "Proveedores",
 "Forte": "Fuerte",
 "Foto": "Foto",
 "Foto da galeria": "Foto de la galería",
 "Foto do contato": "Foto del contacto",
 "Foto inteira": "Foto completa",
 "Foto ou PDF (lido pela sua IA)": "Foto o PDF (lo lee tu IA)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Fotografía cada habitación en la inspección de salida y en la de entrada. Las fotos te protegen al devolver la vivienda.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Fotografía cada recibo de médico, dentista, escuela y plan de pensiones en cuanto pagues. A fin de año todo está listo.",
 "Fotos": "Fotos",
 "Fotos JPG, PNG e outras viram um PDF.": "Fotos JPG, PNG y otras se vuelven un PDF.",
 "Fotos de {d}": "Fotos del {d}",
 "Fotos do espaço pronto": "Fotos del espacio listo",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Las fotos y archivos de esta ficha también van a la carpeta del grupo, para que los participantes puedan abrirlos.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Las fotos y los archivos se guardan solo en este dispositivo. Los datos del documento van a tu cuenta, protegidos.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Las fotos y archivos se quedan en este dispositivo (y en tu Drive o OneDrive, si está conectado en Ajustes).",
 "Fotos e notas": "Fotos y notas",
 "Fotos e vídeos": "Fotos y videos",
 "Fotos, arquivos e links": "Fotos, archivos y enlaces",
 "Fraldas e lenços": "Pañales y toallitas",
 "Francês": "Francés",
 "Frango com osso": "Pollo con hueso",
 "Frango sem osso": "Pollo sin hueso",
 "Frase (opcional, ex.: Bom dia!)": "Frase (opcional, ej.: ¡Buenos días!)",
 "Freelancer & Projetos": "Freelancer & Proyectos",
 "Freezer": "Congelador",
 "Freios": "Frenos",
 "Frente": "Frente",
 "Frente do documento": "Frente del documento",
 "Frente e verso na mesma folha": "Frente y reverso en la misma hoja",
 "Frente pronta": "Frente lista",
 "Frequência": "Frecuencia",
 "Frio": "Frío",
 "Fruta": "Fruta",
 "Frágil": "Frágil",
 "Fundação e estrutura": "Cimentación y estructura",
 "Fundo": "Fondo",
 "Fundos e renda fixa": "Fondos y renta fija",
 "Fuso": "Huso",
 "Fuso horário": "Huso horario",
 "Fuso horário do destino": "Zona horaria del destino",
 "Futebol": "Fútbol",
 "Física": "Física",
 "Físico (obra pronta): {p}%": "Físico (obra lista): {p}%",
 "GASTOS POR CATEGORIA": "GASTOS POR CATEGORÍA",
 "GIF guardado nos seus GIFs.": "GIF guardado en tus GIFs.",
 "Garagem": "Garaje",
 "Garantia": "Garantía",
 "Garantia até {data}.": "Garantía hasta el {data}.",
 "Garantia legal": "Garantía legal",
 "Garantia vencendo": "Garantía por vencer",
 "Garantias": "Garantías",
 "Garrafa de água": "Botella de agua",
 "Gasolina": "Gasolina",
 "Gasto": "Gasto",
 "Gasto até agora": "Gastado hasta ahora",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Gasto de {v} registrado. {n} precio(s) guardado(s) para tu lista de la compra.",
 "Gasto neste mês: {v}": "Gastado este mes: {v}",
 "Gasto: {v}": "Gastado: {v}",
 "Gastos": "Gastos",
 "Gastos por categoria": "Gastos por categoría",
 "Gato": "Gato",
 "Geladeira": "Nevera",
 "Geografia": "Geografía",
 "Gerado por": "Generado por",
 "Gerando QR Code...": "Generando código QR...",
 "Gerar PDF": "Generar PDF",
 "Gerar as cobranças do mês": "Generar los cobros del mes",
 "Gerar as parcelas": "Generar las cuotas",
 "Gerar lista da mala": "Generar lista de la maleta",
 "Gerar pelo cardápio e pela despensa": "Generar a partir del menú y la despensa",
 "Gesso e forro": "Yeso y falso techo",
 "Gira todas as páginas ou só as escolhidas.": "Gira todas las páginas o solo las elegidas.",
 "Girar": "Girar",
 "Google Drive e OneDrive": "Google Drive y OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive y Google Calendar: solo si los conectas, y solo para guardar tus archivos y eventos.",
 "Gorro, cachecol e luvas": "Gorro, bufanda y guantes",
 "Gota": "Gota",
 "Graduação e Pós": "Grado y Posgrado",
 "Grande": "Grande",
 "Gravando": "Grabando",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Grabar recordatorios y notas por voz cuando lo pidas. El micrófono solo se activa cuando tocas.",
 "Gravar reunião": "Grabar reunión",
 "Gravação de áudio": "Grabación de audio",
 "Gravações das reuniões": "Grabaciones de las reuniones",
 "Grossa": "Grueso",
 "Grupo": "Grupo",
 "Grupo com convite (turma, equipe, convidados)": "Grupo con invitación (clase, equipo, invitados)",
 "Grupo criado": "Grupo creado",
 "Grupo da família": "Grupo de la familia",
 "Grupo da mudança (família e ajudantes)": "Grupo de la mudanza (familia y ayudantes)",
 "Grupo da obra (equipe)": "Grupo de la obra (equipo)",
 "Grupo da turma (convidar alunos)": "Grupo de la clase (invitar alumnos)",
 "Grupo da viagem (convidar quem vai)": "Grupo del viaje (invitar a quien va)",
 "Grupo de cuidado (família ou profissional)": "Grupo de cuidado (familia o profesional)",
 "Grupo de estudos (convidar colegas)": "Grupo de estudio (invitar compañeros)",
 "Grupo de leitura (convidar)": "Grupo de lectura (invitar)",
 "Grupo do cliente": "Grupo del cliente",
 "Grupo do evento (convidar)": "Grupo del evento (invitar)",
 "Grupos": "Grupos",
 "Grupos de estudo": "Grupos de estudio",
 "Grupos de {aba}": "Grupos de {aba}",
 "Grupos desta aba: {n}": "Grupos de esta pestaña: {n}",
 "Grupos e convites": "Grupos e invitaciones",
 "Grátis no lançamento": "Gratis en el lanzamiento",
 "Guarda-chuva": "Paraguas",
 "Guardada nas suas figurinhas.": "Guardado en tus stickers.",
 "Guardado": "Ahorrado",
 "Guardado até agora: {v}": "Ahorrado hasta ahora: {v}",
 "Guardado em outro dispositivo": "Guardado en otro dispositivo",
 "Guardado na pasta \"{pasta}\" do celular.": "Guardado en la carpeta \"{pasta}\" del celular.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Guardado en la caja fuerte, con cifrado de extremo a extremo.",
 "Guardado no {nome}.": "Guardado en {nome}.",
 "Guardado {onde} em {quando}": "Guardado {onde} el {quando}",
 "Guardando...": "Guardando...",
 "Guardar": "Ahorrar",
 "Guardar como recibo do IR": "Guardar como recibo del IR",
 "Guardar dinheiro": "Ahorrar dinero",
 "Guardar e enviar": "Guardar y enviar",
 "Guardar na meta": "Ahorrar en la meta",
 "Guardar nas minhas figurinhas": "Guardar en mis stickers",
 "Guardar nos meus GIFs": "Guardar en mis GIFs",
 "Guardar o PDF {onde}": "Guardar el PDF {onde}",
 "Guardar os PDFs em": "Guardar los PDF en",
 "Guardar os arquivos prontos em": "Guardar los archivos listos en",
 "Guardar sozinho cada arquivo pronto": "Guardar automáticamente cada archivo listo",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Guarda las prescripciones e indicaciones que usas siempre. En la consulta, toca ⋮ › Usar plantilla.",
 "Guarde seus documentos num lugar só": "Guarda tus documentos en un solo lugar",
 "Guarde {v} por mês até {d}": "Ahorra {v} al mes hasta el {d}",
 "Guardou": "Ahorrado",
 "Guia de imposto": "Guía de impuesto",
 "Gás": "Gas",
 "Gênero ou categoria": "Género o categoría",
 "HISTÓRICO DOS DADOS": "HISTORIAL DE LOS DATOS",
 "HOJE": "HOY",
 "Hall de entrada": "Recibidor",
 "Halteres": "Pesas",
 "Hexágono": "Hexágono",
 "Hidratante": "Crema hidratante",
 "Hidratante labial": "Bálsamo labial",
 "Hidráulica": "Fontanería",
 "Higiene bucal": "Higiene bucal",
 "Higienizar": "Limpiar",
 "História": "Historia",
 "Histórico": "Historial",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Historial de la familia, pruebas protegidas, vacunas, consultas y alarma de medicamentos en la línea de tiempo.",
 "Hmm...": "Mmm...",
 "Hoje": "Hoy",
 "Hoje: {a} de {m} aulas ({p}%)": "Hoy: {a} de {m} clases ({p}%)",
 "Hoje: {n} página(s)": "Hoy: {n} página(s)",
 "Hora": "Hora",
 "Hora da pausa": "Hora de la pausa",
 "Hora de voltar": "Hora de volver",
 "Hora de voltar!": "¡Hora de volver!",
 "Hora do check-in": "Hora del check-in",
 "Hora do check-out": "Hora del check-out",
 "Horas": "Horas",
 "Horas de sono": "Horas de sueño",
 "Horário": "Horario",
 "Horário de check-in": "Horario de check-in",
 "Horário de check-out": "Horario de check-out",
 "Horário do lembrete": "Hora del recordatorio",
 "Horário inválido": "Hora no válida",
 "Horário ocupado": "Horario ocupado",
 "Horários": "Horarios",
 "Horários (remédio diário)": "Horarios (medicamento diario)",
 "Hospedados agora": "Hospedados ahora",
 "Hospedagem": "Alojamiento",
 "Hospital ou pronto-socorro de referência": "Hospital o urgencias de referencia",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Hay una nueva versión de My Planner Web. Recarga para usarla.",
 "Híbrido": "Híbrido",
 "Hóspede": "Huésped",
 "Hóspede ({c})": "Huésped ({c})",
 "Hóspedes (máximo)": "Huéspedes (máximo)",
 "IA ligada": "IA activada",
 "IA não ligada": "IA no activada",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "IA no activada. Actívala en Ajustes › Inteligencia artificial.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS retenido por el tomador",
 "Ida": "Ida",
 "Identidade": "Identificación",
 "Idioma": "Idioma",
 "Idiomas": "Idiomas",
 "Ilimitados": "Ilimitados",
 "Imagem": "Imagen",
 "Imagem escolhida (trocar)": "Imagen elegida (cambiar)",
 "Imagem guardada no {nome}. Toque para abrir.": "Imagen guardada en {nome}. Toca para abrir.",
 "Imagens para PDF": "Imágenes a PDF",
 "Imagens {data}": "Imágenes {data}",
 "Imperdíveis": "Imperdibles",
 "Imperdível": "Imperdible",
 "Importar": "Importar",
 "Importar XML de nota": "Importar XML de factura",
 "Importar arquivo": "Importar archivo",
 "Importar backup?": "¿Importar copia de seguridad?",
 "Importar extrato": "Importar extracto",
 "Importar extrato do banco (OFX ou CSV)": "Importar extracto bancario (OFX o CSV)",
 "Importar fatura": "Importar estado de cuenta",
 "Importar fotos": "Importar fotos",
 "Importar reservas do Airbnb, Booking...": "Importar reservas de Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Importar {n} movimiento(s)",
 "Imóveis e espaços": "Inmuebles y espacios",
 "Imóvel": "Inmueble",
 "Imóvel inteiro": "Inmueble entero",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Inmueble entero o por habitación: reservas de Airbnb, Booking o directas, limpieza al check-out, gastos, ocupación y ganancia del mes.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Incluye {v} de las facturas emitidas en la pestaña Facturas.",
 "Independência do Brasil": "Independencia de Brasil",
 "Indicação": "Recomendación",
 "Indique e ganhe": "Recomienda y gana",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Recomienda My Planner a amigos y familia. Quien cree su cuenta con tu código obtiene 10 días con todas las pestañas desbloqueadas.",
 "Infantil": "Infantil",
 "Informações do PDF": "Información del PDF",
 "Informe a descrição e o valor.": "Indica la descripción y el monto.",
 "Informe de quantos em quantos dias regar ou adubar.": "Indica cada cuántos días regar o abonar.",
 "Informe o nome do produto.": "Indica el nombre del producto.",
 "Informe o rótulo e o nome.": "Indica la etiqueta y el nombre.",
 "Informe o total de aulas da matéria em Editar.": "Indica el total de clases de la materia en Editar.",
 "Informe o valor.": "Indica el monto.",
 "Informe os horários": "Indica los horarios",
 "Informe quanto quer juntar.": "Indica cuánto quieres juntar.",
 "Informe seu nome.": "Indica tu nombre.",
 "Informática": "Informática",
 "Inglês": "Inglés",
 "Ingredientes (um por linha)": "Ingredientes (uno por línea)",
 "Inscrição municipal (se tiver)": "Inscripción municipal (si tienes)",
 "Inspeção": "Inspección",
 "Instalar ou atualizar o Health Connect": "Instalar o actualizar Health Connect",
 "Instruções, receita, observações...": "Instrucciones, receta, observaciones...",
 "Insumos (papel, sabonete, café)": "Insumos (papel, jabón, café)",
 "Inteligência artificial": "Inteligencia artificial",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Inteligencia artificial (Claude, ChatGPT o Gemini): solo si la activas, con tu propia clave, que se queda solo en el dispositivo. El texto de la pregunta va directo al servicio elegido.",
 "Intensidade": "Intensidad",
 "Internação": "Ingreso hospitalario",
 "Internet": "Internet",
 "Intimação": "Notificación",
 "Intimação com prazo": "Notificación con plazo",
 "Investimento": "Inversión",
 "Investimentos": "Inversiones",
 "Início": "Inicio",
 "Início {ini} · Fim {fim} · Duração {dur}": "Inicio {ini} · Fin {fim} · Duración {dur}",
 "Iogurte": "Yogur",
 "Ir para Ajustes (exportar meus dados)": "Ir a Ajustes (exportar mis datos)",
 "Ir para hoje": "Ir a hoy",
 "Ir para o My Planner Web": "Ir a My Planner Web",
 "Italiano": "Italiano",
 "Item": "Elemento",
 "Item da despensa": "Producto de la despensa",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Elemento protegido: las fotos y archivos se cifran en la caja fuerte, solo en este dispositivo (no van a Drive ni a OneDrive).",
 "Itens": "Artículos",
 "Itens de higiene (xampu, sabonete)": "Artículos de higiene (champú, jabón)",
 "Jantar": "Cena",
 "Japonês": "Japonés",
 "Jaqueta impermeável": "Chaqueta impermeable",
 "Jogo": "Juego",
 "Jovem e divertido": "Joven y divertido",
 "Juntar PDFs": "Unir PDFs",
 "Juros": "Intereses",
 "Juros ainda por vir: {v}": "Intereses por venir: {v}",
 "Juros ao mês": "Interés mensual",
 "JÁ RESPONDIDOS": "YA RESPONDIDOS",
 "Já aberta na casa nova": "Ya abierta en la casa nueva",
 "Já enviado para a turma": "Ya enviado al grupo",
 "Já está compacto": "Ya está compacto",
 "Já está no Planner": "Ya está en el Planner",
 "Já está pago": "Ya está pagado",
 "Já há horários deste item no My Planner": "Ya hay horarios de este elemento en My Planner",
 "Já pago: {v}": "Ya pagado: {v}",
 "Já tenho o app: abrir nele": "Ya tengo la app: abrir en ella",
 "Já tenho o app: abrir o convite nele": "Ya tengo la app: abrir la invitación en ella",
 "Já visitei": "Ya lo visité",
 "Kit de primeiros socorros": "Botiquín de primeros auxilios",
 "Kkkk": "Jaja",
 "Kkkkk": "Jajaja",
 "Km de hoje no painel": "Km de hoy en el cuentakilómetros",
 "Km no dia": "Km del día",
 "Km no painel": "Km en el cuentakilómetros",
 "LANÇAMENTOS": "MOVIMIENTOS",
 "LINHA DO TEMPO": "LÍNEA DE TIEMPO",
 "Laboratório": "Laboratorio",
 "Lanche": "Merienda",
 "Lanche da manhã": "Media mañana",
 "Lanche da tarde": "Merienda",
 "Lanches e água": "Tentempiés y agua",
 "Lançamentos": "Movimientos",
 "Lavanderia": "Lavandería",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Lavandería, insumos, mantenimiento, cuentas y tasas. Entran en la ganancia del mes.",
 "Lavar o rosto com sabonete facial": "Lavarse la cara con limpiador facial",
 "Lazer": "Ocio",
 "Leg press": "Prensa de piernas",
 "Legenda": "Leyenda",
 "Legislação Específica": "Legislación Específica",
 "Legumes": "Verduras",
 "Leia hoje para começar uma sequência": "Lee hoy para empezar una racha",
 "Leite": "Leche",
 "Leitura": "Lectura",
 "Leitura automática do texto": "Lectura automática del texto",
 "Leitura da IA": "Lectura de la IA",
 "Leitura, Cursos & Mídia": "Lectura, Cursos & Medios",
 "Lembrete": "Recordatorio",
 "Lembrete de hoje": "Recordatorio de hoy",
 "Lembrete de renovação no Planner": "Recordatorio de renovación en el Planner",
 "Lembrete no Planner": "Recordatorio en el Planner",
 "Lembrete no planner": "Recordatorio en el planner",
 "Lembrete pelo WhatsApp": "Recordatorio por WhatsApp",
 "Lembrete: começa às {hora}": "Recordatorio: empieza a las {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Leemos todos los mensajes. Si hace falta, te respondemos por correo.",
 "Lendo": "Leyendo",
 "Lendo a fatura...": "Leyendo el estado de cuenta...",
 "Lendo a página": "Leyendo la página",
 "Lendo o boleto...": "Leyendo el boleto...",
 "Lendo o cupom...": "Leyendo el ticket...",
 "Lendo o documento...": "Leyendo el documento...",
 "Lendo o extrato...": "Leyendo el extracto...",
 "Lendo o relógio...": "Leyendo el reloj...",
 "Lendo o texto": "Leyendo el texto",
 "Ler a fatura": "Leer el estado de cuenta",
 "Ler a publicação inteira": "Leer la publicación completa",
 "Ler com a minha IA": "Leer con mi IA",
 "Ler de novo": "Leer de nuevo",
 "Ler de novo agora": "Volver a leer ahora",
 "Ler o texto": "Leer el texto",
 "Ler o texto completo": "Leer el texto completo",
 "Ler publicação inteira": "Leer publicación completa",
 "Ler sozinho as publicações novas": "Leer solas las publicaciones nuevas",
 "Leve": "Ligera",
 "Leve (sem perder qualidade)": "Ligero (sin perder calidad)",
 "Li e aceito os termos e a política de privacidade": "He leído y acepto los términos y la política de privacidad",
 "Li mais {n} páginas": "Leí {n} páginas más",
 "Liberada pelo suporte": "Habilitada por soporte",
 "Liberar para a equipe": "Compartir con el equipo",
 "Liberar para a turma em": "Liberar al grupo el",
 "Liberar para o grupo": "Liberar para el grupo",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Las habilitaciones y créditos están vinculados a tu CPF. Se actualiza al sincronizar.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Permite el acceso a la cámara para My Planner en la configuración del celular para leer el código QR.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Permite el acceso a la cámara para My Planner en los ajustes del móvil.",
 "Libere outras abas em Ajustes › Compras.": "Desbloquea otras pestañas en Ajustes › Compras.",
 "Licenciamento": "Licencia del vehículo",
 "Lidas hoje": "Leídas hoy",
 "Lido": "Leído",
 "Ligando. Toque para atender.": "Llamando. Toca para contestar.",
 "Ligar": "Llamar",
 "Ligar certificado": "Conectar certificado",
 "Ligar para a assistência": "Llamar al servicio técnico",
 "Ligar para {nome}": "Llamar a {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Activa tu IA en Ajustes › Inteligencia artificial (Claude, ChatGPT o Gemini) para usar esta herramienta.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Activa tu IA en Ajustes › Inteligencia artificial para leer el texto, resumir y preguntar sobre el documento.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Activa tu IA en Ajustes › Inteligencia artificial.",
 "Ligue o certificado A1 da empresa primeiro.": "Conecta primero el certificado A1 de la empresa.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Conecta tu Google Drive u OneDrive para guardar fotos y archivos (que podrás abrir en cualquier dispositivo) y tener copias de seguridad completas.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Actívalo para que el grupo trabaje con los mismos datos (obra, viaje, clase, inmueble, consultorio), cada persona con su rol.",
 "Ligue pelo menos 4 pontos.": "Une al menos 4 puntos.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Límite anual editable en Ajustes › Pestañas › Pestaña Finanzas. Verifícalo siempre con tu contador.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Límite de consultas alcanzado. Inténtalo de nuevo en 1 minuto.",
 "Limite de energia por dia": "Límite de energía por día",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Límite de facturación anual del MEI (verifica el valor vigente con tu contador).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Se alcanzó el límite de mensajes de hoy. Inténtalo mañana.",
 "Limite diário": "Límite diario",
 "Limite livre: {v} de {l}": "Límite disponible: {v} de {l}",
 "Limite total (opcional)": "Límite total (opcional)",
 "Limpar": "Borrar",
 "Limpar a agenda": "Limpiar la agenda",
 "Limpar banheiro": "Limpiar el baño",
 "Limpar cozinha e louça": "Limpiar cocina y platos",
 "Limpar feitos": "Borrar hechos",
 "Limpeza": "Limpieza",
 "Limpeza após {h}": "Limpieza tras {h}",
 "Limpeza final": "Limpieza final",
 "Limpeza · {e}": "Limpieza · {e}",
 "Limpeza: {e}": "Limpieza: {e}",
 "Limpezas": "Limpiezas",
 "Linha do tempo, tarefas, energia e alertas.": "Línea de tiempo, tareas, energía y alertas.",
 "Link": "Enlace",
 "Link (Drive, OneDrive, Dropbox)": "Enlace (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Enlace copiado. Pégalo donde quieras enviarlo.",
 "Link da aula ou reunião online (opcional)": "Enlace de la clase o reunión online (opcional)",
 "Link da nota fiscal (Drive ou OneDrive)": "Enlace de la factura (Drive u OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Enlace de la carpeta en Drive u OneDrive (opcional)",
 "Link da reserva": "Enlace de la reserva",
 "Link da sala online (Meet, Zoom...)": "Enlace de la sala en línea (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Enlace de otro calendario (iCal)",
 "Link do calendário do Airbnb (iCal)": "Enlace del calendario de Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Enlace del calendario de Booking (iCal)",
 "Link inválido": "Enlace inválido",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Enlaces de materiales (Drive, videos, PDF), uno por línea",
 "Links: {n}": "Enlaces: {n}",
 "Lista": "Lista",
 "Lista da mala": "Lista de la maleta",
 "Lista de compras": "Lista de la compra",
 "Lista de exercícios": "Lista de ejercicios",
 "Lista rápida": "Lista rápida",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Listas rápidas y tarjetas que se convierten en tarea o van a otra pestaña.",
 "Literatura": "Literatura",
 "Litros": "Litros",
 "Livre": "Libre",
 "Livro": "Libro",
 "Livros": "Libros",
 "Local": "Lugar",
 "Local ou endereço": "Lugar o dirección",
 "Local: {l}": "Lugar: {l}",
 "Localização (país e fuso horário)": "Ubicación (país y zona horaria)",
 "Logo, foto ou rubrica nas páginas.": "Logo, foto o rúbrica en las páginas.",
 "Loja (opcional)": "Tienda (opcional)",
 "Lote": "Lote",
 "Lua": "Luna",
 "Lugar": "Lugar",
 "Lugar para visitar": "Lugar para visitar",
 "Lugares": "Lugares",
 "Luz": "Luz",
 "Luz indireta": "Luz indirecta",
 "Luz, água, gás e internet": "Luz, agua, gas e internet",
 "Lápis": "Lápiz",
 "Língua Portuguesa": "Lengua Portuguesa",
 "MAIS ADIANTE": "MÁS ADELANTE",
 "MAIS USADOS": "MÁS USADOS",
 "ME ou EPP do Simples": "ME o EPP del Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: facturación en {ano} de {v} (límite {l}).",
 "MEMBROS ({n})": "MIEMBROS ({n})",
 "METAS": "METAS",
 "MS": "MS",
 "Mais": "Más",
 "Mais abas": "Más pestañas",
 "Mais cidades entram nas próximas versões.": "Más ciudades llegarán en las próximas versiones.",
 "Mais emojis": "Más emojis",
 "Mais ferramentas": "Más herramientas",
 "Mais figurinhas animadas (KLIPY)": "Más stickers animados (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Más opciones de esta pestaña llegarán en las próximas versiones.",
 "Mais uma": "Una más",
 "Mala": "Maleta",
 "Mala ({clima}, {n} dias)": "Maleta ({clima}, {n} días)",
 "Mamadeiras e leite": "Biberones y leche",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Enviamos un código de 6 números al WhatsApp del número {tel}.",
 "Mandar as orientações pelo WhatsApp": "Mandar las indicaciones por WhatsApp",
 "Mandar de novo": "Reenviar",
 "Mandar e-mail": "Enviar correo",
 "Mandar lembrete": "Enviar recordatorio",
 "Mandar meu código": "Enviar mi código",
 "Mandar o acerto para o grupo": "Mandar el ajuste al grupo",
 "Mandar para quem limpa (WhatsApp)": "Mandar a quien limpia (WhatsApp)",
 "Mandarim": "Mandarín",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Envía un correo pidiendo la eliminación, con el documento de la cuenta. Respondemos en hasta 15 días.",
 "Manter": "Mantener",
 "Manter ambas": "Mantener ambas",
 "Manter ambos": "Mantener ambos",
 "Manter aqui também": "Mantener aquí también",
 "Manter tarefas": "Mantener tareas",
 "Manutenção": "Mantenimiento",
 "Manutenções": "Mantenimientos",
 "Mapas (Apple)": "Mapas de Apple",
 "Marca d'água": "Marca de agua",
 "Marca-texto": "Resaltador",
 "Marcado": "Marcado",
 "Marcado como feito hoje.": "Marcado como hecho hoy.",
 "Marcar como concluída ({dia})": "Marcar como completada ({dia})",
 "Marcar como devolvido": "Marcar como devuelto",
 "Marcar como feita hoje": "Marcar como hecha hoy",
 "Marcar como lido": "Marcar como leído",
 "Marcar como paga": "Marcar como pagada",
 "Marcar como pago": "Marcar como pagado",
 "Marcar como quitado": "Marcar como liquidado",
 "Marcar como recebida": "Marcar como cobrada",
 "Marcar como recebida?": "¿Marcar como cobrada?",
 "Marcar como recebido": "Marcar como recibido",
 "Marcar como visto": "Marcar como visto",
 "Marcar e avisar a equipe": "Programar y avisar al equipo",
 "Marcar esta conta como paga?": "¿Marcar esta cuenta como pagada?",
 "Marcar fatura como paga": "Marcar estado de cuenta como pagado",
 "Marcar grupo": "Marcar grupo",
 "Marcar reunião": "Programar reunión",
 "Marcenaria": "Carpintería",
 "Margem": "Margen",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Marca las fotos del diario como Antes o Después para armar la galería.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Marca los días en que estudias y el horario de cada día. Cada día se convierte en una tarea que se repite cada semana, vinculada a este elemento.",
 "Marque um ou mais estados.": "Marca uno o más estados.",
 "Martelo": "Martillo",
 "Masculino": "Masculino",
 "Masculino e minimalista": "Masculino y minimalista",
 "Matemática": "Matemáticas",
 "Materiais": "Materiales",
 "Material": "Material",
 "Matrícula, placa, código ou CNPJ": "Registro, matrícula, código o CNPJ",
 "Matéria ou material": "Materia o material",
 "Matéria ou módulo": "Materia o módulo",
 "Matérias": "Materias",
 "Meia-sombra": "Semisombra",
 "Melhorando a imagem...": "Mejorando la imagen...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "Las mejoras nuevas ya se descargaron. Solo tarda unos segundos y tus datos se mantienen.",
 "Membros": "Miembros",
 "Menos de 1 minuto": "Menos de 1 minuto",
 "Mensagem": "Mensaje",
 "Mensagem apagada": "Mensaje eliminado",
 "Mensagem enviada. Obrigado!": "Mensaje enviado. ¡Gracias!",
 "Mensagem ou observações": "Mensaje u observaciones",
 "Mensagens": "Mensajes",
 "Mensagens que você envia em Fale conosco.": "Mensajes que envías en Contáctanos.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Mensajes: tu lista de amigos, los chats y las fotos y archivos enviados se guardan en el servidor para llegar a los demás dispositivos. Las llamadas de audio y video no se graban.",
 "Mensalidade de {m}": "Mensualidad de {m}",
 "Mensalidade ou valor por aluno": "Mensualidad o valor por alumno",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Mensualidades, clases sueltas y materiales. En ⋮ del grupo, \"Generar los cobros del mes\" crea uno para cada alumno.",
 "Mercado": "Supermercado",
 "Mesa flexora": "Curl femoral tumbado",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Maestro de obras",
 "Meta": "Meta",
 "Meta 100% batida": "Meta 100% cumplida",
 "Meta atingida": "Meta alcanzada",
 "Meta atingida!": "¡Meta alcanzada!",
 "Meta da semana: {dur}": "Meta de la semana: {dur}",
 "Meta de aulas": "Meta de clases",
 "Meta de aulas batida": "Meta de clases cumplida",
 "Meta de copos por dia": "Meta de vasos por día",
 "Meta de páginas por dia": "Meta de páginas por día",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Meta de páginas, progreso y resúmenes de libros, películas y series por ver, y clases de los cursos.",
 "Meta diária": "Meta diaria",
 "Meta por dia": "Meta diaria",
 "Meta por semana:": "Meta semanal:",
 "Meta {meta} · copo de {copo} · {n} copos": "Meta {meta} · vaso de {copo} · {n} vasos",
 "Metas": "Metas",
 "Metodologia Científica": "Metodología Científica",
 "Meu caderno": "Mi cuaderno",
 "Meu cartão de contato": "Mi tarjeta de contacto",
 "Meu plano": "Mi plan",
 "Meus GIFs ({n})": "Mis GIFs ({n})",
 "Meus PDFs": "Mis PDFs",
 "Meus dados": "Mis datos",
 "Meus dados profissionais": "Mis datos profesionales",
 "Microchip": "Microchip",
 "Microfone": "Micrófono",
 "Microscópio": "Microscopio",
 "Militares estaduais": "Militares estatales",
 "Minha Casa": "Mi Casa",
 "Minha conta": "Mi cuenta",
 "Minhas anotações do livro": "Mis notas del libro",
 "Minhas figurinhas": "Mis stickers",
 "Minutos": "Minutos",
 "Minutos de exercício": "Minutos de ejercicio",
 "Mirante": "Mirador",
 "Mirantes": "Miradores",
 "Modelo": "Modelo",
 "Modelo de prescrição": "Plantilla de prescripción",
 "Modelos": "Plantillas",
 "Modificado em": "Modificado el",
 "Modo": "Modo",
 "Modo de preparo": "Preparación",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Modo seguro: tareas automáticas desactivadas hasta que vuelvas a abrir la app",
 "Moeda": "Moneda",
 "Moeda: {m}": "Moneda: {m}",
 "Moedas": "Monedas",
 "Momento do evento": "Momento del evento",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitor del Diario de Justicia Electrónico (DJEN) por nombre y OAB.",
 "Monitor ou co-professor": "Monitor o coprofesor",
 "Montando o PDF: página {n} de {total}...": "Creando el PDF: página {n} de {total}...",
 "Montar a mala pelo clima ({n} dias)": "Hacer la maleta según el clima ({n} días)",
 "Monte o cronograma alimentar para ver o relatório.": "Arma tu cronograma de comidas para ver el informe.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Arma el itinerario día a día. Durante el viaje, aparece en la línea de tiempo de My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Arma tu plan de comidas y tus cuidados abajo. Lo que sea de hoy aparece aquí para marcar.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Arma abajo tu cronograma de comidas, cuidados, entrenamientos y suplementos. Lo que sea de hoy aparece aquí para marcar.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Arma tus entrenamientos con actividades listas: máquinas del gimnasio, ejercicios en casa, caminata, carrera, yoga, pilates...",
 "Mostrando as 120 mais recentes.": "Mostrando las 120 más recientes.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Mostrando solo el itinerario. {n} tarea(s) del día oculta(s).",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Mostrar fechas, horas, moneda y feriados correctos para donde estás. No usamos el GPS.",
 "Mostrar menos": "Mostrar menos",
 "Mostrar só o roteiro durante a viagem": "Mostrar solo el itinerario durante el viaje",
 "Motivo do cancelamento": "Motivo de la cancelación",
 "Moto": "Moto",
 "Mover": "Mover",
 "Mover para hoje": "Mover a hoy",
 "Mudança": "Mudanza",
 "Mudança: {para}": "Mudanza: {para}",
 "Mudanças": "Mudanzas",
 "Mudar e-mail": "Cambiar correo",
 "Mudar o nome": "Renombrar",
 "Mudar senha": "Cambiar contraseña",
 "Mudo": "Silenciar",
 "Muitas tentativas": "Demasiados intentos",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Demasiados intentos fallidos. Inténtalo de nuevo en {s} segundos.",
 "Muitas tentativas. Aguarde alguns minutos.": "Demasiados intentos. Espera unos minutos.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Muy bien: ya ahorraste {v} este mes. La constancia vale más que una cifra alta.",
 "Multa": "Multa",
 "Multa e juros": "Multa e intereses",
 "Multa e juros de {v}": "Multa e intereses de {v}",
 "Multa e juros estimados: {v}": "Multa e intereses estimados: {v}",
 "Multas e juros pagos": "Multas e intereses pagados",
 "Mundo": "Mundo",
 "Municipal": "Municipal",
 "Município da prestação (IBGE), se for outro": "Municipio de la prestación (IBGE), si es otro",
 "Município da prestação (código IBGE, 7 números)": "Municipio de la prestación (código IBGE, 7 números)",
 "Mural": "Mural",
 "Museu": "Museo",
 "Museus": "Museos",
 "My Planner (vira tarefa)": "My Planner (se convierte en tarea)",
 "My Planner bloqueado": "My Planner bloqueado",
 "Máxima": "Máxima",
 "Média": "Media",
 "Média para aprovação": "Media para aprobar",
 "Média · repouso {n}": "Media · reposo {n}",
 "Médico": "Médico",
 "Médico ou clínica": "Médico o clínica",
 "Médio": "Mediano",
 "Mês": "Mes",
 "Mês a mês": "Mes a mes",
 "Mês atual": "Mes actual",
 "Mês passado": "Mes pasado",
 "Móveis e enxoval": "Muebles y ropa de casa",
 "Móvel": "Mueble",
 "Música": "Música",
 "NAS ABAS": "EN LAS PESTAÑAS",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: la SEFAZ exige 1 hora entre búsquedas. La próxima a partir de las {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: indica el estado (UF) de la empresa para buscar las facturas de productos.",
 "NFS-e emitida": "NFS-e emitida",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "El (opcional):",
 "Na agenda": "En la agenda",
 "Na agenda em {data}": "En la agenda el {data}",
 "Na barra": "En la barra",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "En la demostración no hay servidor de facturas. Usa la app con tu cuenta.",
 "Na hora": "Al instante",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "A la hora de la pausa aparece un aviso grande en la pantalla, con cuenta regresiva.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "En la línea de tiempo, tocar el temporizador también abre esta página.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "En la carpeta \"{pasta}\" del celular. Cada archivo listo va allí.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "En la carpeta \"{pasta}\" del celular. Cada documento nuevo va ahí cuando sales de él.",
 "Na prévia de demonstração não há chamadas de verdade.": "En la vista previa de demostración no hay llamadas reales.",
 "Na prévia de demonstração não há gravação de verdade.": "En la vista previa de demostración no hay grabación real.",
 "Na prévia de demonstração os arquivos não abrem.": "En la vista previa de demostración los archivos no se abren.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "En la versión de las tiendas, la compra será por Google Play o App Store. Por ahora, el interruptor simula la suscripción para pruebas.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "En la versión de las tiendas, este botón abre la compra de Google Play o de App Store.",
 "Nacional": "Nacional",
 "Nada a gerar": "Nada que generar",
 "Nada encontrado.": "No se encontró nada.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Nada entra en la agenda de nadie sin autorización: cada persona acepta, edita o rechaza.",
 "Nada foi registrado.": "No se registró nada.",
 "Nada lançado neste mês.": "Nada registrado este mes.",
 "Nada no mês": "Nada en el mes",
 "Nada no roteiro deste dia.": "Nada en el itinerario de este día.",
 "Nada para apagar com esse filtro.": "No hay nada que borrar con este filtro.",
 "Nada para comprar": "Nada que comprar",
 "Nada para enviar.": "Nada para enviar.",
 "Nada planejado para este dia": "Nada planeado para este día",
 "Nada planejado para hoje. Bom dia!": "Nada planeado para hoy. ¡Buenos días!",
 "Nada por aqui.": "Nada por aquí.",
 "Nada recebido ainda.": "Aún no has recibido nada.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "En los chats, cada persona ve tu nombre y lo que envías allí. Puedes eliminar un mensaje para todos, salir de un grupo o bloquear a alguien.",
 "Nascimento": "Nacimiento",
 "Natal": "Navidad",
 "Natação": "Natación",
 "Navegador conectado": "Navegador conectado",
 "Negrito": "Negrita",
 "Negócios": "Negocios",
 "Nenhum": "Ninguno",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Ningún XML en este período (o se guardaron en otro dispositivo).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "No hay amigos para añadir. Invita por WhatsApp o añade amigos en Mensajes (código de amigo).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "No hay archivos, imágenes ni enlaces en las páginas de esta materia.",
 "Nenhum arquivo.": "Ningún archivo.",
 "Nenhum atendimento pago neste mês.": "Ninguna consulta pagada este mes.",
 "Nenhum cartão": "Ninguna tarjeta",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Aún no hay comprobantes guardados. Al pagar una cuenta, tócala y adjunta la foto, el PDF o la captura del comprobante.",
 "Nenhum cômodo ainda": "Ninguna habitación todavía",
 "Nenhum dia": "Ningún día",
 "Nenhum documento ainda.": "Aún no hay documentos.",
 "Nenhum documento neste filtro.": "Ningún documento en este filtro.",
 "Nenhum e-mail cadastrado": "Ningún correo registrado",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "No hay errores registrados. Si la app se cierra sola o una pantalla falla, el error aparece aquí para que lo envíes al equipo.",
 "Nenhum feriado neste ano.": "No hay feriados este año.",
 "Nenhum fichário ainda": "Ninguna carpeta todavía",
 "Nenhum grupo ainda.": "Aún no hay grupos.",
 "Nenhum item em {nome}": "Ningún elemento en {nome}",
 "Nenhum lançamento encontrado": "No se encontraron movimientos",
 "Nenhum país encontrado.": "No se encontró ningún país.",
 "Nenhum selecionado": "Ninguno seleccionado",
 "Nenhuma (plano gratuito)": "Ninguna (plan gratuito)",
 "Nenhuma aba encontrada.": "No se encontró ninguna pestaña.",
 "Nenhuma aba fixada além do My Planner.": "Ninguna pestaña fijada además de My Planner.",
 "Nenhuma aba liberada para receber": "Ninguna pestaña desbloqueada puede recibirlo",
 "Nenhuma agenda encontrada": "No se encontró ningún calendario",
 "Nenhuma agenda para trazer": "Ningún calendario para importar",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "No se encontró ninguna audiencia ni plazo en esta publicación.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "No hay tarjetas archivadas. Desliza una tarjeta a la izquierda para archivarla.",
 "Nenhuma compra encontrada": "No se encontraron compras",
 "Nenhuma compra nesta fatura.": "No hay compras en este estado de cuenta.",
 "Nenhuma conta a pagar cadastrada.": "No hay cuentas por pagar registradas.",
 "Nenhuma conta a receber cadastrada.": "No hay cuentas por cobrar registradas.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Ninguna cuenta este mes. Toca + para registrar (alquiler, luz, tarjeta...).",
 "Nenhuma cópia de segurança ainda.": "Aún no hay copias de seguridad.",
 "Nenhuma cópia encontrada.": "No se encontró ninguna copia.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Ninguna garantía activa. Registra una con el +.",
 "Nenhuma garantia vencida.": "Ninguna garantía vencida.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Aún no hay mensajes. ¡Saluda! 👋",
 "Nenhuma nota neste período.": "Ninguna factura en este período.",
 "Nenhuma opção ainda.": "Aún no hay opciones.",
 "Nenhuma publicação nova.": "Ninguna publicación nueva.",
 "Nenhuma refeição neste dia.": "Ninguna comida este día.",
 "Nenhuma reunião marcada.": "No hay reuniones programadas.",
 "Nesse ritmo, termina em {d}": "A este ritmo, terminas el {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "En esta fase de lanzamiento, todas las pestañas están liberadas y gratis.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "En esta fase de pruebas, la contraseña la restablece el soporte. Escribe a {email} indicando tu CPF o correo.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "En esta fase de pruebas, la contraseña la restablece el soporte. Escribe a {email} indicando tu CPF.",
 "Neve": "Nieve",
 "Ninguém deve nada a ninguém.": "Nadie le debe nada a nadie.",
 "Ninguém entrou ainda. Envie o convite.": "Nadie se ha unido todavía. Envía la invitación.",
 "Ninguém usou o seu código ainda.": "Nadie ha usado tu código todavía.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "En Android, la app guarda solo el acceso directo al archivo elegido: sigue donde está (Drive, OneDrive, Descargas) y se abre en la app del celular. No se copia nada. Esta opción vale para las fotos tomadas con la cámara.",
 "No Google Drive ou OneDrive: {n}": "En Google Drive u OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "En Google Drive, la app solo ve los archivos que ella misma creó en la carpeta My Planner. El uso de la información recibida de las API de Google se rige por la Política de Datos de Usuario de los Servicios de las API de Google, incluidos los requisitos de Uso Limitado: nada se vende, se usa para publicidad ni lo leen personas, salvo con tu autorización o por obligación legal.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "En la app de tu reloj (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), activa la opción \"Health Connect\" o \"Sincronizar con Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "En la app nueva (versión 0.49), el celular detecta solo los bordes de la hoja. En esta versión, ajusta las 4 esquinas con el dedo.",
 "No centro": "En el centro",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "En la computadora, abre {url}, toca el botón de arriba y apunta la cámara al código QR de la pantalla.",
 "No dia (opcional):": "El día (opcional):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "En iPhone, la app abre \"Guardar en Archivos\" para que elijas la carpeta (puede ser iCloud Drive).",
 "No início": "Al inicio",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "En modo seguro la app se abre sin las tareas automáticas (avisos, Google Calendar, publicaciones, mensajes y reloj). Tus datos no cambian y todo vuelve a la normalidad la próxima vez que la abras.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "En el navegador, las páginas solo se conservan mientras esta página esté abierta.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "En el navegador, pega el enlace del archivo de Drive, OneDrive o Dropbox (en Estudios o Documentos, opción Enlace). En el móvil, el botón de archivo ya muestra Drive y OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "En el navegador, el PDF se descarga en la computadora.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "En el navegador solo puedes guardar imágenes pequeñas (hasta 200 KB). Para otros archivos, añade un enlace de Drive, OneDrive o Dropbox, o usa la app en el móvil.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "En la otra app, copia el enlace del archivo (Compartir › Copiar enlace) y pégalo en el bloque de enlace que quedó en esta página.",
 "No ritmo atual, o ano fecha em {v}.": "Al ritmo actual, el año cierra en {v}.",
 "No seu fuso: {hora}{dia}": "En tu huso: {hora}{dia}",
 "Nome": "Nombre",
 "Nome (cliente ou fornecedor)": "Nombre (cliente o proveedor)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Nombre (ej.: 8.º B, Pacientes de la clínica, Cumpleaños de Ana)",
 "Nome (ex.: Almoço)": "Nombre (ej.: Almuerzo)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Nombre (ej.: Alquiler cobrado, Cliente X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Nombre (ej.: Alquiler, Luz, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Nombre (ej.: Doctorado UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Nombre (ej.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Nombre (ej.: Skincare de noche)",
 "Nome (ex.: Treino A)": "Nombre (ej.: Entrenamiento A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Nombre (ej.: Viaje de vacaciones, Fondo de emergencia)",
 "Nome (ex.: Vitamina C)": "Nombre (ej.: Vitamina C)",
 "Nome (opcional)": "Nombre (opcional)",
 "Nome (opcional, ex.: CNH do Walter)": "Nombre (opcional, ej.: Licencia de Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Nombre (editable, ej.: \"Jugo de uva\")",
 "Nome completo": "Nombre completo",
 "Nome curto": "Nombre corto",
 "Nome da lista": "Nombre de la lista",
 "Nome da matéria": "Nombre de la materia",
 "Nome da obra": "Nombre de la obra",
 "Nome da pasta (ex.: Recibos, Contratos)": "Nombre de la carpeta (ej.: Recibos, Contratos)",
 "Nome da tarefa": "Nombre de la tarea",
 "Nome da tarefa (ex.: Academia)": "Nombre de la tarea (ej.: Gimnasio)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Nombre de la tarea (ej.: Limpiar el baño)",
 "Nome do PDF (opcional)": "Nombre del PDF (opcional)",
 "Nome do conselho": "Nombre del colegio",
 "Nome do cômodo": "Nombre de la habitación",
 "Nome do documento": "Nombre del documento",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Nombre de la oficina (ej.: Ravasco Contabilidade)",
 "Nome do evento": "Nombre del evento",
 "Nome do grupo (ex.: Família)": "Nombre del grupo (ej.: Familia)",
 "Nome do modelo": "Nombre de la plantilla",
 "Nome ou modelo": "Nombre o modelo",
 "Nome ou razão social": "Nombre o razón social",
 "Nome, subtarefa ou anotação": "Nombre, subtarea o nota",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "En los grupos, cada persona responde por lo que añade. Quien administra el grupo decide quién participa.",
 "Nossa Senhora Aparecida": "Nuestra Señora Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nuestra Señora de la Luz de los Pinares",
 "Nota cancelada": "Factura cancelada",
 "Nota fiscal": "Factura",
 "Nota fiscal emitida": "Factura emitida",
 "Nota fiscal, certificado de garantia e fotos": "Factura, certificado de garantía y fotos",
 "Nota importada": "Factura importada",
 "Notas": "Facturas",
 "Notas Fiscais": "Facturas",
 "Notebook e carregador": "Portátil y cargador",
 "Nova avaliação": "Nueva evaluación",
 "Nova caixa (ex.: Compras, Ideias)": "Nueva tarjeta (ej.: Compras, Ideas)",
 "Nova conversa": "Nuevo chat",
 "Nova garantia": "Nueva garantía",
 "Nova matéria": "Nueva materia",
 "Nova meta": "Nueva meta",
 "Nova pasta": "Nueva carpeta",
 "Nova página": "Nueva página",
 "Nova página com esta caixa": "Nueva página con esta tarjeta",
 "Nova refeição": "Nueva comida",
 "Nova tarefa": "Nueva tarea",
 "Nova tarefa da casa": "Nueva tarea de la casa",
 "Nova tarefa neste cômodo": "Nueva tarea en esta habitación",
 "Novas": "Nuevas",
 "Novo": "Nuevo",
 "Novo alerta:": "Nueva alerta:",
 "Novo cartão": "Nueva tarjeta",
 "Novo cartão de crédito": "Nueva tarjeta de crédito",
 "Novo cuidado": "Nuevo cuidado",
 "Novo documento": "Nuevo documento",
 "Novo e-mail": "Nuevo correo",
 "Novo fichário": "Nueva carpeta",
 "Novo grupo": "Nuevo grupo",
 "Novo item": "Nuevo elemento",
 "Novo perfil": "Nuevo perfil",
 "Novo suplemento": "Nuevo suplemento",
 "Novo treino": "Nuevo entrenamiento",
 "Novo: {nome}": "Nuevo: {nome}",
 "Novos": "Nuevos",
 "Num período": "En un período",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Numera cada caja e indica la habitación y el contenido. Usa la búsqueda para encontrar dónde está cada cosa.",
 "Nº": "N.º",
 "Não": "No",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "No encontré el total en el ticket. Prueba con una foto más nítida.",
 "Não consegue entrar?": "¿No puedes entrar?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "No pude abrir \"{nome}\". Prueba la herramienta Reparar PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "No pude conectar la llamada. Revisa tu conexión a internet e inténtalo de nuevo.",
 "Não deu certo: {msg}": "No funcionó: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "No se pudo reducir más este PDF ({tam}).",
 "Não dá para tirar todas as páginas.": "No puedes quitar todas las páginas.",
 "Não encontrei texto neste PDF.": "No encontré texto en este PDF.",
 "Não encontrei texto neste documento.": "No encontré texto en este documento.",
 "Não foi possível": "No fue posible",
 "Não foi possível abrir": "No se pudo abrir",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "No se pudo abrir el certificado guardado. Conecta el certificado de nuevo.",
 "Não foi possível abrir.": "No se pudo abrir.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "No se pudieron descargar los feriados de este país. Revisa tu conexión a internet.",
 "Não foi possível conectar": "No se pudo conectar",
 "Não foi possível conectar o {nome}": "No se pudo conectar {nome}",
 "Não foi possível consultar o DJEN agora.": "No se pudo consultar el DJEN ahora.",
 "Não foi possível continuar": "No se pudo continuar",
 "Não foi possível criar um evento na agenda: {msg}": "No se pudo crear un evento en el calendario: {msg}",
 "Não foi possível entrar.": "No se pudo entrar.",
 "Não foi possível enviar": "No se pudo enviar",
 "Não foi possível enviar.": "No se pudo enviar.",
 "Não foi possível guardar: {erro}": "No se pudo guardar: {erro}",
 "Não foi possível ler o arquivo.": "No se pudo leer el archivo.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "No se pudo leer el calendario. Revisa el enlace en Editar.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "No se pudo buscar ahora. Lo intentará de nuevo solo más tarde.",
 "Não foi possível reiniciar sozinho.": "No se pudo reiniciar automáticamente.",
 "Não foi possível sincronizar com a agenda: {msg}": "No se pudo sincronizar con el calendario: {msg}",
 "Não foi possível trocar a foto": "No se pudo cambiar la foto",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "No hay garantía de aviso con la app cerrada. La verificación ocurre al abrir la app (cada 6 horas) o en \"Verificar ahora\".",
 "Não identificado": "No identificado",
 "Não marcada como feita": "No marcada como hecha",
 "Não optante pelo Simples": "No adherido al Simples",
 "Não se repete": "No se repite",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "No uses la app para actividades ilegales, para guardar contenido de terceros sin autorización ni para intentar acceder a datos de otras personas.",
 "Não vai": "No va",
 "Não vence": "No vence",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "No vendemos tus datos ni usamos tu contenido para publicidad.",
 "Não é possível adicionar esta pessoa.": "No es posible añadir a esta persona.",
 "Não é um XML de nota fiscal": "No es un XML de factura",
 "Número": "Número",
 "Número (opcional)": "Número (opcional)",
 "Número da OAB": "Número de OAB",
 "Número da caixa": "Número de caja",
 "Número da carteirinha": "Número de tarjeta",
 "Número da guia do convênio": "Número de autorización del seguro",
 "Número da parcela": "Número de cuota",
 "Número de hóspedes": "Número de huéspedes",
 "Número de parcelas": "Número de cuotas",
 "Número do contrato": "Número de contrato",
 "Número do registro": "Número de matrícula",
 "Número na chamada": "Número de lista",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Número {n}. El XML quedó guardado en la factura. Tócala para ver el PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "El número, el organismo emisor y las observaciones se cifran (AES-256) en el dispositivo antes de ir a la nube.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Número, organismo emisor, observaciones, fotos y PDF se cifran (AES-256) en el dispositivo. Los archivos protegidos quedan solo en este dispositivo.",
 "Número: {n}": "Número: {n}",
 "Números de página": "Números de página",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT no lee PDF desde aquí. Saca una foto o una captura de la página, o usa Claude o Gemini en Ajustes › Inteligencia artificial.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "El DAS vence el día {dia}. Márcalo como pagado en Finanzas.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "La Oficina aún no se ha activado en el servidor. En el ordenador, ejecuta 29-SERVIDOR-0.45.bat (solo una vez).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "El Mestre Achado cuida de tu dinero: cuentas, tarjetas y estados de cuenta, presupuesto por categoría, metas, extracto y ticket por foto, informe y MEI.",
 "O Mestre está pensando...": "El Mestre está pensando...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner crea la carpeta \"My Planner\" en tu Drive y solo ve lo que él mismo guardó allí.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner ya se abrió en la computadora, con tus datos.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner lee los datos del reloj a través de {fonte}, donde el reloj y las apps de salud y ejercicio guardan todo.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner organiza tu agenda, tareas, finanzas, documentos y otras áreas de la vida. Lo ofrece Walter Ravasco da Costa, que es el responsable de los datos personales tratados en la app.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner solo usa la carpeta Aplicaciones › My Planner de tu OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "El PDF y las imágenes se eliminarán de este dispositivo y de la nube.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "El PDF supera los 15 MB. Si WhatsApp o el correo lo rechazan, activa \"Archivo más ligero\".",
 "O QUE COMER": "QUÉ COMER",
 "O QUE OS MEMBROS PODEM": "QUÉ PUEDEN HACER LOS MIEMBROS",
 "O QUE VOCÊ MANDA": "LO QUE ENVÍAS",
 "O QUE VOCÊ RECEBE": "LO QUE RECIBES",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "El acceso sigue siendo con el CPF. El correo sirve para que el soporte se comunique contigo.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "El administrador del grupo podrá enviar citas, materiales y avisos. Nada entra en tu agenda sin que lo aceptes.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "La alarma vuelve a sonar cada 2 minutos (hasta 4 veces) mientras el medicamento no se marque como tomado.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "La app ayuda a organizarte, pero no sustituye la orientación de médicos, abogados, contadores u otros profesionales. Revisa los plazos, importes y fechas importantes.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "La app avisa 3 días antes y el día del vencimiento, a las 9 h.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "La app consulta el servicio público del CNJ (DJEN) con los nombres y la OAB que registres. Estos datos se envían a ese servicio en cada verificación.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "La app y el servidor de My Planner consultan el servicio público del CNJ (DJEN) con los nombres y las OAB que registres y, si lo marcas, Querido Diário (diarios oficiales municipales). Estos datos se envían a esos servicios en cada verificación.",
 "O app fechou sozinho {n} vezes seguidas": "La app se cerró sola {n} veces seguidas",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "La app instalada en este dispositivo es la versión {v}. Para hacer llamadas de audio y video, instala la app 0.35 o más reciente (APK nuevo). Los mensajes ya funcionan.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "La app no se cerró y tus datos siguen guardados. Inténtalo de nuevo o envía el informe para que el equipo lo corrija.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "La app pide el desbloqueo al abrirse y al volver del segundo plano.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "La app pide el desbloqueo al abrirse. Cambiar de app o de pantalla un momento no lo vuelve a pedir; si el móvil se bloquea o la app queda fuera de la pantalla más tiempo que el plazo de abajo, sí.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "La app solo lee (pasos, distancia, calorías, ejercicio, pulsaciones y sueño) y nunca modifica tus datos de salud. Los totales de cada día se guardan en tu cuenta para que aparezcan también en la web y en el otro móvil.",
 "O app volta a pedir a senha para desbloquear.": "La app volverá a pedir la contraseña para desbloquear.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "La app está pensada para mayores de 18 años. Los datos de niños solo pueden registrarlos los padres o tutores.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "El archivo quedó solo en este dispositivo. No se pudo guardar en {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "El archivo ya no está en ese lugar (se borró o se movió).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "El archivo ya no está en ese lugar (se borró, se movió o su app quitó el permiso). Adjúntalo de nuevo.",
 "O arquivo passa de 15 MB.": "El archivo supera los 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "El archivo supera los 15 MB. Activa \"Archivo más ligero\" e inténtalo de nuevo.",
 "O arquivo passa de 25 MB.": "El archivo supera los 25 MB.",
 "O arquivo passa de 50 MB.": "El archivo supera los 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "El archivo sale de este celular. Las copias que guardaste en Drive, OneDrive o enviaste a alguien siguen allí.",
 "O arquivo sai do escritório para todos.": "El archivo se elimina de la oficina para todos.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "El aviso llega a las 9 h, y de nuevo el día del vencimiento.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "La base de datos aún no está preparada. Ejecuta el archivo supabase/schema.sql en Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "La tarjeta {c} tiene usado el {p}% del límite. Evita nuevas compras en cuotas con ella por ahora.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "El móvil no avisa a la app cuando se bloquea la pantalla, por eso la app cuenta el tiempo fuera. Con 1 minuto, bloquear el móvil y volver después pide la biometría; responder un mensaje rápido, no.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "El celular solo sirve para confirmar que la cuenta es tuya (código por WhatsApp al registrarte y al cambiar de número). Un número por cuenta.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "El uso compartido aún no se activó en el servidor. En la computadora, abre la carpeta C:\\MyPlanner y haz doble clic en 12-LIGAR-COMPARTILHAMENTO.bat (solo una vez).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "La computadora abrirá My Planner con tu cuenta. Hazlo solo en computadoras de confianza.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "La invitación incluye el enlace de la app y del APK más reciente. Quien entra por el enlace llega directo a la oficina.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "El código de recomendación solo vale en los primeros 30 días de la cuenta.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "El patrón se guarda solo en este dispositivo, protegido. La contraseña sigue funcionando si olvidas el patrón.",
 "O dinheiro gasto está à frente do andamento da obra.": "El dinero gastado va por delante del avance de la obra.",
 "O documento não tem páginas.": "El documento no tiene páginas.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "El extracto se lee aquí en el dispositivo. Las cuentas por pagar con el mismo importe y fecha cercana se marcan como pagadas automáticamente.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "El extracto se lee aquí en el dispositivo. Las cuentas por pagar con el mismo importe y fecha cercana se dan de baja automáticamente. El pago del estado de cuenta de la tarjeta no se cuenta dos veces.",
 "O governo recusou a nota": "El gobierno rechazó la factura",
 "O governo recusou a nota.": "El gobierno rechazó la factura.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "El idioma se aplica a este dispositivo. Los datos que escribiste no se traducen.",
 "O item vinculado foi apagado ou movido.": "El elemento vinculado se borró o se movió.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "El elemento vinculado se borró o se movió. Edita la tarea para elegir otro.",
 "O link antigo deixa de funcionar.": "El enlace anterior dejará de funcionar.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "El enlace anterior deja de funcionar. Quien ya está en el grupo sigue en él.",
 "O link deve começar com https://": "El enlace debe empezar con https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "El navegador no permite leer el calendario de las plataformas. Importa desde la app en el celular.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "El plan básico y los períodos de prueba de las pestañas siguen las reglas que se muestran en Ajustes > Compras. Los beneficios por recomendación valen una vez por cuenta.",
 "O que acontece": "Qué pasa",
 "O que apagar": "Qué borrar",
 "O que comprou": "Qué compraste",
 "O que fazer": "Qué hacer",
 "O que foi comido:": "Lo que se comió:",
 "O que foi feito": "Qué se hizo",
 "O que foi visto": "Qué se vio",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Lo que funcionó, qué ajustar, metodologías, resúmenes...",
 "O que já foi guardado continua nos lançamentos como investimento.": "Lo que ya se ahorró sigue en los movimientos como inversión.",
 "O que levar ou estudar": "Qué llevar o estudiar",
 "O que o app pode usar": "Qué puede usar la app",
 "O que o médico disse": "Qué dijo el médico",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Lo que enviaron tus grupos. Las citas aceptadas van a My Planner; los materiales y avisos van a Notas.",
 "O que precisa": "Qué se necesita",
 "O que tem dentro": "Qué hay dentro",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Lo que prestaste o te prestaron: foto, quién lo tiene y aviso de devolución.",
 "O que é apagado": "Qué se borra",
 "O quê": "Qué",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "El selector muestra Google Drive, OneDrive y Dropbox cuando esas apps están instaladas en el celular. La app guarda solo el acceso directo: el archivo sigue donde está y se abre en la app del celular.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "El selector muestra Google Drive, OneDrive y Dropbox cuando esas apps están instaladas en el móvil. El archivo elegido se guarda en este dispositivo.",
 "O servidor ainda não buscou para os seus perfis.": "El servidor aún no buscó para tus perfiles.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "El servidor aún no está preparado para los mensajes. Ejecuta 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "El servidor todavía no está preparado para recomendaciones. Inténtalo más tarde.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "El servidor aún no está preparado para la tarjeta de contacto. Ejecuta 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "El servidor aún no está preparado para datos compartidos. En la computadora, abre la carpeta C:\\MyPlanner y haz doble clic en 15-LIGAR-GRUPOS-COLABORATIVOS.bat (solo una vez).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "El servidor aún no está preparado para Drive y OneDrive (consulta COMO RODAR, versión 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "El servidor aún no está preparado para el acceso web (ejecuta supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "El servidor aún no tiene la función \"qr-login\". Consulta el paso de la versión 0.6 en COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "El servidor de llamadas rechazó la clave de LiveKit. En el ordenador del administrador, ejecuta 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "El servidor de facturas respondió algo inesperado (HTTP {s}). Revisa la dirección.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "El servidor hace la captura automática cada 2 horas, de 08:00 a 20:00 (hora de Brasilia), incluso con la app cerrada. Las publicaciones capturadas aparecen cuando abres la app. También puedes usar \"Verificar ahora\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "El servidor hace la captura automática todos los días a las 08:00 y 12:00 (hora de Brasilia), incluso con la app cerrada. Las publicaciones capturadas aparecen cuando abres la app. También puedes usar \"Verificar ahora\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "El servidor rechazó el acceso: en la función \"nuvem\" de Supabase, desactiva \"Verify JWT\" (32-LIGAR-DRIVE-ONEDRIVE.bat ya lo hace).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "El servidor rechazó el acceso: en la función \"nuvem\" de Supabase, desactiva \"Verify JWT\" (9-LIGAR-DRIVE-ONEDRIVE.bat ya lo hace).",
 "O seu papel no grupo não permite incluir aqui.": "Tu rol en el grupo no permite agregar aquí.",
 "O site deve começar com https://": "El sitio debe empezar con https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "El tamaño predeterminado del vaso ({copo}) se cambia en Ajustar, en el cuadro del agua.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "El tema cambia los colores de las pestañas (los iconos siguen siendo los mismos) y vale en los modos claro y oscuro. Después aún puedes cambiar el color de una pestaña en Ajustes > Pestañas.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "El temporizador se llena de color a medida que pasa el tiempo de la tarea. Al tocarlo se abre el vínculo de la tarea.",
 "O teste grátis terminou": "La prueba gratis terminó",
 "O texto": "El texto",
 "O texto do PDF num arquivo .docx para editar.": "El texto del PDF en un archivo .docx para editar.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "El texto también va oculto dentro del PDF: puedes buscarlo y copiarlo en el lector de PDF.",
 "O tom escolhido fica para os próximos emojis.": "El tono elegido se mantiene para los próximos emojis.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "El total aparece arriba en My Planner. Si pasa del límite, el rayo se pone rojo. Las tareas \"Relajarse\" valen 0.",
 "OAB (opcional, para advogados)": "OAB (opcional, para abogados)",
 "OBS": "OBS.",
 "OCR: texto pesquisável": "OCR: texto buscable",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "O ELEGIR HABITACIÓN…",
 "Objetivos": "Objetivos",
 "Objeto": "Objeto",
 "Objetos": "Objetos",
 "Objetos e valores": "Objetos y valores",
 "Obra": "Obra",
 "Obras": "Obras",
 "Obras & Reformas": "Obras & Reformas",
 "Obrigado": "Gracias",
 "Obrigado!": "¡Gracias!",
 "Observações": "Observaciones",
 "Observações (alergias, ração...)": "Observaciones (alergias, pienso...)",
 "Observações (chave Pix, conta para depósito...)": "Observaciones (clave Pix, cuenta para depósito...)",
 "Observações (código de barras, chave Pix...)": "Observaciones (código de barras, clave Pix...)",
 "Observações (dados bancários, PIX...)": "Observaciones (datos bancarios, PIX...)",
 "Observações (estado do item...)": "Observaciones (estado del artículo...)",
 "Observações (garantia, seguro, CET...)": "Observaciones (garantía, seguro, CFT...)",
 "Observações (nº de série, modelo...)": "Observaciones (n.º de serie, modelo...)",
 "Observações (onde está o original, categoria da CNH...)": "Observaciones (dónde está el original, categoría de la licencia...)",
 "Observações (recibo de entrega, número...)": "Observaciones (albarán, número...)",
 "Observações (restrição alimentar...)": "Observaciones (restricción alimentaria...)",
 "Ocultar texto (tarja)": "Ocultar texto (franja)",
 "Ocupado": "Ocupado",
 "Oficina": "Taller",
 "Ofício": "Oficio",
 "Oi!": "¡Hola!",
 "Oi! Tudo certo para sábado?": "¡Hola! ¿Todo listo para el sábado?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "¡Hola, {pessoa}! Todavía tengo el/la {coisa} que me prestaste. ¿Cuándo te viene bien que te lo devuelva?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "¡Hola, {pessoa}! ¿Qué tal? Te escribo para recordarte el/la {coisa} que te presté el {data}. ¿Puedes devolverlo {quando}?",
 "Oi?!": "¿¡Qué?!",
 "Olá!": "¡Hola!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "¡Hola! Soy el Mestre Achado. Pregúntame por tus gastos, cuentas, tarjetas y metas: respondo con tus números.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "¡Hola! Te recuerdo el pago de {ref} ({v}), con vencimiento el {d}. ¡Gracias!",
 "Olá! Preciso de assistência técnica para: {item}": "¡Hola! Necesito asistencia técnica para: {item}",
 "Olá, {nome}!": "¡Hola, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "¡Hola, {nome}! Bienvenido(a).",
 "Ombros: girar para trás": "Hombros: girar hacia atrás",
 "Omelete": "Tortilla francesa",
 "Onde": "Dónde",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Dónde ayuda la IA: Publicaciones (audiencias y plazos), Documentos (completar la ficha con la foto) y Notas (convertir una tarjeta en tareas).",
 "Onde assistir": "Dónde verlo",
 "Onde eu mais gastei este mês?": "¿En qué gasté más este mes?",
 "Onde fica": "Dónde está",
 "Onde guardar fotos e arquivos novos": "Dónde guardar fotos y archivos nuevos",
 "Onde na página": "Dónde en la página",
 "Ontem": "Ayer",
 "Organizar": "Organizar",
 "Organizar barra": "Organizar barra",
 "Organizar com IA": "Organizar con IA",
 "Organizar com IA (vira tarefas)": "Organizar con IA (se vuelve tareas)",
 "Organizar páginas": "Organizar páginas",
 "Orgulho e vibrante": "Orgullo y vibrante",
 "Origem": "Origen",
 "Origem da reserva": "Origen de la reserva",
 "Original": "Original",
 "Orquídeas": "Orquídeas",
 "Orçado": "Presupuestado",
 "Orçamento": "Presupuesto",
 "Orçamento do mês": "Presupuesto del mes",
 "Orçamento por categoria": "Presupuesto por categoría",
 "Orçamento total": "Presupuesto total",
 "Orçamento: {v}": "Presupuesto: {v}",
 "Os alertas precisam de um horário.": "Las alertas necesitan un horario.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Los adjuntos que quedan solo en el dispositivo no aparecen en los demás y se pierden si cambias de celular. Activa Google Drive u OneDrive en Ajustes para guardar una copia.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Los archivos y copias que ya están allí se quedan. My Planner solo deja de guardar cosas nuevas.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Los archivos guardados en este dispositivo también se borrarán.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Los archivos de tu Google Drive, OneDrive o del celular siguen contigo. Los registros que la ley obliga a guardar (como los de acceso) pueden conservarse durante el plazo legal y luego se borran.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Los avisos del grupo aún no se activaron en el servidor. En la computadora, haz doble clic en 15-LIGAR-GRUPOS-COLABORATIVOS.bat (solo una vez).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Los avisos están desactivados para My Planner. Toca Abrir ajustes y activa las notificaciones.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Los avisos en el móvil funcionan en la app instalada (Android o iPhone).",
 "Os campos do formulário viram parte da página.": "Los campos del formulario pasan a formar parte de la página.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Los datos actuales se reemplazarán por los del archivo, aquí y en la nube.",
 "Os dados continuam salvos na nuvem.": "Los datos siguen guardados en la nube.",
 "Os dados da aba ainda são só seus": "Los datos de la pestaña todavía son solo tuyos",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Los datos de la pestaña {aba} pasan a ser visibles para el equipo, cada persona según el rol que elijas.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Los datos de este grupo aún no se han liberado. Pide a quien creó el grupo que abra My Planner actualizado: la app los libera sola.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Los datos de este grupo aún no se han liberado. Pide a quien creó el grupo que actualice My Planner y abra el grupo: allí aparece el botón para liberar.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Los datos de la caja fuerte se cifran aquí en el dispositivo (AES-256) antes de ir a la nube. Ni el soporte puede leerlos. Si olvidas la contraseña de la caja fuerte, estos datos no se pueden recuperar.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Los datos se guardan mientras exista la cuenta. Al borrar la cuenta, los datos se eliminan, salvo lo que la ley obligue a conservar.",
 "Os desenhos não conferem. Comece de novo.": "Los patrones no coinciden. Empieza de nuevo.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Los días están en la app o en el estado de cuenta del banco. Las compras hechas después del cierre van al siguiente estado de cuenta.",
 "Os emojis que você usar aparecem aqui.": "Los emojis que uses aparecen aquí.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Los grupos aún no se activaron en el servidor. En la computadora, abre la carpeta C:\\MyPlanner y haz doble clic en 11-LIGAR-GRUPOS.bat (solo una vez).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Los grupos aún no se activaron en el servidor. Ejecuta supabase\\migracao-0.21.sql en Supabase (ver COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Los lugares se abren en Google Maps, Waze o Mapas, según lo elegido en Ajustes.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Los miembros siempre ven a los administradores y solo reciben lo que se les envió.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Los demás miembros dejan de ver los datos (la copia desaparece de sus dispositivos). Todo sigue contigo.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Los perfiles y los resultados quedan en tu cuenta de My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Los perfiles, las OAB y los tribunales están dentro de la pestaña Publicaciones. La búsqueda automática se ejecuta en el servidor a las 08:00 y a las 12:00 (hora de Brasilia).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Los precios se guardan y aparecen en la lista de Compras de la pestaña Alimentación & Despensa como el precio de la última compra.",
 "Os resultados deste perfil também serão apagados.": "Los resultados de este perfil también se borrarán.",
 "Os termos foram atualizados": "Los términos se actualizaron",
 "Ou digite (ex.: 2 ovos mexidos)": "O escribe (ej.: 2 huevos revueltos)",
 "Ou escreva o prato": "O escribe el plato",
 "Ou escreva o seu": "O escribe el tuyo",
 "Outra": "Otra",
 "Outra aba…": "Otra pestaña…",
 "Outra atividade (digite e dê Enter)": "Otra actividad (escribe y pulsa Enter)",
 "Outro": "Otro",
 "Outro (ml)": "Otro (ml)",
 "Outro valor": "Otro importe",
 "Outros": "Otros",
 "Outros países": "Otros países",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Otros relojes (Garmin, Samsung, Xiaomi, Amazfit...): en la app del reloj, activa la opción de enviar los datos a la app Salud (Apple Salud).",
 "Ovo": "Huevo",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "PAGADO, RECIBIDO, CONFIDENCIAL, APROBADO o tu texto, con la fecha.",
 "PARA ACERTAR": "POR AJUSTAR",
 "PARA QUEM": "PARA QUIÉN",
 "PARA {refeicao}": "PARA {refeicao}",
 "PASSO A PASSO": "PASO A PASO",
 "PASSO {n}": "PASO {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF con texto digital: sale al instante en el navegador. PDF escaneado (foto): tu IA lee cada página.",
 "PDF grande": "PDF grande",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF guardado en la carpeta \"{pasta}\" del celular.",
 "PDF guardado no {nome}.": "PDF guardado en {nome}.",
 "PDF numa página só": "PDF en una sola página",
 "PDF para Word": "PDF a Word",
 "PDF para imagens": "PDF a imágenes",
 "PDF para texto": "PDF a texto",
 "PDFs arquivados ({n})": "PDFs archivados ({n})",
 "PDFs juntados {data}": "PDFs unidos {data}",
 "PEDIDOS RECEBIDOS": "SOLICITUDES RECIBIDAS",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPIA Y PEGA",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "PRÓXIMOS ESTADOS DE CUENTA (YA COMPROMETIDO)",
 "Paciente": "Paciente",
 "Paciente ou aluno": "Paciente o alumno",
 "Pacientes": "Pacientes",
 "Padrão": "Predeterminado",
 "Padrão da aba": "Predeterminado de la pestaña",
 "Paga": "Pagada",
 "Paga (toque para desfazer)": "Pagada (toca para deshacer)",
 "Pagador": "Pagador",
 "Pagamento já contado": "Pago ya contado",
 "Pagar": "Pagar",
 "Pagar parcela {n}/{t} · {c}": "Pagar cuota {n}/{t} · {c}",
 "Pagas": "Pagadas",
 "Pago": "Pagado",
 "Pago com": "Pagado con",
 "Pago: {p} · Falta pagar: {f}": "Pagado: {p} · Falta pagar: {f}",
 "Pagos": "Pagados",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "¿Pagaste {v}? Si tuviste descuento, multa o intereses, indica el importe pagado. ¿Quieres guardar el comprobante ahora?",
 "Paguei outro valor (desconto, multa ou juros)": "Pagué otro importe (descuento, multa o intereses)",
 "Paixão de Cristo": "Viernes Santo",
 "Palavras-chave (separe com vírgula)": "Palabras clave (separa con comas)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Para que la meta \"{m}\" llegue a tiempo, serían {v} al mes. Conviene alargar el plazo o empezar con un importe menor.",
 "Para clareza, firmo o presente.": "Para que conste, firmo la presente.",
 "Para comprar": "Para comprar",
 "Para continuar, digite a senha do app.": "Para continuar, escribe la contraseña de la app.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Para conversar, activa tu IA en Ajustes › Inteligencia artificial (Claude, ChatGPT o Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Para dividir los gastos, escribe en \"Quién va\" los nombres separados por comas (edita el viaje).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Para emitir y buscar facturas, enciende una vez el servidor de facturas: en el ordenador, haz doble clic en 13-LIGAR-NOTAS.bat y pega aquí la dirección que muestre (termina en .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Para ejercer tus derechos, usa Contáctanos en la app o escribe al correo de abajo. Respondemos en un plazo de 15 días.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Para hacer llamadas de audio y video, instala la nueva versión de la app (0.35). Los mensajes ya funcionan.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Para que la app funcione: guardar y sincronizar tus datos entre dispositivos, enviar alertas, compartir con los grupos que elegiste y dar soporte.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Para guardar los PDF en {nome}, conecta tu cuenta en Ajustes › Google Drive y OneDrive.",
 "Para hoje": "Para hoy",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Para leer una foto o PDF, activa tu IA en Ajustes › Inteligencia artificial (Claude, ChatGPT o Gemini). El extracto en OFX o CSV funciona sin IA.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Para leer el reloj automáticamente, instala la nueva versión de la app (0.33). Mientras tanto, puedes introducir los datos a mano.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Para leer el reloj, conéctalo desde la app en el móvil. Los números también aparecen aquí.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Para leer el reloj, permite que My Planner acceda a los datos de actividad.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Para leer el texto, resumir y preguntar, activa tu IA en Ajustes › Inteligencia artificial (Claude, ChatGPT o Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Para activarla, usa la app en el móvil (Ajustes > Google Calendar). Después, todo aparecerá aquí también.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Para activarla, usa la app en el móvil (Ajustes › Configuración general › Google Calendar). Después, todo aparecerá aquí también.",
 "Para monitorar a OAB, informe o número e a UF.": "Para monitorear la OAB, indica el número y el estado (UF).",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Para no preguntar más, elige la app en Ajustes › Configuración general.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Para profesionales de la salud: pacientes, evolución en la caja fuerte, prescripciones con plantillas, finanzas, recibo y declaración para reembolso en PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Para profesionales de la salud: pacientes, evolución, prescripciones con plantillas, finanzas con seguro médico, recibo y declaración para reembolso.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Para proteger tu cuenta, confirmamos tu celular una vez, con un código por WhatsApp. Solo se vuelve a pedir si cambias de número.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Para quien alquila el inmueble o una habitación por temporada (Airbnb, Booking o directo): reservas, limpieza, gastos y la ganancia de cada mes.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Para recibir la agenda, el lugar y los avisos del evento en el móvil, entra al grupo: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Para sincronizar, permite que My Planner acceda al calendario en los ajustes del móvil.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Para quitar un permiso que ya diste al sistema (cámara, fotos, micrófono), usa también los ajustes del móvil.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Para una lectura más completa, activa tu IA en Ajustes › Inteligencia artificial.",
 "Parabéns": "Felicidades",
 "Parabéns!": "¡Felicidades!",
 "Parada": "Quieto",
 "Parar": "Detener",
 "Parar de compartilhar?": "¿Dejar de compartir?",
 "Parar e salvar": "Detener y guardar",
 "Parar gravação": "Detener grabación",
 "Parcela": "Cuota",
 "Parcela de financiamento": "Cuota de financiamiento",
 "Parcela {n}/{t}": "Cuota {n}/{t}",
 "Parcela {n}/{t} · {c}": "Cuota {n}/{t} · {c}",
 "Parcelas": "Cuotas",
 "Parcelas a pagar nos próximos meses": "Cuotas por pagar en los próximos meses",
 "Parcelas recalculadas": "Cuotas recalculadas",
 "Parece que foi impresso e escaneado.": "Parece impreso y escaneado.",
 "Parei": "Lo dejé",
 "Parei na aula": "Me quedé en la clase",
 "Parei na aula...": "Me quedé en la clase...",
 "Pares de meia": "Pares de calcetines",
 "Parque ou natureza": "Parque o naturaleza",
 "Parques": "Parques",
 "Parte": "Parte",
 "Partes": "Partes",
 "Participa": "Participa",
 "Participantes": "Participantes",
 "Participação em empresa": "Participación en empresa",
 "Passa do limite do MEI: fale com seu contador.": "Supera el límite del MEI: habla con tu contador.",
 "Passaporte": "Pasaporte",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Pasa el dedo sobre el dibujo para borrar solo esa parte.",
 "Passeio": "Excursión",
 "Passeios": "Excursiones",
 "Passo a passo": "Paso a paso",
 "Passos": "Pasos",
 "Passos, exercício, calorias, batimentos e sono": "Pasos, ejercicio, calorías, pulsaciones y sueño",
 "Passou do orçamento": "Pasaste el presupuesto",
 "Passou do orçamento em {v}": "Superó el presupuesto en {v}",
 "Pasta": "Carpeta",
 "Patrimônio": "Patrimonio",
 "Patrimônio & Imposto de Renda": "Patrimonio & Impuesto sobre la Renta",
 "Patrimônio pelo valor de compra: {v}": "Patrimonio por valor de compra: {v}",
 "Pausa (s)": "Descanso (s)",
 "Pausa de {m} min": "Pausa de {m} min",
 "Pausado": "En pausa",
 "Pausar": "Pausar",
 "Pausas": "Pausas",
 "Pausas de estudo": "Pausas de estudio",
 "Pauta (opcional)": "Temas (opcional)",
 "Paz": "Paz",
 "Pediatra": "Pediatra",
 "Pedido": "Solicitud",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Solicitud enviada a {nome}. Cuando la acepte, ya podrán chatear.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Solicitud enviada. Cuando la persona la acepte, ya podrán chatear.",
 "Pedidos de documentos": "Solicitudes de documentos",
 "Pedir de novo depois de": "Volver a pedir después de",
 "Peguei emprestado": "Me prestaron",
 "Peito de frango": "Pechuga de pollo",
 "Peixe": "Pez",
 "Pela última compra: cerca de {v}": "Según la última compra: unos {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Con las cuentas que aún vencen este mes, te faltarán {v}. Mira qué puedes aplazar o recortar antes de asumir un gasto nuevo.",
 "Pendente": "Pendiente",
 "Pensão alimentícia": "Pensión alimenticia",
 "Pequena": "Pequeña",
 "Pequeno": "Pequeño",
 "Percentual de tributos do Simples (para sair na nota)": "Porcentaje de tributos del Simples (para que salga en la factura)",
 "Perguntar ao Mestre": "Preguntar al Mestre",
 "Perguntar sempre": "Preguntar siempre",
 "Pergunte ao Mestre...": "Pregunta al Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Pregunta sobre el documento (ej.: ¿cuál es el plazo?)",
 "Permissões": "Permisos",
 "Personalizado": "Personalizado",
 "Perto do limite do orçamento": "Cerca del límite del presupuesto",
 "Período": "Período",
 "Período da meta": "Período de la meta",
 "Pescoço: inclinar para os lados": "Cuello: inclinar hacia los lados",
 "Peso": "Peso",
 "Peso na média": "Peso en la media",
 "Pesquisar no mapa": "Buscar en el mapa",
 "Pessoa": "Persona",
 "Pessoa de contato": "Persona de contacto",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Las personas de tus grupos solo ven lo que se comparte en el grupo.",
 "Pet": "Mascota",
 "Pet & Família": "Mascotas & Familia",
 "Pet shop": "Peluquería canina",
 "Pet shop ou clínica": "Peluquería o clínica",
 "Pets": "Mascotas",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Pide documentos al cliente con plazo. Él recibe la solicitud, adjunta y marca como entregado.",
 "Pijamas": "Pijamas",
 "Pilates": "Pilates",
 "Pintura": "Pintura",
 "Pix copia e cola": "Pix copia y pega",
 "Placa": "Matrícula",
 "Planejado": "Planeado",
 "Planejado e comido": "Planeado y comido",
 "Planilha": "Hoja de cálculo",
 "Planilha (Excel)": "Hoja de cálculo (Excel)",
 "Planilha do mês para o Receita Saúde": "Planilla del mes para Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Plan básico: My Planner + Notas",
 "Plano de aula": "Plan de clase",
 "Plano de saúde": "Seguro médico",
 "Planos de aula": "Planes de clase",
 "Planta": "Planta",
 "Plantas": "Plantas",
 "Plantas & Jardim": "Plantas & Jardín",
 "Plataforma ou escola": "Plataforma o escuela",
 "Pneus novos": "Neumáticos nuevos",
 "Podcast": "Pódcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "¿Puedes confirmar tu asistencia respondiendo a este mensaje?",
 "Polichinelo": "Saltos de tijera",
 "Polo ativo": "Parte actora",
 "Polo passivo": "Parte demandada",
 "Política de privacidade (LGPD)": "Política de privacidad (LGPD)",
 "Política de privacidade, LGPD e permissões": "Política de privacidad, LGPD y permisos",
 "Política de privacidade, LGPD e termos": "Política de privacidad, LGPD y términos",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Pon aquí las fotos y los videos del viaje. En el grupo, todos los ven y todos pueden subir los suyos.",
 "Ponte de glúteos": "Puente de glúteos",
 "Ponto facultativo": "Día no laborable opcional",
 "Ponto facultativo: {nome}": "Día no laborable opcional: {nome}",
 "Ponto turístico": "Atracción turística",
 "Pontos turísticos": "Atracciones turísticas",
 "Por dia": "Por día",
 "Por faixas": "Por rangos",
 "Por mês": "Por mes",
 "Por nome": "Por nombre",
 "Por semana": "Por semana",
 "Portal": "Portal",
 "Portal do Cliente": "Portal del Cliente",
 "Portal do cliente (convidar o cliente)": "Portal del cliente (invitar al cliente)",
 "Português": "Portugués",
 "Porão": "Sótano",
 "Porções": "Raciones",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Poco espacio libre: las fotos y adjuntos nuevos podrían no guardarse. Libera espacio o guarda los adjuntos en Google Drive u OneDrive.",
 "Praia": "Playa",
 "Prancha": "Plancha",
 "Prato do cardápio": "Plato del menú",
 "Prato principal": "Plato principal",
 "Prazo": "Plazo",
 "Prazo (pagamento ou entrega)": "Plazo (pago o entrega)",
 "Prazo até {fim} · fazer em {dia}": "Plazo hasta {fim} · hacer el {dia}",
 "Prazo final: {fim}": "Plazo final: {fim}",
 "Prazo: {d}": "Plazo: {d}",
 "Prazo: {t}": "Plazo: {t}",
 "Prazos criados": "Plazos creados",
 "Precisa da sua IA": "Necesita tu IA",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Completa la descripción, el código de tributación nacional (6 números) y el valor.",
 "Preenche os campos do PDF e, se quiser, trava.": "Rellena los campos del PDF y, si quieres, los bloquea.",
 "Preencher formulário": "Rellenar formulario",
 "Preencher pela foto com a minha IA": "Completar con la foto usando mi IA",
 "Preencher pela nota fiscal com a minha IA": "Completar con la factura usando mi IA",
 "Preparando a conversa da equipe...": "Preparando la conversación del equipo...",
 "Preparando a página {n} de {total}...": "Preparando la página {n} de {total}...",
 "Preparando o arquivo": "Preparando el archivo",
 "Prescrição, conduta e orientações": "Prescripción, conducta e indicaciones",
 "Presente": "Presente",
 "Presença": "Asistencia",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Mantén pulsado el código para copiarlo, o toca Enviar y elige \"Copiar\".",
 "Pressione e segure o código para copiar.": "Mantén pulsado el código para copiarlo.",
 "Pressione e segure um lançamento para apagar.": "Mantén pulsado un movimiento para borrarlo.",
 "Pressione e segure um perfil para removê-lo.": "Mantén presionado un perfil para quitarlo.",
 "Preto e branco": "Blanco y negro",
 "Previdência privada": "Plan de pensiones",
 "Preço ou ingresso": "Precio o entrada",
 "Price": "Sistema francés (cuota fija)",
 "Primeira": "Primera",
 "Primeira cota ou cota única do IR": "Primera cuota o cuota única del IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Primera cuota en el estado de cuenta de {mes}, que vence el {data}.",
 "Prioridade": "Prioridad",
 "Privacidade": "Privacidad",
 "Privacidade e termos": "Privacidad y términos",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Privacidad: el texto o la imagen analizada va directo de este dispositivo a la empresa de la IA elegida, con tu clave. My Planner no guarda copia.",
 "Problema": "Problema",
 "Problemas, erros e sugestões": "Problemas, errores y sugerencias",
 "Procedimento": "Procedimiento",
 "Procedimento: {c}": "Procedimiento: {c}",
 "Processo": "Proceso",
 "Processo Civil": "Derecho Procesal Civil",
 "Processo Penal": "Derecho Procesal Penal",
 "Processo do Trabalho": "Derecho Procesal Laboral",
 "Processo não informado": "Proceso no informado",
 "Proclamação da República": "Proclamación de la República",
 "Procurando a folha...": "Buscando la hoja...",
 "Procurando atualização...": "Buscando actualización...",
 "Procurar aba": "Buscar pestaña",
 "Procurar atualização agora": "Buscar actualización ahora",
 "Procurar documento": "Buscar documento",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Buscar herramienta (ej.: unir, firmar, comprimir)",
 "Produto": "Producto",
 "Produto (ex.: Geladeira)": "Producto (ej.: Refrigerador)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Productos, facturas, servicio técnico y aviso antes del vencimiento.",
 "Produção (vale de verdade)": "Producción (válida de verdad)",
 "Produção restrita (teste)": "Producción restringida (prueba)",
 "Produção restrita (teste, não vale)": "Producción restringida (prueba, no válida)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Producción restringida: entorno de prueba del gobierno. Las facturas no valen. Prueba todo aquí antes de cambiar a Producción (en Editar).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Producción: las facturas emitidas valen de verdad y van a la municipalidad y a la Receita Federal.",
 "Produção: vale de verdade": "Producción: válida de verdad",
 "Professor": "Profesor",
 "Professor & Mentoria": "Profesor y Mentoría",
 "Professor(a)": "Profesor(a)",
 "Profissionais": "Profesionales",
 "Profissional": "Profesional",
 "Profissional assistente": "Profesional asistente",
 "Profissional ou fornecedor": "Profesional o proveedor",
 "Profissional ou local": "Profesional o lugar",
 "Profissão ou especialidade": "Profesión o especialidad",
 "Profissões": "Profesiones",
 "Programação": "Programación",
 "Progresso geral": "Progreso general",
 "Projeto e licenças": "Proyecto y licencias",
 "Projetos": "Proyectos",
 "Prontas": "Listos",
 "Pronto": "Listo",
 "Pronto! Todas as abas estão liberadas até {data}.": "¡Listo! Todas las pestañas están desbloqueadas hasta el {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Listo. Bloquea la pantalla y espera 1 minuto: el aviso debe aparecer con sonido.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Historia clínica, evolución y recetas, sin la parte financiera.",
 "Protegendo a chave...": "Protegiendo la clave...",
 "Proteger no cofre": "Proteger en la caja fuerte",
 "Protegido": "Protegido",
 "Protegido no cofre": "Protegido en la caja fuerte",
 "Protegidos pelo cofre: {n}": "Protegidos por la caja fuerte: {n}",
 "Protetor solar": "Protector solar",
 "Protocolo": "N.º de solicitud",
 "Prova": "Examen",
 "Próxima": "Próxima",
 "Próxima até a data": "Próxima antes de la fecha",
 "Próxima com quantos km": "Próxima a los km",
 "Próxima dose": "Próxima dosis",
 "Próxima: {data}": "Próxima: {data}",
 "Próxima: {d} · {v}": "Próxima: {d} · {v}",
 "Próximas": "Próximas",
 "Próximo": "Siguiente",
 "Próximo ano": "Año siguiente",
 "Próximo número da DPS": "Próximo número de la DPS",
 "Próximos 7 dias": "Próximos 7 días",
 "Próximos vencimentos ({n})": "Próximos vencimientos ({n})",
 "Publicação": "Publicación",
 "Publicações": "Publicaciones",
 "Pula": "Salta",
 "Pulsa": "Late",
 "Punho": "Puño",
 "Puxada frontal": "Jalón al pecho",
 "PÁGINAS": "PÁGINAS",
 "PÔR NA BARRA": "PONER EN LA BARRA",
 "Pág. {n}": "Pág. {n}",
 "Página": "Página",
 "Página 1": "Página 1",
 "Página 1 de 10": "Página 1 de 10",
 "Página em branco no fim": "Página en blanco al final",
 "Página em que estou": "Página en la que voy",
 "Página escaneada": "Página escaneada",
 "Página inteira": "Página entera",
 "Página {a} de {n}": "Página {a} de {n}",
 "Página {n}": "Página {n}",
 "Página {n} de {total}": "Página {n} de {total}",
 "Página: {titulo}": "Página: {titulo}",
 "Páginas": "Páginas",
 "Páginas, tamanho, autor, datas e campos.": "Páginas, tamaño, autor, fechas y campos.",
 "Pássaro": "Pájaro",
 "Pão francês": "Pan francés (panecillo)",
 "Pão integral": "Pan integral",
 "Pôr a data de hoje": "Poner la fecha de hoy",
 "Pôr as parcelas no My Planner": "Poner las cuotas en My Planner",
 "Pôr na barra": "Poner en la barra",
 "Pôr no roteiro da viagem": "Añadir al itinerario del viaje",
 "Pôr uma foto": "Poner una foto",
 "Quadro": "Tablero",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Tablero Kanban, cronómetro de horas por cliente y plazos en My Planner.",
 "Quais contas vencem nos próximos dias?": "¿Qué cuentas vencen en los próximos días?",
 "Quais páginas ficam no PDF novo": "Qué páginas quedan en el PDF nuevo",
 "Quais páginas sair": "Qué páginas quitar",
 "Qual IA": "Qué IA",
 "Qualidade alta": "Calidad alta",
 "Qualidade boa (menor)": "Calidad buena (más pequeño)",
 "Quantidade": "Cantidad",
 "Quanto cortar de cada lado (% da página)": "Cuánto recortar de cada lado (% de la página)",
 "Quanto já tem guardado (opcional)": "Cuánto tienes ahorrado (opcional)",
 "Quanto paga por limpeza": "Cuánto paga por limpieza",
 "Quanto preciso guardar por mês para as minhas metas?": "¿Cuánto necesito ahorrar al mes para mis metas?",
 "Quanto quer juntar": "Cuánto quieres juntar",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Cuánto quieres gastar, como máximo, en cada categoría al mes. Déjalo en blanco para no controlarla.",
 "Quarta": "Miércoles",
 "Quarta-feira de Cinzas (até 14h)": "Miércoles de Ceniza (hasta las 14 h)",
 "Quarto": "Dormitorio",
 "Quarto das crianças": "Habitación de los niños",
 "Quarto de casal": "Dormitorio principal",
 "Quarto de hóspedes": "Cuarto de huéspedes",
 "Quarto infantil": "Cuarto infantil",
 "Queijo": "Queso",
 "Queixa principal": "Motivo de consulta",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Quien abra el enlace descarga My Planner (o lo usa en el navegador), inicia sesión y pasa a formar parte del grupo.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Quien cree su cuenta con tu código ya será tu amigo aquí, sin necesidad de solicitud.",
 "Quem enviou": "Quién lo envió",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Quien está en un grupo de la app contigo (clase, familia, viaje...) ya puede chatear sin ser amigo. Mantén pulsado un amigo para eliminar la amistad o bloquearlo.",
 "Quem faz a limpeza": "Quién hace la limpieza",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Quién paga, si no es el paciente (madre, padre, responsable)",
 "Quem pagou": "Quién pagó",
 "Quem recebeu (médico, escola...)": "Quién lo recibió (médico, escuela...)",
 "Quem vai": "Quién va",
 "Quem vai limpar": "Quién va a limpiar",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Quién la ve: solo quienes chatean contigo, tus amigos y quienes están en un grupo de la app contigo. Deja en blanco lo que no quieras mostrar.",
 "Quente": "Calor",
 "Quer escanear mais uma página?": "¿Quieres escanear otra página?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "¿Quieres guardar el comprobante ahora? Foto, PDF o captura del Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "¿Quieres mandar una captura de pantalla? Envíala por correo y adjunta la imagen.",
 "Quer trocar pelos novos ou manter os dois?": "¿Quieres cambiarlos por los nuevos o mantener ambos?",
 "Quero assistir": "Quiero ver",
 "Quero ir": "Quiero ir",
 "Quero ler": "Quiero leer",
 "Quero ver": "Quiero ver",
 "Quilometragem atual": "Kilometraje actual",
 "Quilometragem: {km}": "Kilometraje: {km}",
 "Quinta": "Jueves",
 "Quintal": "Patio",
 "Quitado": "Liquidado",
 "Quitados": "Liquidados",
 "Química": "Química",
 "RECIBO": "RECIBO",
 "RG / Carteira de identidade": "Documento de identidad (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Identificación, licencia de conducir, pasaporte, contratos y certificados, con aviso antes de vencer y envío con un toque.",
 "Raciocínio Lógico": "Razonamiento Lógico",
 "Razão social ou nome": "Razón social o nombre",
 "Razão social ou nome do consultório": "Razón social o nombre del consultorio",
 "Razão social ou nome fantasia": "Razón social o nombre comercial",
 "Raça": "Raza",
 "Realizado": "Realizado",
 "Recado": "Mensaje",
 "Recalcular": "Recalcular",
 "Recalcular as parcelas em aberto": "Recalcular las cuotas pendientes",
 "Recalcular as parcelas?": "¿Recalcular las cuotas?",
 "Receber": "Cobrar",
 "Receber de volta: {i} ({p})": "Recuperar: {i} ({p})",
 "Receber o código no WhatsApp": "Recibir el código por WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Cobrar cuota {n}/{t} · {c}",
 "Recebeu um convite?": "¿Recibiste una invitación?",
 "Recebeu um código?": "¿Recibiste un código?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Recibí de {pagador}{doc} la cantidad de {valor}{extenso}, por concepto de {tipo} realizado(a) el {data}{paciente}.",
 "Recebi outro valor": "Recibí otro importe",
 "Recebida": "Recibida",
 "Recebida (toque para desfazer)": "Cobrada (toca para deshacer)",
 "Recebidas": "Recibidas",
 "Recebido": "Recibido",
 "Recebido: {v}": "Recibido: {v}",
 "Recebidos": "Recibidos",
 "Recebidos dos grupos": "Recibidos de los grupos",
 "Recebimento": "Cobro",
 "Receita": "Receta",
 "Receitas": "Recetas",
 "Recibo": "Recibo",
 "Recibo em PDF": "Recibo en PDF",
 "Recibo emitido": "Recibo emitido",
 "Recibo guardado": "Recibo guardado",
 "Recibos dedutíveis": "Recibos deducibles",
 "Recomendada": "Recomendada",
 "Recomeçar": "Empezar de nuevo",
 "Recortar": "Recortar",
 "Recortar margens": "Recortar márgenes",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Recortar, girar y los filtros llegan con la app nueva (versión 0.49).",
 "Recusada": "Rechazada",
 "Recusado": "Rechazado",
 "Recusar": "Rechazar",
 "Redação": "Redacción",
 "Refazer": "Rehacer",
 "Refeição": "Comida",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Comidas, ejercicios, cuidados y suplementos previstos para hoy",
 "Referente a": "Concepto",
 "Referência": "Referencia",
 "Reforço": "Refuerzo",
 "Regar a cada quantos dias": "Regar cada cuántos días",
 "Regar hoje": "Regar hoy",
 "Regar: {p}": "Regar: {p}",
 "Regional": "Regional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Registra el diario, las etapas y las entregas, sin ver los importes.",
 "Registrar venda/serviço do MEI": "Registrar venta/servicio del MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Registra cada consulta: la evolución queda en la caja fuerte, cifrada. La prescripción puede venir de una plantilla.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Registra compras y ventas de inmuebles, vehículos e inversiones con los comprobantes. Ayuda mucho a la hora del impuesto.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Registra lo que fue distinto del cronograma (cambiaste un alimento, cambiaste la comida). Entra en el informe de la semana.",
 "Registro": "Registro",
 "Registro clínico": "Registro clínico",
 "Registro de horas": "Registro de horas",
 "Registro do diário": "Entrada del diario",
 "Regiões com feriado próprio (marque as suas):": "Regiones con feriado propio (marca las tuyas):",
 "Regras da casa": "Reglas de la casa",
 "Regras da casa:": "Reglas de la casa:",
 "Reguei": "Regué",
 "Reguei hoje": "Regué hoy",
 "Reiniciar": "Reiniciar",
 "Reiniciar o app": "Reiniciar la app",
 "Relatório": "Informe",
 "Relatório da semana": "Informe de la semana",
 "Relatório em PDF ou Excel": "Informe en PDF o Excel",
 "Relatório enviado. Obrigado!": "Informe enviado. ¡Gracias!",
 "Relatórios": "Informes",
 "Relatórios do Bem-Estar": "Informes de Bienestar",
 "Relatórios gerados ({n})": "Informes generados ({n})",
 "Relaxar": "Relajarse",
 "Religião": "Religión",
 "Relógio": "Reloj",
 "Relógio e apps de saúde": "Reloj y apps de salud",
 "Remada baixa": "Remo sentado en polea",
 "Remover": "Quitar",
 "Remover \"{nome}\"?": "¿Quitar \"{nome}\"?",
 "Remover anotações": "Quitar anotaciones",
 "Remover este bloco?": "¿Quitar este bloque?",
 "Remover páginas": "Quitar páginas",
 "Remover vínculo": "Quitar vínculo",
 "Remover {nome}?": "¿Quitar a {nome}?",
 "Remédio": "Medicamento",
 "Remédio contínuo": "Medicamento continuo",
 "Remédio na linha do tempo": "Medicamento en la línea de tiempo",
 "Remédios": "Medicamentos",
 "Remédios de uso contínuo": "Medicamentos de uso continuo",
 "Renavam ou chassi": "Renavam o número de bastidor",
 "Renegociado": "Renegociado",
 "Renomear": "Renombrar",
 "Renomear com IA": "Renombrar con IA",
 "Renomear ou trocar ícone": "Renombrar o cambiar ícono",
 "Renomear pasta": "Renombrar carpeta",
 "Renomear, ícone ou cor": "Renombrar, ícono o color",
 "Renovar: {nome}": "Renovar: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Reorganiza el archivo por dentro. Ayuda poco en PDFs con fotos.",
 "Reparar PDF": "Reparar PDF",
 "Repelente": "Repelente",
 "Repete": "Se repite",
 "Repetir a cada quantos dias": "Repetir cada cuántos días",
 "Repetições": "Repeticiones",
 "Repita a senha": "Repite la contraseña",
 "Repita a senha do cofre": "Repite la contraseña de la caja fuerte",
 "Repita a senha nova": "Repite la contraseña nueva",
 "Replantio": "Trasplante",
 "Replantios": "Trasplantes",
 "Repor papel higiênico, sabonete e café": "Reponer papel higiénico, jabón y café",
 "Representatividade": "Representatividad",
 "Reserva": "Reserva",
 "Reservas": "Reservas",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Reservas, limpieza, ingresos y gastos en la pestaña Alquiler y Hospedaje",
 "Respirar fundo 5 vezes": "Respirar hondo 5 veces",
 "Respondendo a {nome}": "Respondiendo a {nome}",
 "Responder": "Responder",
 "Responsável": "Responsable",
 "Responsável (imobiliária, vistoriador)": "Responsable (inmobiliaria, inspector)",
 "Resposta da SEFAZ": "Respuesta de la SEFAZ",
 "Resta {tempo}": "Queda {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Faltan {ml} = {n} vaso(s) de {copo}",
 "Restaurante": "Restaurante",
 "Restaurantes": "Restaurantes",
 "Restaurar": "Restaurar",
 "Restaurar esta cópia?": "¿Restaurar esta copia?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Restaurar reemplaza TODOS los datos actuales por los de la copia, aquí y en tu cuenta.",
 "Restaurar uma cópia": "Restaurar una copia",
 "Resultado": "Resultado",
 "Resultado nas vendas: {v}": "Resultado de las ventas: {v}",
 "Resumir": "Resumir",
 "Resumir e perguntar": "Resumir y preguntar",
 "Resumo": "Resumen",
 "Resumo (falta o XML completo)": "Resumen (falta el XML completo)",
 "Resumo da manhã": "Resumen de la mañana",
 "Resumo da pasta": "Resumen de la carpeta",
 "Resumo e opinião": "Resumen y opinión",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Resumen, gastos por categoría, cuentas, estados de cuenta, metas y todos los movimientos. Ideal para enviar al contador o guardar para el IR.",
 "Retirar": "Retirar",
 "Retirar da meta": "Retirar de la meta",
 "Retorno": "Revisión",
 "Reunião": "Reunión",
 "Reunião agora": "Reunión ahora",
 "Reunião de equipe": "Reunión de equipo",
 "Reuniões": "Reuniones",
 "Revestimento e pisos": "Revestimientos y suelos",
 "Revisão": "Revisión",
 "Revolução Constitucionalista": "Revolución Constitucionalista",
 "Rico em matéria orgânica": "Rico en materia orgánica",
 "Rodízio de pneus": "Rotación de neumáticos",
 "Roedor": "Roedor",
 "Romance": "Romance",
 "Rosca direta": "Curl de bíceps con barra",
 "Rota": "Ruta",
 "Rota passando pelos {n} lugares que faltam": "Ruta por los {n} lugares que faltan",
 "Rotas e mapas": "Rutas y mapas",
 "Roteiro": "Itinerario",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Itinerario diario que entra en la línea de tiempo durante el viaje, maleta según el clima, reservas y zonas horarias.",
 "Rotina": "Rutina",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Rutinas paso a paso: skincare, estiramiento, cabello... Toca \"+ Cuidado\" para elegir un modelo o crear el tuyo.",
 "Roupa": "Ropa",
 "Roupa social": "Ropa formal",
 "Roupas de banho": "Bañadores",
 "Roupas extras das crianças": "Ropa extra para los niños",
 "Roupas íntimas": "Ropa interior",
 "Rua": "Calle",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Calle, número, barrio, ciudad (o el nombre del lugar)",
 "Régua": "Regla",
 "Réptil": "Reptil",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Etiqueta (ej.: Mi nombre, Empresa del cliente)",
 "SAC": "Sistema alemán (amortización fija)",
 "SEM HORÁRIO": "SIN HORARIO",
 "SEU MÊS EM NÚMEROS": "TU MES EN NÚMEROS",
 "SEU TREINO": "TU ENTRENAMIENTO",
 "SEUS GRUPOS DO APP": "TUS GRUPOS DE LA APP",
 "SP": "SP",
 "SUBTAREFA": "SUBTAREA",
 "SUBTAREFAS": "SUBTAREAS",
 "SUPLEMENTAÇÃO": "SUPLEMENTACIÓN",
 "Sabonete facial": "Limpiador facial",
 "Sabão para lavar roupa": "Detergente para la ropa",
 "Sacada": "Balcón",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Solo sale de la lista de esta app. La copia guardada en Drive, en OneDrive o en la carpeta del celular sigue ahí.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Sale solo de la lista. El archivo sigue donde se guardó.",
 "Sair": "Salir",
 "Sair da conta?": "¿Cerrar sesión?",
 "Sair do escritório": "Salir de la oficina",
 "Sair do escritório?": "¿Salir de la oficina?",
 "Sair do grupo": "Salir del grupo",
 "Sair do grupo?": "¿Salir del grupo?",
 "Sair sem baixar": "Salir sin descargar",
 "Saiu": "Salió",
 "Sala": "Salón",
 "Sala de estar": "Sala de estar",
 "Sala de jantar": "Comedor",
 "Sala virtual": "Sala virtual",
 "Salada": "Ensalada",
 "Saldo": "Saldo",
 "Saldo depois desta parcela": "Saldo después de esta cuota",
 "Saldo devedor: {v}": "Saldo pendiente: {v}",
 "Saldo do mês": "Saldo del mes",
 "Salvar": "Guardar",
 "Salvar backup do My Planner": "Guardar copia de seguridad de My Planner",
 "Salvar cuidado": "Guardar cuidado",
 "Salvar cômodo": "Guardar habitación",
 "Salvar e colocar no My Planner": "Guardar y poner en My Planner",
 "Salvar e sincronizar": "Guardar y sincronizar",
 "Salvar e testar": "Guardar y probar",
 "Salvar endereço": "Guardar dirección",
 "Salvar no My Planner": "Guardar en My Planner",
 "Salvar refeição": "Guardar comida",
 "Salvar suplemento": "Guardar suplemento",
 "Salvar tarefa": "Guardar tarea",
 "Salvar treino": "Guardar entrenamiento",
 "Sanduíche natural": "Sándwich natural",
 "Santo Antônio": "San Antonio",
 "Sapato confortável": "Calzado cómodo",
 "Saudade": "Te extraño",
 "Saída (imóvel antigo)": "Salida (vivienda anterior)",
 "Saída de praia": "Pareo",
 "Saúde": "Salud",
 "Saúde & Prontuário": "Salud & Historial médico",
 "Saúde (médicos, dentistas, exames, plano)": "Salud (médicos, dentistas, pruebas, seguro médico)",
 "Saúde e bem-estar": "Salud y bienestar",
 "Scanner": "Escáner",
 "Scanner PDF": "Escáner PDF",
 "Sci-Fi": "Ciencia ficción",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Si algo no responde, reinicia la app. Tus datos están guardados.",
 "Se der tempo": "Si da tiempo",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Si esta política cambia de forma importante, la app te avisará y te pedirá que la aceptes de nuevo.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Si apareció este aviso, las alertas de los compromisos funcionan.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Si existe una cuenta con {email}, te enviamos un enlace para crear una contraseña nueva. Revisa también el spam.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Si la alerta se retrasa o no aparece: en los ajustes de la app, deja las notificaciones activadas, la batería \"Sin restricciones\" y permite \"Alarmas y recordatorios\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Si el reloj está conectado, sus números reemplazan a los introducidos a mano cuando tenga el dato.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Si conectas el reloj: totales diarios de pasos, distancia, calorías, ejercicio, pulsaciones y sueño, leídos de Health Connect (Android) o de la app Salud (iPhone). La app solo lee y nunca modifica estos datos.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Si ya usaste esta pestaña, no se borró nada: todo vuelve como estaba al suscribirte.",
 "Secretária ou recepção": "Secretaria o recepción",
 "Seg a sex": "Lun a vie",
 "Seguir": "Seguir",
 "Segunda": "Lunes",
 "Segurança": "Seguridad",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Mantén pulsado y arrastra para cambiar el orden. ↻ gira, ⧉ duplica y ✕ quita la página.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Mantén pulsado un GIF en un chat y toca \"Guardar\" para que aparezca aquí.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Mantén pulsada una habitación para cambiarla de lugar. Con la habitación abierta, mantén pulsada una tarea y suéltala en otra habitación para llevarla allí.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Mantén pulsada una carpeta, una materia o una página para cambiar el orden. Suelta una materia en otra carpeta para llevarla allí.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Mantén pulsado un chat para silenciarlo o archivarlo. Archivado sigue recibiendo y enviando, pero sin aviso.",
 "Seguro": "Seguro",
 "Seguro da casa": "Seguro del hogar",
 "Seguro viagem": "Seguro de viaje",
 "Selecionar": "Seleccionar",
 "Sem": "Sin",
 "Sem alerta": "Sin alerta",
 "Sem categoria": "Sin categoría",
 "Sem comprovante": "Sin comprobante",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Sin conexión con el servidor de facturas. Revisa tu internet y la dirección del servidor.",
 "Sem conexão com o servidor. Confira a internet.": "Sin conexión con el servidor. Revisa tu conexión a internet.",
 "Sem conexão com os GIFs agora.": "Sin conexión con los GIFs ahora.",
 "Sem cômodo": "Sin habitación",
 "Sem data de fim": "Sin fecha de fin",
 "Sem exercícios": "Sin ejercicios",
 "Sem fatura em {mes}": "Sin estado de cuenta en {mes}",
 "Sem fim": "Sin fin",
 "Sem horário": "Sin horario",
 "Sem internet ou servidor ainda não preparado.": "Sin internet o el servidor aún no está preparado.",
 "Sem internet. Envia quando voltar.": "Sin internet. Se enviará cuando vuelva.",
 "Sem internet. Tente de novo.": "Sin internet. Inténtalo de nuevo.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Sin esto, la franja solo tapa: el texto de debajo sigue en el archivo y se puede copiar.",
 "Sem itens": "Sin elementos",
 "Sem juros": "Sin intereses",
 "Sem limite": "Sin límite",
 "Sem link de calendário": "Sin enlace de calendario",
 "Sem margem": "Sin margen",
 "Sem nome": "Sin nombre",
 "Sem número na primeira página (capa)": "Sin número en la primera página (portada)",
 "Sem pasta": "Sin carpeta",
 "Sem pausas": "Sin pausas",
 "Sem permissão": "Sin permiso",
 "Sem prazo": "Sin plazo",
 "Sem recibo": "Sin recibo",
 "Sem tarefas": "Sin tareas",
 "Sem texto.": "Sin texto.",
 "Sem tomador identificado": "Sin tomador identificado",
 "Sem título": "Sin título",
 "Sem validade": "Sin vencimiento",
 "Semana": "Semana",
 "Semana completa": "Semana completa",
 "Semana de {de} a {ate}": "Semana del {de} al {ate}",
 "Semanal": "Semanal",
 "Semanal · dias úteis": "Semanal · días hábiles",
 "Semanal · todos os dias": "Semanal · todos los días",
 "Semanal · {dias}": "Semanal · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Siempre aparecen, junto con los días no laborables opcionales (Carnaval, Miércoles de Ceniza y Corpus Christi).",
 "Senha": "Contraseña",
 "Senha (8 caracteres ou mais)": "Contraseña (8 caracteres o más)",
 "Senha alterada.": "Contraseña cambiada.",
 "Senha atual": "Contraseña actual",
 "Senha atual do cofre": "Contraseña actual de la caja fuerte",
 "Senha da conta": "Contraseña de la cuenta",
 "Senha do certificado": "Contraseña del certificado",
 "Senha do cofre": "Contraseña de la caja fuerte",
 "Senha do cofre alterada.": "Contraseña de la caja fuerte cambiada.",
 "Senha do cofre incorreta.": "Contraseña de la caja fuerte incorrecta.",
 "Senha incorreta": "Contraseña incorrecta",
 "Senha incorreta.": "Contraseña incorrecta.",
 "Senha nova (8 caracteres ou mais)": "Contraseña nueva (8 caracteres o más)",
 "Senha nova do cofre (6 caracteres ou mais)": "Nueva contraseña de la caja fuerte (6 caracteres o más)",
 "Senha, biometria, bloqueio e privacidade": "Contraseña, biometría, bloqueo y privacidad",
 "Senha, e-mail e formas de desbloquear": "Contraseña, correo y formas de desbloqueo",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Reunir los certificados de rendimientos (bancos, empleador, corredoras)",
 "Servidor de notas": "Servidor de facturas",
 "Servidor não configurado (lib/config.ts).": "Servidor no configurado (lib/config.ts).",
 "Servidor não configurado.": "Servidor no configurado.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Servidor no configurado: faltan los datos de Supabase en lib/config.ts.",
 "Serviço": "Servicio",
 "Serviço não prestado": "Servicio no prestado",
 "Serviços": "Servicios",
 "Será excluída em 1 dia": "Se eliminará en 1 día",
 "Será excluída em {n} dias": "Se eliminará en {n} días",
 "Será excluída hoje": "Se eliminará hoy",
 "Sessão": "Sesión",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Tu acceso aún debe habilitarse. Intenta entrar en unos instantes.",
 "Seu código": "Tu código",
 "Seu código de amigo": "Tu código de amigo",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Tu código para que tus amigos obtengan 10 días con todas las pestañas",
 "Seu nome": "Tu nombre",
 "Seu papel: {p}": "Tu rol: {p}",
 "Seu papel: {p}. {d}": "Tu rol: {p}. {d}",
 "Seu scanner de bolso": "Tu escáner de bolsillo",
 "Seus dados continuam salvos na nuvem.": "Tus datos siguen guardados en la nube.",
 "Seus dados na nuvem do My Planner": "Tus datos en la nube de My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Tus datos son tuyos: no los vendemos ni los usamos para publicidad. Puedes exportarlos o borrarlos todos cuando quieras.",
 "Seus {n} meses grátis terminaram": "Tus {n} meses gratis terminaron",
 "Sexta": "Viernes",
 "Sextou": "Viernes",
 "Sextou!": "¡Por fin viernes!",
 "Shampoo": "Champú",
 "Show ou passeio": "Espectáculo o paseo",
 "Silenciar avisos": "Silenciar avisos",
 "Sim": "Sí",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Sincronizado el {data}",
 "Sincronizando pelo dispositivo {nome}": "Sincronizando desde el dispositivo {nome}",
 "Sincronizando...": "Sincronizando...",
 "Sincronizar agora": "Sincronizar ahora",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Sincronización detenida: confirma tu contraseña. No se pierde nada.",
 "Site da assistência": "Sitio del servicio técnico",
 "Site da assistência (https://...)": "Sitio del servicio técnico (https://...)",
 "Site ou ingresso online": "Web o entrada online",
 "Situação": "Estado",
 "Situação agora": "Situación actual",
 "Skincare da manhã": "Skincare de mañana",
 "Skincare da noite": "Skincare de noche",
 "Slides": "Diapositivas",
 "Smileys e pessoas": "Caras y personas",
 "Sobremesa": "Postre",
 "Sobrou no mês": "Sobró en el mes",
 "Sociologia": "Sociología",
 "Sofá": "Sofá",
 "Sol": "Sol",
 "Sol pleno": "Pleno sol",
 "Solo ou substrato": "Suelo o sustrato",
 "Solte numa matéria para mover a página para lá:": "Suelta en una materia para mover la página allí:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Suma la garantía legal y la del fabricante. Verifícalo en el certificado de garantía. Avisa 15 y 3 días antes.",
 "Sombra": "Sombra",
 "Somente esta tarefa": "Solo esta tarea",
 "Sono": "Sueño",
 "Sono da noite": "Sueño de la noche",
 "Sopa": "Sopa",
 "Sou MEI": "Soy MEI",
 "Status": "Estado",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Tu conexión con la nube venció (pasa cuando la app pasa mucho tiempo sin abrirse o la contraseña se cambió en otro dispositivo). No se pierde nada: lo que está aquí se envía en cuanto confirmes.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Tu equipo en un solo lugar: chat, documentos, videorreuniones con grabación e invitación por enlace.",
 "Sua rotina em um só lugar": "Tu rutina en un solo lugar",
 "Sua senha": "Tu contraseña",
 "Suas abas": "Tus pestañas",
 "Substituir": "Reemplazar",
 "Substrato usado": "Sustrato usado",
 "Subtarefa {n}": "Subtarea {n}",
 "Suco": "Jugo",
 "Sugerir nome": "Sugerir nombre",
 "Sugestão": "Sugerencia",
 "Sugestões de {categoria}": "Sugerencias de {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: guarda la cuenta y los datos sincronizados, como encargado. Los servidores pueden estar fuera de Brasil, con las garantías del art. 33 de la LGPD.",
 "Superiores": "Superiores",
 "Supino reto": "Press de banca",
 "Suplemento": "Suplemento",
 "Suspense": "Suspenso",
 "Suíte": "Suite",
 "Sábado": "Sábado",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Son más de 60 archivos. Usa \"Cada N páginas\".",
 "Série": "Serie",
 "Série da DPS": "Serie de la DPS",
 "Série e turma": "Curso y grupo",
 "Séries": "Series",
 "Sérum": "Sérum",
 "Símbolos": "Símbolos",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Solo lo ve el equipo de la oficina. Hasta 50 MB por archivo.",
 "Só acompanha": "Solo sigue",
 "Só acompanha, sem valores": "Solo sigue, sin importes",
 "Só administradores": "Solo administradores",
 "Só em {data}": "Solo el {data}",
 "Só leitura": "Solo lectura",
 "Só mandar para a aba Estudos (sem escolher página)": "Solo enviar a la pestaña Estudios (sin elegir página)",
 "Só neste dispositivo": "Solo en este dispositivo",
 "Só neste dispositivo: {n}": "Solo en este dispositivo: {n}",
 "Só o código": "Solo el código",
 "Só o dia {data}": "Solo el día {data}",
 "Só os dados (texto)": "Solo los datos (texto)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Solo los totales de Finanzas van a tu IA. No es una recomendación de inversión.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Solo tuyo: estudios, estrategias pedagógicas y lo que funcionó o no en cada clase. Los alumnos no lo ven.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Solo un móvil se sincroniza con el calendario. Para pasar a este, toca abajo.",
 "Só uma vez": "Solo una vez",
 "Só uma vez (abrir a ficha da tarefa)": "Solo una vez (abrir la ficha de la tarea)",
 "Só áudio": "Solo audio",
 "Sótão": "Ático",
 "TAREFAS DA CASA": "TAREAS DE LA CASA",
 "TELEFONE (OPCIONAL)": "TELÉFONO (OPCIONAL)",
 "TRAZER PARA O MY PLANNER": "TRAER A MY PLANNER",
 "TV por assinatura": "TV de pago",
 "Tabela": "Tabla",
 "Talvez": "Quizás",
 "Tamanho": "Tamaño",
 "Tamanho da foto": "Tamaño de la foto",
 "Tamanho da página": "Tamaño de página",
 "Tamanho das páginas": "Tamaño de las páginas",
 "Tamanho do arquivo": "Tamaño del archivo",
 "Tamanho do copo": "Tamaño del vaso",
 "Também procurar nos Diários Oficiais dos municípios": "Buscar también en los Diarios Oficiales de los municipios",
 "Também serão excluídos {n} item(ns) dentro dele.": "También se eliminarán {n} elemento(s) que contiene.",
 "Tapioca": "Tapioca (crepe de yuca)",
 "Tarefa": "Tarea",
 "Tarefa da casa": "Tarea de la casa",
 "Tarefa de casa": "Deberes",
 "Tarefa duplicada": "Tarea duplicada",
 "Tarefa ou entrega": "Tarea o entrega",
 "Tarefa para {nome}": "Tarea para {nome}",
 "Tarefas da casa": "Tareas de la casa",
 "Tarefas e itens de todas as abas": "Tareas y elementos de todas las pestañas",
 "Tarefas novas do My Planner vão para: {agenda}": "Las tareas nuevas de My Planner van a: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Las tareas que se repiten y pasan del período continúan los demás días; solo se quitan los días elegidos.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Franjas negras sobre CPF, importes y nombres. Borra de verdad.",
 "Tartaruga": "Tortuga",
 "Taxa de limpeza": "Tarifa de limpieza",
 "Taxa de limpeza cobrada do hóspede": "Tarifa de limpieza cobrada al huésped",
 "Taxas e anúncios": "Tasas y anuncios",
 "Te amo": "Te quiero",
 "Tecnologia": "Tecnología",
 "Tela cheia": "Pantalla completa",
 "Teleconsulta": "Teleconsulta",
 "Telefone": "Teléfono",
 "Telefone da assistência": "Teléfono del servicio técnico",
 "Telefone da empresa": "Teléfono de la empresa",
 "Telefone da escola": "Teléfono de la escuela",
 "Telefone da limpeza": "Teléfono de la limpieza",
 "Telefone de emergência": "Teléfono de emergencia",
 "Telefone do veterinário": "Teléfono del veterinario",
 "Telhado": "Tejado",
 "Tem anexos": "Tiene adjuntos",
 "Tem certeza?": "¿Seguro?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Tienes {n} cuenta(s) atrasada(s) que suman {v}. Paga primero las que cobran más intereses, como la tarjeta y el descubierto.",
 "Tema": "Tema",
 "Tempo de preparo": "Tiempo de preparación",
 "Temporada": "Temporada",
 "Temporizador (direita)": "Temporizador (derecha)",
 "Tenta consertar um PDF que não abre direito.": "Intenta arreglar un PDF que no abre bien.",
 "Tentar de novo": "Intentar de nuevo",
 "Tente uma foto mais nítida, com a página inteira.": "Prueba con una foto más nítida, con la página entera.",
 "Termina às {hora}": "Termina a las {hora}",
 "Terminar até": "Terminar antes del",
 "Terminei em": "Terminé el",
 "Terminou": "Terminó",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Terminó el {data}. No se borró nada: todo vuelve como estaba al suscribirte.",
 "Termos de uso": "Términos de uso",
 "Termos de uso e privacidade": "Términos de uso y privacidad",
 "Terror": "Terror",
 "Terça": "Martes",
 "Testando...": "Probando...",
 "Testar alerta (1 minuto)": "Probar alerta (1 minuto)",
 "Testar aviso": "Probar aviso",
 "Teste de alerta do Planner": "Prueba de alerta del Planner",
 "Teste grátis até {data} ({n} dia(s))": "Prueba gratis hasta el {data} ({n} día(s))",
 "Teste grátis: {n} dia(s)": "Prueba gratis: {n} día(s)",
 "Teste terminado": "Prueba terminada",
 "Teste terminou em {data}": "La prueba terminó el {data}",
 "Teste: aviso feito pelo próprio celular.": "Prueba: aviso generado por el propio móvil.",
 "Texto": "Texto",
 "Texto completo": "Texto completo",
 "Texto copiado. Cole onde quiser enviar.": "Texto copiado. Pégalo donde quieras enviarlo.",
 "Texto do documento": "Texto del documento",
 "Texto extra do convite (traje, presentes...)": "Texto extra de la invitación (vestimenta, regalos...)",
 "Texto livre": "Texto libre",
 "Texto ou recado": "Texto o aviso",
 "Texto para PDF": "Texto a PDF",
 "Texto {data}": "Texto {data}",
 "Tipo": "Tipo",
 "Tipo sanguíneo": "Grupo sanguíneo",
 "Tira as páginas que você não quer.": "Quita las páginas que no quieres.",
 "Tira autor, programas, comandos escondidos e anexos.": "Quita autor, programas, comandos ocultos y adjuntos.",
 "Tira comentários, destaques e desenhos de outros programas.": "Quita comentarios, resaltados y dibujos de otros programas.",
 "Tira o texto do PDF (arquivo .txt).": "Saca el texto del PDF (archivo .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Quitar",
 "Tirar a assinatura": "Quitar la firma",
 "Tirar a foto": "Quitar la foto",
 "Tirar a foto agora": "Tomar la foto ahora",
 "Tirar admin": "Quitar admin",
 "Tirar alarmes do My Planner": "Quitar alarmas de My Planner",
 "Tirar arquivos anexados": "Quitar archivos adjuntos",
 "Tirar comentários, destaques e links": "Quitar comentarios, resaltados y enlaces",
 "Tirar da agenda": "Quitar de la agenda",
 "Tirar da barra": "Quitar de la barra",
 "Tirar daqui": "Quitar de aquí",
 "Tirar das minhas figurinhas?": "¿Quitar de mis stickers?",
 "Tirar de administrador": "Quitar como administrador",
 "Tirar do escritório": "Quitar de la oficina",
 "Tirar dos meus GIFs?": "¿Quitar de mis GIFs?",
 "Tirar este copo": "Quitar este vaso",
 "Tirar foto": "Hacer foto",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Tomar fotos de boletos, tickets y documentos y elegir fotos y videos de la galería.",
 "Tirar o desenho padrão?": "¿Quitar el patrón?",
 "Tirar o lixo": "Sacar la basura",
 "Tire a foto e a sua IA preenche a ficha": "Toma la foto y tu IA completa la ficha",
 "Titular (de quem é o documento)": "Titular (de quién es el documento)",
 "Titular: {nome}": "Titular: {nome}",
 "Toalha de praia": "Toalla de playa",
 "Tocar os pés": "Tocarse los pies",
 "Toda a agenda": "Toda la agenda",
 "Toda semana": "Cada semana",
 "Todas": "Todas",
 "Todas (passadas, esta e futuras)": "Todas (pasadas, esta y futuras)",
 "Todas ({n})": "Todas ({n})",
 "Todas as abas liberadas até {data}.": "Todas las pestañas desbloqueadas hasta el {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Todas las capitales. Marca una o más ciudades.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Todas las herramientas de PDF: unir, dividir, organizar, firmar, sello, franjas, números de página, formularios, comprimir, convertir, OCR e IA. Guarda en el celular, en Google Drive o en OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Todas las herramientas están en la pantalla de la pestaña.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Todas las fotos del viaje están aquí: las que subas al álbum y las del itinerario, los lugares y las reservas.",
 "Todas as plantas estão regadas.": "Todas las plantas están regadas.",
 "Todas as páginas, uma embaixo da outra.": "Todas las páginas, una debajo de otra.",
 "Todo ano": "Cada año",
 "Todo dia": "Cada día",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Cada día a la hora elegida: cuántas tareas tiene el día, la primera y la energía total.",
 "Todo mês": "Cada mes",
 "Todo mês · dia {d}": "Cada mes · día {d}",
 "Todo o histórico": "Todo el historial",
 "Todos": "Todos",
 "Todos ({n})": "Todos ({n})",
 "Todos do grupo": "Todos los del grupo",
 "Todos do grupo veem": "Todo el grupo lo ve",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Todos en la reunión ven el aviso \"Grabando\". El archivo va a los Documentos de la oficina, visible solo para ti hasta que lo compartas con el equipo.",
 "Todos os cuidados": "Todos los cuidados",
 "Todos os dias": "Todos los días",
 "Todos os suplementos": "Todos los suplementos",
 "Todos os treinos": "Todos los entrenamientos",
 "Todos os tribunais": "Todos los tribunales",
 "Todos presentes": "Todos presentes",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Todos salen del grupo. Lo que cada persona ya aceptó sigue en su agenda.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Todos trabajan con los mismos datos, cada uno según su rol. Toca el rol de cada persona en Miembros para cambiarlo.",
 "Tomador": "Tomador",
 "Tomador (quem contratou)": "Tomador (quien contrató)",
 "Tomadores": "Tomadores",
 "Tomei": "Tomé prestado",
 "Toque aqui ou no + para criar uma tarefa": "Toca aquí o en el + para crear una tarea",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Toca \"Borrar mi cuenta y todos los datos\" y confirma.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Toca + › Nueva tarjeta de crédito e indica los días de cierre y de vencimiento.",
 "Toque em Ajustes e depois em Segurança.": "Toca Ajustes y luego Seguridad.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Toca Conectar y, en la pantalla de Apple, activa los elementos que My Planner puede leer.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Toca Conectar y, en la pantalla de Health Connect, permite que My Planner lea los datos.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Toca a quien NO debe ver esta ficha (ni lo que contiene). Ej.: el regalo sorpresa.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Toca una pestaña para abrirla. Las bloqueadas muestran cómo suscribirse.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Toca una pestaña para abrirla. Cada pestaña extra se puede probar gratis por 10 días.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Toca una pestaña para abrirla. Toca 📌 para poner o quitar la pestaña de la barra inferior. Cada pestaña extra se puede probar gratis durante 10 días.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Toca un área para abrirla. Las bloqueadas muestran cómo suscribirte.",
 "Toque no desenho para continuar desenhando.": "Toca el dibujo para seguir dibujando.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Toca lo que este grupo va a compartir. Todo lo que hay dentro (itinerario, fotos, reservas...) va junto y todos participan.",
 "Toque nos PDFs na ordem em que devem ficar.": "Toca los PDFs en el orden en que deben quedar.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Toca un vaso para cambiar el volumen; mantén pulsado + para un vaso de otro tamaño.",
 "Toque num feriado para adicioná-lo ao Planner.": "Toca un feriado para agregarlo al Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Toca un movimiento para cambiar la categoría, guardar el recibo en el IR o borrarlo.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Toca un movimiento para cambiar la categoría. Mantén pulsado para borrar.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Toca un perfil para editarlo. Mantén presionado para eliminarlo.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Toca un texto, dibujo o checklist y arrástralo a cualquier lugar de la hoja.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Toca una página para recortar, girar o cambiar el filtro. Mantén pulsado y arrastra para cambiar el orden.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Toca una tarea para copiarla o moverla a hoy.",
 "Toque onde quer a checklist.": "Toca donde quieres la checklist.",
 "Toque onde quer escrever.": "Toca donde quieres escribir.",
 "Toque para abrir": "Toca para abrir",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Toca para abrir en la app del celular. Desliza a la derecha para quitar de la lista.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Toca para abrir, mantén pulsado para renombrar. Desliza a la izquierda para archivar o a la derecha para eliminar.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Toca para abrir. Desliza a la derecha para quitar de la lista.",
 "Toque para aceitar ou recusar.": "Toca para aceptar o rechazar.",
 "Toque para aceitar, editar ou recusar.": "Toca para aceptar, editar o rechazar.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Toca para aplicarla ahora. O se aplica sola al reabrir la app.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Toca para descargar e instalar encima. Tus datos se mantienen.",
 "Toque para conversar": "Toca para chatear",
 "Toque para enviar o emoji animado": "Toca para enviar el emoji animado",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Toca para enviar. Mantén pulsado para guardar o quitar de los tuyos.",
 "Toque para escolher": "Toca para elegir",
 "Toque para fechar": "Toca para cerrar",
 "Toque para gerar um novo QR Code": "Toca para generar un nuevo código QR",
 "Tornar admin": "Hacer admin",
 "Tornar administrador": "Hacer administrador",
 "Tosa": "Corte de pelo",
 "Totais por alimento": "Totales por alimento",
 "Total": "Total",
 "Total bruto": "Total bruto",
 "Total das reservas: {v}": "Total de reservas: {v}",
 "Total de aulas": "Total de clases",
 "Total de capítulos": "Total de capítulos",
 "Total de módulos": "Total de módulos",
 "Total de páginas": "Total de páginas",
 "Total de recibos: {v}": "Total de recibos: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Total: {n}. Cada pestaña puede tener hasta {lim} de texto (fotos y archivos no cuentan: quedan en el dispositivo o en tu Drive).",
 "Total: {v}": "Total: {v}",
 "Trabalhando...": "Trabajando...",
 "Trabalho": "Laborales",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Trae los eventos de tu Google Calendar a My Planner y edítalos aquí: los cambios vuelven al calendario.",
 "Trans": "Trans",
 "Transferir: {s}": "Cambiar: {s}",
 "Transferência": "Cambio de titular",
 "Transferências": "Cambios de titular",
 "Transporte": "Transporte",
 "Tratamento": "Tratamiento",
 "Travar depois de preencher": "Bloquear después de rellenar",
 "Trazer todas para hoje": "Traer todas a hoy",
 "Trazer tudo para hoje?": "¿Traer todo a hoy?",
 "Trecho ou ideia": "Cita o idea",
 "Treino": "Entrenamiento",
 "Trem ou ônibus": "Tren o autobús",
 "Treme": "Tiembla",
 "Tribunais": "Tribunales",
 "Trilha": "Senderismo",
 "Triste": "Triste",
 "Triângulo": "Triángulo",
 "Troca de óleo": "Cambio de aceite",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Cambio de aceite, rotación de neumáticos, revisiones por km, IPVA, licencia y seguro.",
 "Trocador portátil": "Cambiador portátil",
 "Trocar": "Cambiar",
 "Trocar a categoria": "Cambiar la categoría",
 "Trocar a foto": "Cambiar la foto",
 "Trocar a pasta": "Cambiar la carpeta",
 "Trocar a senha do cofre": "Cambiar la contraseña de la caja fuerte",
 "Trocar número": "Cambiar número",
 "Trocar o certificado": "Cambiar el certificado",
 "Trocar o código": "Cambiar el código",
 "Trocar o código?": "¿Cambiar el código?",
 "Trocar o desenho": "Cambiar el patrón",
 "Trocar o emoji": "Cambiar el emoji",
 "Trocar o modelo": "Cambiar el modelo",
 "Trocar o número": "Cambiar el número",
 "Trocar o número do celular": "Cambiar el número de celular",
 "Trocar por:": "Cambiar por:",
 "Trocar roupa de cama e toalhas": "Cambiar ropa de cama y toallas",
 "Tríceps na polia": "Extensión de tríceps en polea",
 "Tubo de ensaio": "Tubo de ensayo",
 "Tudo": "Todo",
 "Tudo certo": "Todo en orden",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Todo al día por aquí. Registra los gastos del día a día para que vea a dónde va el dinero.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Todo ya queda guardado en tu cuenta. El archivo es una copia extra que guardas donde quieras.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Todo lo que está dentro de \"{nome}\" pasa a ser visible para el grupo, cada persona según el rol que elijas (quien entra empieza con el rol más limitado).",
 "Tudo! Já comprei os ingressos.": "¡Todo! Ya compré las entradas.",
 "Turma": "Grupo",
 "Turma (opcional)": "Grupo (opcional)",
 "Turmas": "Grupos",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Grupos y clases (clases, mentoría, entrenamiento): alumnos, asistencia, notas, planes, materiales, cobros y tu cuaderno.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Grupos, alumnos, asistencia, notas y planes de clase.",
 "Turmas, pacientes, equipes e convidados": "Clases, pacientes, equipos e invitados",
 "Técnico": "Técnico",
 "Título": "Título",
 "Título (ex.: Capítulo 3)": "Título (ej.: Capítulo 3)",
 "Título (opcional)": "Título (opcional)",
 "Título da caixa": "Título de la tarjeta",
 "Título de eleitor": "Credencial de elector",
 "Título, autor, assunto e palavras-chave.": "Título, autor, asunto y palabras clave.",
 "Tô chegando": "Ya llego",
 "Tônico": "Tónico",
 "UF": "UF",
 "Uau": "Guau",
 "Uhuul!": "¡Yuju!",
 "Um PDF novo só com as páginas escolhidas.": "Un PDF nuevo solo con las páginas elegidas.",
 "Um texto clarinho na diagonal de todas as páginas.": "Un texto suave en diagonal en todas las páginas.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Una carpeta para cada cliente: intercambian documentos en ambos sentidos y cada cliente solo ve su carpeta.",
 "Uma página por arquivo": "Una página por archivo",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Una página por archivo, cada N páginas o por rangos.",
 "Unicórnio": "Unicornio",
 "Unidade": "Unidad",
 "Universal": "Universal",
 "União": "Unión",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Usa la cuenta de Google que ya está en el móvil. My Planner no te pide ninguna contraseña de Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Usado: {u} · disponible: {v} · límite {l}",
 "Usar": "Usar",
 "Usar \"{nome}\"": "Usar \"{nome}\"",
 "Usar biometria": "Usar biometría",
 "Usar desenho padrão": "Usar patrón",
 "Usar este celular": "Usar este móvil",
 "Usar este nome": "Usar este nombre",
 "Usar modelo: {m}": "Usar plantilla: {m}",
 "Usar no navegador (My Planner Web)": "Usar en el navegador (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Usar el archivo ya adjunto ({nome})",
 "Usar o código": "Usar el código",
 "Usar senha": "Usar contraseña",
 "Usar {ia}": "Usar {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Usa la contraseña nueva la próxima vez que entres, aquí y en My Planner Web.",
 "Use a senha para desbloquear.": "Usa la contraseña para desbloquear.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Usa tu propia IA para leer publicaciones, documentos y notas y sugerir citas. Siempre confirmas antes de que algo entre en el Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Usa este código al crear tu cuenta y obtén 10 días con todas las pestañas desbloqueadas.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Usa el extracto en OFX (lo más recomendable) o CSV, descargado en la app o la web de tu banco.",
 "Use o seu planner no computador, sincronizado com o celular.": "Usa tu planner en la computadora, sincronizado con el celular.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Usa un enlace https de Google Drive, Google Docs, OneDrive o SharePoint.",
 "Uso": "Uso",
 "Uso próprio": "Uso propio",
 "VRBO": "VRBO",
 "Vacina": "Vacuna",
 "Vacina {nome}: {pet}": "Vacuna {nome}: {pet}",
 "Vacina: {nome}": "Vacuna: {nome}",
 "Vacinas": "Vacunas",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Vacunas y medicamentos de las mascotas, peluquería y la rutina escolar y de salud de los niños.",
 "Vai na viagem": "Va al viaje",
 "Vale até {d}": "Válido hasta {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Se aplica a Estudios y Documentos. En la nube, el archivo se abre en cualquier dispositivo y en My Planner Web (hasta 15 MB por archivo).",
 "Vale quantos pontos": "Cuántos puntos vale",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Solo se aplica a ti. Como máximo un aviso cada 3 minutos por persona, aunque añada varias cosas.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Vale una vez, en los primeros 30 días de tu cuenta.",
 "Validade": "Vencimiento",
 "Validade do certificado A1": "Validez del certificado A1",
 "Validade: {data}": "Vence: {data}",
 "Valor": "Importe",
 "Valor ({m})": "Monto ({m})",
 "Valor a pagar": "Valor a pagar",
 "Valor combinado": "Importe acordado",
 "Valor combinado por atendimento": "Valor acordado por consulta",
 "Valor da hora": "Precio por hora",
 "Valor da parcela (1ª)": "Valor de la cuota (1.ª)",
 "Valor da venda": "Precio de venta",
 "Valor de costume": "Valor habitual",
 "Valor do atendimento: {v}{pago}.": "Valor de la consulta: {v}{pago}.",
 "Valor emprestado ou financiado": "Valor prestado o financiado",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Precio final definido por Google Play o la App Store, ya en la moneda de tu país.",
 "Valor maior que o guardado nesta meta.": "Importe mayor que lo ahorrado en esta meta.",
 "Valor padrão da consulta ou sessão": "Valor estándar de la consulta o sesión",
 "Valor pago": "Importe pagado",
 "Valor pago (com multa ou desconto)": "Valor pagado (con multa o descuento)",
 "Valor pago (opcional)": "Importe pagado (opcional)",
 "Valor pago: {v}": "Importe pagado: {v}",
 "Valor que este aluno paga (se for diferente)": "Valor que paga este alumno (si es diferente)",
 "Valor recebido": "Importe recibido",
 "Valor recebido: {v}": "Importe recibido: {v}",
 "Valor total da compra": "Importe total de la compra",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Los importes y los datos clínicos solo aparecen para quien tenga un rol que lo permita. Puedes desactivarlo cuando quieras: los datos siguen contigo.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Importes para revisar con tu contable. Las reglas de deducción cambian cada año.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "¿Chateamos por My Planner? Añádeme como amigo con el código {codigo} (pestaña Mensajes > Amigos).",
 "Vaso": "Maceta",
 "Veja os planos em Ajustes › Compras.": "Mira los planes en Ajustes › Compras.",
 "Vem da aba Empréstimos & Financiamentos": "Viene de la pestaña Préstamos y Financiamientos",
 "Vence em {data}.": "Vence el {data}.",
 "Vence em {fim} (data informada na publicação).": "Vence el {fim} (fecha indicada en la publicación).",
 "Vence em {n} dia(s)": "Vence en {n} día(s)",
 "Vence hoje": "Vence hoy",
 "Vence {data}": "Vence {data}",
 "Vencendo": "Por vencer",
 "Venceu há {n} dia(s)": "Venció hace {n} día(s)",
 "Vencidas": "Vencidas",
 "Vencidos": "Vencidos",
 "Vencimento": "Vencimiento",
 "Vencimento (guias e boletos)": "Vencimiento (guías y boletos)",
 "Vencimento da 1ª parcela": "Vencimiento de la 1.ª cuota",
 "Vencimentos": "Vencimientos",
 "Venda": "Venta",
 "Venda/serviço do MEI": "Venta/servicio del MEI",
 "Vendidos": "Vendidos",
 "Ver": "Ver",
 "Ver a lista de membros": "Ver la lista de miembros",
 "Ver a rota": "Ver la ruta",
 "Ver arquivos": "Ver archivos",
 "Ver detalhes do erro": "Ver detalles del error",
 "Ver e editar": "Ver y editar",
 "Ver em Compras": "Ver en Compras",
 "Ver mais": "Ver más",
 "Ver mais páginas": "Ver más páginas",
 "Ver no My Planner": "Ver en My Planner",
 "Ver o dia": "Ver el día",
 "Ver os feriados do ano": "Ver los feriados del año",
 "Ver participantes": "Ver participantes",
 "Ver páginas": "Ver páginas",
 "Ver todos": "Ver todos",
 "Ver todos ({n})": "Ver todos ({n})",
 "Ver {nome}": "Ver {nome}",
 "Verificar agora": "Verificar ahora",
 "Vermífugo": "Desparasitante",
 "Vermífugo ou remédio": "Desparasitante o medicamento",
 "Vermífugos e remédios": "Desparasitantes y medicamentos",
 "Verso": "Reverso",
 "Verso do documento": "Reverso del documento",
 "Versão do PDF": "Versión del PDF",
 "Versão instalada": "Versión instalada",
 "Versão {versao} disponível": "Versión {versao} disponible",
 "Versão {v}": "Versión {v}",
 "Veterinário": "Veterinario",
 "Veterinário ou clínica": "Veterinario o clínica",
 "Veículo": "Vehículo",
 "Veículo e acessórios": "Vehículo y accesorios",
 "Veículos": "Vehículos",
 "Veículos & Manutenção": "Vehículos & Mantenimiento",
 "Vi mais um episódio": "Vi otro episodio",
 "Viagem": "Viaje",
 "Viagens": "Viajes",
 "Viagens & Lazer": "Viajes & Ocio",
 "Viagens e lugares": "Viajes y lugares",
 "Vida noturna": "Vida nocturna",
 "Vidros e esquadrias": "Cristales y carpintería de ventanas",
 "Vigente": "Vigente",
 "Vigentes": "Vigentes",
 "Virar": "Girar",
 "Virar a câmera": "Girar la cámara",
 "Virar tarefa (levar à assistência)": "Convertir en tarea (llevar al servicio técnico)",
 "Visita domiciliar": "Visita a domicilio",
 "Visitados": "Visitados",
 "Visto": "Visto",
 "Vistoria": "Inspección",
 "Vistoria: {i}": "Inspección: {i}",
 "Vistorias": "Inspecciones",
 "Visualizar feriados": "Ver feriados",
 "Vitamina": "Vitamina",
 "Vitamina D": "Vitamina D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitaminas, whey, creatina... con la frecuencia de cada uno. Lo que sea de hoy aparece en \"Hoy\" para marcar.",
 "Você": "Tú",
 "Você aceitou os termos em {data}.": "Aceptaste los términos el {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Aún no tienes amigos en la app. Añádelos por código.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Aún no tienes carpetas. Crea una en la pestaña Estudios.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Dejarás de ver la conversación, los documentos y las reuniones.",
 "Você deve: {v}": "Debes: {v}",
 "Você entrou no grupo": "Te uniste al grupo",
 "Você entrou no grupo \"{nome}\".": "Te uniste al grupo \"{nome}\".",
 "Você está convidado(a) para: {evento}": "Estás invitado(a) a: {evento}",
 "Você foi convidado para o My Planner": "Te invitaron a My Planner",
 "Você foi convidado para o grupo": "Te invitaron al grupo",
 "Você juntou {v} para \"{m}\".": "Juntaste {v} para \"{m}\".",
 "Você já tem todas as abas.": "Ya tienes todas las pestañas.",
 "Você já usou um código de indicação nesta conta.": "Ya usaste un código de recomendación en esta cuenta.",
 "Você ligou": "Llamaste",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Puedes borrar tu cuenta en cualquier momento, en la app del celular o en el sitio:",
 "Você não tem permissão para isso neste grupo.": "No tienes permiso para eso en este grupo.",
 "Você não vê os outros membros deste grupo.": "No ves a los demás miembros de este grupo.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Puedes borrar tu cuenta en cualquier momento en Ajustes > Seguridad. Esto borra para siempre los datos en la nube y en el dispositivo.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Puedes: confirmar si tratamos tus datos, acceder a ellos, corregirlos, pedir la portabilidad (exportar el archivo en Ajustes > Configuración general), pedir su eliminación, saber con quién los compartimos, revocar el consentimiento y reclamar ante la ANPD.",
 "Você recebe (líquido)": "Recibes (neto)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Eres responsable de tu contraseña y de lo que se haga en tu cuenta. Usa datos verdaderos en el registro.",
 "Volta": "Vuelta",
 "Volta ou check-out": "Vuelta o check-out",
 "Volta às {hora}": "Vuelve a las {hora}",
 "Voltar": "Volver",
 "Voltar ao cardápio da semana neste dia": "Volver al menú de la semana en este día",
 "Voltar ao cálculo": "Volver al cálculo",
 "Voltar ao foco": "Volver al enfoque",
 "Voltar ao padrão": "Restablecer",
 "Voltar ao planejado": "Volver a lo planeado",
 "Voltar para Anotações": "Volver a Notas",
 "Voltar para as cores do My Planner": "Volver a los colores de My Planner",
 "Voltar para novas": "Volver a nuevas",
 "Voltar para o QR Code": "Volver al código QR",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Vuelve a la app My Planner en el móvil. La pantalla de Ajustes se actualiza sola.",
 "Voo": "Vuelo",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Vuelos, hoteles, coche y excursiones en un solo lugar, con el código y el comprobante.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Ve a Ajustes y toca \"Conectar navegador\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Ve a Ajustes › Configuración general y toca \"Conectar navegador\".",
 "Várias páginas por folha": "Varias páginas por hoja",
 "Vários PDFs num só, na ordem que você escolher.": "Varios PDFs en uno, en el orden que elijas.",
 "Vê as aulas e os materiais liberados.": "Ve las clases y los materiales disponibles.",
 "Vê as etapas e registra o diário.": "Ve las etapas y registra el diario.",
 "Vê e altera tudo, inclusive os valores.": "Ve y modifica todo, incluidos los importes.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Ve y envía los documentos de su propia carpeta y responde a las solicitudes.",
 "Vê o andamento, sem os valores e sem alterar.": "Ve el avance, sin los importes y sin modificar.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Ve los check-ins y check-outs y marca la limpieza hecha, sin importes.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Ve todo y registra gastos, lugares, itinerario y equipaje.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Ve todo, añade, edita, comenta y sube fotos. Solo no añade ni quita personas del grupo.",
 "Vê tudo, inclusive os valores, sem alterar.": "Ve todo, incluidos los importes, sin modificar.",
 "Vídeo": "Video",
 "Vínculo": "Vínculo",
 "Vínculo perdido": "Vínculo perdido",
 "WhatsApp da assistência": "WhatsApp del servicio técnico",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (red y contraseña)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Zumbi y Conciencia Negra",
 "Zzz": "Zzz",
 "a cada {n} dias": "cada {n} días",
 "a pagar": "por pagar",
 "a receber": "por cobrar",
 "a receber {v}": "por recibir {v}",
 "a reserva": "la reserva",
 "a última execução falhou; avise o suporte": "la última ejecución falló; avisa a soporte",
 "abr": "abr",
 "abril": "abril",
 "acabou": "agotado",
 "achatado": "aplanado",
 "administra": "admin",
 "ago": "ago",
 "agosto": "agosto",
 "ajustado": "ajustado",
 "algo novo": "algo nuevo",
 "alterou": "modificó",
 "amanhã": "mañana",
 "anual": "anual",
 "apagou": "eliminó",
 "aplicada em {d}": "aplicada el {d}",
 "app {v} · atualização {p} de {data}": "app {v} · actualización {p} del {data}",
 "assinado": "firmado",
 "atrasada": "atrasada",
 "atrasada há {n} dia(s)": "atrasada hace {n} día(s)",
 "até": "hasta",
 "até {data}": "hasta el {data}",
 "até {d}": "hasta el {d}",
 "aula {a} de {n}": "clase {a} de {n}",
 "avisos silenciados": "avisos silenciados",
 "caixa": "tarjeta",
 "colher(es)": "cucharada(s)",
 "coluna": "columna",
 "com anexos": "con adjuntos",
 "com imagem": "con imagen",
 "com tarjas": "con franjas",
 "com texto": "con texto",
 "com {p}": "con {p}",
 "como planejado": "como lo planeado",
 "comprado em {data}": "comprado el {data}",
 "comprado em {d} por {v}": "comprado el {d} por {v}",
 "comprimido": "comprimido",
 "comprovante": "comprobante",
 "concha(s)": "cucharón/cucharones",
 "confirmados": "confirmados",
 "consulta recusada": "consulta rechazada",
 "contratado": "contratado",
 "contínuo": "continuo",
 "copo(s)": "vaso(s)",
 "corridos": "naturales",
 "criou o grupo": "creó el grupo",
 "de": "de",
 "de Anotações": "de Notas",
 "de {meta} passos": "de {meta} pasos",
 "de {n}": "de {n}",
 "de {p}": "de {p}",
 "dentro / fora do planejado": "dentro / fuera de lo planificado",
 "desconto {v}": "descuento {v}",
 "desfazer": "deshacer",
 "destino": "destino",
 "deve {v}": "debe {v}",
 "devolvido em {d}": "devuelto el {d}",
 "dez": "dic",
 "dezembro": "diciembre",
 "dia": "día",
 "dias": "días",
 "dias com a meta batida": "días con la meta cumplida",
 "dias com a meta de passos": "días con la meta de pasos",
 "digital": "huella digital",
 "diária média": "tarifa media diaria",
 "do cliente": "del cliente",
 "do escritório": "de la oficina",
 "dom": "dom",
 "domingo": "domingo",
 "e mais {n}": "y {n} más",
 "em aberto": "pendiente",
 "em atraso": "atrasada",
 "em {n} dias": "en {n} días",
 "emitida": "emitida",
 "entregue": "entregado",
 "entrou no escritório": "se unió a la oficina",
 "enviado": "enviado",
 "escaneado": "escaneado",
 "escolha": "elige",
 "este": "este",
 "este dispositivo": "este dispositivo",
 "este item": "este elemento",
 "exercícios concluídos": "ejercicios completados",
 "falta {v}": "faltan {v}",
 "faltam {km}": "faltan {km}",
 "fatia(s)": "rebanada(s)",
 "faturamento": "facturación",
 "feita em {d}": "hecha el {d}",
 "feito {dur}": "hecho {dur}",
 "fev": "feb",
 "fevereiro": "febrero",
 "frequência {p}%": "asistencia {p}%",
 "gasto {v}": "gastado {v}",
 "girado": "girado",
 "guardado": "guardado",
 "higienizado": "limpio",
 "hoje": "hoy",
 "hora fixa no dia": "hora fija del día",
 "há {n} dias": "hace {n} días",
 "iPhone ou computador: {link}": "iPhone o computadora: {link}",
 "incluiu": "agregó",
 "jan": "ene",
 "janeiro": "enero",
 "jul": "jul",
 "julho": "julio",
 "jun": "jun",
 "junho": "junio",
 "já importado": "ya importado",
 "liberar em {d}": "liberar el {d}",
 "ligou o compartilhamento": "activó el uso compartido",
 "linha": "fila",
 "lucro líquido": "ganancia neta",
 "mai": "may",
 "maio": "mayo",
 "mar": "mar",
 "marca d'água": "marca de agua",
 "marcada por {nome}": "programada por {nome}",
 "março": "marzo",
 "menos de 1 ano": "menos de 1 año",
 "mensalidade": "mensualidad",
 "meta batida!": "¡meta cumplida!",
 "metadados": "metadatos",
 "min": "min",
 "min antes": "min antes",
 "min antes do início": "min antes del inicio",
 "min · {de} às {ate}": "min · de {de} a {ate}",
 "multa e juros {v}": "multa e intereses {v}",
 "média {m}": "media {m}",
 "mês(es)": "mes(es)",
 "na nuvem": "en la nube",
 "na pasta \"{pasta}\"": "en la carpeta \"{pasta}\"",
 "na pasta escolhida": "en la carpeta elegida",
 "neste dispositivo": "en este dispositivo",
 "neste celular": "en este celular",
 "no Planner": "en Planner",
 "no {nome}": "en {nome}",
 "nos próximos dias": "en los próximos días",
 "nov": "nov",
 "novembro": "noviembre",
 "numerado": "numerado",
 "nunca verificado": "nunca verificado",
 "não vão": "no van",
 "o documento mudou depois disso: guarde de novo": "el documento cambió después: guárdalo de nuevo",
 "ocupação": "ocupación",
 "ontem": "ayer",
 "organizado": "organizado",
 "orçando": "pidiendo presupuesto",
 "out": "oct",
 "outubro": "octubre",
 "paga": "pagada",
 "paga em {d}": "pagada el {d}",
 "pago": "pagado",
 "pago em {d}": "pagado el {d}",
 "pago por {p}": "pagado por {p}",
 "pagou {v}": "pagó {v}",
 "parcela {a} de {n}": "cuota {a} de {n}",
 "parece já lançado": "parece ya registrado",
 "parte {n}": "parte {n}",
 "passos por dia (média)": "pasos por día (media)",
 "passou {km}": "pasó {km}",
 "pausa {p}": "descanso {p}",
 "pausado": "en pausa",
 "peso {n}": "peso {n}",
 "pesquisável": "buscable",
 "por dia": "por día",
 "por dia (média)": "por día (media)",
 "por dia disponível": "por día disponible",
 "por semana": "por semana",
 "por {p}": "por {p}",
 "porção(ões)": "porción(es)",
 "preenchido": "rellenado",
 "primeira às {hora}: {tarefa}": "primera a las {hora}: {tarefa}",
 "produção": "producción",
 "próxima em {data}": "próxima el {data}",
 "próxima rega {d}": "próximo riego {d}",
 "publicação": "publicación",
 "página de estudo": "página de estudio",
 "página única": "página única",
 "páginas": "páginas",
 "páginas {p}": "páginas {p}",
 "qua": "mié",
 "quarta": "miércoles",
 "quarta-feira": "miércoles",
 "qui": "jue",
 "quinta": "jueves",
 "quinta-feira": "jueves",
 "quitada": "saldada",
 "recebe {v}": "recibe {v}",
 "recebida": "recibida",
 "reconhecimento facial": "reconocimiento facial",
 "recortado": "recortado",
 "refeições feitas": "comidas hechas",
 "rega a cada {n} dias": "riego cada {n} días",
 "regar hoje": "regar hoy",
 "reparado": "reparado",
 "retorno {d}": "revisión {d}",
 "saldo {v}": "saldo {v}",
 "seg": "lun",
 "segunda": "lunes",
 "segunda-feira": "lunes",
 "sem anotações": "sin anotaciones",
 "sem as páginas {p}": "sin las páginas {p}",
 "sem cliente": "sin cliente",
 "sem dias previstos": "sin días previstos",
 "sem horário": "sin hora",
 "sem meta": "sin meta",
 "sem resposta": "sin respuesta",
 "sem tempo": "sin tiempo",
 "semana(s)": "semana(s)",
 "set": "sep",
 "setembro": "septiembre",
 "seu@email.com": "tu@email.com",
 "sex": "vie",
 "sexta": "viernes",
 "sexta-feira": "viernes",
 "sáb": "sáb",
 "sábado": "sábado",
 "talvez": "quizás",
 "tarefa da casa": "tarea de la casa",
 "tarefa: {t}": "tarea: {t}",
 "taxas e despesas": "tasas y gastos",
 "ter": "mar",
 "termina em {d}": "termina el {d}",
 "terça": "martes",
 "terça-feira": "martes",
 "teste": "prueba",
 "todas": "todas",
 "todo ano em {d}": "cada año el {d}",
 "todo dia {d}": "cada mes el día {d}",
 "todos": "todos",
 "toque para abrir": "toca para abrir",
 "toque para pausar": "toca para pausar",
 "toque para ver o contato": "toca para ver el contacto",
 "toque para voltar a hoje": "toca para volver a hoy",
 "treinos concluídos": "entrenamientos completados",
 "uma vez em {d}": "una vez el {d}",
 "unidade(s)": "unidad(es)",
 "vale {n}": "vale {n}",
 "vence em {n} dias": "vence en {n} días",
 "vence {d}": "vence {d}",
 "venceu em {data}": "venció el {data}",
 "vencido": "vencido",
 "vendido com ganho de {v}": "vendido con ganancia de {v}",
 "vendido com perda de {v}": "vendido con pérdida de {v}",
 "verificado {quando}": "verificado {quando}",
 "você": "tú",
 "você administra": "eres admin",
 "xícara(s)": "taza(s)",
 "{aba} bloqueada": "{aba} bloqueada",
 "{aba} está bloqueada": "{aba} está bloqueada",
 "{aba}, em \"Anotações recebidas\"": "{aba}, en \"Notas recibidas\"",
 "{a} aula(s) feita(s)": "{a} clase(s) hecha(s)",
 "{a} de {n} aulas": "{a} de {n} clases",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} llegó al {p}% del presupuesto ({g} de {l}).",
 "{c} confirmados de {n} convidados": "{c} confirmados de {n} invitados",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} está en el {p}% del presupuesto del mes. Aún faltan {dias} día(s) para que termine el mes.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} ya está {v} por encima de todo el mes pasado. Revisa si fue algo fuera de lo común.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} ya pasó el presupuesto: {g} de {l}. Frena ese gasto hasta que cambie el mes.",
 "{c} passou do orçamento: {g} de {l}.": "{c} pasó el presupuesto: {g} de {l}.",
 "{de} paga {v} para {para}": "{de} paga {v} a {para}",
 "{de} às {ate}": "de {de} a {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} de {mes} de {a}",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}/{m}",
 "{dur} na semana": "{dur} en la semana",
 "{dur} registrados": "{dur} registrados",
 "{d}/{n} notas": "{d}/{n} notas",
 "{feito} de {meta}": "{feito} de {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} de {n} hechos",
 "{f}/{n} transferências feitas": "{f}/{n} cambios hechos",
 "{hora} em {fuso}": "{hora} en {fuso}",
 "{h} este mês": "{h} este mes",
 "{h} h": "{h} h",
 "{h} h {m} min": "{h} h {m} min",
 "{h} no seu relógio": "{h} en tu reloj",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} conectado. {n} modelo(s) disponible(s) en tu cuenta.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: clave de API no válida o sin permiso.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: límite de uso alcanzado. Revisa el saldo o el límite de tu cuenta de API.",
 "{item}: em {n} dias ({data}).": "{item}: en {n} días ({data}).",
 "{item}: hoje ({data}).": "{item}: hoy ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: termina en {n} días ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: vence en {n} días ({data}).",
 "{item}: vence hoje ({data}).": "{item}: vence hoy ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: venció el {data} y aún no se marcó como hecho.",
 "{livre} livres de {total}": "{livre} libres de {total}",
 "{m} min": "{m} min",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} ahora es tu amigo. Ya pueden chatear.",
 "{nome} conectado!": "¡{nome} conectado!",
 "{nome} ligou": "{nome} llamó",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} nueva(s), {atualizadas} actualizada(s), {enviadas} enviada(s), {removidas} eliminada(s)",
 "{n} ITEM(NS)": "{n} ARTÍCULO(S)",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} pestaña(s) en tu plan · colores y opciones de cada una",
 "{n} aba(s) para comprar": "{n} pestaña(s) para comprar",
 "{n} adicionada(s)": "{n} añadida(s)",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} alerta(s) programada(s) en este celular para los próximos días.",
 "{n} aluno(s)": "{n} alumno(s)",
 "{n} anexo(s)": "{n} adjunto(s)",
 "{n} ano(s)": "{n} año(s)",
 "{n} arquivo(s)": "{n} archivo(s)",
 "{n} atendimento(s)": "{n} consulta(s)",
 "{n} atrasada(s)": "{n} atrasada(s)",
 "{n} atrasado(s)": "{n} atrasado(s)",
 "{n} caixa(s)": "{n} caja(s)",
 "{n} caixa(s) frágil(eis)": "{n} caja(s) frágil(es)",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} caja(s) · {a} ya abierta(s) en la casa nueva",
 "{n} cancelada(s).": "{n} cancelada(s).",
 "{n} cartão(ões) abertos": "{n} tarjeta(s) abierta(s)",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} cobro(s) creado(s) con vencimiento el {d}.",
 "{n} com vencimento": "{n} con vencimiento",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} compra(s) en la tarjeta {c}. Las cuotas futuras ya aparecen en los próximos estados de cuenta.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} cuenta(s) marcada(s) como pagada(s) automáticamente.",
 "{n} copo(s), {ml} de {meta}": "{n} vaso(s), {ml} de {meta}",
 "{n} de {meta} copos": "{n} de {meta} vasos",
 "{n} de {total}": "{n} de {total}",
 "{n} de {total} dias": "{n} de {total} días",
 "{n} de {total} hoje": "{n} de {total} hoy",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} de {t} artículo(s) con precio, de los tickets leídos en Finanzas.",
 "{n} dia(s)": "{n} día(s)",
 "{n} dia(s) seguido(s) lendo": "{n} día(s) seguido(s) leyendo",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} día(s) quitado(s) de tareas que se repiten",
 "{n} dias": "{n} días",
 "{n} dias grátis": "{n} días gratis",
 "{n} dias grátis para testar": "{n} días gratis para probar",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} días {tipo}: publicada el {pub}, cómputo desde el {ini}, vence el {fim}.",
 "{n} documento(s)": "{n} documento(s)",
 "{n} em atraso": "{n} en mora",
 "{n} etapa(s) atrasada(s)": "{n} etapa(s) atrasada(s)",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} eliminación(es) esperando a que el móvil se sincronice.",
 "{n} falta(s)": "{n} falta(s)",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} ficha(s) en el grupo. Elige el rol de cada persona en Miembros.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} foto(s) y video(s) del viaje, de todo el grupo. Las fotos del itinerario, los lugares y las reservas también aparecen aquí.",
 "{n} item(ns) adicionado(s).": "{n} elemento(s) añadido(s).",
 "{n} item(ns) com outras pessoas": "{n} artículo(s) con otras personas",
 "{n} item(ns) no Planner.": "{n} elemento(s) en el Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} movimiento(s) encontrado(s)",
 "{n} lançamento(s) novo(s).": "{n} movimiento(s) nuevo(s).",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} recordatorio(s) puesto(s) en My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} libro(s) leído(s) este año",
 "{n} marcado(s)": "{n} marcado(s)",
 "{n} matéria(s)": "{n} materia(s)",
 "{n} membro(s) · abrir a conversa do grupo": "{n} miembro(s) · abrir el chat del grupo",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} meses gratis desde la creación de la cuenta; después {preco} al año.",
 "{n} min": "{n} min",
 "{n} min antes": "{n} min antes",
 "{n} módulo(s)": "{n} módulo(s)",
 "{n} noite(s)": "{n} noche(s)",
 "{n} nota(s) nova(s).": "{n} factura(s) nueva(s).",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} factura(s) sin XML en este dispositivo quedaron fuera.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} factura(s) · emitidas {e} · recibidas {r}",
 "{n} nova(s)": "{n} nueva(s)",
 "{n} novo(s) do cliente": "{n} nuevo(s) del cliente",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} nuevo(s) para aceptar, editar o rechazar.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} cuota(s) añadida(s) a My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} cuota(s) pendiente(s) recalculada(s). Las pagadas quedaron como estaban.",
 "{n} parcela(s) em atraso": "{n} cuota(s) en mora",
 "{n} parcela(s) em atraso: {v}": "{n} cuota(s) en mora: {v}",
 "{n} participantes · toque para ver": "{n} participantes · toca para ver",
 "{n} passo(s)": "{n} paso(s)",
 "{n} pausa(s)": "{n} pausa(s)",
 "{n} pedido(s) de amizade": "{n} solicitud(es) de amistad",
 "{n} pedido(s) em aberto": "{n} solicitud(es) abierta(s)",
 "{n} pessoa(s)": "{n} persona(s)",
 "{n} pessoa(s) já entraram com o seu código.": "{n} persona(s) ya se registraron con tu código.",
 "{n} pessoas": "{n} personas",
 "{n} por folha": "{n} por hoja",
 "{n} porções": "{n} raciones",
 "{n} publicação(ões) nova(s).": "{n} publicación(es) nueva(s).",
 "{n} publicações novas": "{n} publicaciones nuevas",
 "{n} página(s)": "{n} página(s)",
 "{n} página(s) · {r} revisada(s)": "{n} página(s) · {r} revisada(s)",
 "{n} páginas": "{n} páginas",
 "{n} recebido(s) dos seus grupos": "{n} recibido(s) de tus grupos",
 "{n} recebido(s) para responder": "{n} recibido(s) por responder",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} comida(s), con el menú de ese día",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} reserva(s) nueva(s) o modificada(s).",
 "{n} resultado(s) em todas as publicações": "{n} resultado(s) en todas las publicaciones",
 "{n} selecionado(s): {lista}": "{n} seleccionado(s): {lista}",
 "{n} tarefa(s)": "{n} tarea(s)",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} tarea(s) borrada(s) por completo",
 "{n} tarefa(s) criada(s)": "{n} tarea(s) creada(s)",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} tarea(s) de la casa salieron de My Planner y ahora están solo en Mi Casa. Para llevar una al Planner, abre la tarea y toca \"Enviar a My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} tarea(s) de ayer sin completar",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} tarea(s) de los últimos días sin completar",
 "{n} tarefa(s) hoje": "{n} tarea(s) hoy",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} tarea(s) pendiente(s) pasarán a la lista de hoy.",
 "{n} tarjas no documento": "{n} franjas en el documento",
 "{n} treino(s), cada um nos dias dele": "{n} entrenamiento(s), cada uno en sus días",
 "{n} tribunais": "{n} tribunales",
 "{n}x de {v}": "{n} cuotas de {v}",
 "{n}º alerta": "{n}.ª alerta",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} subido(s), {falhas} con error. Inténtalo de nuevo más tarde.",
 "{ok} enviado(s).": "{ok} subido(s).",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} de {d} noches ocupadas. Las reservas que pasan de un mes a otro se dividen por noches.",
 "{preco} por ano": "{preco} al año",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} de {t} cuotas pagadas ({pct}%)",
 "{p} presentes · {f} faltas": "{p} presentes · {f} faltas",
 "{p}% da meta de {m} páginas": "{p}% de la meta de {m} páginas",
 "{p}% feito": "{p}% hecho",
 "{p}% ocupado no mês": "{p}% ocupado en el mes",
 "{p}% pronta": "{p}% lista",
 "{p}/{t} pagas": "{p}/{t} pagadas",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} te invitó al grupo \"{grupo}\" en My Planner. Toca el enlace para unirte (la app es gratis para empezar): {link}\nCódigo de invitación: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} y otros añadieron {n} elementos al grupo.",
 "{quem} incluiu {item} no grupo.": "{quem} añadió {item} al grupo.",
 "{servico} do veículo": "{servico} del vehículo",
 "{s} de {a}": "{s} de {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: vuelve a las {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (copia)",
 "{uso} usados de {total} reservados para o site": "{uso} usados de {total} reservados para el sitio",
 "{v} · atualização de {data}": "{v} · actualización del {data}",
 "{v}/hora": "{v}/hora",
 "À direita": "A la derecha",
 "À vista": "Al contado",
 "Às": "A las",
 "Às {hora}": "A las {hora}",
 "ÁGUA": "AGUA",
 "Ácido": "Ácido",
 "Água": "Agua",
 "Água hoje": "Agua hoy",
 "Área externa": "Zona exterior",
 "Áreas": "Áreas",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "Es una ayuda y no sustituye el seguimiento de las notificaciones en los canales oficiales. Los plazos deben verificarse en el sistema oficial.",
 "Ética Profissional": "Ética Profesional",
 "Ícone e aba": "Ícono y pestaña",
 "Óculos de sol": "Gafas de sol",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Organismo emisor (ej.: DETRAN-MS, Policía Federal)",
 "Órgão emissor: {nome}": "Organismo emisor: {nome}",
 "Ômega 3": "Omega 3",
 "Última": "Última",
 "Última adubação": "Último abonado",
 "Última aplicação": "Última aplicación",
 "Última busca do servidor para você: {quando}": "Última búsqueda del servidor para ti: {quando}",
 "Última cópia de segurança: {data}": "Última copia de seguridad: {data}",
 "Última rega": "Último riego",
 "Última sincronização: {quando}": "Última sincronización: {quando}",
 "Última: {data}": "Última: {data}",
 "Último dia para entregar a declaração do IR": "Último día para presentar la declaración del IR",
 "Último erro: {m}": "Último error: {m}",
 "Últimos 30 dias": "Últimos 30 días",
 "Últimos 7 dias": "Últimos 7 días",
 "íris": "iris",
 "última vez em {data}": "última vez el {data}",
 "último em {d}": "última el {d}",
 "úteis": "hábiles",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ es el color de My Planner. La elección se aplica a todos los chats de este dispositivo y de tu cuenta.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} te está llamando (video)",
 "📆 Conectar a agenda deste celular": "📆 Conectar el calendario de este móvil",
 "📞 {nome} está ligando (áudio)": "📞 {nome} te está llamando (audio)",
 "Link bloqueado por segurança.": "Enlace bloqueado por seguridad.",
 "Este arquivo não é uma imagem válida.": "Este archivo no es una imagen válida.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "La búsqueda automática del servidor sigue los 5 primeros perfiles. Los demás se revisan cuando tocas \"Verificar ahora\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Esta pantalla muestra la línea de tiempo del viaje, con las actividades y los lugares que tienen día asignado. Para añadir o editar la información completa de un lugar, usa la pestaña Lugares.",
 "Para a viagem {d}": "Para el viaje {d}",
 "sem nome": "sin nombre",
 "Foi para a viagem {d}.": "Se movió al viaje {d}.",
 "Orçamento total (se não for detalhar)": "Presupuesto total (si no lo vas a detallar)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Arma el itinerario día a día. Los lugares con día asignado aparecen aquí solos. Durante el viaje, el itinerario aparece en la línea de tiempo de My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Indica el día y la hora en el lugar para que aparezca solo en el Itinerario.",
 "No roteiro": "En el itinerario",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" está en el itinerario del {data}. Para cambiar el día o la hora, edita el lugar.",
 "Para o roteiro desta viagem": "Para el itinerario de este viaje",
 "Orçamento e gastos": "Presupuesto y gastos",
 "Parada (cidade)": "Parada (ciudad)",
 "Item da categoria": "Elemento de la categoría",
 "Orçamento da viagem inteira": "Presupuesto de todo el viaje",
 "Orçamento geral da viagem": "Presupuesto general del viaje",
 "Previsto {p} · gasto {g}": "Previsto {p} · gastado {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Aquí van los costos del viaje que no son de una parada (ej.: pasajes, seguro). Cada parada tiene su propio presupuesto.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Indica cuánto piensas gastar en cada categoría. Al registrar los gastos, la app muestra cuánto ya se usó.",
 "Orçamento por parada": "Presupuesto por parada",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "¿Vas a pasar por más de una ciudad? Registra las paradas (pestaña Paradas): cada una tiene su propio presupuesto y los gastos de esas fechas entran en ella solos.",
 "Coloque o valor do gasto.": "Indica el importe del gasto.",
 "Orçamento de {c}": "Presupuesto de {c}",
 "Lançar um gasto nesta parada": "Registrar un gasto en esta parada",
 "Lançar gasto": "Registrar gasto",
 "Orçamento e gastos da parada": "Presupuesto y gastos de la parada",
 "Gastos lançados ({n})": "Gastos registrados ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Para corregir o borrar un gasto, usa la pestaña Presupuesto y gastos del viaje.",
 "Paradas": "Paradas",
 "Cidade ou lugar": "Ciudad o lugar",
 "Ex.: Porto": "Ej.: Oporto",
 "Chegada": "Llegada",
 "Saída": "Salida",
 "Onde vai ficar": "Dónde te vas a alojar",
 "gasto {g} de {p}": "gastado {g} de {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "¿Vas a pasar por más de una ciudad? Registra cada parada con sus fechas. Cada una tiene su propio presupuesto (alojamiento, comidas, transporte...) y los gastos de esas fechas entran en ella solos.",
 "Café da tarde": "Merienda",
 "Outros / Lanches": "Otros / Meriendas",
 "Gasto {v}": "Gastado {v}",
 "Gasto {g} de {p} · {a} acima": "Gastado {g} de {p} · {a} por encima",
 "Gasto {g} de {p}": "Gastado {g} de {p}",
 "Tirar \"{nome}\" do orçamento?": "¿Quitar \"{nome}\" del presupuesto?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Los gastos ya registrados en ella siguen en la lista de gastos.",
 "Previsto para {nome}": "Previsto para {nome}",
 "Tirar {nome}": "Quitar {nome}",
 "Nome do item (ex.: Jantar especial)": "Nombre del elemento (ej.: Cena especial)",
 "Adicionar item": "Añadir elemento",
 "Detalhar em itens": "Detallar en elementos",
 "Nova categoria (ex.: Seguro, Presentes)": "Nueva categoría (ej.: Seguro, Regalos)",
 "Voltar às categorias sugeridas?": "¿Volver a las categorías sugeridas?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Los importes previstos de esta lista se borrarán. Los gastos registrados se mantienen.",
 "Voltar às categorias sugeridas": "Volver a las categorías sugeridas",
 "Previsto": "Previsto",
 "Ainda pode gastar": "Aún puedes gastar",
 "Passou do previsto": "Superó lo previsto",
 "Não foi possível buscar o câmbio": "No se pudo obtener el tipo de cambio",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Sin internet o la moneda {m} no está en la tabla. Edita el viaje y escribe el tipo de cambio a mano.",
 "Câmbio de {m} ainda não definido": "Tipo de cambio de {m} aún sin definir",
 "Câmbio de hoje": "Cambio de hoy",
 "Atualizado em {d}": "Actualizado el {d}",
 "Valor em {m}": "Valor en {m}",
 "Moeda do destino": "Moneda del destino",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Tipo de cambio: cuánto vale 1 de la moneda del destino en tu moneda",
 "Sem dia marcado": "Sin día marcado",
 "Valor na moeda do destino": "Valor en la moneda del destino",
 "Tirar só desta lista ou excluir de vez?": "¿Quitar solo de esta lista o eliminar para siempre?",
 "Excluir de vez": "Eliminar para siempre",
 "Relatório da viagem (PDF)": "Informe del viaje (PDF)",
 "Planilha da viagem (Excel)": "Hoja de cálculo del viaje (Excel)",
 "Geral da viagem": "General del viaje",
 "Viagem {d}": "Viaje {d}",
 "Quem vai: {p}": "Quién va: {p}",
 "Outros gastos": "Otros gastos",
 "Orçamento · {n}": "Presupuesto · {n}",
 "Código": "Código",
 "Pagou": "Pagó",
 "Permissão internacional para dirigir": "Permiso internacional de conducir",
 "Vacina (certificado)": "Vacuna (certificado)",
 "Autorização de viagem de menor": "Autorización de viaje de menor",
 "Vence antes da volta": "Vence antes del regreso",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Vence menos de 6 meses después del regreso (muchos países no lo aceptan)",
 "A lista básica já está aqui.": "La lista básica ya está aquí.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} documento(s) con vencimiento que puede afectar el viaje",
 "Lista básica: passaporte de cada um e seguro viagem": "Lista básica: pasaporte de cada uno y seguro de viaje",
 "Lista básica: identidade de cada um": "Lista básica: documento de identidad de cada uno",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Indica el vencimiento de cada documento: la app avisa antes de que venza y comprueba si el pasaporte es válido 6 meses después del regreso. Las fotos de los documentos quedan protegidas en la caja fuerte.",
 "De quem": "De quién",
 "Número (protegido no cofre)": "Número (protegido en la caja fuerte)",
 "Está em mãos": "Lo tengo en mano",
 "Válido até {d}": "Válido hasta {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Pasaporte, visa, seguro de viaje, vacuna, autorización de menor... con vencimiento y foto. Márcalo cuando lo tengas en mano.",
 "acerto entre os viajantes (não entra no orçamento)": "ajuste entre viajeros (no entra en el presupuesto)",
 "Só gastos": "Solo gastos",
 "Acertos": "Ajustes",
 "Marcar como pago?": "¿Marcar como pagado?",
 "{de} já pagou {v} para {para}?": "¿{de} ya pagó {v} a {para}?",
 "Já pagou": "Ya pagó",
 "Acerto: {de} pagou {para}": "Ajuste: {de} pagó a {para}",
 "Conferir minhas assinaturas": "Revisar mis suscripciones",
 "Gerenciar ou cancelar assinaturas na loja": "Gestionar o cancelar suscripciones en la tienda",
 "Restaurar compras": "Restaurar compras",
 "Procurando...": "Buscando...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} suscripción(es) encontrada(s) y activada(s).",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Suscripción anual, se renueva sola. Cancela cuando quieras en las suscripciones de la tienda, hasta 24 horas antes de la renovación.",
 "Assinaturas da loja": "Suscripciones de la tienda",
 "Gerenciar assinaturas (App Store)": "Gestionar suscripciones (App Store)",
 "Gerenciar assinaturas (Google Play)": "Gestionar suscripciones (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "La suscripción se hace en la app del celular (Google Play o App Store) y también vale aquí en el sitio.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Esta suscripción aún no está disponible en la tienda. Inténtalo más tarde.",
 "Assinatura feita": "Suscripción hecha",
 "Já assinei no celular: conferir": "Ya me suscribí en el celular: revisar",
 "Nenhuma assinatura encontrada nesta conta da loja.": "No se encontró ninguna suscripción en esta cuenta de la tienda.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Revisa internet e inténtalo de nuevo. No se cobró nada.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} activada. También vale en tus otros dispositivos y en el sitio.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Para suscribirte, actualiza My Planner desde Google Play o App Store.",
 "Assinada, renova em {data}": "Suscrita, se renueva el {data}",
 "Não deu para assinar agora": "No se pudo suscribir ahora",
 "Assinar por {preco} por ano": "Suscribirse por {preco} al año",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" pasó al Mural, en Logros.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" ya forma parte de tu rutina. Pasó al Mural, en Logros.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" volvió a su lugar.",
 "1 ano": "1 año",
 "1 mês": "1 mes",
 "A IA não achou o valor no comprovante.": "La IA no encontró el valor en el comprobante.",
 "A cada {n} dias": "Cada {n} días",
 "A carta está vazia": "La carta está vacía",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "La carta queda bloqueada hasta el {d}. Hasta entonces no se puede releer ni editar. Para cambiar algo, escribe otra carta.",
 "A lixeira está vazia.": "La papelera está vacía.",
 "A mesma do app e do celular": "La misma de la app y del móvil",
 "A mesma forma de desbloqueio do app e do celular": "El mismo método de desbloqueo de la app y del móvil",
 "A senha do diário precisa ter 6 caracteres ou mais.": "La contraseña del diario debe tener 6 caracteres o más.",
 "A senha precisa ter 6 caracteres ou mais.": "La contraseña debe tener 6 caracteres o más.",
 "A turma ainda não tem grupo": "El grupo aún no tiene grupo de chat",
 "AS 4 BOLINHAS DE COR": "LOS 4 PUNTOS DE COLOR",
 "Aberta em {d}": "Abierta el {d}",
 "Abra a aba para poder restaurar": "Abre la pestaña para poder restaurar",
 "Abra o diário primeiro": "Abre primero el diario",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Se abre con la biometría, el reconocimiento facial o la contraseña de la app. La contraseña del diario solo se pide la primera vez en cada dispositivo.",
 "Abre em {d}": "Se abre el {d}",
 "Abrir carta para o futuro": "Abrir carta al futuro",
 "Abrir em {aba}": "Abrir en {aba}",
 "Abrir o Diário": "Abrir el Diario",
 "Abrir o diário": "Abrir el diario",
 "Abrir {aba}": "Abrir {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Sigue el inmueble, las reservas, la ocupación, los gastos y la ganancia, sin cambiar nada.",
 "Adicionar foto": "Añadir foto",
 "Apaga tudo o que está no quadro desta página.": "Borra todo lo que hay en la pizarra de esta página.",
 "Apagar o desenho?": "¿Borrar el dibujo?",
 "Apagar o diário": "Borrar el diario",
 "Apagar para todos?": "¿Borrar para todos?",
 "Aplicar a todas as páginas desta matéria": "Aplicar a todas las páginas de esta materia",
 "Aplicar a todas as páginas desta pasta": "Aplicar a todas las páginas de esta carpeta",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Apuntes, listas, diapositivas, videos, enlaces y avisos. Desde ⋮ › Enviar al grupo, cada alumno lo recibe en su app.",
 "Aquarela": "Acuarela",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Aquí aparece, sin costo, lo que los grupos compartieron contigo. Para usar la pestaña con tus propios datos, suscríbete a la pestaña.",
 "Arquivados": "Archivados",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Desliza a la derecha para eliminar, o a la izquierda para archivar.",
 "As cobranças desta aula extra já existem.": "Los cobros de esta clase extra ya existen.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Las notas van solo a cada alumno. Para eso, el nombre de la persona en el grupo debe ser igual al nombre del alumno o del responsable en el registro.",
 "Atestado": "Certificado médico",
 "Atestados": "Certificados médicos",
 "Até quando (opcional)": "Hasta cuándo (opcional)",
 "Até {d}": "Hasta el {d}",
 "Aula extra": "Clase extra",
 "Aula extra (fora dos dias de aula)": "Clase extra (fuera de los días de clase)",
 "Aula extra de {d}": "Clase extra del {d}",
 "Avaliação de {d}": "Evaluación del {d}",
 "Avaliação salva": "Evaluación guardada",
 "Avançar": "Siguiente",
 "Aviso da revisão do mês": "Aviso de la revisión del mes",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Aviso el último día del mes: \"¿Qué tal si revisas tu mes? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Aviso sin ningún contenido del diario: \"¿Cómo fue tu día? ✍️\"",
 "Avulsa": "Suelta",
 "Avulsas": "Sueltas",
 "Azul": "Azul",
 "Baixar na App Store": "Descargar en App Store",
 "Baixar na Google Play": "Descargar en Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Descarga My Planner en la tienda: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometría, reconocimiento facial o la contraseña de la app. La contraseña del diario queda guardada para la primera vez en cada dispositivo.",
 "Branco": "Blanco",
 "Buscando o clima…": "Buscando el clima…",
 "Básicas": "Básicas",
 "COMO ESTOU": "CÓMO ESTOY",
 "COMO O DIÁRIO ABRE": "CÓMO SE ABRE EL DIARIO",
 "COR DA FOLHA": "COLOR DE LA HOJA",
 "Caixinha no My Planner": "Hucha en My Planner",
 "Caixinha {m}": "Hucha {m}",
 "Carta de {d}": "Carta del {d}",
 "Carta guardada": "Carta guardada",
 "Carta para o futuro": "Carta al futuro",
 "Carta trancada": "Carta bloqueada",
 "Cartas abertas podem ser lidas, mas não editadas.": "Las cartas abiertas se pueden leer, pero no editar.",
 "Cartas para o Futuro": "Cartas al Futuro",
 "Cartões arquivados": "Tarjetas archivadas",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Llegó una carta de {nome} de hace {tempo} 💌",
 "Chegou! Toque para abrir 💌": "¡Llegó! Toca para abrir 💌",
 "Cinza-escuro": "Gris oscuro",
 "Clara (segue o tema)": "Clara (sigue el tema)",
 "Claras e pastel (boas para folha escura)": "Claros y pastel (buenos para hoja oscura)",
 "Clima (toque para preencher)": "Clima (toca para completar)",
 "Clima automático": "Clima automático",
 "Clima do dia": "Clima del día",
 "Cobrar a aula extra": "Cobrar la clase extra",
 "Cobrar a aula extra dos presentes": "Cobrar la clase extra a los presentes",
 "Cobrar a turma toda": "Cobrar a todo el grupo",
 "Cole um link que comece com https://": "Pega un enlace que empiece con https://",
 "Coloque o valor da aula extra na turma (Editar).": "Pon el valor de la clase extra en el grupo (Editar).",
 "Coloque o valor.": "Pon el valor.",
 "Colunas": "Columnas",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Con tu IA activada (Ajustes › Inteligencia artificial), la app lee el valor, la fecha y la descripción en la foto.",
 "Como cuidei de mim hoje?": "¿Cómo me cuidé hoy?",
 "Como foi o seu dia? ✍️": "¿Cómo fue tu día? ✍️",
 "Compartilhar este projeto (convidar)": "Compartir este proyecto (invitar)",
 "Compartilhar o texto": "Compartir el texto",
 "Completa": "Completa",
 "Comprovante (foto, PDF ou print)": "Comprobante (foto, PDF o captura)",
 "Comprovante anexado": "Comprobante adjunto",
 "Comprovante de pagamento (foto ou PDF)": "Comprobante de pago (foto o PDF)",
 "Concluído: hábito formado": "Completado: hábito formado",
 "Concluídos": "Completados",
 "Configurar o Diário": "Configurar el Diario",
 "Confirmar pagamento": "Confirmar pago",
 "Confirmar recebimento": "Confirmar cobro",
 "Conquistas": "Logros",
 "Contas arquivadas": "Cuentas archivadas",
 "Continuar escrevendo": "Seguir escribiendo",
 "Copiado ✓": "Copiado ✓",
 "Copiar código": "Copiar código",
 "Copiar link": "Copiar enlace",
 "Cor atual": "Color actual",
 "Cor {n}": "Color {n}",
 "Creme": "Crema",
 "Criada em {d}": "Creada el {d}",
 "Criar as cobranças": "Crear los cobros",
 "Criar o grupo da turma": "Crear el grupo de chat del grupo",
 "Criar o meu diário": "Crear mi diario",
 "Crie a senha do diário (6 ou mais)": "Crea la contraseña del diario (6 o más)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Crea el grupo de chat del grupo y envía la invitación a los alumnos. Después, el envío les llega directamente.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Crea tu primera meta, objetivo o sueño con el botón + de abajo.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Crea un proyecto, invita a quienes participan y reparte los pasos. Cada persona marca lo que hizo.",
 "Crie uma senha nova para começar.": "Crea una contraseña nueva para empezar.",
 "Cuidados arquivados": "Cuidados archivados",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Cuidados personales del día hechos (Bienestar)",
 "Curto prazo": "Corto plazo",
 "Custos": "Costos",
 "Céu estrelado": "Cielo estrellado",
 "Círculo": "Círculo",
 "Cômodos arquivados": "Habitaciones archivadas",
 "DIAS CUMPRIDOS": "DÍAS CUMPLIDOS",
 "Data (opcional)": "Fecha (opcional)",
 "De {d}": "Del {d}",
 "Desafixar do topo": "Desfijar de arriba",
 "Desenho mais fraco ou mais forte": "Dibujo más suave o más fuerte",
 "Desfazer \"Concluído\" ({d})": "Deshacer \"Completado\" ({d})",
 "Desligado": "Desactivado",
 "Desmarcar": "Desmarcar",
 "Desmarcar como paga?": "¿Desmarcar como pagada?",
 "Desmarcar como recebida?": "¿Desmarcar como recibida?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Desmarca lo que no usas: desaparece de la pantalla y la pestaña queda más simple. Puedes cambiarlo después en Ajustes › Pestañas › {aba} › Partes de esta pestaña.",
 "Dias da semana": "Días de la semana",
 "Dias de aula": "Días de clase",
 "Dias de aula: {d}": "Días de clase: {d}",
 "Dias escritos": "Días escritos",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Consejo: dibuja la forma a mano y mantén el dedo al final del trazo para que quede perfecta.",
 "Ditado": "Dictado",
 "Ditar (falar para escrever)": "Dictar (hablar para escribir)",
 "Diário apagado": "Diario borrado",
 "Diário protegido": "Diario protegido",
 "Dom": "Dom",
 "Dê um nome a ele na pasta Hábitos.": "Ponle un nombre en la carpeta Hábitos.",
 "EVOLUÇÃO": "EVOLUCIÓN",
 "Editada em {d}": "Editada el {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Se abre el {d} ({n} días). Hasta entonces no se puede releer ni editar.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Se abre el {d}. Recibirás un aviso ese día.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Queda guardada con la fecha de hoy para comparar después.",
 "Enorme": "Enorme",
 "Enviado ao paciente": "Enviado al paciente",
 "Enviado em": "Enviado el",
 "Enviar \"{t}\" para todos do grupo {g}?": "¿Enviar \"{t}\" a todos del grupo {g}?",
 "Enviar a nota para cada aluno": "Enviar la nota a cada alumno",
 "Enviar as notas": "Enviar las notas",
 "Enviar o arquivo: {nome}": "Enviar el archivo: {nome}",
 "Enviar o recado para a turma": "Enviar el aviso al grupo",
 "Enviar o título para outra aba": "Enviar el título a otra pestaña",
 "Enviar para a turma": "Enviar al grupo",
 "Enviar para outra aba": "Enviar a otra pestaña",
 "Escolha a cor desta bolinha": "Elige el color de este punto",
 "Escolha uma data no futuro": "Elige una fecha en el futuro",
 "Escolher qualquer cor": "Elegir cualquier color",
 "Esconder a barra": "Ocultar la barra",
 "Escreva a frase": "Escribe la frase",
 "Escreva a que se refere a cobrança.": "Escribe a qué se refiere el cobro.",
 "Escreva alguma coisa antes de guardar.": "Escribe algo antes de guardar.",
 "Escreva alguma coisa antes de salvar.": "Escribe algo antes de guardar.",
 "Escreva hoje, abra no futuro": "Escribe hoy, ábrela en el futuro",
 "Escreva o que você quer mudar a partir de hoje": "Escribe lo que quieres cambiar a partir de hoy",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Escríbele a tu yo del futuro. La carta queda bloqueada hasta el día de abrirla.",
 "Escrever uma carta": "Escribir una carta",
 "Escrita em {e} · abre em {a}": "Escrita el {e} · se abre el {a}",
 "Escuras (boas para folha clara)": "Oscuros (buenos para hoja clara)",
 "Esperado": "Esperado",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Esperado: {e} · Hecho: {f} · Faltó: {fa}",
 "Esqueceu a senha do diário?": "¿Olvidaste la contraseña del diario?",
 "Esqueci a senha do diário": "Olvidé la contraseña del diario",
 "Esta semana": "Esta semana",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Este movimiento viene de otra parte de la app y no se borra aquí.",
 "Estudo: {h}": "Estudio: {h}",
 "Esvaziar": "Vaciar",
 "Esvaziar a lixeira": "Vaciar la papelera",
 "Esvaziar a lixeira?": "¿Vaciar la papelera?",
 "Ex.: Comer uma fruta por dia": "Ej.: Comer una fruta al día",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Ej.: Ejercicios para casa, Certificado médico de 2 días",
 "Ex.: Reservar a pousada": "Ej.: Reservar la posada",
 "Ex.: Viagem em família, juntar para a festa": "Ej.: Viaje en familia, ahorrar para la fiesta",
 "Excluir de vez?": "¿Eliminar definitivamente?",
 "Excluir esta avaliação?": "¿Eliminar esta evaluación?",
 "Excluir este bloco?": "¿Eliminar este bloque?",
 "Excluir este desenho?": "¿Eliminar este dibujo?",
 "Excluir este item?": "¿Eliminar este elemento?",
 "Excluir {n} item(ns)?": "¿Eliminar {n} elemento(s)?",
 "Exportar como imagem": "Exportar como imagen",
 "Exportar em PDF": "Exportar en PDF",
 "FOTOS": "FOTOS",
 "FRASE DO DIA": "FRASE DEL DÍA",
 "FREQUÊNCIA": "FRECUENCIA",
 "Falta o valor": "Falta el valor",
 "Feriado": "Feriado",
 "Feriado: {f}": "Feriado: {f}",
 "Fica 30 dias na lixeira.": "Se queda 30 días en la papelera.",
 "Ficam 30 dias na lixeira.": "Se quedan 30 días en la papelera.",
 "Fichários arquivados": "Carpetas archivadas",
 "Fixar no topo": "Fijar arriba",
 "Floral": "Floral",
 "Folha": "Hoja",
 "Folha, tema e cores das páginas com escrita": "Hoja, tema y colores de las páginas con escritura",
 "Folhas e plantas": "Hojas y plantas",
 "Foto adicionada": "Foto añadida",
 "Foto do sonho": "Foto del sueño",
 "Fotos do dia": "Fotos del día",
 "Frase": "Frase",
 "Frase do dia (aparece no topo do Meu Dia)": "Frase del día (aparece arriba en Mi Día)",
 "Frases, textos, vídeos e fotos que motivam": "Frases, textos, videos y fotos que motivan",
 "Geométrico": "Geométrico",
 "Gerar": "Generar",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Grabar recordatorios y notas por voz y dictar textos (🎤) cuando lo pidas. El micrófono solo se activa cuando lo tocas, y el audio del dictado no se guarda.",
 "Guardar e trancar": "Guardar y bloquear",
 "Guardar e trancar?": "¿Guardar y bloquear?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Guarda aquí lo que te motiva: frases, textos tuyos, videos y fotos.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Guarda bien esta contraseña: sin ella el diario no se puede recuperar.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Hoy es feriado: {f}. ¿Registrar de todos modos?",
 "Humor do mês": "Ánimo del mes",
 "Humor do período": "Ánimo del período",
 "HÁBITOS LIGADOS": "HÁBITOS VINCULADOS",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "Hay elementos grandes en la selección. Solo se pueden eliminar uno por uno, con confirmación y contraseña.",
 "Há um ano": "Hace un año",
 "Há um mês": "Hace un mes",
 "Hábito": "Hábito",
 "Hábito criado": "Hábito creado",
 "Hábitos": "Hábitos",
 "Hábitos cumpridos": "Hábitos cumplidos",
 "Hábitos cumpridos: {f} de {n}": "Hábitos cumplidos: {f} de {n}",
 "Hábitos formados": "Hábitos formados",
 "INSPIRAÇÃO": "INSPIRACIÓN",
 "Imagem adicionada": "Imagen añadida",
 "Imagem não encontrada": "Imagen no encontrada",
 "Incrível": "Increíble",
 "Informação nutricional": "Información nutricional",
 "Inserir": "Insertar",
 "Inspiração": "Inspiración",
 "Item para o paciente": "Elemento para el paciente",
 "Itens grandes só se excluem um por um.": "Los elementos grandes solo se eliminan uno por uno.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Reúne fotos de lo que quieres vivir. Mantén pulsado y arrastra para organizar.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "VINCULAR A UN SUEÑO DEL PROYECTO DE VIDA (OPCIONAL)",
 "LIGAR A UMA META (OPCIONAL)": "VINCULAR A UNA META (OPCIONAL)",
 "LINKS DE VÍDEO": "ENLACES DE VIDEO",
 "Lance as notas antes de enviar.": "Pon las notas antes de enviar.",
 "Lançamentos arquivados": "Movimientos archivados",
 "Legenda (opcional)": "Leyenda (opcional)",
 "Lembrete diário": "Recordatorio diario",
 "Lendo o comprovante...": "Leyendo el comprobante...",
 "Ler o comprovante com a minha IA": "Leer el comprobante con mi IA",
 "Ligado": "Activado",
 "Ligar um texto de motivação (Inspiração)": "Vincular un texto de motivación (Inspiración)",
 "Lilás": "Lila",
 "Limpar a folha inteira?": "¿Limpiar la hoja entera?",
 "Linha reta": "Línea recta",
 "Linhas": "Líneas",
 "Link do vídeo (YouTube, Instagram...)": "Enlace del video (YouTube, Instagram...)",
 "Lisa": "Lisa",
 "Liste os passos do projeto e diga quem faz cada um.": "Enumera los pasos del proyecto y di quién hace cada uno.",
 "Lixeira": "Papelera",
 "Longo prazo": "Largo plazo",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "MARCAR AUTOMÁTICAMENTE CON BIENESTAR (OPCIONAL)",
 "META OU SONHO LIGADO (OPCIONAL)": "META O SUEÑO VINCULADO (OPCIONAL)",
 "Mais opções": "Más opciones",
 "Mal": "Mal",
 "Mandar ao paciente pelo WhatsApp": "Enviar al paciente por WhatsApp",
 "Marque o que fez em cada dia": "Marca lo que hiciste cada día",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Marca los días de clase en el grupo (Editar) para que la lista de asistencia muestre solo esos días.",
 "Matérias arquivadas": "Materias archivadas",
 "Mensalidade": "Mensualidad",
 "Meta de água do Bem-Estar": "Meta de agua de Bienestar",
 "Metas arquivadas": "Metas archivadas",
 "Metas e sonhos concluídos": "Metas y sueños completados",
 "Metas em andamento": "Metas en curso",
 "Metas que avançaram": "Metas que avanzaron",
 "Metas, objetivos e sonhos, com passos e prazos": "Metas, objetivos y sueños, con pasos y plazos",
 "Meu Dia": "Mi Día",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "Mi Día con página libre, proyecto de vida, hábitos, tablero de sueños, rueda de la vida, cartas al futuro y logros. Protegido con contraseña.",
 "Minimalista": "Minimalista",
 "Mostrar as contas antes do vencimento": "Mostrar las cuentas antes del vencimiento",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Mostrar fechas, horas, moneda y feriados correctos para donde estás. La ubicación aproximada del móvil solo se usa cuando pides el clima del día en el Diario, y no se guarda.",
 "Muito bem": "Muy bien",
 "Muito mal": "Muy mal",
 "Mural de fotos dos seus sonhos": "Mural de fotos de tus sueños",
 "Mural, relatório e revisão do mês": "Mural, informe y revisión del mes",
 "Médio prazo": "Mediano plazo",
 "N dias cumpridos no mês": "N días cumplidos en el mes",
 "N dias seguidos": "N días seguidos",
 "NESTE DIA": "EN ESTE DÍA",
 "Nada a enviar": "Nada que enviar",
 "Nenhum estudo registrado nesta semana.": "Ningún estudio registrado esta semana.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Aún no hay hábitos. Ej.: \"Comer una fruta al día\", \"Beber 2 L de agua\", \"No saltarme el desayuno\".",
 "Nenhum no período.": "Ninguno en el período.",
 "Nenhuma": "Ninguna",
 "Nenhuma carta ainda.": "Aún no hay cartas.",
 "Nenhuma foto ainda.": "Aún no hay fotos.",
 "Neutras e opacas": "Neutros y opacos",
 "Ninguém encontrado no grupo": "No se encontró a nadie en el grupo",
 "No computador: {link}": "En el ordenador: {link}",
 "No navegador, a senha do diário é pedida sempre.": "En el navegador, la contraseña del diario se pide siempre.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "El último día del mes: \"¿Qué tal si revisas tu mes? ✨\"",
 "Nome da página (opcional)": "Nombre de la página (opcional)",
 "Nome de quem faz este passo": "Nombre de quien hace este paso",
 "Nome do vídeo (opcional)": "Nombre del video (opcional)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Nota de 0 a 10 para cada área de la vida",
 "Nota: {a}": "Nota: {a}",
 "Nova caixa": "Nueva tarjeta",
 "Nova carta": "Nueva carta",
 "Nova meta, objetivo ou sonho": "Nueva meta, objetivo o sueño",
 "Nova senha (6 caracteres ou mais)": "Nueva contraseña (6 caracteres o más)",
 "Nova área (ex.: Espiritualidade)": "Nueva área (ej.: Espiritualidad)",
 "Novo cômodo": "Nueva habitación",
 "Novo hábito": "Nuevo hábito",
 "Não dá para excluir em grupo": "No se puede eliminar en grupo",
 "Não enviados": "No enviados",
 "Não estão no grupo (ou com outro nome): {l}": "No están en el grupo (o tienen otro nombre): {l}",
 "Não foi possível exportar": "No se pudo exportar",
 "Não foi possível ouvir agora ({erro}).": "No se pudo escuchar ahora ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "No pide la contraseña del diario. Es la única parte que se puede compartir.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "No es día de clase de este grupo. La asistencia queda como recuperación o clase extra.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "La app avisa {n} día(s) antes y el día del vencimiento, a las 9h. Puedes cambiarlo en Ajustes › Pestañas › Finanzas.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "El clima automático usa la ubicación del móvil. Sin permiso, queda para completarlo aquí.",
 "O conteúdo desta carta não foi encontrado.": "No se encontró el contenido de esta carta.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "El dictado llega con la nueva versión de la app. Actualiza My Planner en la tienda (o instala el APK nuevo) para usar el micrófono.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "El diario pide la contraseña cada vez que entras, aunque la app esté desbloqueada.",
 "O diário só abre com essa senha, sempre.": "El diario solo se abre con esa contraseña, siempre.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "El diario está cifrado: sin la contraseña, nadie puede abrirlo, ni siquiera soporte. Si quieres, puedes borrar el diario y empezar uno nuevo (los Proyectos en Grupo se mantienen).",
 "O que aprendi hoje?": "¿Qué aprendí hoy?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "¿Qué te enseñó este mes? ¿Qué quieres llevar al próximo?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Lo que queda desmarcado desaparece de la pantalla. Los datos siguen guardados.",
 "O que foi bom hoje?": "¿Qué fue bueno hoy?",
 "O que foi excluído nos últimos 30 dias": "Lo que se eliminó en los últimos 30 días",
 "O que quero melhorar amanhã?": "¿Qué quiero mejorar mañana?",
 "O que quero mudar agora": "Lo que quiero cambiar ahora",
 "O que você escreveu nesta carta vai se perder.": "Lo que escribiste en esta carta se perderá.",
 "O que você quer fazer com o arquivo?": "¿Qué quieres hacer con el archivo?",
 "Objetivo": "Objetivo",
 "Oculta": "Oculta",
 "Orientação": "Indicación",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Indicaciones, recetas, certificados médicos y materiales para entregar al paciente, con archivos. Solo se envía lo que está aquí: la historia clínica nunca sale por esta carpeta.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Los días con página escrita quedan marcados. Toca un día para abrirlo.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Los elementos se eliminan definitivamente y ya no se pueden restaurar.",
 "Outra data": "Otra fecha",
 "Outras moedas": "Otras monedas",
 "Ouvindo…": "Escuchando…",
 "PASSOS": "PASOS",
 "PDF com seus dados e assinatura": "PDF con tus datos y firma",
 "POR DIA": "POR DÍA",
 "POR MATÉRIA": "POR MATERIA",
 "PROGRESSO": "PROGRESO",
 "Paciente: {nome}": "Paciente: {nome}",
 "Para o paciente": "Para el paciente",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Para cambiar el método de apertura, entra en el Diario con su contraseña y vuelve aquí.",
 "Para {nome} de {tempo} depois": "Para {nome} de {tempo} después",
 "Parar o ditado": "Detener el dictado",
 "Parcelado": "En cuotas",
 "Partes desta aba": "Partes de esta pestaña",
 "Passo": "Paso",
 "Pastas arquivadas": "Carpetas archivadas",
 "Pastas arquivadas ({n})": "Carpetas archivadas ({n})",
 "Pautada": "Rayada",
 "Pautada com margem": "Rayada con margen",
 "Pedido de exame": "Solicitud de examen",
 "Pelo que sou grata hoje?": "¿Por qué estoy agradecida hoy?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Permite el micrófono y el reconocimiento de voz para My Planner en los ajustes del móvil.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Personalizar: tipo, color y tema de la hoja y colores de los puntos, solo para esta pestaña",
 "Pontilhada": "Punteada",
 "Posto": "Asignado",
 "Preenche o clima do Meu Dia pela localização do celular.": "Completa el clima de Mi Día con la ubicación del móvil.",
 "Preencher pela foto do comprovante": "Completar con la foto del comprobante",
 "Primeira vez neste aparelho: digite a senha do diário.": "Primera vez en este dispositivo: escribe la contraseña del diario.",
 "Projeto": "Proyecto",
 "Projeto de Vida": "Proyecto de Vida",
 "Projetos com amigos e família (compartilhados)": "Proyectos con amigos y familia (compartidos)",
 "Projetos em Grupo": "Proyectos en Grupo",
 "Proprietário / Locador": "Propietario / Arrendador",
 "Páginas arquivadas": "Páginas archivadas",
 "Páginas desta aba": "Páginas de esta pestaña",
 "QUANDO ELA ABRE": "CUÁNDO SE ABRE",
 "Qua": "Mié",
 "Quadriculada": "Cuadriculada",
 "Quadro dos Sonhos": "Tablero de Sueños",
 "Quais partes você vai usar?": "¿Qué partes vas a usar?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Cuando completes una meta o formes un hábito, aparecerá aquí para celebrarlo. 🎉",
 "Quanto você pagou?": "¿Cuánto pagaste?",
 "Quanto você recebeu?": "¿Cuánto recibiste?",
 "Que tal revisar o seu mês? ✨": "¿Qué tal si revisas tu mes? ✨",
 "Quem faz": "Quién lo hace",
 "Quem fez o meu dia melhor?": "¿Quién hizo mejor mi día?",
 "Quer guardar o comprovante agora?": "¿Quieres guardar el comprobante ahora?",
 "Qui": "Jue",
 "REFLEXÃO DO MÊS": "REFLEXIÓN DEL MES",
 "Recebeu {v} a mais": "Recibiste {v} de más",
 "Recebeu {v} a menos": "Recibiste {v} de menos",
 "Receita médica": "Receta médica",
 "Receitas médicas": "Recetas médicas",
 "Recolher": "Contraer",
 "Refeições arquivadas": "Comidas archivadas",
 "Refeições do cronograma feitas (Bem-Estar)": "Comidas del plan hechas (Bienestar)",
 "Referente a (ex.: material, passeio, inscrição)": "Concepto (ej.: material, paseo, inscripción)",
 "Registrar": "Registrar",
 "Relacionamentos": "Relaciones",
 "Relatório de estudos": "Informe de estudios",
 "Relatório de realizações": "Informe de logros",
 "Relatório em PDF": "Informe en PDF",
 "Renomear, adicionar ou tirar áreas": "Renombrar, añadir o quitar áreas",
 "Reposição": "Recuperación",
 "Restaurado": "Restaurado",
 "Resumida": "Resumida",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Resumida: solo una línea con el total. Completa: muestra los elementos del día. Oculta: no aparece. Nada de esta pestaña se convierte en tarea por sí solo.",
 "Resumo de {nome}": "Resumen de {nome}",
 "Resumo do dia": "Resumen del día",
 "Retângulo": "Rectángulo",
 "Revisar antes": "Revisar antes",
 "Revisão do mês": "Revisión del mes",
 "Roda da Vida": "Rueda de la Vida",
 "Rosa": "Rosa",
 "Sair sem guardar?": "¿Salir sin guardar?",
 "Salvar avaliação de hoje": "Guardar la evaluación de hoy",
 "Salvar ou enviar": "Guardar o enviar",
 "Seg": "Lun",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Mantén pulsadas las carpetas y arrástralas para cambiar el orden. Desliza a la izquierda para archivar.",
 "Sem chamada neste dia: cobra todos os alunos.": "Sin lista de asistencia este día: se cobra a todos los alumnos.",
 "Sem ideia do que escrever? Toque numa pergunta:": "¿No sabes qué escribir? Toca una pregunta:",
 "Sem registros de humor.": "Sin registros de ánimo.",
 "Sem tema": "Sin tema",
 "Semana de {d}": "Semana del {d}",
 "Senha atual do diário": "Contraseña actual del diario",
 "Senha do diário": "Contraseña del diario",
 "Senha do diário incorreta.": "Contraseña del diario incorrecta.",
 "Senha do diário trocada": "Contraseña del diario cambiada",
 "Senha própria só do diário": "Contraseña propia solo del diario",
 "Sequência dos hábitos": "Racha de hábitos",
 "Seta": "Flecha",
 "Seu diário, só seu": "Tu diario, solo tuyo",
 "Seu texto de motivação": "Tu texto de motivación",
 "Sex": "Vie",
 "Sonho": "Sueño",
 "Suplementos arquivados": "Suplementos archivados",
 "Sáb": "Sáb",
 "Só abre com a senha do diário.": "Solo se abre con la contraseña del diario.",
 "TEMA DECORATIVO": "TEMA DECORATIVO",
 "TIPO DE FOLHA": "TIPO DE HOJA",
 "Tarefas arquivadas": "Tareas archivadas",
 "Ter": "Mar",
 "Texto para o paciente": "Texto para el paciente",
 "Tipo, cor e tema da folha": "Tipo, color y tema de la hoja",
 "Tirar a área \"{a}\"?": "¿Quitar el área \"{a}\"?",
 "Tirar da frase do dia": "Quitar de la frase del día",
 "Tirar do arquivo": "Desarchivar",
 "Tirar esta foto do quadro?": "¿Quitar esta foto del tablero?",
 "Tirar esta pergunta?": "¿Quitar esta pregunta?",
 "Tirar este vídeo?": "¿Quitar este video?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Todos los días a las {h}: \"¿Cómo fue tu día? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Todos los alumnos ya tienen un cobro con este concepto.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Toca de nuevo para \"Otros\" (justificado, certificado médico...): no cuenta como falta ni como clase.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Toca el círculo para marcar lo que hiciste hoy. Los hábitos no van a My Planner por sí solos: usa Enviar, en el menú ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Toca un día para marcarlo o desmarcarlo.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Toca un punto para cambiar el color. En la página, mantener pulsado el punto hace lo mismo.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Toca para abrir. Desliza a la izquierda para archivar o duplicar, o a la derecha para eliminar.",
 "Treino do dia feito (Bem-Estar)": "Entrenamiento del día hecho (Bienestar)",
 "Treinos arquivados": "Entrenamientos archivados",
 "Trocar a senha do diário": "Cambiar la contraseña del diario",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Todo lo que escribas en el diario se cifra en este dispositivo antes de ir a tu cuenta. Nadie más puede leerlo, ni siquiera soporte.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Todo lo que eliminas queda aquí durante 30 días. Después se elimina definitivamente.",
 "Título (ex.: Ter uma boa alimentação)": "Título (ej.: Tener una buena alimentación)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Un cobro suelto para cada uno de los {n} alumno(s). Para cobrar solo a un alumno, toca +.",
 "Uma senha própria, só do diário": "Una contraseña propia, solo del diario",
 "Usar a senha do diário": "Usar la contraseña del diario",
 "Usar como frase do dia": "Usar como frase del día",
 "Usar este valor": "Usar este valor",
 "Usar o padrão do app": "Usar el predeterminado de la app",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Aplica a los valores de todas las pestañas (Finanzas, alquiler, mensualidades...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Aplica a todas las páginas con escritura (Estudios, Notas, Diario, Documentos...). Cada pestaña puede tener su propio predeterminado en Ajustes › Pestañas, y cada página puede cambiar la hoja en ⋮ › Hoja.",
 "Valor da aula extra (por aluno)": "Valor de la clase extra (por alumno)",
 "Valor por aluno": "Valor por alumno",
 "Valor previsto: {v}": "Valor previsto: {v}",
 "Vencimento: {d}": "Vencimiento: {d}",
 "Ver o comprovante": "Ver el comprobante",
 "Verde": "Verde",
 "Visualizar": "Vista previa",
 "Você está como convidado": "Estás como invitado",
 "Voltar a acompanhar este hábito": "Volver a seguir este hábito",
 "Voltar ao início da folha": "Volver al inicio de la hoja",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Volver al predeterminado inicial (hoja rayada; negro, azul, rojo y verde)",
 "Voltar para a nova avaliação": "Volver a la nueva evaluación",
 "Vídeos": "Videos",
 "X vezes por semana": "X veces por semana",
 "abre em {n} dias": "se abre en {n} días",
 "agradável": "agradable",
 "arquivo": "archivo",
 "aula extra": "clase extra",
 "calor": "calor",
 "chuva": "lluvia",
 "concluído": "completado",
 "céu limpo": "cielo despejado",
 "de {n} planejados": "de {n} planificados",
 "dentro de {p}": "dentro de {p}",
 "enviado em {d}": "enviado el {d}",
 "estudados na semana": "estudiados en la semana",
 "excluído em {d}": "eliminado el {d}",
 "falta 1 dia": "falta 1 día",
 "faltam {n} dias": "faltan {n} días",
 "feito {dur} na semana": "hecho {dur} en la semana",
 "fresco": "fresco",
 "frio": "frío",
 "garoa": "llovizna",
 "hoje não está planejado": "hoy no está planificado",
 "hábito formado ✨": "hábito formado ✨",
 "incorreta": "incorrecta",
 "neblina": "niebla",
 "neve": "nieve",
 "nublado": "nublado",
 "não enviado": "no enviado",
 "parcela {k}/{n}": "cuota {k}/{n}",
 "passou há {n} dias": "pasó hace {n} días",
 "pelo Bem-Estar": "por Bienestar",
 "poucas nuvens": "poco nuboso",
 "reposição": "recuperación",
 "sai de vez em {n} dia(s)": "se elimina definitivamente en {n} día(s)",
 "sem registros": "sin registros",
 "tempestade": "tormenta",
 "tracejado: {d}": "discontinuo: {d}",
 "ver mais": "ver más",
 "ver menos": "ver menos",
 "{aluno}: {n} de {max}": "{aluno}: {n} de {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} es feriado: {f}. ¿Registrar de todos modos?",
 "{f} de {n} passos feitos": "{f} de {n} pasos hechos",
 "{f}/{n} passos": "{f}/{n} pasos",
 "{nome} daqui a 1 ano": "{nome} dentro de 1 año",
 "{nome} daqui a 10 anos": "{nome} dentro de 10 años",
 "{nome} daqui a 6 meses": "{nome} dentro de 6 meses",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} alumno(s) reciben solo su propia nota de \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} alumno(s) recibieron la nota.",
 "{n} aluno(s) · {v} cada": "{n} alumno(s) · {v} cada uno",
 "{n} anos": "{n} años",
 "{n} dia(s) antes": "{n} día(s) antes",
 "{n} dia(s) cumprido(s) no mês": "{n} día(s) cumplido(s) en el mes",
 "{n} dia(s) registrado(s) · média {e}": "{n} día(s) registrado(s) · promedio {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} día(s) registrado(s), promedio {m} de 6",
 "{n} dia(s) seguido(s)": "{n} día(s) seguido(s)",
 "{n} dispensada(s) hoje": "{n} justificada(s) hoy",
 "{n} meses": "{n} meses",
 "{n} outro(s)": "{n} otro(s)",
 "{n} selecionado(s)": "{n} seleccionado(s)",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} tarea(s) completada(s) en My Planner",
 "{n} vez(es) por semana": "{n} vez/veces por semana",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Agua: {a} de {m} ml",
 "ÚLTIMAS 8 SEMANAS": "ÚLTIMAS 8 SEMANAS",
 "Última parcela em {d}": "Última cuota el {d}",
 "é hoje!": "¡es hoy!",
 "A mesma do app": "La misma de la app",
 "Abrir com o código": "Abrir con el código",
 "Ainda não criado": "Aún no creado",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "Al crearlo, la app muestra un código de recuperación para que lo guardes.",
 "Apagar o diário e começar de novo": "Borrar el diario y empezar de nuevo",
 "Biometria ou código do dispositivo": "Biometría o código del dispositivo",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometría, PIN del dispositivo o la contraseña de la app. No hace falta crear otra contraseña.",
 "Bloquear o app": "Bloquear la app",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Registra una huella, tu rostro o un código de bloqueo en el dispositivo para usarlo.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Con la biometría activada, aparece primero. Si falla, la misma ventana ofrece el código/PIN/patrón del dispositivo; la contraseña de la app sigue valiendo.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Con él recuperas el diario si olvidas la contraseña o cambias de dispositivo.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Con este código recuperas el diario si olvidas la contraseña o cambias de dispositivo. Guárdalo en un lugar seguro y no se lo muestres a nadie.",
 "Como funciona a Roda da Vida": "Cómo funciona la Rueda de la Vida",
 "Como o diário abre": "Cómo se abre el diario",
 "Crie a senha que vai abrir o diário.": "Crea la contraseña que abrirá el diario.",
 "Crie o PIN do diário (4 a 6 números)": "Crea el PIN del diario (4 a 6 números)",
 "Crie o diário de novo para começar.": "Crea el diario de nuevo para empezar.",
 "Código aceito. Crie uma senha nova para o diário.": "Código aceptado. Crea una contraseña nueva para el diario.",
 "Código de recuperação": "Código de recuperación",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Código de recuperación (ej.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Código de recuperación incorrecto.",
 "Cômodos": "Habitaciones",
 "Depois de 1 minuto": "Después de 1 minuto",
 "Depois de {n} minutos": "Después de {n} minutos",
 "Desenhe o padrão do diário": "Dibuja el patrón del diario",
 "Dias no mês": "Días en el mes",
 "Dias seguidos": "Días seguidos",
 "Digite o seu PIN": "Escribe tu PIN",
 "Diário ainda não criado": "Diario aún no creado",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Ponle una nota de 0 a 10 a cómo te sientes hoy en cada área de la vida. El dibujo muestra dónde tu vida está equilibrada y dónde necesita atención. Guarda la evaluación y repítela de vez en cuando (por ejemplo, cada mes) para comparar y ver tu evolución. Puedes renombrar, añadir o quitar áreas.",
 "Entre na aba Diário para criar o seu diário.": "Ve a la pestaña Diario para crear tu diario.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Entra en el Diario (con su contraseña o el desbloqueo de la app) y vuelve aquí.",
 "Esconder a senha": "Ocultar la contraseña",
 "Gerar novo código": "Generar nuevo código",
 "Gerar um código de recuperação novo?": "¿Generar un código de recuperación nuevo?",
 "Guarde este código": "Guarda este código",
 "Já guardei": "Ya lo guardé",
 "Ligar um hábito que já existe": "Vincular un hábito que ya existe",
 "Mostrar a senha": "Mostrar la contraseña",
 "Mudar como o diário abre": "Cambiar cómo se abre el diario",
 "My Planner · Código de recuperação do Diário": "My Planner · Código de recuperación del Diario",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "No se pudo abrir con la clave de este dispositivo. Usa la contraseña del diario o el código de recuperación.",
 "O Caps Lock parece estar ligado.": "Parece que Bloq Mayús está activado.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "El PIN se guarda solo en este dispositivo, protegido. La contraseña sigue valiendo si olvidas el PIN.",
 "O PIN precisa ter de 4 a 6 números.": "El PIN debe tener de 4 a 6 números.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "El código anterior deja de valer. Por seguridad, el código no se guarda en la app: solo se puede ver en el momento en que se genera.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "El código no se guarda en ningún lugar que el soporte pueda ver. Sin la contraseña y sin el código, el diario no se puede recuperar.",
 "O diário agora abre só com a senha dele.": "Ahora el diario se abre solo con su propia contraseña.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "El reconocimiento facial de este dispositivo no puede ser usado por apps. Usa la huella o el código/PIN del dispositivo.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "El tiempo cuenta desde el momento en que la app sale de la pantalla (otra app, pantalla de inicio o pantalla apagada). Bajar las notificaciones, la ventana de biometría, una solicitud de permiso o elegir una foto o archivo no cuentan.",
 "Os PINs não conferem.": "Los PIN no coinciden.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 a 6 números)",
 "PIN (só números, 4 a 6)": "PIN (solo números, 4 a 6)",
 "PIN do diário": "PIN del diario",
 "PIN incorreto": "PIN incorrecto",
 "PIN salvo.": "PIN guardado.",
 "Padrão do app": "Predeterminado de la app",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Para borrar, confirma con la contraseña de la app, la biometría o el PIN del dispositivo. Esto borra Mi Día, metas, hábitos, cartas y fotos del diario. Los Proyectos en Grupo se mantienen.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Para continuar, escribe la contraseña de la app o usa la biometría/el código del dispositivo.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Para recuperar el diario si olvidas la contraseña o cambias de dispositivo.",
 "Pastas": "Carpetas",
 "Pedir a senha de novo": "Pedir la contraseña de nuevo",
 "Personalizada": "Personalizada",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Primera vez en este dispositivo: escribe la contraseña del diario o usa el código de recuperación.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Primera vez en este dispositivo: escribe el código de recuperación del diario.",
 "Reconhecimento de rosto": "Reconocimiento facial",
 "Repita o PIN": "Repite el PIN",
 "Salvar a senha nova": "Guardar la contraseña nueva",
 "Salvar em arquivo / no Drive": "Guardar en archivo / en Drive",
 "Salvar o código de recuperação": "Guardar el código de recuperación",
 "Senha (letras e números)": "Contraseña (letras y números)",
 "Senha do app": "Contraseña de la app",
 "Senha nova do diário": "Contraseña nueva del diario",
 "Senha própria": "Contraseña propia",
 "Senha própria do diário": "Contraseña propia del diario",
 "Tarefas": "Tareas",
 "Trocar o PIN": "Cambiar el PIN",
 "Usar a senha": "Usar la contraseña",
 "Usar o PIN": "Usar el PIN",
 "Usar o código de recuperação": "Usar el código de recuperación",
 "Usar o desbloqueio do app": "Usar el desbloqueo de la app",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Usa la biometría o el código/PIN/patrón del dispositivo.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Usa el código de recuperación que apareció cuando se creó el diario. Sin la contraseña y sin el código, nadie puede abrir el diario, ni siquiera el soporte.",
 "Voltar a usar só a senha?": "¿Volver a usar solo la contraseña?",
 "incorreto": "incorrecto",
 "1 h": "1 h",
 "12 horas (2:30 PM)": "12 horas (2:30 PM)",
 "15 min": "15 min",
 "24 horas (14:30)": "24 horas (14:30)",
 "30 min": "30 min",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "La papelera tiene elementos grandes. Confirma con la contraseña de la app, la biometría o el código del dispositivo.",
 "A semana começa na": "La semana empieza el",
 "Abra o Diário primeiro": "Abre primero el Diario",
 "Abrir configurações do celular": "Abrir ajustes del móvil",
 "Agenda e mapas": "Agenda y mapas",
 "Agora: {m}": "Ahora: {m}",
 "Ajuda e sobre": "Ayuda e información",
 "Alarme (som)": "Alarma (sonido)",
 "Alarme ou vibração das pausas": "Alarma o vibración de las pausas",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Borra para siempre la cuenta y todos los datos en la nube y en este dispositivo. Antes te pide la contraseña.",
 "Apagar todas ({n})": "Borrar todas ({n})",
 "Apagar {n} selecionada(s)": "Borrar {n} seleccionada(s)",
 "Aparência": "Apariencia",
 "App das rotas": "App de rutas",
 "Ardósia": "Pizarra",
 "Arrastar para a direita": "Deslizar a la derecha",
 "Arrastar para a esquerda": "Deslizar a la izquierda",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Las cuentas de Finanzas aparecen en My Planner con esta antelación.",
 "Atualizações e sobre": "Actualizaciones e información",
 "Avisar antes do vencimento": "Avisar antes del vencimiento",
 "Aviso marcado": "Aviso programado",
 "Aviso no começo e no fim de cada pausa": "Aviso al inicio y al final de cada pausa",
 "Avisos desta aba": "Avisos de esta pestaña",
 "Avisos e alarmes": "Avisos y alarmas",
 "Avisos silenciosos": "Avisos silenciosos",
 "Avisos: som e vibração": "Avisos: sonido y vibración",
 "Avisos: só som": "Avisos: solo sonido",
 "Avisos: só vibração": "Avisos: solo vibración",
 "Azul elétrico": "Azul eléctrico",
 "Azul-aço": "Azul acero",
 "Azul-bebê": "Azul bebé",
 "Azul-marinho": "Azul marino",
 "Baixar meus dados": "Descargar mis datos",
 "Baixar todos os meus dados": "Descargar todos mis datos",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Descargar todos mis datos y eliminar la cuenta (LGPD)",
 "Biometria": "Biometría",
 "Bissexual": "Bisexual",
 "Brilhante": "Brillante",
 "Buscar abas": "Buscar pestañas",
 "Buscar nos ajustes": "Buscar en los ajustes",
 "Cancelar aviso": "Cancelar aviso",
 "Cinza-chumbo": "Gris plomo",
 "Cofre": "Caja fuerte",
 "Coloque pelo menos uma matéria.": "Añade al menos una materia.",
 "Como usar": "Cómo usar",
 "Conexões": "Conexiones",
 "Cor da aba": "Color de la pestaña",
 "Cor de destaque": "Color de acento",
 "Crie uma matéria primeiro": "Crea primero una materia",
 "Cítrico": "Cítrico",
 "Cópia de segurança em arquivo": "Copia de seguridad en archivo",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Datos de pacientes e historias clínicas. Confirma con la contraseña de la app, la biometría o el código del dispositivo.",
 "Desligadas": "Desactivadas",
 "Digite a senha da sua conta para confirmar.": "Escribe la contraseña de tu cuenta para confirmar.",
 "Duração padrão de uma tarefa nova": "Duración predeterminada de una tarea nueva",
 "Editar sessão": "Editar sesión",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Se repite sin fecha de fin: aparecen las veces hasta el {data}. Si las marcas todas, se elimina la tarea entera.",
 "Em atividade": "En actividad",
 "Em pausa": "En pausa",
 "Emoji da pausa": "Emoji de la pausa",
 "Encerrar": "Terminar",
 "Encerrar a sessão?": "¿Terminar la sesión?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Entra en el modo selección, para elegir varios elementos a la vez.",
 "Escolha um horário no futuro.": "Elige una hora en el futuro.",
 "Escolher a matéria": "Elegir la materia",
 "Esconde os valores em dinheiro (R$ •••)": "Oculta los importes en dinero (R$ •••)",
 "Esconder o CPF": "Ocultar el CPF",
 "Esconder os valores": "Ocultar los importes",
 "Esta e as próximas": "Esta y las siguientes",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Esta tarea se repite. ¿Dónde aplicar el cambio?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Este elemento tiene mucho contenido. Confirma con la contraseña de la app, la biometría o el código del dispositivo.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Elimina el elemento (pide confirmación). Después puedes deshacerlo o restaurarlo desde la Papelera.",
 "Excluir minha conta": "Eliminar mi cuenta",
 "Ficha protegida": "Ficha protegida",
 "Formato da hora": "Formato de hora",
 "Foto do Quadro dos Sonhos": "Foto del Tablero de Sueños",
 "Geral": "General",
 "Gestos": "Gestos",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive y archivo de copia",
 "Grafite": "Grafito",
 "Guardar em": "Guardar en",
 "Hábito do Diário": "Hábito del Diario",
 "Idioma e moeda": "Idioma y moneda",
 "Inspiração do Diário": "Inspiración del Diario",
 "Intenso": "Intenso",
 "Item arquivado": "Elemento archivado",
 "Item excluído": "Elemento eliminado",
 "Lavanda": "Lavanda",
 "Ligadas": "Activadas",
 "Limite de energia": "Límite de energía",
 "Lésbica": "Lesbiana",
 "Marque as vezes que vão ser apagadas.": "Marca las veces que se van a borrar.",
 "Matéria": "Materia",
 "Me avise em…": "Avísame en…",
 "Menta": "Menta",
 "Menu ⋮": "Menú ⋮",
 "Meta do Diário": "Meta del Diario",
 "Modo discreto": "Modo discreto",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Arma la sesión una vez (materias, tiempo de cada una y pausas) y repítela otros días tocando Empezar. El tiempo estudiado se suma solo a la meta.",
 "Mostra Arquivar e Duplicar.": "Muestra Archivar y Duplicar.",
 "Mostrar feriados no topo": "Mostrar feriados arriba",
 "Mostrar os valores": "Mostrar los importes",
 "Muda a ordem dos itens.": "Cambia el orden de los elementos.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Cambia solo el color de My Planner. El color de acento de la app está en Ajustes > Apariencia. Cada tarea puede tener su propio color en la ficha.",
 "Nada encontrado nos ajustes.": "No se encontró nada en los ajustes.",
 "Nenhuma sessão salva ainda.": "Aún no hay sesiones guardadas.",
 "Neon": "Neón",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "En este horario la app no suena ni vibra. Los avisos siguen llegando, en silencio.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "En el menú ⋮ de cualquier elemento: el móvil te avisa a la hora elegida, sin crear una tarea en My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Nombre (ej.: Sesión del máster)",
 "Nova sessão": "Nueva sesión",
 "Nuvem e cópias de segurança": "Nube y copias de seguridad",
 "Não perturbe": "No molestar",
 "Não perturbe {de}–{ate}": "No molestar {de}–{ate}",
 "Não-binário": "No binario",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "El botón 🎉 Feriados arriba en My Planner. El país y la lista de feriados están en Ajustes > Feriados.",
 "O celular avisa às {h}.": "El móvil te avisará a las {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Lo que sale del Diario queda cifrado en la papelera. Entra en el Diario y luego vuelve aquí para restaurarlo.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Lo que salga queda en la Papelera durante 30 días. Escribe la contraseña de tu cuenta para confirmar.",
 "O que saiu fica na Lixeira por 30 dias.": "Lo que salió queda en la Papelera durante 30 días.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "El tema cambia los colores de las pestañas, el color de acento y un toque suave en el fondo, en los modos claro y oscuro. Para cambiar el color de una sola pestaña, ve a Ajustes > Pestañas.",
 "O tempo estudado até agora entra na meta.": "El tiempo estudiado hasta ahora se suma a la meta.",
 "Oliva": "Oliva",
 "Orgulho": "Orgullo",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Los avisos funcionan en la app instalada, con las notificaciones activadas.",
 "Os gestos do app": "Los gestos de la app",
 "Outro (escolher a hora)": "Otro (elegir la hora)",
 "Pansexual": "Pansexual",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Para activarlo, usa la app en el móvil (Ajustes › Agenda y mapas › Google Calendar). Después, todo aparece aquí también.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Para que no se pregunte más, elige la app en Ajustes › Agenda y mapas.",
 "Pausa": "Pausa",
 "Petróleo": "Azul petróleo",
 "Pink elétrico": "Rosa eléctrico",
 "Preto total": "Negro total",
 "Progresso": "Progreso",
 "Pêssego": "Melocotón",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Cuántos días antes aparecen las cuentas se configura en Ajustes > Avisos y alarmas.",
 "Rosa-chá": "Rosa té",
 "Roxo-profundo": "Púrpura intenso",
 "Segurança e dados": "Seguridad y datos",
 "Segurar e arrastar": "Mantener y arrastrar",
 "Segurar e soltar": "Mantener y soltar",
 "Selecionar todas": "Seleccionar todas",
 "Semana começa na {dia}": "La semana empieza el {dia}",
 "Sessão de estudo": "Sesión de estudio",
 "Sessão encerrada": "Sesión terminada",
 "Sessão pausada": "Sesión en pausa",
 "Som e vibração": "Sonido y vibración",
 "Suave": "Suave",
 "Só esta semana": "Solo esta semana",
 "Só hoje": "Solo hoy",
 "Só neste dia ({data})": "Solo este día ({data})",
 "Tamanho das caixas": "Tamaño de las cajas",
 "Tamanho do texto": "Tamaño del texto",
 "Tarefa nova": "Tarea nueva",
 "Tela inicial": "Pantalla de inicio",
 "Tema e cor de destaque": "Tema y color de acento",
 "Testar alerta": "Probar alerta",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Probar alerta, \"No molestar\" y los ajustes del móvil están en Ajustes > Avisos y alarmas.",
 "Testar e conferir": "Probar y revisar",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Todas las opciones del elemento: editar, mover, compartir, archivar, eliminar...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Toca un color del tema {tema} para usarlo en los botones, en el botón + y en el elemento seleccionado.",
 "Total: {dur}": "Total: {dur}",
 "Tropical": "Tropical",
 "Turquesa": "Turquesa",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Un archivo con todos tus datos de My Planner, para guardarlo o llevarlo a otro lugar (portabilidad, LGPD).",
 "Usar no computador, pelo navegador": "Usar en el ordenador, desde el navegador",
 "Usar o padrão": "Usar el predeterminado",
 "Usar o padrão ({emoji})": "Usar el predeterminado ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Usa la app en el móvil para descargar el archivo.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Vale para todas las pestañas. Cada pestaña puede tener el suyo en Ajustes > Pestañas.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Valen para las tareas con pausas. Cada tarea puede cambiar la alarma y el emoji en su propia ficha.",
 "Ver lista": "Ver lista",
 "Ver o CPF inteiro": "Ver el CPF completo",
 "Verde-floresta": "Verde bosque",
 "Verde-água": "Verde agua",
 "Vibração": "Vibración",
 "Vinho": "Burdeos",
 "Você pediu para ser avisado agora.": "Pediste que te avisaran ahora.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Puedes: confirmar si tratamos tus datos, acceder a ellos, corregirlos, pedir la portabilidad (descargar tus datos en Ajustes > Mis datos), pedir su eliminación, saber con quién los compartimos, revocar el consentimiento y reclamar ante la ANPD.",
 "Voltar ao filtro": "Volver al filtro",
 "Voltar à lista": "Volver a la lista",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Ve a Ajustes › My Planner Web y toca \"Conectar navegador\".",
 "atividade {n} de {total}": "actividad {n} de {total}",
 "matéria {n} de {t}": "materia {n} de {t}",
 "padrão": "predeterminado",
 "pausa em {n} min": "pausa en {n} min",
 "pausa {n} de {total}": "pausa {n} de {total}",
 "termina em {n} min": "termina en {n} min",
 "todas as vezes": "todas las veces",
 "troca em {n} min": "cambio en {n} min",
 "volta em {n} min": "vuelve en {n} min",
 "{nome} · {n} dia(s)": "{nome} · {n} día(s)",
 "{n} de {total} vezes": "{n} de {total} veces",
 "{n} itens arquivados": "{n} elementos archivados",
 "{n} itens excluídos": "{n} elementos eliminados",
 "{n} marcada(s)": "{n} marcada(s)",
 "{n} vezes": "{n} veces",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} min / {total}",
 "📔 Diário": "📔 Diario",
 "Agendados": "Programados",
 "Atrasado": "Atrasado",
 "Atrasado: {v}": "Atrasado: {v}",
 "Atualizar o a receber": "Actualizar lo por cobrar",
 "Até (fim do contrato, se houver)": "Hasta (fin del contrato, si lo hay)",
 "Clínica": "Clínica",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Cuenta cada día con asistencia registrada o con plan de clase marcado como \"Clase dada\".",
 "Data do recebimento": "Fecha de cobro",
 "Data prevista do pagamento": "Fecha prevista de pago",
 "Desmarcar como recebido": "Desmarcar como cobrado",
 "Dia do pagamento": "Día de pago",
 "Diferença: {v} (juros/multa)": "Diferencia: {v} (intereses/multa)",
 "Diferença: {v} (taxas/descontos)": "Diferencia: {v} (comisiones/descuentos)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Escuelas, universidades y cursos que te pagan. Con salario fijo, la app genera lo por cobrar de cada mes; por hora de clase, suma las clases dadas en los grupos vinculados a la institución.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Elige el tipo de pago (Editar) para que la app calcule lo que tienes por cobrar.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Este importe viene de la sección \"Dónde trabajo\" de la pestaña {aba}. Márcalo aquí como cobrado o abre la pestaña para ver la institución.",
 "Ex.: Colégio Estadual, Universidade Federal": "Ej.: Colegio Estatal, Universidad Federal",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Ej.: Hospital Santa Casa, Clínica Vida",
 "Ex.: Salário de outubro, 13º, férias": "Ej.: Salario de octubre, aguinaldo, vacaciones",
 "Feitos": "Hechos",
 "Horas-aula de cada aula": "Horas de clase por clase",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Hospitales y clínicas que te pagan. Con salario fijo, la app genera lo por cobrar de cada mes; por guardia o consulta, marca los hechos y la app calcula.",
 "Hospital": "Hospital",
 "Instituição": "Institución",
 "Instituição (Onde trabalho)": "Institución (Dónde trabajo)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Vincula los grupos a esta institución (en el grupo, Editar › Institución) para que la app sume las clases dadas.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Marca cada guardia o consulta como hecha: la app suma y calcula el importe del mes.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Marca cada guardia o consulta hecha en esta institución. La app suma y calcula el importe por cobrar del mes.",
 "Nome da instituição": "Nombre de la institución",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Lo que la institución tiene que pagarte, mes a mes. Márcalo como cobrado cuando entre el dinero: también pasa a la pestaña Finanzas.",
 "Onde trabalho": "Dónde trabajo",
 "Plantão": "Guardia",
 "Plantão ou atendimento": "Guardia o consulta",
 "Plantões e atendimentos": "Guardias y consultas",
 "Por atendimento ou procedimento": "Por consulta o procedimiento",
 "Por hora-aula": "Por hora de clase",
 "Por plantão": "Por guardia",
 "Previsto: {v}": "Previsto: {v}",
 "Previsão do mês: {v}": "Previsión del mes: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Cantidad (clases, guardias o consultas)",
 "Recebe no mês seguinte ao trabalhado": "Cobra el mes siguiente al trabajado",
 "Receber: {t}": "Cobrar: {t}",
 "Recebimentos": "Cobros",
 "Salário": "Salario",
 "Salário (valor do mês)": "Salario (importe del mes)",
 "Salário fixo": "Salario fijo",
 "Telefone (RH ou financeiro)": "Teléfono (RR. HH. o finanzas)",
 "Tipo de pagamento": "Tipo de pago",
 "Universidade": "Universidad",
 "Valor da hora-aula": "Valor de la hora de clase",
 "Valor de cada um (se for diferente)": "Importe de cada uno (si es diferente)",
 "Valor do plantão": "Valor de la guardia",
 "Valor por atendimento ou procedimento": "Importe por consulta o procedimiento",
 "Valor previsto": "Importe previsto",
 "feito": "hecho",
 "recebido em {d}": "cobrado el {d}",
 "{n} aula(s) dada(s)": "{n} clase(s) dada(s)",
 "{n} hora(s)-aula": "{n} hora(s) de clase",
 "{n} plantão(ões)": "{n} guardia(s)",
 "Abas do My Planner Anne": "Pestañas de My Planner Anne",
 "Acesso ao Não perturbe": "Acceso a No molestar",
 "Alarme dos remédios (mesmo no silencioso)": "Alarma de medicamentos (incluso en silencio)",
 "Algodão-doce": "Algodón de azúcar",
 "Aplicar tema": "Aplicar tema",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Los colores propios de cada tema: floral rosado, hojas verdes, cielo azul...",
 "Assim ficam as letras no app.": "Así se ven las letras en la app.",
 "Automática": "Automática",
 "Baht tailandês": "Baht tailandés",
 "Boliviano": "Boliviano",
 "Bolívar venezuelano": "Bolívar venezolano",
 "Botão": "Botón",
 "Buscar moeda": "Buscar moneda",
 "Cor do desenho": "Color del dibujo",
 "Coroa dinamarquesa": "Corona danesa",
 "Coroa norueguesa": "Corona noruega",
 "Coroa sueca": "Corona sueca",
 "Coroa tcheca": "Corona checa",
 "Crepúsculo": "Crepúsculo",
 "Crescente": "Creciente",
 "Curta": "Corta",
 "Despesas em outra moeda (fora do lucro): {v}": "Gastos en otra moneda (fuera del beneficio): {v}",
 "Dirham dos Emirados Árabes Unidos": "Dírham de los Emiratos Árabes Unidos",
 "Dirham marroquino": "Dírham marroquí",
 "Do seu país": "De tu país",
 "Dong vietnamita": "Dong vietnamita",
 "Dupla": "Doble",
 "Dólar americano": "Dólar estadounidense",
 "Dólar australiano": "Dólar australiano",
 "Dólar canadense": "Dólar canadiense",
 "Dólar de Hong Kong": "Dólar de Hong Kong",
 "Dólar de Singapura": "Dólar de Singapur",
 "Dólar neozelandês": "Dólar neozelandés",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Envía todos los elementos de esta lista, incluidos los nuevos que se creen después.",
 "Enviar todos para a equipe": "Enviar todos al equipo",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Elige si la alarma de este medicamento debe sonar incluso con el móvil en silencio.",
 "Euro": "Euro",
 "Exemplo": "Ejemplo",
 "Falta uma resposta": "Falta una respuesta",
 "Folha, tema e cores da caneta e das letras": "Hoja, tema y colores del bolígrafo y las letras",
 "Franco suíço": "Franco suizo",
 "Guarani paraguaio": "Guaraní paraguayo",
 "Hryvnia ucraniana": "Grivna ucraniana",
 "Iene japonês": "Yen japonés",
 "Kwanza angolano": "Kwanza angoleño",
 "Libra egípcia": "Libra egipcia",
 "Libra esterlina": "Libra esterlina",
 "Lira turca": "Lira turca",
 "Longa": "Larga",
 "Mais usadas": "Más usadas",
 "Metical moçambicano": "Metical mozambiqueño",
 "Na página, segurar a bolinha faz o mesmo.": "En la página, mantener pulsado el círculo hace lo mismo.",
 "Naira nigeriana": "Naira nigeriana",
 "Nenhuma moeda encontrada": "No se encontró ninguna moneda",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "En Android, para que la alarma del medicamento suene con \"No molestar\" activado, el móvil debe permitir el acceso a \"No molestar\" para My Planner. Toca \"Abrir ajustes\", busca My Planner en la lista y activa el permiso.",
 "No My Planner": "En My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "En iPhone, el modo silencio puede impedir la alarma. Deja el móvil en modo normal.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "En iPhone, el ▶ muestra una idea de cada tipo. Los avisos reales usan la vibración predeterminada del iPhone.",
 "Novo dólar taiwanês": "Nuevo dólar taiwanés",
 "Novo shekel israelense": "Nuevo séquel israelí",
 "Ouvir/Sentir": "Oír/Sentir",
 "Peso argentino": "Peso argentino",
 "Peso chileno": "Peso chileno",
 "Peso colombiano": "Peso colombiano",
 "Peso filipino": "Peso filipino",
 "Peso mexicano": "Peso mexicano",
 "Peso uruguaio": "Peso uruguayo",
 "Política de privacidade": "Política de privacidad",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Listo. Bloquea la pantalla y espera 1 minuto: el aviso debe aparecer en silencio.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Listo. Bloquea la pantalla y espera 1 minuto: el aviso debe aparecer vibrando, sin sonido.",
 "Páginas e canetas": "Páginas y bolígrafos",
 "Pôr do sol": "Atardecer",
 "Rand sul-africano": "Rand sudafricano",
 "Real brasileiro": "Real brasileño",
 "Ringgit malaio": "Ringgit malayo",
 "Riyal saudita": "Riyal saudí",
 "Rublo russo": "Rublo ruso",
 "Rupia indiana": "Rupia india",
 "Rupia indonésia": "Rupia indonesia",
 "Rupia paquistanesa": "Rupia pakistaní",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Si My Planner no aparece en la lista, este permiso llegará en la próxima versión de la app (actualiza desde la tienda).",
 "Sentir": "Sentir",
 "Sol peruano": "Sol peruano",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Son los colores rápidos del bolígrafo y las letras en las páginas. El primero es el color predeterminado al abrir una página. Toca un círculo para cambiar su color.",
 "Taka bengali": "Taka bangladesí",
 "Teste grátis por {n} dias": "Prueba gratis durante {n} días",
 "Tipo de vibração": "Tipo de vibración",
 "Tirar do My Planner": "Quitar de My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Sonar incluso en silencio y en No molestar",
 "Tocar só se o celular estiver no normal": "Sonar solo si el móvil está en modo normal",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Todos los elementos de esta lista aparecen en My Planner, incluidos los nuevos.",
 "Vaga-lume": "Luciérnaga",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Se aplica a todos los avisos que vibran (Vibración y Sonido y vibración).",
 "Won sul-coreano": "Won surcoreano",
 "Xelim queniano": "Chelín keniano",
 "Yuan chinês": "Yuan chino",
 "Zloty polonês": "Esloti polaco",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 ¿La alarma de este medicamento debe sonar incluso con el móvil en silencio?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "La galería de fotos llega en la próxima versión de la app. Por ahora, usa Archivos o Tomar foto.",
 "Abrir o fichário do grupo": "Abrir el archivador del grupo",
 "Arrastar a barra": "Arrastrar la barra",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "En cuanto se comparta el archivador, aparecerá aquí.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Buscar icono por nombre (ej.: libro, casa, café)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Con la pestaña Estudios creas tus archivadores, usas el cronómetro, sigues tu informe y mucho más. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Con la pestaña {aba} creas lo tuyo y usas todas las funciones. ✨",
 "Conhecer a aba": "Conocer la pestaña",
 "Crie um fichário em Estudos e volte aqui.": "Crea un archivador en Estudios y vuelve aquí.",
 "Em sessão": "En sesión",
 "Encerrar e salvar o cronômetro e começar a sessão?": "¿Detener y guardar el cronómetro y empezar la sesión?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "¿Detener y guardar el cronómetro y continuar la sesión?",
 "Enquadre e toque no botão": "Encuadra y toca el botón",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Elige el archivador que tus compañeros verán en pantalla (solo lectura).",
 "Esconder": "Ocultar",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Este archivo está guardado solo en el dispositivo o en el Drive de quien lo compartió, por eso no aparece aquí.",
 "Fichário do grupo": "Archivador del grupo",
 "Guia passo a passo do app e de cada aba": "Guía paso a paso de la app y de cada pestaña",
 "Há um cronômetro em andamento.": "Hay un cronómetro en marcha.",
 "Há uma sessão em andamento.": "Hay una sesión en curso.",
 "Inserir imagem": "Insertar imagen",
 "Mais ícones": "Más iconos",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Ningún icono con ese nombre. Prueba otra palabra o elige una categoría.",
 "Nenhuma matéria neste fichário ainda.": "Aún no hay materias en este archivador.",
 "Nenhuma página nesta matéria ainda.": "Aún no hay páginas en esta materia.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "En el grupo de estudio, las imágenes y los PDF se abren aquí en pantalla. Este tipo de archivo no tiene vista previa dentro de la app.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "No se pudo mostrar ahora. Revisa tu conexión a internet e inténtalo de nuevo.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "El uso compartido de archivadores aún se está preparando. Vuelve en un rato.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "El archivador de este grupo está en otro de tus dispositivos. Sigue compartido desde allí.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Conocer la pestaña · Cancelar = Ahora no",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Tus compañeros dejarán de ver el archivador. Todo sigue contigo.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Tus compañeros ven este archivador en pantalla, solo para leer: no editan, no descargan, no imprimen y no comparten. Tus metas, el cronómetro y las páginas repasadas siguen siendo solo tuyos.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Para ver PDF aquí en pantalla, instala la versión más reciente de la app desde la tienda.",
 "Parar de compartilhar": "Dejar de compartir",
 "Pausar a sessão": "Pausar la sesión",
 "Pausar a sessão e estudar só esta?": "¿Pausar la sesión y estudiar solo esta?",
 "Página em branco.": "Página en blanco.",
 "Quer estudar com tudo isso?": "¿Quieres estudiar con todo esto?",
 "Quer usar tudo isso?": "¿Quieres usar todo esto?",
 "Selecionar todos": "Seleccionar todo",
 "Trocar fichário": "Cambiar archivador",
 "Você está participando do grupo de {nome}": "Estás participando en el grupo de {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Ves en pantalla lo que se compartió en este grupo, para leer y seguir.",
 "abacate, fruta": "aguacate, palta, fruta",
 "academia, musculação, treino, peso": "gimnasio, musculación, entrenamiento, pesas",
 "acampamento, camping": "acampada, camping",
 "alfinete, fixar, importante": "alfiler, chincheta, importante",
 "almoço, arroz, prato": "almuerzo, arroz, plato",
 "alvo, meta, objetivo, foco": "diana, meta, objetivo, enfoque",
 "aniversário, bolo": "cumpleaños, pastel",
 "anotação, nota, lista, escrever": "anotación, nota, lista, escribir",
 "arco-íris": "arcoíris",
 "avião, viagem, voo": "avión, viaje, vuelo",
 "balança, direito, justiça, lei, processo": "balanza, derecho, justicia, ley, proceso",
 "balde, limpeza": "cubo, balde, limpieza",
 "banana, fruta": "plátano, banana, fruta",
 "banheira, banho, banheiro": "bañera, baño, cuarto de baño",
 "barbear, barba, lâmina": "afeitar, barba, cuchilla",
 "bicicleta, pedalar, bike": "bicicleta, pedalear, bici",
 "bolo, doce, sobremesa": "pastel, dulce, postre",
 "brilho, mágica": "brillo, magia",
 "cabelo, cabeleireiro, corte": "cabello, peluquería, corte",
 "cachorro, cão, pet": "perro, can, mascota",
 "caderno": "cuaderno",
 "caderno, fichário, amarelo": "cuaderno, archivador, amarillo",
 "café, xícara, pausa": "café, taza, pausa",
 "caixa, pacote, mudança, entrega": "caja, paquete, mudanza, entrega",
 "calendário, agenda, data": "calendario, agenda, fecha",
 "cama, quarto": "cama, dormitorio",
 "caminhada, caminhar, andar": "caminata, caminar, andar",
 "camisa, gravata, roupa, trabalho": "camisa, corbata, ropa, trabajo",
 "carne, churrasco": "carne, asado, barbacoa",
 "carrinho, mercado, compras, supermercado": "carrito, mercado, compras, supermercado",
 "carro, dirigir, veículo": "coche, conducir, vehículo",
 "certo, feito, visto": "correcto, hecho, visto",
 "cesto, roupa, lavanderia, lavar roupa": "cesto, ropa, lavandería, lavar ropa",
 "chave de fenda, ferramenta, conserto": "destornillador, herramienta, arreglo",
 "chave, senha": "llave, contraseña",
 "chocolate, doce": "chocolate, dulce",
 "chuveiro, banho": "ducha, baño",
 "chá, xícara": "té, taza",
 "compras, sacolas, shopping": "compras, bolsas, centro comercial",
 "computador, monitor, tela": "ordenador, monitor, pantalla",
 "computador, notebook, informática": "computadora, portátil, informática",
 "coração amarelo": "corazón amarillo",
 "coração azul": "corazón azul",
 "coração branco": "corazón blanco",
 "coração laranja": "corazón naranja",
 "coração roxo": "corazón morado",
 "coração verde": "corazón verde",
 "coração, amor, saúde, vermelho": "corazón, amor, salud, rojo",
 "corrida, correr": "carrera, correr",
 "creme, hidratante, pele, skincare": "crema, hidratante, piel, cuidado de la piel",
 "croissant, pão, café da manhã": "cruasán, pan, desayuno",
 "câmera, foto, fotografia": "cámara, foto, fotografía",
 "cérebro, mente, memória, pensar": "cerebro, mente, memoria, pensar",
 "dado, jogo de tabuleiro": "dado, juego de mesa",
 "dente, dentista": "diente, dentista",
 "despertador, relógio, alarme, acordar": "despertador, reloj, alarma, despertar",
 "diamante, joia": "diamante, joya",
 "dinheiro, pagar, conta, pagamento": "dinero, pagar, cuenta, pago",
 "dormir, sono, descanso": "dormir, sueño, descanso",
 "e-mail, mensagem, carta": "correo, mensaje, carta",
 "escada": "escalera",
 "escova de dentes, dentes": "cepillo de dientes, dientes",
 "escrever, redação, caneta": "escribir, redacción, bolígrafo",
 "esponja, lavar louça": "esponja, fregar platos",
 "esquadro, régua, geometria, desenho técnico": "escuadra, regla, geometría, dibujo técnico",
 "estrela brilhante, destaque": "estrella brillante, destacado",
 "estrela, favorito": "estrella, favorito",
 "etiqueta, marcador": "etiqueta, marcador",
 "extintor, segurança, incêndio": "extintor, seguridad, incendio",
 "falar, idioma, inglês, conversa": "hablar, idioma, inglés, conversación",
 "feito, concluído, certo": "hecho, completado, correcto",
 "ferramenta, conserto, manutenção": "herramienta, arreglo, mantenimiento",
 "festa, comemoração": "fiesta, celebración",
 "filme, cinema, série": "película, cine, serie",
 "fogo, urgente, sequência": "fuego, urgente, racha",
 "folha, natureza, erva, chá": "hoja, naturaleza, hierba, té",
 "fone de ouvido, áudio, música, podcast": "auriculares, audio, música, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "graduación, birrete, facultad, diploma, universidad",
 "força, braço, músculo": "fuerza, brazo, músculo",
 "frango, coxa": "pollo, muslo",
 "frigideira, cozinhar, ovo, cozinha": "sartén, cocinar, huevo, cocina",
 "futebol, bola, esporte": "fútbol, balón, deporte",
 "gato, pet": "gato, mascota",
 "gelo, geladeira, congelador": "hielo, nevera, congelador",
 "gráfico, planilha, finanças, relatório": "gráfico, hoja de cálculo, finanzas, informe",
 "ingresso, show, evento": "entrada, concierto, evento",
 "jogo, videogame, game": "juego, videojuego, gaming",
 "lancha, barco": "lancha, barco",
 "leite, copo": "leche, vaso",
 "letras, alfabeto, português": "letras, alfabeto, lengua",
 "link, corrente": "enlace, cadena",
 "livro aberto, leitura, ler": "libro abierto, lectura, leer",
 "livro azul, caderno": "libro azul, cuaderno",
 "livro laranja, caderno": "libro naranja, cuaderno",
 "livro verde, caderno": "libro verde, cuaderno",
 "livro vermelho, caderno": "libro rojo, cuaderno",
 "livros, estudo, estudar, biblioteca": "libros, estudio, estudiar, biblioteca",
 "lixo, lixeira": "basura, papelera",
 "lua, noite": "luna, noche",
 "lâmpada, ideia, luz": "bombilla, idea, luz",
 "macarrão, massa": "fideos, pasta",
 "maleta, trabalho, escritório, negócios": "maletín, trabajo, oficina, negocios",
 "massagem, relaxar": "masaje, relajarse",
 "maçã, fruta": "manzana, fruta",
 "microfone, cantar, karaokê, palestra": "micrófono, cantar, karaoke, charla",
 "microscópio, ciência, biologia": "microscopio, ciencia, biología",
 "mochila, escola, filhos": "mochila, escuela, hijos",
 "montanha, trilha": "montaña, sendero",
 "mundo, planeta, geografia": "mundo, planeta, geografía",
 "médico, consulta, exame, saúde": "médico, consulta, examen, salud",
 "música, nota musical": "música, nota musical",
 "natação, nadar, piscina": "natación, nadar, piscina",
 "olho, visão, oftalmologista": "ojo, visión, oftalmólogo",
 "oração, orar, gratidão, igreja": "oración, rezar, gratitud, iglesia",
 "ovo": "huevo",
 "pastas, arquivo, fichário, divisórias": "carpetas, archivo, archivador, separadores",
 "peixe": "pez",
 "pescaria, pescar": "pesca, pescar",
 "pessoas, reunião, equipe, grupo": "personas, reunión, equipo, grupo",
 "piano, teclado musical": "piano, teclado musical",
 "pintura, arte, desenho": "pintura, arte, dibujo",
 "pipa": "cometa",
 "pipoca, cinema": "palomitas, cine",
 "pizza": "pizza",
 "planta, vaso, regar": "planta, maceta, regar",
 "porta, entrada": "puerta, entrada",
 "praia, férias": "playa, vacaciones",
 "prato, refeição, louça, jantar": "plato, comida, vajilla, cena",
 "prédio, história, governo, tribunal": "edificio, historia, gobierno, tribunal",
 "pão, padaria": "pan, panadería",
 "pé, podólogo": "pie, podólogo",
 "pôr do sol, amanhecer": "atardecer, amanecer",
 "quebra-cabeça, peça": "rompecabezas, pieza",
 "queijo": "queso",
 "raio, energia, rápido": "rayo, energía, rápido",
 "refrigerante, suco, bebida": "refresco, zumo, bebida",
 "remédio, medicamento, vitamina, farmácia": "remedio, medicamento, vitamina, farmacia",
 "sabão, sabonete, lavar": "jabón, pastilla de jabón, lavar",
 "salada, dieta, verdura": "ensalada, dieta, verdura",
 "sanduíche, lanche": "sándwich, merienda",
 "sino, aviso, lembrete": "campana, aviso, recordatorio",
 "skate": "monopatín, skate",
 "sofá, sala": "sofá, sala",
 "sol, manhã, dia": "sol, mañana, día",
 "spa, sauna, autocuidado": "spa, sauna, autocuidado",
 "teatro, máscaras": "teatro, máscaras",
 "telefone, ligação, ligar": "teléfono, llamada, llamar",
 "tigela, cereal, sopa, mingau": "tazón, cereal, sopa, papilla",
 "trevo, sorte": "trébol, suerte",
 "troféu, conquista, prêmio": "trofeo, logro, premio",
 "tubo de ensaio, química, laboratório": "tubo de ensayo, química, laboratorio",
 "tênis, esporte": "zapatillas, deporte",
 "unha, manicure": "uña, manicura",
 "vassoura, limpeza, faxina, varrer": "escoba, limpieza, limpiar, barrer",
 "violão, guitarra": "guitarra, guitarra acústica",
 "yoga, meditação, alongamento": "yoga, meditación, estiramiento",
 "{n} selecionada": "{n} seleccionada",
 "{n} selecionadas": "{n} seleccionadas",
 "{n} selecionado": "{n} seleccionado",
 "{n} selecionados": "{n} seleccionados",
 "ábaco, matemática, contas, cálculo, contabilidade": "ábaco, matemáticas, cuentas, cálculo, contabilidad",
 "água, gota, hidratar": "agua, gota, hidratarse",
 "árvore, jardim, quintal": "árbol, jardín, patio",
 "ônibus, transporte": "autobús, transporte",
 "1 dia antes": "1 día antes",
 "1 dia depois": "1 día después",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "La suscripción se hace en la app del teléfono, a través de la tienda de apps, y también vale aquí en el sitio web.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "La clave está incompleta (demasiado corta). Cópiala de nuevo con el botón de copiar de la página de la clave.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "La clave tiene caracteres que no forman parte de una clave. Cópiala de nuevo, solo la clave, sin texto alrededor.",
 "A galeria chega na próxima atualização do app.": "La galería llega en la próxima actualización de la app.",
 "ALERTAS": "ALERTAS",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Abre una pestaña de pago y empieza la prueba gratuita. Después vuelve aquí.",
 "Abrir a barra do editor": "Abrir la barra del editor",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Ahora es el horario de No molestar de la app: el aviso llega en hasta 5 segundos, sin sonido ni vibración.",
 "Aguardando confirmação": "Esperando confirmación",
 "Aguardando envio ao My Planner": "Pendiente de envío a My Planner",
 "Alertas de cada fatura": "Alertas de cada factura",
 "Alertas do fim da garantia": "Alertas del fin de la garantía",
 "Alertas do vencimento": "Alertas del vencimiento",
 "Alertas: {campo}": "Alertas: {campo}",
 "Alvorada": "Alborada",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "Al abrir esta pestaña, la app pide el mismo desbloqueo de la app (contraseña, biometría o PIN). Puedes cambiarlo en Ajustes > Pestañas.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Al tocar un archivo adjunto, se abre en la app del teléfono que elijas (si el teléfono pregunta, \"Solo una vez\" o \"Siempre\"). Lo que edites allí se guarda en el propio archivo.",
 "App instalado": "App instalada",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: ya graba todo en la app Salud del teléfono. No necesitas hacer nada.",
 "Arquivados e fixados": "Archivados y fijados",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "Archivo para leer y guardar, organizado por pestaña. Generado el {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Las notificaciones de My Planner están desactivadas en el teléfono.",
 "Atualização automática disponível no app instalado.": "Actualización automática disponible en la app instalada.",
 "Aurora": "Aurora",
 "Avisos: alarme (som)": "Avisos: alarma (sonido)",
 "Baixar o app": "Descargar la app",
 "Baixar o arquivo técnico": "Descargar el archivo técnico",
 "Baixar para ler (PDF)": "Descargar para leer (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Barra del editor (bolígrafo, resaltador, texto)",
 "Brisa": "Brisa",
 "Campainha": "Timbre",
 "Canal": "Canal",
 "Cole a chave antes de testar.": "Pega la clave antes de probar.",
 "Começa em": "Empieza el",
 "Como avisar": "Cómo avisar",
 "Confira a chave": "Revisa la clave",
 "Conta de teste de compras": "Cuenta de prueba de compras",
 "Conta vencida": "Factura vencida",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Copia la clave enseguida (solo aparece una vez). Empieza con \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Copia la clave enseguida (solo aparece una vez). Empieza con \"sk-ant-\".",
 "Cristal": "Cristal",
 "Daqui a 1 hora": "Dentro de 1 hora",
 "Daqui a 1 semana": "Dentro de 1 semana",
 "Daqui a 3 dias": "Dentro de 3 días",
 "Depois de 5 min fora": "Tras 5 min fuera",
 "Depois de 5 minutos fora": "Tras 5 minutos fuera",
 "Desligar a senha desta aba": "Desactivar la contraseña de esta pestaña",
 "Detalhes técnicos": "Detalles técnicos",
 "Dia {n} de {t}": "Día {n} de {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Consejo: la clave es como una contraseña. No la envíes por mensaje ni la publiques. Si se filtra, bórrala en el sitio web y crea otra.",
 "Documento vencido": "Documento vencido",
 "Ela abre em {d}.": "Se abre el {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Se abre el {d}. Recibirás avisos: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Se abre el {d}. Recibirás un aviso: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "En \"API keys\", toca \"Create key\" (Crear clave) y ponle un nombre, por ejemplo \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "En \"Billing\" (Facturación), añade una tarjeta y algunos dólares de crédito. La suscripción ChatGPT Plus no vale aquí.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "En \"Billing\" (Facturación), compra créditos. La suscripción Claude Pro no vale aquí.",
 "Em breve": "Próximamente",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Inicia sesión con la misma cuenta de ChatGPT o crea una.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Inicia sesión con tu cuenta de Google (sirve la misma de Gmail).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Inicia sesión o crea una cuenta (puede ser el mismo correo de Claude).",
 "Enviados para o My Planner": "Enviados a My Planner",
 "Enviar agora": "Enviar ahora",
 "Escolha hoje ou uma data futura.": "Elige hoy o una fecha futura.",
 "Escolhas lembradas": "Elecciones recordadas",
 "Escolher a data": "Elegir la fecha",
 "Escolher células": "Elegir celdas",
 "Escolher quando": "Elegir cuándo",
 "Espessura": "Grosor",
 "Esquecer": "Olvidar",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Esta clave es de otro servicio ({servico}). Aquí solo funcionan claves de Claude, ChatGPT o Gemini.",
 "Esta chave é do {ia}, não do {escolhida}.": "Esta clave es de {ia}, no de {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Esta cuenta ve la app como una cuenta nueva, sin ninguna pestaña desbloqueada, para revisar los candados, la prueba gratuita y la compra. Las demás cuentas no cambian.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Esta herramienta necesita ver las páginas del PDF, algo que llega con la app nueva (versión 0.50). Usa el navegador o actualiza My Planner desde la tienda.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Esta no parece una clave de {ia}. Las claves de {ia} empiezan con {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Este aviso está en \"Desactivado\": no sonará nada.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Este teléfono aún no recibe avisos con la app cerrada. Actualiza My Planner desde la tienda (versión {v} o más reciente). Con la app abierta, los avisos ya funcionan.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Este tipo de aviso está desactivado en los ajustes de notificaciones del teléfono.",
 "Estudado": "Estudiado",
 "Estudado: {dur}": "Estudiado: {dur}",
 "Faltou: {dur}": "Faltó: {dur}",
 "Fazer os testes terminarem agora": "Hacer que las pruebas terminen ahora",
 "Fechar a barra do editor": "Cerrar la barra del editor",
 "Fichário": "Carpeta",
 "Figurinhas e emojis": "Stickers y emojis",
 "Garantia terminou": "Garantía terminada",
 "Gerando…": "Generando…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Guarda documentos, análisis clínicos e historial de salud con una contraseña propia. Ni siquiera el soporte puede leerlo. Si olvidas la contraseña, no hay forma de recuperarla.",
 "Harpa": "Arpa",
 "Horas por dia": "Horas por día",
 "Identificação": "Identificación",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Esto parece un enlace o un correo, no una clave. Copia la clave completa en la página de claves de API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Esto solo aparece en My Planner si lo envías. ¿Quieres enviarlo ahora?",
 "Já dá para confirmar {titulo}?": "¿Ya puedes confirmar {titulo}?",
 "Lembrar minha escolha nesta aba": "Recordar mi elección en esta pestaña",
 "Lembrete para confirmar: {data}": "Recordatorio para confirmar: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Marca al menos un día de la semana en el plan.",
 "Me lembre de confirmar": "Recuérdame confirmar",
 "Me lembre depois": "Recuérdamelo después",
 "Menos": "Menos",
 "Meta somada": "Meta sumada",
 "Meta somada: {dur}": "Meta sumada: {dur}",
 "Meus dados - My Planner {data}": "Mis datos - My Planner {data}",
 "Meus dados do My Planner": "Mis datos de My Planner",
 "Mostrar a barra": "Mostrar la barra",
 "Mudar senha do diário": "Cambiar contraseña del diario",
 "Na primeira vez, aceite os termos de uso.": "La primera vez, acepta los términos de uso.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "En la versión de las tiendas, la compra se hará por la tienda de apps del teléfono. Por ahora, la clave simula la suscripción para pruebas.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Nada de otras pestañas va solo a My Planner. Estos elementos tienen fecha y aún no se han enviado.",
 "Nenhum estudo registrado neste mês.": "No hay estudio registrado este mes.",
 "Nenhum item aguardando envio.": "Ningún elemento pendiente de envío.",
 "Nenhum teste começado": "Ninguna prueba iniciada",
 "Nesta tela não há nada para adicionar.": "En esta pantalla no hay nada que añadir.",
 "No dia": "El mismo día",
 "Nova nota rápida": "Nueva nota rápida",
 "Nova página do dia": "Nueva página del día",
 "Não deu certo": "No funcionó",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "No se incluyen: el contenido del Diario y los campos de la caja fuerte (quedan protegidos por la contraseña), fotos y archivos adjuntos. Para restaurar los datos en la app, usa el archivo técnico.",
 "Não foi possível gerar o PDF.": "No se pudo generar el PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "No se pudo probar ahora. Inténtalo de nuevo en unos segundos.",
 "Não lembrar": "No recordar",
 "Não, obrigada": "No, gracias",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "El Diario está protegido por su propia contraseña y no se incluye en este archivo.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "La app abre \"Guardar en Archivos\" para que elijas la carpeta (puede ser iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "La app solo guarda el acceso directo al archivo elegido: sigue donde está (Drive, OneDrive, Descargas) y se abre en la app del teléfono. No se copia nada. Esta opción vale para las fotos tomadas con la cámara.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "La app instalada en este dispositivo es la versión {v}. Para hacer llamadas de audio y video, actualiza My Planner desde la tienda (versión 0.35 o más reciente). Los mensajes ya funcionan.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "El aviso llegará en silencio, directo a la lista de notificaciones: activa las alertas de My Planner en los ajustes del teléfono.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "El aviso llegará sin sonido: el sonido de este tipo de aviso se desactivó en los ajustes del teléfono.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "El aviso llegará, pero el sonido de las notificaciones de My Planner está desactivado en el teléfono.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "La invitación incluye el enlace para descargar la app. Quien entra por el enlace va directo a la oficina.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "El dictado llega con la nueva versión de la app. Actualiza My Planner desde la tienda para usar el micrófono.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "El mismo desbloqueo de la app: contraseña, biometría o PIN. Se pide una vez al entrar; dentro de la pestaña no se vuelve a pedir. Abrir la galería, la cámara o los archivos no cuenta como salir. Los elementos grandes siguen pidiendo la contraseña para eliminarlos.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "El modo silencio del teléfono puede impedir la alarma. Deja el teléfono en modo normal.",
 "O plano fica só em Estudos (não vai para o My Planner).": "El plan queda solo en Estudios (no va a My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Opcional: plazo, horas por día y días de la semana.",
 "Os avisos do celular funcionam no app instalado.": "Los avisos del teléfono funcionan en la app instalada.",
 "Os avisos no celular funcionam no app instalado.": "Los avisos en el teléfono funcionan en la app instalada.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Las pruebas iniciadas terminaron. Abre la pestaña para ver \"La prueba gratuita terminó\".",
 "Outros dados": "Otros datos",
 "Ouvir": "Escuchar",
 "Pacote em uso": "Paquete en uso",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Para suscribirte, actualiza My Planner desde la tienda de apps del teléfono.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Para leer (PDF): organizado por pestaña, con títulos y fechas. Se abre en cualquier dispositivo u ordenador.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Para que la alarma del medicamento suene con \"No molestar\" activado, el teléfono debe permitir a My Planner el acceso a \"No molestar\". Toca \"Abrir ajustes\", busca My Planner en la lista y activa el permiso.",
 "Passo a passo para criar a chave": "Paso a paso para crear la clave",
 "Pedir de novo": "Volver a pedir",
 "Pedir senha ao abrir esta aba": "Pedir contraseña al abrir esta pestaña",
 "Plano com período": "Plan con período",
 "Plano começa em {d}": "El plan empieza el {d}",
 "Por matéria": "Por materia",
 "Prolongar": "Prolongar",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Listo: el aviso llega en hasta 5 segundos, con sonido. Si no suena, comprueba si el teléfono está en silencio.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Listo: el aviso llega en hasta 5 segundos, solo con vibración.",
 "Publicado em": "Publicado el",
 "Pulso": "Pulso",
 "Quando o app bloquear": "Cuando la app se bloquee",
 "Quer proteger esta aba com senha?": "¿Quieres proteger esta pestaña con contraseña?",
 "Recolher ou arrastar a barra": "Contraer o arrastrar la barra",
 "Recomeçar os testes grátis": "Reiniciar las pruebas gratuitas",
 "Recomeçar os testes grátis?": "¿Reiniciar las pruebas gratuitas?",
 "Rolar a folha para os lados": "Desplazar la hoja hacia los lados",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Si conectas el reloj: totales diarios de pasos, distancia, calorías, ejercicio, pulsaciones y sueño, leídos de Health Connect o de la app Salud del teléfono. La app solo lee y nunca modifica esos datos.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Sin internet o se cayó la conexión. Revisa el Wi-Fi o los datos móviles e inténtalo de nuevo.",
 "Senha desta aba": "Contraseña de esta pestaña",
 "Seu plano terminou": "Tu plan terminó",
 "Sino": "Campana",
 "Som do alarme": "Sonido de la alarma",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Suma la garantía legal y la del fabricante. Revísalo en el certificado de garantía.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Son dos archivos con tus datos de My Planner (portabilidad, LGPD):",
 "Só quando o app bloquear": "Solo cuando la app se bloquee",
 "Tamanho da borracha": "Tamaño del borrador",
 "Tamanho da letra": "Tamaño de letra",
 "Tempo": "Tiempo",
 "Termina em": "Termina el",
 "Testar": "Probar",
 "Texto de exemplo": "Texto de ejemplo",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Suena en los avisos en \"Alarma (sonido)\". \"Sonido y vibración\" usa el sonido de notificación del teléfono.",
 "Toda vez que sair": "Cada vez que salgas",
 "Toda vez que sair da aba": "Cada vez que salgas de la pestaña",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Todas las pestañas vuelven a \"{n} días gratis para probar\", como en una cuenta nueva. Las suscripciones simuladas se desactivan.",
 "Todos os fichários": "Todas las carpetas",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Toca \"Create API key\" (Crear clave de API). Si pide un proyecto, elige el que aparezca o crea uno nuevo.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Toca \"Crear mi clave de API\" arriba. Se abre la plataforma de OpenAI (no es el sitio de ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Toca \"Crear mi clave de API\" arriba. Se abre la Consola de Anthropic (no es el sitio de Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Toca \"Crear mi clave de API\" arriba. Se abre Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Toca Conectar y, en la pantalla de la app Salud, activa los elementos que My Planner puede leer.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Toca el icono de copiar junto a la clave. Empieza con \"AIza\" o \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Toca una celda de la tabla (o \"Elegir celdas\") para cambiar su tamaño de letra.",
 "Transparência": "Transparencia",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Técnico (para restaurar): copia completa que solo My Planner lee. Para usarla, ve a Ajustes › Nube y copias de seguridad › Importar archivo.",
 "Uma carta da {nome} abre em {n} dias 💌": "Una carta de {nome} se abre en {n} días 💌",
 "Usa a senha do app": "Usa la contraseña de la app",
 "Usar no {ia}": "Usar en {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Usa la app en el teléfono para descargar el archivo técnico.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Precio final definido por la tienda de apps, ya en la moneda de tu país.",
 "Você ainda não enviou {titulo} para o My Planner.": "Aún no has enviado {titulo} a My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Vuelve aquí, pégala en el campo de abajo y toca \"Guardar y probar\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Vuelve a \"API keys\" y toca \"Create new secret key\" (Crear clave).",
 "atualização automática": "actualización automática",
 "erro desconhecido": "error desconocido",
 "estudados no mês": "estudiados en el mes",
 "faltou {dur}": "faltó {dur}",
 "hoje {feito} de {meta}": "hoy {feito} de {meta}",
 "hoje é folga": "hoy es día libre",
 "login do Google (não é chave de API)": "inicio de sesión de Google (no es clave de API)",
 "meta cumprida": "meta cumplida",
 "o que veio com a instalação": "lo que vino con la instalación",
 "outro": "otro",
 "provisório": "provisional",
 "superou {dur}": "superó {dur}",
 "token de login (não é chave de API)": "token de inicio de sesión (no es clave de API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} tardó demasiado en responder. Inténtalo de nuevo en unos instantes.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} está caído o sobrecargado ahora. No es un problema de tu clave: inténtalo de nuevo más tarde.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} respondió a la prueba con el modelo {modelo}. Ya puedes usarlo en las pestañas.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} se negó a leer este contenido (filtro de seguridad de la empresa).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: la clave existe, pero no tiene permiso para usar la IA. Crea una clave nueva en la página indicada en el paso a paso.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: clave no válida. Comprueba que copiaste la clave completa o crea una nueva.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: la empresa bloqueó esta clave porque apareció publicada en internet. Bórrala y crea otra.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: límite de uso alcanzado. Espera unos minutos (o hasta mañana, en el plan gratuito) e inténtalo de nuevo.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: el modelo elegido no está disponible para tu cuenta. Elige otro en \"Modelo\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: el servicio no está disponible en tu región o para este tipo de cuenta.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: tu cuenta de API no tiene saldo o no tiene forma de pago. Añade créditos en el sitio web de la empresa.",
 "{item}: a garantia termina hoje ({data}).": "{item}: la garantía termina hoy ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: la garantía terminó el {data}.",
 "{item}: venceu em {data}.": "{item}: venció el {data}.",
 "{mes} de {ano}": "{mes} de {ano}",
 "{nome} protegida com senha": "{nome} protegida con contraseña",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: ¿terminar el plan o prolongarlo con una nueva fecha final? No se borra nada.",
 "{n} dias antes": "{n} días antes",
 "{n} dias de estudo no plano · {dur} por dia": "{n} días de estudio en el plan · {dur} por día",
 "{n} dias de plano": "{n} días de plan",
 "{n} dias depois": "{n} días después",
 "{n} item(ns) aguardando envio ao My Planner": "{n} elemento(s) pendiente(s) de envío a My Planner",
 "{n} itens aguardando envio": "{n} elementos pendientes de envío",
 "{quando} às {hora}": "{quando} a las {hora}",
 "ÚLTIMOS 6 MESES": "ÚLTIMOS 6 MESES",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Abre My Planner Anne e inicia sesión con tu CPF o correo electrónico y tu contraseña.",
 "Anexo": "Adjunto",
 "Assédio ou ameaça": "Acoso o amenaza",
 "Bloquear {nome}": "Bloquear a {nome}",
 "Conte mais (opcional)": "Cuéntanos más (opcional)",
 "Conteúdo impróprio": "Contenido inapropiado",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "No se toleran el contenido ofensivo ni los usuarios abusivos. Nuestro equipo analiza las denuncias en un plazo de 24 horas.",
 "Denunciar": "Denunciar",
 "Denunciar contato": "Denunciar contacto",
 "Denunciar grupo": "Denunciar grupo",
 "Denunciar mensagem": "Denunciar mensaje",
 "Denúncia enviada": "Denuncia enviada",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Denuncias que haces en Mensajes: el motivo, a quién se denunció y el fragmento del mensaje denunciado. Solo el equipo de My Planner las lee, para analizar el caso.",
 "Enviar denúncia": "Enviar denuncia",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Envía un correo electrónico pidiendo la eliminación, con el CPF o el correo de la cuenta. Respondemos en un plazo de 15 días.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "No toleramos contenido ofensivo, ilegal o inapropiado ni usuarios abusivos en Mensajes ni en los grupos. Cualquier persona puede denunciar un mensaje, un contacto o un grupo (mantén pulsado el mensaje o toca ⋮ > Denunciar) y bloquear a quien quiera. Nuestro equipo analiza las denuncias en un plazo de 24 horas: el contenido puede eliminarse y quien lo envió puede tener su cuenta suspendida o cerrada.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Gracias. Nuestro equipo lo analizará en un plazo de 24 horas.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Para las cuentas que inician sesión con CPF, nuestro soporte crea la contraseña nueva después de confirmar que la cuenta es tuya. Escribe a {email} indicando tu CPF o el correo registrado.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "¿Por qué denuncias? La persona denunciada no sabrá quién la denunció.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} ya no puede conversar contigo.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nVálido hasta {d}. Queda cifrado en tu caja fuerte, solo en este dispositivo y en tu copia en la nube.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. En la computadora, abre {url} y elige Entrar con código QR.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Aquí, toca Conectar navegador y apunta la cámara al código QR de la computadora.",
 "Abandonados": "Abandonados",
 "Bloquear o computador": "Bloquear la computadora",
 "Cheguei na página...": "Llegué a la página...",
 "Computador conectado": "Computadora conectada",
 "Computador desconectado": "Computadora desconectada",
 "Conectado em {d}": "Conectada el {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve el material del libro y sigue la lectura. Quien administra agrega, edita y pone fotos, y puede habilitarlo para quien también usa la pestaña. Solo quien administra agrega o quita personas.",
 "Depois de {n} minutos parado": "Después de {n} minutos sin uso",
 "Desconectar o computador?": "¿Desconectar la computadora?",
 "Difícil demais": "Demasiado difícil",
 "Editar livro": "Editar libro",
 "Entrar com o QR Code": "Entrar con el código QR",
 "Escreva (ex.: filosofia)": "Escribe (ej.: filosofía)",
 "Este computador": "Esta computadora",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Esta computadora fue desconectada (desde el celular o porque entró otra computadora). Para usarla de nuevo, entra con el código QR.",
 "Já existe um computador conectado": "Ya hay una computadora conectada",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Ya hay una computadora conectada. ¿Cambiar a esta? La otra se desconectará.",
 "Navegador": "Navegador",
 "Nenhum computador conectado": "Ninguna computadora conectada",
 "Novo livro": "Nuevo libro",
 "Não gostei": "No me gustó",
 "Não, abandonei": "No, lo abandoné",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner se cerrará en la computadora. Para usarlo de nuevo, conéctate con el código QR.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "El código QR cambia cada 3 minutos y solo vale una vez. En una computadora compartida, usa Ajustes › Salir de esta computadora al terminar.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Tus datos siguen guardados en la nube y en el celular. Para entrar de nuevo, usa el código QR.",
 "Parei em": "Dejé el",
 "Perdi o interesse": "Perdí el interés",
 "Por que parei": "Por qué lo dejé",
 "Páginas e meta": "Páginas y meta",
 "Quero voltar a ler?": "¿Quiero volver a leerlo?",
 "Sair deste computador": "Salir de esta computadora",
 "Sair deste computador?": "¿Salir de esta computadora?",
 "Se quiser, escreva com as suas palavras": "Si quieres, escríbelo con tus palabras",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Sin usar el mouse ni el teclado durante ese tiempo, My Planner se bloquea. Para volver, escribe la contraseña de la cuenta (o entra de nuevo con el código QR).",
 "Sem tempo": "Sin tiempo",
 "Sim, depois": "Sí, más tarde",
 "Só um computador pode ficar conectado por vez.": "Solo una computadora puede estar conectada a la vez.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "La foto o el PDF del certificado va en \"Fotos, archivos y enlaces\": márcalo como Certificado.",
 "ABNT copiada": "ABNT copiada",
 "APA copiada": "APA copiada",
 "Ano inválido": "Año no válido",
 "Ano ou data de publicação": "Año o fecha de publicación",
 "Assisti em": "Lo vi el",
 "Buscando os dados...": "Buscando los datos...",
 "Calculado pelos módulos": "Calculado por los módulos",
 "Carga horária (horas)": "Carga horaria (horas)",
 "Certificado": "Certificado",
 "Certificado emitido em": "Certificado emitido el",
 "Cheguei na aula": "Llegué a la clase",
 "Cheguei na aula...": "Llegué a la clase...",
 "Cheguei na temporada": "Voy en la temporada",
 "Cheguei no episódio": "Voy en el episodio",
 "Citação copiada": "Cita copiada",
 "Colocar em pasta": "Poner en carpeta",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Pon libros, películas o cursos en esta carpeta para armar la lista.",
 "Comentário": "Comentario",
 "Copiar ABNT": "Copiar ABNT",
 "Copiar APA": "Copiar APA",
 "Copiar citação (ABNT)": "Copiar cita (ABNT)",
 "Copiar citação (APA)": "Copiar cita (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Crea tarjetas con checklist, lista, texto libre o dibujo para esta materia. Desliza a la derecha para eliminar y a la izquierda para Archivar o Duplicar.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve la lista y la sigue. Quien administra agrega, edita y pone fotos, y puede habilitarlo para quien también usa la pestaña. Solo quien administra agrega o quita personas.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve el material del curso y lo sigue. Quien administra agrega, edita y pone fotos, y puede habilitarlo para quien también usa la pestaña. Solo quien administra agrega o quita personas.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Crea primero una carpeta, en la parte 📁 Carpetas de esta pestaña.",
 "DOI (artigos)": "DOI (artículos)",
 "Data de acesso": "Fecha de acceso",
 "Deixar avulsas": "Dejarlas sueltas",
 "Descrição (objetivo)": "Descripción (objetivo)",
 "Digite o ano com 4 números (ex.: {a}).": "Escribe el año con 4 cifras (ej.: {a}).",
 "Direção": "Dirección",
 "Editar pasta": "Editar carpeta",
 "Editora": "Editorial",
 "Edição": "Edición",
 "Em 1 mês": "En 1 mes",
 "Em {n} meses": "En {n} meses",
 "Episódios por temporada (opcional)": "Episodios por temporada (opcional)",
 "Escreva o trecho na anotação para copiar a citação.": "Escribe el fragmento en la nota para copiar la cita.",
 "Este item já está em todas as pastas.": "Este elemento ya está en todas las carpetas.",
 "Ex.: 10.1590/...": "Ej.: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Ej.: Tesis — Ética y Derecho",
 "Ex.: {a}": "Ej.: {a}",
 "Fazendo": "Haciendo",
 "Grupo de filmes e séries": "Grupo de películas y series",
 "Grupo de leitura": "Grupo de lectura",
 "Grupo do curso": "Grupo del curso",
 "ISBN": "ISBN",
 "Ideia minha": "Idea mía",
 "Instrutor": "Instructor",
 "Itens da pasta": "Elementos de la carpeta",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Junta libros, películas y cursos en una carpeta (ej.: \"Tesis\", \"Solo novelas\"). El mismo elemento puede estar en varias carpetas.",
 "Link (material online)": "Enlace (material en línea)",
 "Lista copiada": "Lista copiada",
 "Lista de referências": "Lista de referencias",
 "Mais de um autor: separe com ponto e vírgula (;).": "Más de un autor: sepáralos con punto y coma (;).",
 "Módulo": "Módulo",
 "Nada novo": "Nada nuevo",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "En el ⋮ de un libro, película o curso, toca \"Poner en carpeta\".",
 "Nome da pasta": "Nombre de la carpeta",
 "Não achei dados novos para completar a ficha.": "No encontré datos nuevos para completar la ficha.",
 "Não foi possível preencher": "No se pudo completar",
 "O módulo não tem cards de anotações.": "El módulo no tiene tarjetas de notas.",
 "Organizador": "Compilador",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Los datos vienen de la ficha del libro (Editar › Referencia).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Los libros, películas y cursos de la carpeta NO se eliminan: siguen en la pestaña.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "La(s) {n} tarjeta(s) de notas de este módulo también va(n) a la papelera.",
 "Pasta vazia": "Carpeta vacía",
 "Preencha o título (e o que mais tiver) na ficha.": "Completa el título (y lo que más tengas) en la ficha.",
 "Preencher pelo DOI": "Completar por el DOI",
 "Preencher pelo link": "Completar por el enlace",
 "Produtora ou país": "Productora o país",
 "Quero fazer": "Quiero hacerlo",
 "Quero voltar?": "¿Quiero volver?",
 "Referência vazia": "Referencia vacía",
 "Referências": "Referencias",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Si las dejas sueltas, siguen sumando en el total del curso.",
 "Subtítulo": "Subtítulo",
 "Tirar da pasta": "Quitar de la carpeta",
 "Total de episódios (opcional)": "Total de episodios (opcional)",
 "Total de temporadas (opcional)": "Total de temporadas (opcional)",
 "Tradutor": "Traductor",
 "Trecho (citação)": "Fragmento (cita)",
 "Trecho vazio": "Fragmento vacío",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Ya viste {n} clase(s). ¿En qué módulo ponerlas?",
 "Volume": "Volumen",
 "{n} item(ns)": "{n} elemento(s)",
 "{n} referência(s) em ordem alfabética.": "{n} referencia(s) en orden alfabético.",
 "Ícone": "Ícono",
 "ASSISTIDOS POR DIA": "VISTOS POR DÍA",
 "ASSISTIDOS POR MÊS": "VISTOS POR MES",
 "AULAS POR DIA": "CLASES POR DÍA",
 "AULAS POR MÊS": "CLASES POR MES",
 "Apagar a meta": "Borrar la meta",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Vi {a} · Viendo {b} · Dejé {c} · Quiero ver {d}",
 "Aulas": "Clases",
 "CURSOS": "CURSOS",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Terminé {a} · Haciendo {b} · Dejé {c}",
 "Datas": "Fechas",
 "Datas escolhidas": "Fechas elegidas",
 "Datas à escolha": "Fechas a elegir",
 "Definir meta de {ano}": "Definir meta de {ano}",
 "Definir meta do ano": "Definir meta del año",
 "FILMES E SÉRIES": "PELÍCULAS Y SERIES",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Faltan {f} curso(s): unos {m} por mes",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Faltan {f} libro(s): unos {m} por mes",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Faltan {f} título(s): unos {m} por mes",
 "Gênero": "Género",
 "Incluir lista de referências no PDF": "Incluir lista de referencias en el PDF",
 "LIVROS": "LIBROS",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Leí {a} libro(s) · Dejé {b} · Leyendo {c}",
 "Meta de {ano}": "Meta de {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Meta de {ano}: ¿usar la de {antes} ({n})?",
 "Meta do ano cumprida": "Meta del año cumplida",
 "Mudar": "Cambiar",
 "Nada neste período.": "Nada en este período.",
 "Nota": "Nota",
 "O PDF não leva as suas anotações, resumos e comentários.": "El PDF no incluye tus notas, resúmenes ni comentarios.",
 "POR ITEM": "POR ELEMENTO",
 "Plataforma": "Plataforma",
 "PÁGINAS POR DIA": "PÁGINAS POR DÍA",
 "PÁGINAS POR MÊS": "PÁGINAS POR MES",
 "Quantos no ano?": "¿Cuántos en el año?",
 "Quero ler {a} · Abandonei {b}": "Quiero leer {a} · Abandoné {b}",
 "Relatório de leitura e mídia": "Informe de lectura y medios",
 "concluídos no período": "terminados en el período",
 "cursos concluídos no período": "cursos terminados en el período",
 "livros lidos no período": "libros leídos en el período",
 "pág. {a} de {n}": "pág. {a} de {n}",
 "títulos assistidos no período": "títulos vistos en el período",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} clase(s) vista(s) en el período · {h} hora(s) de cursos terminados",
 "{a} de {n} aulas ({p}%)": "{a} de {n} clases ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} de {n} curso(s) terminado(s) en {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} de {n} libro(s) en {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} de {n} título(s) visto(s) en {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} elemento(s) sin fecha de cambio de situación: usé la fecha de creación.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} página(s) leída(s) en {d} día(s) · mejor racha: {s} día(s)",
 "{p}% lido · falta {f}%": "{p}% leído · falta {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Esta pestaña pide contraseña. Desbloquéala primero y la guía sigue desde aquí.",
 "Abrir esta aba": "Abrir esta pestaña",
 "Mostrar na tela": "Mostrar en pantalla",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "No encontré este punto en la pantalla. Revisa que esté abierta la pantalla correcta e inténtalo de nuevo.",
 "Primeiros passos": "Primeros pasos",
 "Buscar no guia": "Buscar en la guía",
 "Entendi": "Entendido",
 "{n} de {total} passos feitos": "{n} de {total} pasos hechos",
 "Já fiz": "Ya lo hice",
 "Guia em construção": "Guía en construcción",
 "Limpar marcações": "Limpiar marcas",
 "Este ponto ainda não está marcado no app.": "Este punto aún no está marcado en la app.",
 "Dicas e atalhos": "Consejos y atajos",
 "Gestos do app": "Gestos de la app",
 "Procurando na tela…": "Buscando en la pantalla…",
 "Guia das abas": "Guía de las pestañas",
 "Voltar ao guia": "Volver a la guía",
 "Para que serve": "Para qué sirve",
 "Disponível no app do celular.": "Disponible en la app del celular.",
 "Nada encontrado no guia.": "No se encontró nada en la guía.",
 "Recursos que valem para todas as abas": "Recursos para todas las pestañas",
 "Perguntas comuns": "Preguntas frecuentes",
 "Ligar e desligar partes": "Activar y desactivar partes",
 "Entrada cancelada. Este computador não foi conectado.": "Inicio de sesión cancelado. Este ordenador no se conectó.",
 "Alterações ainda não enviadas": "Cambios aún no enviados",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Algunos cambios aún no se enviaron al servidor (¿sin internet?). Si sales ahora, se perderán. ¿Salir de todos modos?",
 "Sair mesmo assim": "Salir de todos modos",
 "O seu papel no grupo não permite mudar aqui.": "Tu función en el grupo no permite cambiar aquí.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "No se pudo consultar el DOI ahora (¿sin internet?). Inténtalo de nuevo.",
 "DOI inválido.": "DOI no válido.",
 "DOI não encontrado.": "DOI no encontrado.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "El sitio no permitió leer los datos desde aquí (es común en el navegador del ordenador). Prueba con la app en el móvil, usa el DOI o escribe los campos.",
 "Atualizando...": "Actualizando...",
 "Banco de dados (Supabase, plano grátis)": "Base de datos (Supabase, plan gratuito)",
 "Cadeado (HTTPS) até": "Candado (HTTPS) hasta",
 "Dados das abas: {d}": "Datos de las pestañas: {d}",
 "Disco": "Disco",
 "Esta conta não tem acesso a estas informações.": "Esta cuenta no tiene acceso a esta información.",
 "Ligado há": "Encendido desde hace",
 "Livre: {l} · site: {s}": "Libre: {l} · sitio: {s}",
 "Maiores tabelas": "Tablas más grandes",
 "Memória em uso": "Memoria en uso",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "El servidor aún no envió el informe. Lo envía cada 10 minutos después del 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "El servidor aún no tiene esta función. Ejecuta 53-SERVIDOR-0.78.bat en el ordenador.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "El sistema del servidor pide reinicio (actualización de seguridad instalada).",
 "Processador": "Procesador",
 "Relatório do servidor: {q}": "Informe del servidor: {q}",
 "Servidor": "Servidor",
 "Servidor do site (Locaweb)": "Servidor del sitio (Locaweb)",
 "Sistema": "Sistema",
 "Só você vê este quadro.": "Solo tú ves este cuadro.",
 "Versão do site no ar": "Versión del sitio publicada",
 "atrasado: confira se o servidor está ligado": "atrasado: comprueba si el servidor está encendido",
 "sem cadeado": "sin candado",
 "{a} ({n} guardadas)": "{a} ({n} guardadas)",
 "{d} dia(s) e {h} h": "{d} día(s) y {h} h",
 "{n} núcleo(s) · carga {c}": "{n} núcleo(s) · carga {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} nueva(s) y {ativas} activa(s) en 7 días",
 "{u} de {t} ({p}%)": "{u} de {t} ({p}%)",
 "Fechar teclado": "Cerrar teclado",
 "Mostrar as ferramentas": "Mostrar las herramientas",
 "Últimas cores usadas": "Últimos colores usados",
 "Voltar ao topo": "Volver arriba",
 "Topo": "Arriba",
 "1 atividade do roteiro por fazer": "1 actividad del itinerario pendiente",
 "1 dia": "1 día",
 "1 item por pôr na mala": "1 artículo por meter en la maleta",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 lista de Viajes se enviaba entera a My Planner y se quitó de allí. Ahora el envío es elemento por elemento, desde el ⋮ de cada uno.",
 "1 lugar não visitado": "1 lugar sin visitar",
 "1 reserva por confirmar": "1 reserva por confirmar",
 "Abrir o bloco": "Abrir sección",
 "Adicionar pessoa": "Añadir persona",
 "Ainda pode gastar {v}": "Aún puedes gastar {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Al activarlo, el importe entra en Gastos como pagado.",
 "Até (dd/mm/aaaa)": "Hasta (dd/mm/aaaa)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Añade a las personas en \"Quién va\" (edita el viaje).",
 "Como foi?": "¿Qué tal fue?",
 "Concluído em {d}": "Hecho el {d}",
 "Confirmada em {d}": "Confirmada el {d}",
 "Confirmadas": "Confirmadas",
 "Dia anterior": "Día anterior",
 "Dias": "Días",
 "Dias × valor por dia": "Días × valor por día",
 "Documentos (só o tipo e a validade)": "Documentos (solo tipo y validez)",
 "EXIGÊNCIAS DO DESTINO": "REQUISITOS DEL DESTINO",
 "Em mãos": "En mano",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Escribe lo que pide el destino (ej.: 2 páginas en blanco en el pasaporte, certificado de vacunación). Consulta el sitio oficial del país.",
 "Ex.: Lisboa (LIS)": "Ej.: Lisboa (LIS)",
 "Ex.: São Paulo (GRU)": "Ej.: São Paulo (GRU)",
 "Falta confirmar": "Por confirmar",
 "Falta pôr": "Por meter",
 "Faltou ({n}): {l}": "Faltó ({n}): {l}",
 "Foi ({n}): {l}": "Llevado ({n}): {l}",
 "Fotos (lista das legendas)": "Fotos (lista de leyendas)",
 "Gasto de {nome} em {d}": "Gasto de {nome} el {d}",
 "Gastos do dia": "Gastos del día",
 "Gastos em outras moedas (não convertidos): {v}": "Gastos en otras monedas (sin convertir): {v}",
 "Gastos por dia": "Gastos por día",
 "Horário de chegada": "Hora de llegada",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Lugares (visitados, pendientes, imprescindibles y la nota)",
 "Mala (o que foi e o que faltou)": "Maleta (lo que se llevó y lo que faltó)",
 "Marcar como acertado": "Marcar como saldado",
 "Marcar como acertado?": "¿Marcar como saldado?",
 "Na mala": "En la maleta",
 "Nenhuma parada ainda": "Aún no hay paradas",
 "Nova exigência": "Nuevo requisito",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Los números de documentos y lo que está en la caja fuerte nunca van al informe. Los importes en distintas monedas aparecen por separado.",
 "O QUE AINDA FALTA": "LO QUE AÚN FALTA",
 "O QUE INCLUIR": "QUÉ INCLUIR",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Opcional. La app avisa si el pasaporte vence antes, contando desde la vuelta. Consulta el requisito del país.",
 "Orçamento previsto × gasto por categoria": "Presupuesto previsto × gastado por categoría",
 "Passou do previsto em {v}": "Superaste lo previsto en {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Pon la fecha de validez de cada documento: la app avisa antes de que venza. Las fotos de los documentos quedan protegidas en la caja fuerte.",
 "Próximo dia": "Día siguiente",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Quien está en el grupo del viaje entra automáticamente. Usa \"+ Añadir persona\" para quien no tiene la app.",
 "Recolher o bloco": "Contraer sección",
 "Relatório da viagem": "Informe del viaje",
 "Reserva confirmada": "Reserva confirmada",
 "Resumo da viagem": "Resumen del viaje",
 "Resumo da viagem (datas, destino, pessoas)": "Resumen del viaje (fechas, destino, personas)",
 "Roteiro por dia (feito e falta)": "Itinerario por día (hecho y pendiente)",
 "Sem data": "Sin fecha",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Puede que tu pasaporte no sea aceptado. Consulta el requisito del país",
 "Subir": "Subir",
 "Total do dia: {v}": "Total del día: {v}",
 "Uma frase (opcional)": "Una frase (opcional)",
 "Validade mínima exigida (meses)": "Validez mínima exigida del pasaporte (meses)",
 "Validade: {d}": "Validez: {d}",
 "Valor por dia": "Valor por día",
 "Viagens no My Planner": "Viajes en My Planner",
 "Visitado": "Visitado",
 "Visitado em {d}": "Visitado el {d}",
 "Voltaria: {r}": "Volvería: {r}",
 "Voltaria?": "¿Volverías?",
 "confirmada": "confirmada",
 "em mãos": "en mano",
 "gasto na viagem {d}": "gasto en el viaje {d}",
 "meses": "meses",
 "outro gasto": "otro gasto",
 "vence em {d}": "vence el {d}",
 "{a} de {b} confirmadas": "{a} de {b} confirmadas",
 "{a} de {b} em mãos": "{a} de {b} en mano",
 "{a} de {b} feitos": "{a} de {b} hechos",
 "{a} de {b} na mala": "{a} de {b} en la maleta",
 "{a} de {b} pagos": "{a} de {b} pagados",
 "{a} de {b} visitados": "{a} de {b} visitados",
 "{de} deve {v} a {para}": "{de} debe {v} a {para}",
 "{g} de {p}": "{g} de {p}",
 "{n} atividades do roteiro por fazer": "{n} actividades del itinerario pendientes",
 "{n} item(ns) enviado(s).": "{n} elemento(s) enviado(s).",
 "{n} itens por pôr na mala": "{n} artículos por meter en la maleta",
 "{n} já estava(m) no My Planner.": "{n} ya estaba(n) en My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} listas de Viajes se enviaban enteras a My Planner y se quitaron de allí. Ahora el envío es elemento por elemento, desde el ⋮ de cada uno.",
 "{n} lugares não visitados": "{n} lugares sin visitar",
 "{n} reservas por confirmar": "{n} reservas por confirmar",
 "{n} sem data (não foi).": "{n} sin fecha (no se envió).",
 "ARTIGOS E SITES": "ARTÍCULOS Y SITIOS",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Ahora el envío es elemento por elemento (desde el ⋮ del elemento o seleccionando varios). Estas listas se enviaban completas y salieron de My Planner ({n} elemento(s), no se borró nada):",
 "Artigo científico": "Artículo científico",
 "Artigo de site ou blog": "Artículo de sitio o blog",
 "Artigo ou site": "Artículo o sitio",
 "Artigos e sites": "Artículos y sitios",
 "Autor(es)": "Autor(es)",
 "Cadastrar pela foto ou PDF": "Registrar con foto o PDF",
 "Capítulo de livro": "Capítulo de libro",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Crea el grupo y envía el enlace: quien entre ve los artículos y sigue la lectura. Quien administra agrega, edita y pone fotos, y puede habilitarlo para quien también usa la pestaña. Solo quien administra agrega o quita personas.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Fecha o año de publicación",
 "Editar artigo ou site": "Editar artículo o sitio",
 "Enviar para o My Planner (lembrete de renovação)": "Enviar a My Planner (recordatorio de renovación)",
 "Envio para o My Planner": "Envío a My Planner",
 "Ex.: 2024 ou 12/03/2024": "Ej.: 2024 o 12/03/2024",
 "Ex.: 45-60": "Ej.: 45-60",
 "Grupo de artigos": "Grupo de artículos",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Guarda artículos, noticias y páginas web con la referencia lista (ABNT y APA). Complétala con el DOI o el enlace.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Leí {a} · Leyendo {b} · Dejé {c} · Quiero leer {d}",
 "Minhas anotações do artigo": "Mis notas del artículo",
 "Notícia": "Noticia",
 "Novo artigo ou site": "Nuevo artículo o sitio",
 "Os dados vêm da ficha do artigo (Editar).": "Los datos vienen de la ficha del artículo (Editar).",
 "Páginas (opcional)": "Páginas (opcional)",
 "Revista, site ou veículo": "Revista, sitio o medio",
 "artigos e sites lidos no período": "artículos y sitios leídos en el período",
 "1 confirmado": "1 confirmado",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 invitado que estaba en \"Pendiente\" pasó a \"Por invitar\". Al enviar la invitación por la app, pasa solo a \"Invitado, sin respuesta\".",
 "1 extra": "1 extra",
 "1 talvez": "1 tal vez",
 "A convidar": "Por invitar",
 "Agendar na igreja": "Reservar en la iglesia",
 "Agora": "Ahora",
 "Agradeci": "Agradecí",
 "Agradeci em {d}": "Agradecí el {d}",
 "Agradecidos": "Agradecidos",
 "Alianças": "Anillos",
 "Aluguéis (mesas, cadeiras, louças)": "Alquileres (mesas, sillas, vajilla)",
 "Avisar a data (save the date)": "Avisar la fecha (save the date)",
 "Bebidas": "Bebidas",
 "Beca e cerimônia": "Toga y ceremonia",
 "Bolo": "Pastel",
 "Brincadeiras": "Juegos",
 "Brincadeiras e amigo secreto": "Juegos y amigo invisible",
 "Brindes": "Obsequios",
 "Buffet": "Catering",
 "Calculado sozinho: valor menos o sinal.": "Calculado automáticamente: importe menos la seña.",
 "Calcular quantidades": "Calcular cantidades",
 "Categoria do orçamento": "Categoría del presupuesto",
 "Celebrante": "Celebrante",
 "Cerimônia": "Ceremonia",
 "Cerveja (adultos)": "Cerveza (adultos)",
 "Checklist de preparação": "Lista de preparación",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Pon la fecha del evento (edita el evento) para ver hasta cuándo hacer cada ítem.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Agrega a las personas en \"Personas del evento\" (edita el evento).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Pon cuánto piensas gastar en cada categoría. Usa el ⊕ para calcular por invitado. Los proveedores contratados entran solos en la categoría elegida.",
 "Combinado: {v}": "Acordado: {v}",
 "Comprado": "Comprado",
 "Comprados": "Comprados",
 "Comprar a decoração e as lembrancinhas": "Comprar la decoración y los recuerdos",
 "Comprar as alianças": "Comprar los anillos",
 "Comprar as lembrancinhas": "Comprar los recuerdos",
 "Comprar bebidas e gelo": "Comprar bebidas y hielo",
 "Comprar comida e bebidas": "Comprar comida y bebidas",
 "Comprar o que falta": "Comprar lo que falta",
 "Comprar ou alugar a roupa": "Comprar o alquilar la ropa",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Confirmados con los acompañantes. Cambia solo cuando alguien confirma o cancela.",
 "Confirmar a presença dos convidados": "Confirmar la asistencia de los invitados",
 "Confirmar os fornecedores": "Confirmar a los proveedores",
 "Confirmar os fornecedores e os convidados": "Confirmar a los proveedores y a los invitados",
 "Contratar a comida": "Contratar la comida",
 "Contratar a comida e o bolo": "Contratar la comida y el pastel",
 "Contratar a decoração": "Contratar la decoración",
 "Contratar comida e bebidas": "Contratar comida y bebidas",
 "Contratar foto e vídeo": "Contratar foto y video",
 "Contratar o buffet": "Contratar el catering",
 "Convidado, sem resposta": "Invitado, sin respuesta",
 "Convidados (por situação, com acompanhantes)": "Invitados (por estado, con acompañantes)",
 "Convidados que contam no ⊕": "Invitados que cuentan en el ⊕",
 "Convites": "Invitaciones",
 "Cronograma do dia (com responsáveis e situação)": "Cronograma del día (con responsables y estado)",
 "Data do restante": "Fecha del saldo",
 "Data do sinal": "Fecha de la seña",
 "Decoração": "Decoración",
 "Definir a data e o orçamento": "Definir la fecha y el presupuesto",
 "Definir a lista de convidados": "Definir la lista de invitados",
 "Doces": "Dulces",
 "Dá para mudar, tirar e incluir itens depois.": "Puedes cambiar, quitar y agregar ítems después.",
 "Enviar os convites": "Enviar las invitaciones",
 "Equipamentos (projetor, som)": "Equipos (proyector, sonido)",
 "Equipe (garçons, limpeza)": "Personal (meseros, limpieza)",
 "Escolha \"Outro\" para escrever o nome.": "Elige \"Otro\" para escribir el nombre.",
 "Escolher a roupa": "Elegir la ropa",
 "Escolher a roupa dos noivos": "Elegir la ropa de los novios",
 "Escolher os padrinhos": "Elegir a los padrinos",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Estimación para {n} invitados. Cambia lo que quieras antes de llevarlo.",
 "Eu faço": "Lo hago yo",
 "Ex.: 200 un.": "Ej.: 200 ud.",
 "Ex.: Copos descartáveis": "Ej.: Vasos desechables",
 "Ex.: Jogo de panelas": "Ej.: Juego de ollas",
 "Ex.: Reservar o local": "Ej.: Reservar el lugar",
 "Ex.: em negociação": "Ej.: en negociación",
 "Extras de margem (quem aparece sem avisar)": "Extras de margen (quien aparece sin avisar)",
 "Falta 1 dia": "Falta 1 día",
 "Falta agradecer": "Falta agradecer",
 "Falta comprar": "Falta comprar",
 "Falta pagar": "Falta pagar",
 "Fazer a lista de presentes": "Hacer la lista de regalos",
 "Fazer o curso de batismo": "Hacer el curso de bautismo",
 "Fornecedores (contratado, pago, falta)": "Proveedores (contratado, pagado, falta)",
 "Foto e vídeo": "Foto y video",
 "Fraldas": "Pañales",
 "Frase curta (opcional)": "Frase corta (opcional)",
 "Hoje é o dia do evento!": "¡Hoy es el día del evento!",
 "Igreja e celebrante": "Iglesia y celebrante",
 "Incluir os Talvez": "Incluir los Tal vez",
 "Incluir telefones": "Incluir teléfonos",
 "Item da lista de compras": "Ítem de la lista de compras",
 "Item da preparação": "Ítem de la preparación",
 "Já deram: {d} · Falta: {f}": "Ya dieron: {d} · Falta: {f}",
 "Já deu": "Ya dio",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Registra aquí lo que se gastó. Los pagos a proveedores y las compras marcadas entran solos.",
 "Lançar o gasto": "Registrar el gasto",
 "Lembrancinhas": "Recuerdos",
 "Levar para os itens": "Llevar a los ítems",
 "Local / espaço": "Lugar / salón",
 "Mais um extra": "Un extra más",
 "Menos um extra": "Un extra menos",
 "Música / som / DJ": "Música / sonido / DJ",
 "No dia do evento": "El día del evento",
 "O que comprar": "Qué comprar",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "El total cambia solo cuando alguien confirma o cancela.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "El importe del contrato entra solo como previsto en esta categoría, y lo pagado entra en los gastos.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "El importe entra en los gastos del evento, en la categoría del ítem. Si prefieres, omítelo.",
 "Onde comprar": "Dónde comprar",
 "Orçamento do evento": "Presupuesto del evento",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Los ítems marcados entran en la categoría con el ⊕ por invitado. Luego solo toca el ⊕ y pon el valor unitario.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Los teléfonos de los invitados solo salen en el PDF si marcas \"Incluir teléfonos\". Los importes en monedas distintas aparecen separados.",
 "Pago em {d}": "Pagado el {d}",
 "Parte da vaquinha": "Parte de la vaquita",
 "Pessoas do evento": "Personas del evento",
 "Pessoas do evento: {p}": "Personas del evento: {p}",
 "Preparar as brincadeiras": "Preparar los juegos",
 "Preparação": "Preparación",
 "Presente recebido": "Regalo recibido",
 "Presentes": "Regalos",
 "Prova final da roupa": "Prueba final de la ropa",
 "Pular": "Omitir",
 "Quantidade por convidado": "Cantidad por invitado",
 "Quantidade por convidado × valor unitário": "Cantidad por invitado × valor unitario",
 "Quanto custou?": "¿Cuánto costó?",
 "Quanto já deu": "Cuánto ya dio",
 "Quanto vai contribuir": "Cuánto va a aportar",
 "Quantos dias antes do evento": "Cuántos días antes del evento",
 "Quem deu": "Quién lo dio",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Quien está en el grupo del evento entra solo. Usa \"+ Agregar persona\" para quien no tiene la app. Esta lista se usa en el cronograma, los gastos y la vaquita.",
 "Recreação e brinquedos": "Recreación y juegos",
 "Refrigerante": "Refrescos",
 "Relatório do evento": "Informe del evento",
 "Relatório do evento (PDF)": "Informe del evento (PDF)",
 "Reservar o local": "Reservar el lugar",
 "Reservar o local da cerimônia e da festa": "Reservar el lugar de la ceremonia y de la fiesta",
 "Reservar o local ou a mesa da festa": "Reservar el lugar o la mesa de la fiesta",
 "Restante": "Saldo",
 "Restante pago": "Saldo pagado",
 "Resumo do evento": "Resumen del evento",
 "Roupa e beleza": "Ropa y belleza",
 "Salgados": "Bocadillos salados",
 "Separar a roupa e o que levar": "Separar la ropa y lo que llevar",
 "Separar os documentos e as alianças": "Separar los documentos y los anillos",
 "Separar os documentos e os ingressos": "Separar los documentos y las entradas",
 "Sinal": "Seña",
 "Sinal pago": "Seña pagada",
 "Sinal {v} pago": "Seña {v} pagada",
 "Usar a lista pronta para {tipo}": "Usar la lista lista para {tipo}",
 "Vai contribuir": "Va a aportar",
 "Valor unitário": "Valor unitario",
 "Vaquinha": "Vaquita",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Sigues todo lo compartido, siempre actualizado. Para agregar, editar y tomar tareas, suscríbete a la pestaña.",
 "agradeci": "agradecí",
 "atrasado": "atrasado",
 "completo": "completo",
 "deu {d} de {v}": "dio {d} de {v}",
 "em {l}": "en {l}",
 "falta o valor": "falta el importe",
 "falta {v} até {d}": "falta {v} hasta el {d}",
 "gasto em {e}": "gastado en {e}",
 "kg": "kg",
 "o evento": "el evento",
 "restante": "saldo",
 "sinal": "seña",
 "total": "total",
 "un.": "ud.",
 "{n} confirmados": "{n} confirmados",
 "{n} convidados contam no ⊕ por convidado.": "{n} invitados cuentan en el ⊕ por invitado.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} invitados que estaban en \"Pendiente\" pasaron a \"Por invitar\". Al enviar la invitación por la app, pasan solos a \"Invitado, sin respuesta\".",
 "{n} extras": "{n} extras",
 "{n} talvez": "{n} tal vez",
 "{q} por convidado": "{q} por invitado",
 "{v} por convidado": "{v} por invitado",
 "Item completo": "Elemento completo",
 "Nota rápida": "Nota rápida",
 "📝 Nota rápida": "📝 Nota rápida",
 "Conteúdo da nota": "Contenido de la nota",
 "{c} confirmado(s) de {n} convidado(s)": "{c} confirmado(s) de {n} invitado(s)",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Se borrarán para todos: los documentos, las reuniones programadas y las grabaciones de la oficina \"{nome}\". La conversación sigue en Mensajes.",
 "Confirme para apagar o escritório": "Confirma para borrar la oficina",
 "Escreva o assunto da reunião para poder marcar.": "Escribe el asunto de la reunión para poder programarla.",
 "{n} min (marcada para {m} min)": "{n} min (programada para {m} min)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "No se pudo descargar el archivo ahora. Revisa internet e inténtalo de nuevo.",
 "Meus clientes": "Mis clientes",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Una sola lista de clientes, usada por todas las pestañas de trabajo: contacto, dirección, etiquetas, notas y archivos.",
 "Copiar para Meus clientes": "Copiar a Mis clientes",
 "Ver ou mudar": "Ver o cambiar",
 "Ver o documento completo": "Ver el documento completo",
 "CEP incompleto": "CEP incompleto",
 "O CEP tem 8 números.": "El CEP tiene 8 números.",
 "CEP não encontrado": "CEP no encontrado",
 "Confira os números ou preencha o endereço à mão.": "Revisa los números o completa la dirección a mano.",
 "Não foi possível buscar o CEP": "No se pudo buscar el CEP",
 "Confira a internet ou preencha o endereço à mão.": "Revisa tu conexión a internet o completa la dirección a mano.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Parece que falta algo en este correo (ej.: nombre@sitio.com).",
 "opcional": "opcional",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Tus clientes ahora están en una sola lista, usada por todas las pestañas de trabajo.",
 "Portal do Cliente: {n} cliente(s).": "Portal del Cliente: {n} cliente(s).",
 "Freelancer & Projetos: {n} cliente(s).": "Freelancer y Proyectos: {n} cliente(s).",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} eran el mismo cliente en más de una pestaña y se unieron en una sola ficha.",
 "Nenhum cliente repetido.": "Ningún cliente repetido.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "No se borró nada: documentos, pedidos, tarjetas y horas siguen donde estaban.",
 "Já está em Meus clientes": "Ya está en Mis clientes",
 "{nome} já está na lista.": "{nome} ya está en la lista.",
 "Copiado para Meus clientes": "Copiado a Mis clientes",
 "Só o nome e o contato foram copiados.": "Solo se copiaron el nombre y el contacto.",
 "Aniversário hoje!": "¡Cumpleaños hoy!",
 "Fechar tudo": "Cerrar todo",
 "Abrir tudo": "Abrir todo",
 "Quem é": "Quién es",
 "Razão social": "Razón social",
 "Nome fantasia": "Nombre comercial",
 "Data de abertura": "Fecha de apertura",
 "Inscrição estadual / municipal": "Inscripción estatal / municipal",
 "Outras pessoas de contato": "Otras personas de contacto",
 "Como chamar": "Cómo llamarlo",
 "Cliente desde": "Cliente desde",
 "Outro telefone": "Otro teléfono",
 "Site": "Sitio web",
 "Melhor jeito de falar": "Mejor forma de contacto",
 "Autorizou receber mensagens": "Autorizó recibir mensajes",
 "Outros endereços": "Otras direcciones",
 "Relacionamento": "Relación",
 "Como me conheceu": "Cómo me conoció",
 "Etiquetas": "Etiquetas",
 "Nada anotado ainda.": "Aún no hay notas.",
 "Bloco da aba {aba}": "Bloque de la pestaña {aba}",
 "Abrir na aba {aba}": "Abrir en la pestaña {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Una sola lista, usada por todas las pestañas de trabajo.",
 "Escreva o nome do cliente.": "Escribe el nombre del cliente.",
 "Telefone / WhatsApp": "Teléfono / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Solo el nombre es obligatorio. Abre las partes que quieras completar.",
 "Como chamar (apelido)": "Cómo llamarlo (apodo)",
 "Inscrição estadual / municipal (opcional)": "Inscripción estatal / municipal (opcional)",
 "Cargo": "Cargo",
 "Telefone da pessoa de contato": "Teléfono de la persona de contacto",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Otras personas de contacto (una por línea: nombre, cargo, teléfono)",
 "O telefone principal é WhatsApp": "El teléfono principal es WhatsApp",
 "O outro telefone é WhatsApp": "El otro teléfono es WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Ej.: @nombre",
 "Ex.: WhatsApp, à tarde": "Ej.: WhatsApp, por la tarde",
 "Estado (UF)": "Estado (UF)",
 "Endereço (como estava escrito)": "Dirección (como estaba escrita)",
 "Outros endereços (trabalho, entrega...)": "Otras direcciones (trabajo, entrega...)",
 "Google": "Google",
 "Passou na frente": "Pasó por delante",
 "Indicado por": "Recomendado por",
 "Criar etiqueta": "Crear etiqueta",
 "Ex.: VIP, Mensal, Atacado": "Ej.: VIP, Mensual, Mayorista",
 "Ativo": "Activo",
 "Inativo": "Inactivo",
 "Em negociação": "En negociación",
 "O cliente autorizou receber mensagens?": "¿El cliente autorizó recibir mensajes?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Sin autorización, nada de mensajes de cumpleaños, cobros automáticos ni promociones para este cliente.",
 "aniversário hoje": "cumpleaños hoy",
 "contato: {n}": "contacto: {n}",
 "com esse telefone": "con este teléfono",
 "com esse e-mail": "con este correo",
 "com esse documento": "con este documento",
 "com esse nome": "con este nombre",
 "Cliente parecido": "Cliente parecido",
 "Já existe {nome} {por}. Abrir?": "Ya existe {nome} {por}. ¿Abrir?",
 "Cadastrar mesmo assim": "Registrar de todos modos",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Se borrarán: la ficha, las notas y los archivos de este cliente.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "También en las pestañas: {abas} (con sus documentos, pedidos, tarjetas y horas).",
 "Juntar com outra ficha": "Unir con otra ficha",
 "Juntar fichas": "Unir fichas",
 "Não há outra ficha para juntar.": "No hay otra ficha para unir.",
 "Juntar \"{nome}\" com:": "Unir \"{nome}\" con:",
 "Juntar as duas fichas?": "¿Unir las dos fichas?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" se queda con todo lo de \"{b}\" (datos, notas, archivos y los vínculos con las pestañas). La ficha \"{b}\" dejará de existir.",
 "Juntar": "Unir",
 "Confirme para juntar as fichas": "Confirma para unir las fichas",
 "Aniversariantes do mês": "Cumpleaños del mes",
 "Ativos": "Activos",
 "Inativos": "Inactivos",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Registra cada cliente una vez: aparece en todas las pestañas de trabajo que usas.",
 "Novo cliente": "Nuevo cliente",
 "Editar cliente": "Editar cliente",
 "Linha do tempo": "Historial",
 "{n} registro(s)": "{n} registro(s)",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Nada aún. Aquí aparecen ventas, pagos, documentos y horas.",
 "Me deve": "Me debe",
 "Total pago": "Total pagado",
 "Última compra ou atendimento": "Última compra o atención",
 "Próximo compromisso": "Próxima cita",
 "na entrega": "a la entrega",
 "Passou do limite de fiado ({v}).": "Superó el límite de fiado ({v}).",
 "Recebeu {v} ({p})": "Recibió {v} ({p})",
 "Hoje é aniversário de {n}.": "Hoy es el cumpleaños de {n}.",
 "Mandar parabéns": "Felicitar",
 "{n}: parcela de {v} atrasada.": "{n}: cuota de {v} atrasada.",
 "Cobrar": "Cobrar",
 "{n} não compra há {d} dias.": "{n} no compra desde hace {d} días.",
 "Chamar de volta": "Volver a contactar",
 "🟢 em dia · 🟡 sumido": "🟢 al día · 🟡 ausente",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 al día · 🟡 algo por vencer o cliente ausente · 🔴 atrasado",
 "Limite de fiado (opcional)": "Límite de fiado (opcional)",
 "Avisa quando o que ele deve passar deste valor.": "Avisa cuando lo que debe supere este monto.",
 "A prazo": "A plazos",
 "parcela atrasada": "cuota atrasada",
 "falta na entrega": "pendiente a la entrega",
 "Sumidos": "Ausentes",
 "Sinal pago, falta o resto": "Seña pagada, falta el resto",
 "Pagou {a} de {b}": "Pagó {a} de {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Esta cuota viene de Mis clientes. Márcala aquí como recibida o abre el cliente para cobrar y generar el recibo.",
 "Sinal + restante": "Seña + resto",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Tarjeta de crédito en un pago",
 "Cartão de crédito parcelado": "Tarjeta de crédito en cuotas",
 "Fiado / a prazo": "Fiado / a plazos",
 "Parcela única": "Cuota única",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "¡Hola, {nome}! ¡Feliz cumpleaños! 🎉 Que tengas un día precioso. ¡Un abrazo!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "¡Hola, {nome}! Hace tiempo que no hablamos. ¿Puedo ayudarte en algo? ¡Será un placer atenderte de nuevo!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "¡Hola, {nome}! Paso a recordarte la cuota de {v} que venció el {d}. Cualquier cosa, me avisas. ¡Gracias!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "¡Hola, {nome}! Paso a recordarte la cuota de {v}{d}. Cualquier cosa, me avisas. ¡Gracias!",
 "que vence dia {d}": "que vence el {d}",
 "Quanto recebeu?": "¿Cuánto recibiste?",
 "Falta {v}. Pode ser só uma parte.": "Faltan {v}. Puede ser solo una parte.",
 "(seu nome ou sua marca, em Como você recebe?)": "(tu nombre o tu marca, en ¿Cómo cobras?)",
 "Recibo {c}": "Recibo {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Recibí de {c} la cantidad de {v}, correspondiente a {o}.",
 "{v} no {f} → recebe {l}": "{v} con {f} → recibes {l}",
 "Pagou {a} de {b}, faltam {c}": "Pagó {a} de {b}, faltan {c}",
 "Recebido em {d}": "Recibido el {d}",
 "Cobrar pelo WhatsApp": "Cobrar por WhatsApp",
 "Sem autorização": "Sin autorización",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Este cliente no autorizó recibir mensajes (ficha del cliente › Relación).",
 "Sem telefone": "Sin teléfono",
 "Coloque o telefone na ficha do cliente.": "Agrega el teléfono en la ficha del cliente.",
 "Gerar recibo": "Generar recibo",
 "Como você recebe?": "¿Cómo cobras?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Solo \"Al contado\": la pantalla queda limpia, sin plazos, cuotas ni rojo.",
 "Taxa da maquininha (%)": "Comisión de la terminal (%)",
 "Taxa {k}": "Comisión {k}",
 "Cliente sumido depois de (dias sem comprar)": "Cliente ausente después de (días sin comprar)",
 "Dias para considerar sumido": "Días para considerar ausente",
 "Lembretes de cobrança por parcela atrasada": "Recordatorios de cobro por cuota atrasada",
 "Nome ou marca no recibo": "Nombre o marca en el recibo",
 "Ex.: Ana Beatriz Doces": "Ej.: Ana Beatriz Dulces",
 "Venda ou serviço": "Venta o servicio",
 "O que foi vendido ou feito": "Qué se vendió o hizo",
 "Ex.: Bolo de aniversário": "Ej.: Pastel de cumpleaños",
 "Como paga": "Cómo paga",
 "Sinal (%)": "Seña (%)",
 "Ou escreva o valor do sinal logo abaixo.": "O escribe el monto de la seña justo abajo.",
 "Sinal (valor)": "Seña (monto)",
 "Restante na entrega": "Resto a la entrega",
 "Próximo vencimento": "Próximo vencimiento",
 "Sinal a receber": "Seña por cobrar",
 "falta {v}{q}": "faltan {v}{q}",
 "quitado": "saldado",
 "Parcelas mantidas": "Cuotas mantenidas",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Ya hay un pago registrado: las cuotas no se rehicieron. Para cambiarlas, deshaz primero los pagos.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Registra lo que compró el cliente o el servicio que hiciste, y cómo paga.",
 "Débito": "Débito",
 "Crédito à vista": "Crédito en un pago",
 "Crédito 2x": "Crédito en 2 cuotas",
 "Crédito 3x": "Crédito en 3 cuotas",
 "Crédito 4x": "Crédito en 4 cuotas",
 "Crédito 5x": "Crédito en 5 cuotas",
 "Crédito 6x": "Crédito en 6 cuotas",
 "Crédito 7x": "Crédito en 7 cuotas",
 "Crédito 8x": "Crédito en 8 cuotas",
 "Crédito 9x": "Crédito en 9 cuotas",
 "Crédito 10x": "Crédito en 10 cuotas",
 "Crédito 11x": "Crédito en 11 cuotas",
 "Crédito 12x": "Crédito en 12 cuotas",
 "ATRASADOS": "ATRASADOS",
 "Atrasado (hoje): {v}": "Atrasado (hoy): {v}",
 "Buscar um cliente": "Buscar un cliente",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ completo, dirección completa y fecha de nacimiento. Pide la contraseña de la app.",
 "Cliente cadastrado": "Cliente registrado",
 "Com documentos: guarde o arquivo em lugar seguro.": "Con documentos: guarda el archivo en un lugar seguro.",
 "Como pagou": "Cómo pagó",
 "Esse contato não tem nome.": "Este contacto no tiene nombre.",
 "Exportar planilha": "Exportar hoja de cálculo",
 "Falta receber": "Falta cobrar",
 "Falta receber (hoje): {v}": "Falta cobrar (hoy): {v}",
 "Importar dos contatos": "Importar de contactos",
 "Importar dos contatos do celular": "Importar de los contactos del móvil",
 "Incluir documentos": "Incluir documentos",
 "Incluir documentos no relatório": "Incluir documentos en el informe",
 "MELHORES CLIENTES": "MEJORES CLIENTES",
 "Melhores clientes": "Mejores clientes",
 "Não foi possível gerar a planilha.": "No se pudo generar la hoja de cálculo.",
 "O que foi": "Qué fue",
 "Pago em": "Pagado el",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Para traer clientes de los contactos del móvil, actualiza My Planner desde la tienda de aplicaciones.",
 "RECEBIDO POR DIA": "RECIBIDO POR DÍA",
 "RECEBIDO POR MÊS": "RECIBIDO POR MES",
 "Recebeu": "Recibido",
 "Recebeu no período": "Recibido en el período",
 "Recebeu no período: {v}": "Recibido en el período: {v}",
 "Recebido no período": "Recibido en el período",
 "Relatório de clientes": "Informe de clientes",
 "Relatório deste cliente": "Informe de este cliente",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Sin el permiso de contactos no se puede elegir un contacto. Puedes activarlo en los ajustes del móvil.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Sin documentos: el CPF/CNPJ aparece solo con los 2 últimos números. Las notas nunca aparecen.",
 "Todos os clientes": "Todos los clientes",
 "Trabalha em: {e}": "Trabaja en: {e}",
 "Trazer outro": "Traer otro",
 "VENDAS E ATENDIMENTOS": "VENTAS Y ATENCIONES",
 "Vence": "Vence",
 "Venceu": "Venció",
 "Vendas e atendimentos": "Ventas y atenciones",
 "Vendeu": "Vendido",
 "Vendeu no período": "Vendido en el período",
 "Vendeu no período: {v}": "Vendido en el período: {v}",
 "venceu {d}": "venció el {d}",
 "vendido no período": "vendido en el período",
 "{nome} comprou no período": "{nome} compró en el período",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} se añadió a Mis clientes. Revisa la ficha y marca si autorizó recibir mensajes.",
 "{n} compra(s)": "{n} compra(s)",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Desliza una caja a la izquierda para archivar o a la derecha para eliminar. Mantén pulsada una parte libre de la caja y arrastra para cambiar el orden.",
 "Bloco": "Bloque",
 "Confirme para apagar o grupo": "Confirma para eliminar el grupo",
 "Descer": "Bajar",
 "Opções do bloco": "Opciones del bloque",
 "Exigências do destino": "Requisitos del destino",
 "{n} para acertar": "{n} por saldar",
 "{n} parada(s)": "{n} parada(s)",
 "Cor do item selecionado": "Color del elemento seleccionado",
 "Abrir o grupo": "Abrir el grupo",
 "Recolher o grupo": "Contraer el grupo",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Desliza una caja a la derecha para eliminar o a la izquierda para archivar. Mantén pulsado y arrastra para cambiar el orden.",
 "Editar subtítulo": "Editar subtítulo",
 "Início da caixa": "Inicio de la caja",
 "Mover para…": "Mover a…",
 "Mover {n} item(ns) para": "Mover {n} elemento(s) a",
 "Opções do item": "Opciones del elemento",
 "Transformar em subtítulo": "Convertir en subtítulo",
 "Transformar em texto": "Convertir en texto",
 "esta caixa": "esta caja",
 "{a} de {n} feitos": "{a} de {n} hechos",
 "1 documento pedido atrasado": "1 documento solicitado atrasado",
 "1 pedido vence logo": "1 solicitud vence pronto",
 "A lista vem de \"Meus clientes\".": "La lista viene de \"Mis clientes\".",
 "Abrir Meus clientes": "Abrir Mis clientes",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Las pestañas Oficina y Portal del Cliente ahora son una sola.",
 "Clientes com pendência": "Clientes con pendientes",
 "Com pendência ({n})": "Con pendientes ({n})",
 "Conversa da equipe": "Chat del equipo",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Crea la oficina e invita a tu equipo (amigos de la app o invitación por enlace): chat, reuniones por video y documentos internos. ¿Trabajas solo? Usa solo Clientes.",
 "Documentos internos": "Documentos internos",
 "Entrar com um código de convite": "Unirse con un código de invitación",
 "Escritório & Clientes": "Oficina y Clientes",
 "Escritórios: {n}": "Oficinas: {n}",
 "Esta parte é para quem trabalha com equipe": "Esta parte es para quien trabaja en equipo",
 "Guias vencendo": "Guías por vencer",
 "Minhas tarefas": "Mis tareas",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "No se borró nada: el equipo, el chat, las reuniones, los documentos y los clientes invitados siguen como estaban.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Aún no hay clientes. Regístralo en \"Mis clientes\" y aparecerá aquí al instante.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Para quien trabaja con clientes, solo o en equipo: la carpeta de cada cliente (documentos, solicitudes, guías), equipo, chat, reuniones y documentos internos.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Carpetas de clientes del Portal: {c} (con {d} documentos y {p} solicitudes)",
 "Pessoa física": "Persona física",
 "Procurar por nome, CNPJ ou CPF": "Buscar por nombre, CNPJ o CPF",
 "Reuniões hoje": "Reuniones hoy",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Sin oficina (equipo). Toca para crear una o unirte con un código.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Solo lo ve el equipo. Los clientes nunca ven esta parte.",
 "Tudo em dia": "Todo al día",
 "Vencendo ({n})": "Por vencer ({n})",
 "chega na próxima versão": "llega en la próxima versión",
 "nos próximos 7 dias": "en los próximos 7 días",
 "vence amanhã": "vence mañana",
 "vence hoje": "vence hoy",
 "{doc} venceu em {d}": "{doc} venció el {d}",
 "{n} documentos pedidos atrasados": "{n} documentos solicitados atrasados",
 "{n} pedidos vencem logo": "{n} solicitudes vencen pronto",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 al día · 🟡 algo vence pronto · 🔴 solicitud atrasada o guía vencida",
 "Acesso ao gov.br": "Acceso a gov.br",
 "Alvará": "Licencia de funcionamiento",
 "Até o dia (do mês)": "Hasta el día (del mes)",
 "CCMEI (certificado do MEI)": "CCMEI (certificado del MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Registra el teléfono del cliente para recordarle por WhatsApp.",
 "Cartão CNPJ": "Tarjeta CNPJ",
 "Checklist criado": "Checklist creada",
 "Checklist de cliente novo": "Checklist de cliente nuevo",
 "Cliente viu {doc}": "El cliente vio {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Pégalo en la app del banco, en Pix copia y pega.",
 "Cole no app do banco.": "Pégalo en la app del banco.",
 "Comprovante de endereço": "Comprobante de domicilio",
 "Contrato social e alterações": "Contrato social y modificaciones",
 "Copiado": "Copiado",
 "Copiar Pix": "Copiar Pix",
 "Copiar código de barras": "Copiar código de barras",
 "Código de barras (linha digitável)": "Código de barras (línea digitable)",
 "Dados bancários": "Datos bancarios",
 "Escreva o recado.": "Escribe el mensaje.",
 "Escritório enviou {doc}": "La oficina envió {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Este cliente no autorizó recibir mensajes (ficha en Mis clientes).",
 "Extratos bancários": "Extractos bancarios",
 "Ficha completa": "Ficha completa",
 "Guia": "Guía de pago",
 "Guias a pagar": "Guías por pagar",
 "Honorário": "Honorarios",
 "Honorário por": "Honorarios por",
 "Informes de rendimentos": "Comprobantes de ingresos",
 "Lembrar pelo WhatsApp": "Recordar por WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Leer la guía o el boleto con mi IA",
 "Lucro presumido": "Lucro presunto",
 "Lucro real": "Lucro real",
 "Nada ainda.": "Nada aún.",
 "Nenhum pedido em aberto.": "No hay pedidos abiertos.",
 "Notas fiscais emitidas": "Facturas emitidas",
 "O cliente": "El cliente",
 "O pedido entrou em Pedidos de documentos.": "El pedido se agregó a Pedidos de documentos.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "¡Hola, {nome}! Falta: {itens}. ¿Puedes enviarlo por aquí?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "¡Hola, {nome}! Faltan: {itens}. ¿Puedes enviarlos por aquí?",
 "Oi, {nome}! Tudo certo por aí?": "¡Hola, {nome}! ¿Todo bien por ahí?",
 "Pedido criado": "Pedido creado",
 "Pedido feito: {o}": "Pedido hecho: {o}",
 "Pedido recebido: {o}": "Pedido recibido: {o}",
 "Pedidos pendentes": "Pedidos pendientes",
 "Pedir de novo todo mês": "Pedir de nuevo cada mes",
 "Pedir nova ({c})": "Pedir nueva ({c})",
 "Pendentes": "Pendientes",
 "Que tipo de cliente?": "¿Qué tipo de cliente?",
 "RG e CPF": "RG y CPF",
 "RG e CPF do titular": "RG y CPF del titular",
 "RG e CPF dos sócios": "RG y CPF de los socios",
 "Recados": "Mensajes",
 "Recados entre você e o cliente, presos à pasta dele.": "Mensajes entre tú y el cliente, guardados en su carpeta.",
 "Responde ao pedido": "Responde al pedido",
 "Tipo / regime": "Tipo / régimen",
 "Visto pelo cliente em {d}": "Visto por el cliente el {d}",
 "Válido até": "Válido hasta",
 "ano": "año",
 "código Pix copia e cola, se houver": "código Pix copia y pega, si lo hay",
 "data de vencimento": "fecha de vencimiento",
 "documento": "documento",
 "linha digitável do boleto ou da guia, só números": "línea digitable del boleto o la guía, solo números",
 "mês": "mes",
 "novo": "nuevo",
 "todo mês, até o dia {n}": "cada mes, hasta el día {n}",
 "valor a pagar": "importe a pagar",
 "válido até {d}": "válido hasta {d}",
 "{c} nova": "{c} nueva",
 "{doc} pago": "{doc} pagado",
 "{n} a pagar": "{n} por pagar",
 "{n} enviou {doc}": "{n} envió {doc}",
 "{n} novo(s)": "{n} nuevo(s)",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} pedido(s) de documentos creado(s), con plazo de 7 días.",
 "{n} vencida(s)": "{n} vencida(s)",
 "Última declaração do Imposto de Renda": "Última declaración del impuesto sobre la renta",
 "Últimas guias pagas": "Últimas guías pagadas",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Esta parte de la Oficina aún no se ha conectado al servidor. En el ordenador, ejecuta 56-SERVIDOR-0.96.bat (solo una vez).",
 "Só vê": "Solo ve",
 "Nova versão": "Nueva versión",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Ya había un archivo con este nombre: el anterior se guarda como versión {n}.",
 "Visto por e comentários": "Visto por y comentarios",
 "Arquivar (só neste aparelho)": "Archivar (solo en este dispositivo)",
 "Tirar do topo": "Quitar de arriba",
 "Fixar no topo (para todos)": "Fijar arriba (para todos)",
 "Mover para a pasta…": "Mover a la carpeta…",
 "versão {n}": "versión {n}",
 "visto por {n}": "visto por {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Hasta 50 MB por archivo. Subir un archivo con el mismo nombre guarda el anterior como versión.",
 "Procurar documento ou pasta": "Buscar documento o carpeta",
 "Fixados": "Fijados",
 "Abrir o documento": "Abrir el documento",
 "enviado por {nome}": "enviado por {nome}",
 "Versões ({n})": "Versiones ({n})",
 "Versão {n} (atual)": "Versión {n} (actual)",
 "Versão {n}": "Versión {n}",
 "Visto por ({n})": "Visto por ({n})",
 "Ninguém da equipe abriu ainda.": "Nadie del equipo lo ha abierto aún.",
 "{nome} em {d}": "{nome} el {d}",
 "Comentários ({n})": "Comentarios ({n})",
 "Escreva um comentário": "Escribe un comentario",
 "Contratos": "Contratos",
 "Financeiro do escritório": "Finanzas de la oficina",
 "RH": "RR. HH.",
 "Mover para a pasta": "Mover a la carpeta",
 "Ou escreva o nome de uma pasta nova": "O escribe el nombre de una carpeta nueva",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Se repite cada semana: al cancelarla, desaparece de todas las semanas, de la lista y de los Recibidos del equipo.",
 "a equipe toda": "todo el equipo",
 "Com {quem}": "Con {quem}",
 "toda semana": "cada semana",
 "Vão: {n}": "Van: {n}",
 "Não vão: {n}": "No van: {n}",
 "Vou": "Voy",
 "Não vou": "No voy",
 "Pauta": "Orden del día",
 "Ata": "Acta",
 "Escrever a ata": "Escribir el acta",
 "Abrir o link": "Abrir el enlace",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Cada persona invitada recibe la reunión en Recibidos y la añade al Planner con un toque, con la alerta.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Escribe primero las notas de la reunión (lo que se habló y se decidió); la IA las organiza en un acta.",
 "Ata: {nome}": "Acta: {nome}",
 "Gerando...": "Generando...",
 "Gerar ata com a minha IA": "Generar acta con mi IA",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "La IA organiza el orden del día y tus notas en un acta. Revisa antes de guardar.",
 "Ainda sem ata.": "Aún sin acta.",
 "Tarefas da reunião ({n})": "Tareas de la reunión ({n})",
 "Tarefa da reunião": "Tarea de la reunión",
 "Salvar a ata": "Guardar el acta",
 "Repetir toda semana ({dia})": "Repetir cada semana ({dia})",
 "Quem participa": "Quién participa",
 "A equipe toda": "Todo el equipo",
 "Link externo (opcional: Meet, Zoom, Teams)": "Enlace externo (opcional: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "El enlace debe empezar con https://",
 "Marcar e avisar quem participa": "Programar y avisar a los participantes",
 "Cargo e papel": "Cargo y rol",
 "Passar o Admin": "Pasar el Admin",
 "Passar o Admin para {nome}?": "¿Pasar el Admin a {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} pasa a ser quien se encarga de la oficina (puede eliminarla). Tú sigues en el equipo como administrador (quien recibe puede cambiarlo después).",
 "Passar": "Pasar",
 "{nome} agora cuida do escritório.": "{nome} ahora se encarga de la oficina.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Tu rol aquí es \"Solo ve\": sigues avisos, tareas, reuniones y documentos.",
 "Edita": "Edita",
 "Incluir": "Añadir",
 "Novo aviso no mural": "Nuevo aviso en el tablón",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Solo puedes ver esta oficina: quien administra eligió el rol \"Solo ve\" para ti. Pídele a quien administra que lo cambie si lo necesitas.",
 "Quem viu": "Quién lo vio",
 "Apagar aviso": "Eliminar aviso",
 "Mural de avisos": "Tablón de avisos",
 "Novo aviso": "Nuevo aviso",
 "Ex.: Feriado na sexta: escritório fechado": "Ej.: Festivo el viernes: oficina cerrada",
 "Fixar no mural": "Fijar en el tablón",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Ningún aviso. Los avisos quedan fijados aquí para todo el equipo.",
 "visto por {n} de {m}": "visto por {n} de {m}",
 "sem responsável": "sin responsable",
 "atrasada desde {d}": "atrasada desde {d}",
 "prazo {d}": "plazo {d}",
 "Comecei": "Empecé",
 "Terminei": "Terminé",
 "Reabrir": "Reabrir",
 "Tarefas da equipe": "Tareas del equipo",
 "1 aberta": "1 abierta",
 "{n} abertas": "{n} abiertas",
 "Minhas tarefas ({n})": "Mis tareas ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Ninguna tarea tuya abierta. Toca \"Yo me encargo\" en una tarea del equipo.",
 "Nenhuma tarefa aberta.": "Ninguna tarea abierta.",
 "Feitas ({n})": "Hechas ({n})",
 "Apagar a tarefa?": "¿Eliminar la tarea?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "¿Qué hay que hacer? (ej.: Calcular el DAS de marzo)",
 "Cliente (opcional)": "Cliente (opcional)",
 "Prazo (opcional)": "Plazo (opcional)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Responsable (opcional; si no, alguien toca \"Yo me encargo\")",
 "Escreva a tarefa para poder salvar.": "Escribe la tarea para poder guardar.",
 "Membro": "Miembro",
 "Cargo (livre)": "Cargo (libre)",
 "Ex.: Advogada, Assistente, Estagiário": "Ej.: Abogada, Asistente, Pasante",
 "Papel": "Rol",
 "Admin: pode tudo no escritório.": "Admin: puede hacerlo todo en la oficina.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Edita: añade tareas, avisos, documentos y reuniones",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Solo ve: sigue todo, sin añadir ni cambiar",
 "Proposta": "Propuesta",
 "Documento sensível (pede a senha do app para abrir)": "Documento sensible (pide la contraseña de la app para abrir)",
 "Li e concordo: {d}": "Leído y acepto: {d}",
 "Li e concordo": "Leí y acepto",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Al tocar Acepto, la app guarda la fecha y la hora en que leíste y aceptaste \"{doc}\". Es una aceptación simple: no reemplaza una firma digital oficial.",
 "Concordo": "Acepto",
 "Fotos (escolha quais entram)": "Fotos (elige cuáles entran)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 foto no se pudo leer en este dispositivo y quedó fuera.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} fotos no se pudieron leer en este dispositivo y quedaron fuera.",
 "Nenhuma foto no álbum desta viagem.": "No hay fotos en el álbum de este viaje.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Toca las fotos para marcarlas o desmarcarlas. Entran reducidas para que el PDF sea liviano.",
 "Sugerir até 12": "Sugerir hasta 12",
 "1 foto marcada": "1 foto marcada",
 "{n} fotos marcadas": "{n} fotos marcadas",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Con más de 12 fotos el PDF pesa más.",
 "Confirme para abrir este documento": "Confirma para abrir este documento",
 "Como usar esta aba": "Cómo usar esta pestaña",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 cliente estaba en más de una pestaña y pasó a ser una sola ficha.",
 "Juntar {n} fotos num PDF?": "¿Unir {n} fotos en un PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Las fotos pasan a ser las páginas de un solo PDF, en el orden de la lista. Las fotos sueltas salen de esta ficha.",
 "Não foi possível ler as fotos neste dispositivo.": "No se pudieron leer las fotos en este dispositivo.",
 "PDF criado": "PDF creado",
 "Montando o PDF...": "Creando el PDF...",
 "Juntar as {n} fotos num PDF": "Unir las {n} fotos en un PDF",
 "Baixar o mês": "Descargar el mes",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "Los archivos de este mes están en otro dispositivo y no se pudieron leer aquí.",
 "Os documentos deste mês não têm arquivos.": "Los documentos de este mes no tienen archivos.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 archivo está en otro dispositivo y quedó fuera.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} archivos están en otro dispositivo y quedaron fuera.",
 "Conversa sobre este documento": "Conversación sobre este documento",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Pregunta o responde algo sobre este documento. Lo ven el despacho y el cliente.",
 "Escreva a mensagem": "Escribe el mensaje",
 "Usar um modelo de pedido ({n})": "Usar una plantilla de solicitud ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Recordar a {nome} por WhatsApp: {o}",
 "Sem honorário": "Sin honorarios",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Registra el valor del honorario en el bloque \"Despacho\" de la ficha del cliente, en Mis clientes.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Recibí de {c} la cantidad de {v}, correspondiente a los honorarios del período {m}.",
 "Recibo honorário {m} {c}": "Recibo honorarios {m} {c}",
 "Recibo do honorário {m}": "Recibo del honorario {m}",
 "Recibo criado": "Recibo creado",
 "O recibo entrou em Documentos, na competência {m}.": "El recibo entró en Documentos, en el período {m}.",
 "Vendo como o cliente": "Viendo como el cliente",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "Así ve el cliente su carpeta: sin las anotaciones internas y sin lo que es solo del equipo. No se puede cambiar nada en este modo.",
 "Voltar a ver como escritório": "Volver a ver como despacho",
 "Ver como o cliente": "Ver como el cliente",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Anotaciones internas (el cliente nunca las ve)",
 "Recibo do honorário…": "Recibo del honorario…",
 "Competência do recibo": "Período del recibo",
 "⬇️ Baixar o mês": "⬇️ Descargar el mes",
 "Me avisar para lembrar o cliente": "Avisarme para recordar al cliente",
 "Guardar como modelo": "Guardar como plantilla",
 "Modelo guardado": "Plantilla guardada",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Al crear una solicitud para cualquier cliente, toca \"Usar una plantilla de solicitud\".",
 "Relatório do mês": "Informe del mes",
 "Notas rápidas": "Notas rápidas",
 "Item completo: {o}": "Elemento completo: {o}",
 "Reuniões do mês": "Reuniones del mes",
 "Tarefas feitas e pendentes": "Tareas hechas y pendientes",
 "Documentos internos enviados": "Documentos internos enviados",
 "Documentos enviados e recebidos dos clientes": "Documentos enviados y recibidos de los clientes",
 "Documentos da competência": "Documentos del período",
 "Guias pagas e vencidas": "Guías de impuestos pagadas y vencidas",
 "Honorários": "Honorarios",
 "Relatório do mês · {m}": "Informe del mes · {m}",
 "Reuniões ({n})": "Reuniones ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Tareas: {f} hechas en el mes · {p} pendientes",
 "Quem fez": "Quién lo hizo",
 "Feita em": "Hecha el",
 "Documentos internos enviados ({n})": "Documentos internos enviados ({n})",
 "Documentos trocados com os clientes": "Documentos intercambiados con los clientes",
 "Enviados pelo escritório": "Enviados por el despacho",
 "Recebidos do cliente": "Recibidos del cliente",
 "Nenhum documento trocado neste mês.": "Ningún documento intercambiado este mes.",
 "Clientes com pendência ({n})": "Clientes con pendientes ({n})",
 "Pendência": "Pendiente",
 "Nenhum cliente com pendência.": "Ningún cliente con pendientes.",
 "Documentos da competência {m} ({n})": "Documentos del período {m} ({n})",
 "Pedidos de documentos ({n})": "Solicitudes de documentos ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Guías del mes: {p} pagadas · {v} vencidas",
 "Vencida": "Vencida",
 "Recebido no mês": "Recibido en el mes",
 "Relatório {m} {q}": "Informe {m} {q}",
 "MÊS": "MES",
 "DE QUEM": "DE QUIÉN",
 "O escritório": "El despacho",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Las reuniones, tareas y documentos internos se incluyen cuando hay un despacho (equipo).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, anotaciones internas y conversaciones nunca van al informe.",
 "Anotações recebidas": "Notas recibidas",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Los valores por cobrar de esta lista aparecen en My Planner, incluidos los nuevos.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Envía solo los valores por cobrar de esta lista (las consultas ya van solas), incluidos los nuevos.",
 "Acrescentar": "Añadir",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "Las {n} cajas están en {aba}, en \"Notas recibidas\".",
 "Enviadas": "Enviadas",
 "Enviar para": "Enviar a",
 "Excluir 1 item?": "¿Eliminar 1 elemento?",
 "Excluir {n} itens?": "¿Eliminar {n} elementos?",
 "Inserir abaixo": "Insertar debajo",
 "Mover para": "Mover a",
 "Mover {n} selecionados para": "Mover {n} seleccionados a",
 "adicionar aqui": "añadir aquí",
 "continue segurando para selecionar": "sigue manteniendo para seleccionar"
}
